// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * Paper Dashboard PRO React - v1.2.0 based on Paper Dashboard 2 Pro - v2.0.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
 * Copyright 2020 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #66615b;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #7a9e9f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #68b3c8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #7ac29a;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #f3bb45;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #eb5e28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
  background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type="radio"],
.bootstrap-switch input[type="checkbox"] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type="radio"].form-control,
.bootstrap-switch input[type="checkbox"].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
  background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
  background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #eb5e28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #f3bb45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #7ac29a;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #7a9e9f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #68b3c8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

/**
 * @author zhixin wen <wenzhixin2010@gmail.com>
 * version: 1.12.1
 * https://github.com/wenzhixin/bootstrap-table/
 */
.bootstrap-table .table {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #dddddd;
  border-collapse: collapse !important;
  border-radius: 1px;
}

.bootstrap-table .table:not(.table-condensed),
.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,
.bootstrap-table .table:not(.table-condensed) > thead > tr > td,
.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {
  padding: 8px;
}

.bootstrap-table .table.table-no-bordered > thead > tr > th,
.bootstrap-table .table.table-no-bordered > tbody > tr > td {
  border-right: 2px solid transparent;
}

.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {
  border-right: none;
}

.fixed-table-container {
  position: relative;
  clear: both;
  border: 1px solid #dddddd;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}

.fixed-table-container.table-no-bordered {
  border: 1px solid transparent;
}

.fixed-table-footer,
.fixed-table-header {
  overflow: hidden;
}

.fixed-table-footer {
  border-top: 1px solid #dddddd;
}

.fixed-table-body {
  overflow-x: auto;
  overflow-y: auto;
  height: 100%;
}

.fixed-table-container table {
  width: 100%;
}

.fixed-table-container thead th {
  height: 0;
  padding: 0;
  margin: 0;
  border-left: 1px solid #dddddd;
}

.fixed-table-container thead th:focus {
  outline: 0 solid transparent;
}

.fixed-table-container thead th:first-child:not([data-not-first-th]) {
  border-left: none;
  border-top-left-radius: 4px;
  -webkit-border-top-left-radius: 4px;
  -moz-border-radius-topleft: 4px;
}

.fixed-table-container thead th .th-inner,
.fixed-table-container tbody td .th-inner {
  padding: 8px;
  line-height: 24px;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table-container thead th .sortable {
  cursor: pointer;
  background-position: right;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.fixed-table-container thead th .both {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fixed-table-container thead th .asc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fixed-table-container thead th .desc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fixed-table-container th.detail {
  width: 30px;
}

.fixed-table-container tbody td {
  border-left: 1px solid #dddddd;
}

.fixed-table-container tbody tr:first-child td {
  border-top: none;
}

.fixed-table-container tbody td:first-child {
  border-left: none;
}

/* the same color with .active */
.fixed-table-container tbody .selected td {
  background-color: #f5f5f5;
}

.fixed-table-container .bs-checkbox {
  text-align: center;
}

.fixed-table-container input[type="radio"],
.fixed-table-container input[type="checkbox"] {
  margin: 0 auto !important;
}

.fixed-table-container .no-records-found {
  text-align: center;
}

.fixed-table-pagination div.pagination,
.fixed-table-pagination .pagination-detail {
  margin-top: 10px;
  margin-bottom: 10px;
}

.fixed-table-pagination div.pagination .pagination {
  margin: 0;
}

.fixed-table-pagination .pagination a {
  padding: 6px 12px;
  line-height: 1.428571429;
}

.fixed-table-pagination .pagination-info {
  line-height: 34px;
  margin-right: 5px;
}

.fixed-table-pagination .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.fixed-table-pagination .dropup .dropdown-menu {
  margin-bottom: 0;
}

.fixed-table-pagination .page-list {
  display: inline-block;
}

.fixed-table-toolbar .columns-left {
  margin-right: 5px;
}

.fixed-table-toolbar .columns-right {
  margin-left: 5px;
}

.fixed-table-toolbar .columns label {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.428571429;
}

.fixed-table-toolbar .bs-bars,
.fixed-table-toolbar .search,
.fixed-table-toolbar .columns {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 34px;
}

.fixed-table-pagination li.disabled a {
  pointer-events: none;
  cursor: default;
}

.fixed-table-loading {
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;
}

.fixed-table-body .card-view .title {
  font-weight: bold;
  display: inline-block;
  min-width: 30%;
  text-align: left !important;
}

/* support bootstrap 2 */
.fixed-table-body thead th .th-inner {
  box-sizing: border-box;
}

.table th,
.table td {
  vertical-align: middle;
  box-sizing: border-box;
}

.fixed-table-toolbar .dropdown-menu {
  text-align: left;
  max-height: 300px;
  overflow: auto;
}

.fixed-table-toolbar .btn-group > .btn-group {
  display: inline-block;
  margin-left: -1px !important;
}

.fixed-table-toolbar .btn-group > .btn-group > .btn {
  border-radius: 0;
}

.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.bootstrap-table .table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 1px solid #ddd;
}

/* support bootstrap 3 */
.bootstrap-table .table thead > tr > th {
  padding: 0;
  margin: 0;
}

.bootstrap-table .fixed-table-footer tbody > tr > td {
  padding: 0 !important;
}

.bootstrap-table .fixed-table-footer .table {
  border-bottom: none;
  border-radius: 0;
  padding: 0 !important;
}

.bootstrap-table .pull-right .dropdown-menu {
  right: 0;
  left: auto;
}

/* calculate scrollbar width */
p.fixed-table-scroll-inner {
  width: 100%;
  height: 200px;
}

div.fixed-table-scroll-outer {
  top: 0;
  left: 0;
  visibility: hidden;
  width: 200px;
  height: 150px;
  overflow: hidden;
}

/* for get correct heights  */
.fixed-table-toolbar:after,
.fixed-table-pagination:after {
  content: "";
  display: block;
  clear: both;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100% !important;
  background: #fff;
}

.bootstrap-table .btn-group:last-child .btn {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  margin-left: -2px;
}

/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  /* Fix 401 */
}

.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}

.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
}

.noUi-handle {
  position: relative;
  z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
  transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 8px;
}

.noUi-horizontal .noUi-handle {
  background: white;
  /* Old browsers */
  /* FF3.6+ */
  /* Chrome,Safari4+ */
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  background: linear-gradient(to bottom, white 0%, #f1f1f2 100%);
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='\$white-color', endColorstr='#f1f1f2',GradientType=0 );
  /* IE6-9 */
  border-radius: 50%;
  box-shadow: 0 1px 1px #ffffff inset, 0 1px 2px rgba(0, 0, 0, 0.4);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -4px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

/* Styling;
 */
.noUi-target {
  background-color: #e5e5e5;
  border-radius: 3px;
}

.noUi-connect {
  background: #3fb8af;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
}

.noUi-active {
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}

/* Handle stripes;
 */
/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  background: #aaa;
}

.noUi-marker-large {
  background: #aaa;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate3d(-50%, 50%, 0);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-info .noUi-connect,
.slider.slider-info.noUi-connect {
  background-color: #0fa0cf;
}

.slider.slider-info .noUi-handle {
  border-color: #0fa0cf;
}

.slider.slider-success .noUi-connect,
.slider.slider-success.noUi-connect {
  background-color: #6bd098;
}

.slider.slider-success .noUi-handle {
  border-color: #6bd098;
}

.slider.slider-warning .noUi-connect,
.slider.slider-warning.noUi-connect {
  background-color: #fbc658;
}

.slider.slider-warning .noUi-handle {
  border-color: #fbc658;
}

.slider.slider-danger .noUi-connect,
.slider.slider-danger.noUi-connect {
  background-color: #ef8157;
}

.slider.slider-danger .noUi-handle {
  border-color: #ef8157;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  animation-name: shake;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInDown {
  animation-name: fadeInDown;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fadeOut {
  animation-name: fadeOut;
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
}

@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

.fadeOutUp {
  animation-name: fadeOutUp;
}

/* perfect-scrollbar v0.6.13 */
.ps-container {
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
  .ps-container {
    overflow: auto !important;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps-container {
    overflow: auto !important;
  }
}

.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 0px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 15px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear,
    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  bottom: 2px;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 6px;
}

.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x,
.ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {
  height: 11px;
}

.ps-container > .ps-scrollbar-y-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  right: 0;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 15px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear,
    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  right: 2px;
  /* there must be 'right' for ps-scrollbar-y */
  width: 6px;
}

.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y,
.ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {
  width: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x
  > .ps-scrollbar-x-rail
  > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y
  > .ps-scrollbar-y-rail
  > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #999;
}

body.swal2-shown {
  overflow-y: hidden;
}

body.swal2-iosfix {
  position: fixed;
  left: 0;
  right: 0;
}

.swal2-container {
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 10px;
  background-color: transparent;
  z-index: 1060;
}

.swal2-container.swal2-fade {
  transition: background-color 0.1s;
}

.swal2-container.swal2-shown {
  background-color: rgba(0, 0, 0, 0.4);
}

.swal2-modal {
  background-color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 5px;
  box-sizing: border-box;
  text-align: center;
  margin: auto;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
  position: relative;
  max-width: 100%;
}

.swal2-modal:focus {
  outline: none;
}

.swal2-modal.swal2-loading {
  overflow-y: hidden;
}

.swal2-modal .swal2-title {
  color: #595959;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 0 0 0.4em;
  padding: 0;
  display: block;
  word-wrap: break-word;
}

.swal2-modal .swal2-buttonswrapper {
  margin-top: 15px;
}

.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {
  opacity: 0.4;
  cursor: no-drop;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {
  box-sizing: border-box;
  border: 4px solid transparent;
  border-color: transparent;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 7.5px;
  vertical-align: top;
  background-color: transparent !important;
  color: transparent;
  cursor: default;
  border-radius: 100%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {
  margin-left: 30px;
  margin-right: 30px;
}

.swal2-modal
  .swal2-buttonswrapper.swal2-loading
  :not(.swal2-styled).swal2-confirm::after {
  display: inline-block;
  content: "";
  margin-left: 5px;
  vertical-align: -1px;
  height: 15px;
  width: 15px;
  border: 3px solid #999999;
  box-shadow: 1px 1px 1px #fff;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
}

.swal2-modal .swal2-styled {
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  font-weight: 500;
  margin: 15px 5px 0;
  padding: 10px 32px;
}

.swal2-modal .swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);
}

.swal2-modal .swal2-image {
  margin: 20px auto;
  max-width: 100%;
}

.swal2-modal .swal2-close {
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  width: 38px;
  height: 40px;
  font-size: 36px;
  line-height: 40px;
  font-family: serif;
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
  color: #cccccc;
  transition: color 0.1s ease;
}

.swal2-modal .swal2-close:hover {
  color: #d55;
}

.swal2-modal > .swal2-input,
.swal2-modal > .swal2-file,
.swal2-modal > .swal2-textarea,
.swal2-modal > .swal2-select,
.swal2-modal > .swal2-radio,
.swal2-modal > .swal2-checkbox {
  display: none;
}

.swal2-modal .swal2-content {
  font-size: 18px;
  text-align: center;
  font-weight: 300;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
  color: #545454;
  word-wrap: break-word;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea,
.swal2-modal .swal2-select,
.swal2-modal .swal2-radio,
.swal2-modal .swal2-checkbox {
  margin: 20px auto;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  border-radius: 3px;
  border: 1px solid #d9d9d9;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.swal2-modal .swal2-input.swal2-inputerror,
.swal2-modal .swal2-file.swal2-inputerror,
.swal2-modal .swal2-textarea.swal2-inputerror {
  border-color: #f27474 !important;
  box-shadow: 0 0 2px #f27474 !important;
}

.swal2-modal .swal2-input:focus,
.swal2-modal .swal2-file:focus,
.swal2-modal .swal2-textarea:focus {
  outline: none;
  border: 1px solid #b4dbed;
  box-shadow: 0 0 3px #c4e6f5;
}

.swal2-modal .swal2-input::placeholder,
.swal2-modal .swal2-file::placeholder,
.swal2-modal .swal2-textarea::placeholder {
  color: #cccccc;
}

.swal2-modal .swal2-range input {
  float: left;
  width: 80%;
}

.swal2-modal .swal2-range output {
  float: right;
  width: 20%;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.swal2-modal .swal2-range input,
.swal2-modal .swal2-range output {
  height: 43px;
  line-height: 43px;
  vertical-align: middle;
  margin: 20px auto;
  padding: 0;
}

.swal2-modal .swal2-input {
  height: 43px;
  padding: 0 12px;
}

.swal2-modal .swal2-input[type="number"] {
  max-width: 150px;
}

.swal2-modal .swal2-file {
  font-size: 20px;
}

.swal2-modal .swal2-textarea {
  height: 108px;
  padding: 12px;
}

.swal2-modal .swal2-select {
  color: #545454;
  font-size: inherit;
  padding: 5px 10px;
  min-width: 40%;
  max-width: 100%;
}

.swal2-modal .swal2-radio {
  border: 0;
}

.swal2-modal .swal2-radio label:not(:first-child) {
  margin-left: 20px;
}

.swal2-modal .swal2-radio input,
.swal2-modal .swal2-radio span {
  vertical-align: middle;
}

.swal2-modal .swal2-radio input {
  margin: 0 3px 0 0;
}

.swal2-modal .swal2-checkbox {
  color: #545454;
}

.swal2-modal .swal2-checkbox input,
.swal2-modal .swal2-checkbox span {
  vertical-align: middle;
}

.swal2-modal .swal2-validationerror {
  background-color: #f0f0f0;
  margin: 0 -20px;
  overflow: hidden;
  padding: 10px;
  color: gray;
  font-size: 16px;
  font-weight: 300;
  display: none;
}

.swal2-modal .swal2-validationerror::before {
  content: "!";
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ea7d7d;
  color: #fff;
  line-height: 24px;
  text-align: center;
  margin-right: 10px;
}

@supports (-ms-accelerator: true) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}

.swal2-icon {
  width: 80px;
  height: 80px;
  border: 4px solid transparent;
  border-radius: 50%;
  margin: 20px auto 30px;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-icon.swal2-error {
  border-color: rgba(255, 54, 54, 0.3);
}

.swal2-icon.swal2-error .swal2-x-mark {
  position: relative;
  display: block;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"] {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #ff3636;
  display: block;
  top: 37px;
  border-radius: 2px;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"][class\$="left"] {
  transform: rotate(45deg);
  left: 17px;
}

.swal2-icon.swal2-error [class^="swal2-x-mark-line"][class\$="right"] {
  transform: rotate(-45deg);
  right: 16px;
}

.swal2-icon.swal2-warning {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #ffb236;
  border-color: #ffb236;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-info {
  font-family: "Open Sans", sans-serif;
  color: #3fc3ee;
  border-color: #9de0f6;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-question {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #87adbd;
  border-color: #c9dae1;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-success {
  border-color: #a5dc86;
}

.swal2-icon.swal2-success [class^="swal2-success-circular-line"] {
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success
  [class^="swal2-success-circular-line"][class\$="left"] {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}

.swal2-icon.swal2-success
  [class^="swal2-success-circular-line"][class\$="right"] {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}

.swal2-icon.swal2-success .swal2-success-ring {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(24, 206, 15, 0.3);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}

.swal2-icon.swal2-success .swal2-success-fix {
  width: 7px;
  height: 90px;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}

.swal2-icon.swal2-success [class^="swal2-success-line"] {
  height: 5px;
  background-color: #18ce0f;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}

.swal2-icon.swal2-success [class^="swal2-success-line"][class\$="tip"] {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^="swal2-success-line"][class\$="long"] {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}

.swal2-progresssteps {
  font-weight: 600;
  margin: 0 0 20px;
  padding: 0;
}

.swal2-progresssteps li {
  display: inline-block;
  position: relative;
}

.swal2-progresssteps .swal2-progresscircle {
  background: #3085d6;
  border-radius: 2em;
  color: #fff;
  height: 2em;
  line-height: 2em;
  text-align: center;
  width: 2em;
  z-index: 20;
}

.swal2-progresssteps .swal2-progresscircle:first-child {
  margin-left: 0;
}

.swal2-progresssteps .swal2-progresscircle:last-child {
  margin-right: 0;
}

.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {
  background: #3085d6;
}

.swal2-progresssteps
  .swal2-progresscircle.swal2-activeprogressstep
  ~ .swal2-progresscircle {
  background: #add8e6;
}

.swal2-progresssteps
  .swal2-progresscircle.swal2-activeprogressstep
  ~ .swal2-progressline {
  background: #add8e6;
}

.swal2-progresssteps .swal2-progressline {
  background: #3085d6;
  height: 0.4em;
  margin: 0 -1px;
  z-index: 10;
}

[class^="swal2"] {
  -webkit-tap-highlight-color: transparent;
}

@keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes hideSweetAlert {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

.swal2-show {
  animation: showSweetAlert 0.3s;
}

.swal2-show.swal2-noanimation {
  animation: none;
}

.swal2-hide {
  animation: hideSweetAlert 0.15s forwards;
}

.swal2-hide.swal2-noanimation {
  animation: none;
}

@keyframes animate-success-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes animate-success-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

.swal2-animate-success-line-tip {
  animation: animate-success-tip 0.75s;
}

.swal2-animate-success-line-long {
  animation: animate-success-long 0.75s;
}

.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {
  animation: rotatePlaceholder 4.25s ease-in;
}

@keyframes animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}

.swal2-animate-error-icon {
  animation: animate-error-icon 0.5s;
}

@keyframes animate-x-mark {
  0% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    margin-top: -6px;
  }
  100% {
    transform: scale(1);
    margin-top: 0;
    opacity: 1;
  }
}

.swal2-animate-x-mark {
  animation: animate-x-mark 0.5s;
}

@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.card-wizard {
  min-height: 410px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  opacity: 0;
  transition: all 300ms linear;
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #e3e3e3;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 12px;
  font-size: 12px;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #66615b;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #ffffff !important;
  cursor: pointer;
  font-weight: 500;
}
.card-wizard[data-color="primary"] .moving-tab {
  color: #51cbce;
}
.card-wizard[data-color="primary"] .picture:hover {
  border-color: #51cbce;
}
.card-wizard[data-color="primary"] .choice:hover .icon,
.card-wizard[data-color="primary"] .choice.active .icon {
  border-color: #51cbce;
  color: #51cbce;
}
.card-wizard[data-color="primary"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #51cbce;
}
.card-wizard[data-color="primary"] .radio input[type="radio"]:checked ~ .check {
  background-color: #51cbce;
}
.card-wizard[data-color="primary"]
  .radio
  input[type="radio"]:checked
  ~ .circle {
  border-color: #51cbce;
}
.card-wizard[data-color="white"] .moving-tab {
  color: #ffffff;
}
.card-wizard[data-color="white"] .picture:hover {
  border-color: #ffffff;
}
.card-wizard[data-color="white"] .choice:hover .icon,
.card-wizard[data-color="white"] .choice.active .icon {
  border-color: #ffffff;
  color: #ffffff;
}
.card-wizard[data-color="white"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .check {
  background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #ffffff;
}
.card-wizard[data-color="green"] .moving-tab {
  color: #6bd098;
}
.card-wizard[data-color="green"] .picture:hover {
  border-color: #6bd098;
}
.card-wizard[data-color="green"] .choice:hover .icon,
.card-wizard[data-color="green"] .choice.active .icon {
  border-color: #6bd098;
  color: #6bd098;
}
.card-wizard[data-color="green"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #6bd098;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .check {
  background-color: #6bd098;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #6bd098;
}
.card-wizard[data-color="blue"] .moving-tab {
  color: #0fa0cf;
}
.card-wizard[data-color="blue"] .picture:hover {
  border-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .choice:hover .icon,
.card-wizard[data-color="blue"] .choice.active .icon {
  border-color: #0fa0cf;
  color: #0fa0cf;
}
.card-wizard[data-color="blue"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .check {
  background-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #0fa0cf;
}
.card-wizard[data-color="orange"] .moving-tab {
  color: #fbc658;
}
.card-wizard[data-color="orange"] .picture:hover {
  border-color: #fbc658;
}
.card-wizard[data-color="orange"] .choice:hover .icon,
.card-wizard[data-color="orange"] .choice.active .icon {
  border-color: #fbc658;
  color: #fbc658;
}
.card-wizard[data-color="orange"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #fbc658;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .check {
  background-color: #fbc658;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #fbc658;
}
.card-wizard[data-color="red"] .moving-tab {
  color: #ef8157;
}
.card-wizard[data-color="red"] .picture:hover {
  border-color: #ef8157;
}
.card-wizard[data-color="red"] .choice:hover .icon,
.card-wizard[data-color="red"] .choice.active .icon {
  border-color: #ef8157;
  color: #ef8157;
}
.card-wizard[data-color="red"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #ef8157;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .check {
  background-color: #ef8157;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #ef8157;
}
.card-wizard .picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #66615b;
  margin: 0 auto 20px;
  border: 1px solid #e3e3e3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon,
.card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type="radio"],
.card-wizard .choice input[type="checkbox"] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #9a9a9a;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #ffffff !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0) !important;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="today"]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 4px;
  width: 16em;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -12px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -11px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 5px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
  border-width: 0;
  color: #66615b;
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action="togglePicker"],
.bootstrap-datetimepicker-widget a[data-action="togglePicker"]:hover {
  color: #429cb6 !important;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.85);
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  height: 38px;
  padding: 0;
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action="today"]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 4px;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 4px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}

.bootstrap-datetimepicker-widget table td > div,
.bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled,
.bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span,
.bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
.bootstrap-datetimepicker-widget
  table
  thead
  tr:first-child
  th.picker-switch:hover {
  background: #e3e3e3;
}

.bootstrap-datetimepicker-widget table td > div {
  border-radius: 4px;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div {
  height: 30px;
  line-height: 31px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
}

.table-condensed .day:hover div {
  transition: all 150ms linear;
}

.bootstrap-datetimepicker-widget table td.minute > div,
.bootstrap-datetimepicker-widget table td.hour > div {
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget table td.day:hover > div,
.bootstrap-datetimepicker-widget table td.hour:hover > div,
.bootstrap-datetimepicker-widget table td.minute:hover > div,
.bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #e3e3e3;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div,
.bootstrap-datetimepicker-widget table td.new > div {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #68b3c8;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.bootstrap-datetimepicker-widget table td.active > div,
.bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #68b3c8;
  color: #ffffff;
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #ffffff;
}

.bootstrap-datetimepicker-widget table td.disabled > div,
.bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span:hover {
  background: #e3e3e3;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #68b3c8;
  color: #ffffff;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled,
.bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget {
  opacity: 0;
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  transform: translate3d(0, -10px, 0) !important;
}
.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0, 10px, 0) !important;
  opacity: 0;
}
.bootstrap-datetimepicker-widget.open {
  opacity: 1;
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  transform: translate3d(0, 2px, 0) !important;
}

.bootstrap-datetimepicker-widget.top.open {
  opacity: 1;
  transform: translate3d(0, -7px, 0) !important;
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}
.bootstrap-datetimepicker-widget.top.open:before {
  border-top: 11px solid #dcd9d1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}
.bootstrap-datetimepicker-widget.top.open:after {
  border-top: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

/*!
 * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  width: 220px;
  /*IE9 and below*/
}
.bootstrap-select > .dropdown-toggle {
  width: 100%;
  padding-right: 25px;
  z-index: 1;
}
.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
}
.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}
.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle {
  border-color: #b94a48;
}
.bootstrap-select.fit-width {
  width: auto !important;
}
.bootstrap-select:not([class*="col-"]):not([class*="form-control"]):not(.input-group-btn) {
  width: 150px;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}
.bootstrap-select.form-control:not([class*="col-"]) {
  width: 100%;
}
.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}
.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)
  > .btn {
  border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn),
.bootstrap-select.btn-group[class*="col-"] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.btn-group.dropdown-menu-right,
.bootstrap-select.btn-group[class*="col-"].dropdown-menu-right,
.row .bootstrap-select.btn-group[class*="col-"].dropdown-menu-right {
  float: right;
}

.form-inline .bootstrap-select.btn-group,
.form-horizontal .bootstrap-select.btn-group,
.form-group .bootstrap-select.btn-group {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control,
.form-group-sm .bootstrap-select.btn-group.form-control {
  padding: 0;
}
.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.form-inline .bootstrap-select.btn-group .form-control {
  width: 100%;
}

.bootstrap-select.btn-group.disabled,
.bootstrap-select.btn-group > .disabled {
  cursor: not-allowed;
}
.bootstrap-select.btn-group.disabled:focus,
.bootstrap-select.btn-group > .disabled:focus {
  outline: none !important;
}

.bootstrap-select.btn-group.bs-container {
  position: absolute;
  height: 0 !important;
  padding: 0 !important;
}
.bootstrap-select.btn-group.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select.btn-group .dropdown-toggle .filter-option {
  display: inline-block;
  overflow: hidden;
  width: 100%;
  text-align: left;
}

.bootstrap-select.btn-group[class*="col-"] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select.btn-group .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
}
.bootstrap-select.btn-group .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
}
.bootstrap-select.btn-group .dropdown-menu li {
  position: relative;
}
.bootstrap-select.btn-group .dropdown-menu li.active small {
  color: #fff;
}
.bootstrap-select.btn-group .dropdown-menu li.disabled a {
  cursor: not-allowed;
}
.bootstrap-select.btn-group .dropdown-menu li a {
  color: #66615b;
  font-size: 16px;
  padding: 5px 45px 5px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.bootstrap-select.btn-group .dropdown-menu li a:hover {
  background-color: #66615b;
  color: rgba(255, 255, 255, 0.7);
  opacity: 1;
  text-decoration: none;
}
.bootstrap-select.btn-group .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}
.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
  display: none;
}
.bootstrap-select.btn-group .dropdown-menu li a span.text {
  display: inline-block;
}
.bootstrap-select.btn-group .dropdown-menu li small {
  padding-left: 0.5em;
}
.bootstrap-select.btn-group .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: whitesmoke;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select.btn-group .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
  position: static;
}

.bootstrap-select.btn-group.show-tick
  .dropdown-menu
  li.selected
  a
  span.check-mark {
  position: absolute;
  display: inline-block;
  right: 15px;
  margin-top: 5px;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
  bottom: auto;
  top: -3px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
  bottom: auto;
  top: -3px;
  border-top: 6px solid white;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:before,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}
.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}
.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

.bootstrap-select.show:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 50px;
}

.bootstrap-select.show:after {
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 51px;
}

.bootstrap-select.dropup.show:before {
  border-top: 11px solid #dcd9d1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: none;
  right: 15px;
  top: -11px;
}

.bootstrap-select.dropup.show:after {
  border-top: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: none;
  right: 15px;
  top: -12px;
}

.bootstrap-select .dropdown-menu .dropdown-menu {
  transform: translate3d(0, 0, 0) !important;
}
.bootstrap-select .dropdown-menu .dropdown-menu:after,
.bootstrap-select .dropdown-menu .dropdown-menu:before {
  display: none;
}

.bootstrap-select.dropup .dropdown-menu.show {
  transform: translate3d(0, -60px, 0) !important;
}

.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #fbc658;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #fbc658;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #ef8157;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #ef8157;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #6bd098;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #6bd098;
}

.input-group-addon:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 3px;
  padding: 0;
}

.bootstrap-tagsinput {
  background-color: transparent;
  display: inline-block;
  padding: 4px 6px;
  vertical-align: middle;
  border-radius: 4px;
  width: 100%;
  line-height: 22px;
  cursor: text;
}
.bootstrap-tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
}
.bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}
.bootstrap-tagsinput input::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.bootstrap-tagsinput input:-ms-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput input::-webkit-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input:-ms-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput .badge {
  transition: all 170ms linear;
}
.bootstrap-tagsinput .badge {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 4px 8px 3px 0.8em;
  border-radius: 12px;
  color: #fff;
  font-size: 0.75em;
  font-weight: 500;
  display: inline-block;
  line-height: 1.5em;
  text-transform: uppercase;
}
.bootstrap-tagsinput .badge:hover {
  padding-right: 25px;
}
.bootstrap-tagsinput .badge:hover [data-role="remove"] {
  opacity: 1;
  padding-right: 6px;
}
.bootstrap-tagsinput .badge [data-role="remove"] {
  cursor: pointer;
  position: absolute;
  top: 3.5px;
  right: 0;
  opacity: 0;
}
.bootstrap-tagsinput .badge [data-role="remove"]:after {
  content: "\\f00d";
  padding: 0px 4px;
  font-size: 18px;
  font: normal normal normal 10px/1 FontAwesome;
}
.bootstrap-tagsinput .badge [data-role="remove"]:hover:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  opacity: 1;
}

.badge-success {
  background-color: #7ac29a;
}

/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3
 *
 * Included libraries:
 *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3
 */
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
}

table.dataTable td,
table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 75px;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.5;
}

table.dataTable thead .sorting:after {
  opacity: 0.2;
  content: "\\e150";
  /* sort */
}

table.dataTable thead .sorting_asc:after {
  content: "\\e155";
  /* sort-by-attributes */
}

table.dataTable thead .sorting_desc:after {
  content: "\\e156";
  /* sort-by-attributes-alt */
}

table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  color: #eee;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
  div.dataTables_wrapper div.dataTables_filter,
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}

table.dataTable.table-condensed > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-condensed .sorting:after,
table.dataTable.table-condensed .sorting_asc:after,
table.dataTable.table-condensed .sorting_desc:after {
  top: 6px;
  right: 6px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:first-child {
  padding-left: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:last-child {
  padding-right: 0;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 0.8;
}

table.dataTable thead .disabled-sorting.sorting:after,
table.dataTable thead .disabled-sorting.sorting_asc:after,
table.dataTable thead .disabled-sorting.sorting_desc:after,
table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,
table.dataTable thead .disabled-sorting.sorting_desc_disabled:after {
  display: none;
}

table.dataTable thead .sorting:after {
  opacity: 0.4;
  content: "\\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\\f0de";
  top: 3px;
}

table.dataTable thead .sorting_desc:after {
  content: "\\f0dd";
  top: -3px;
}

table.dataTable .table-hover > tbody > tr:hover {
  background-color: #fff4dc;
}

table.dataTable .table > thead > tr > th,
table.dataTable .table > tbody > tr > th,
table.dataTable .table > tfoot > tr > th,
table.dataTable .table > thead > tr > td,
table.dataTable .table > tbody > tr > td,
table.dataTable .table > tfoot > tr > td {
  padding: 8px !important;
  outline: 0;
}

table.dataTable .btn.btn-icon {
  margin: 0 3px;
  padding: 5px 8px;
}

.dataTables_paginate a {
  outline: 0;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
  top: 50%;
  margin-top: -9px;
  left: 4px;
  height: 18px;
  width: 18px;
  display: block;
  position: absolute;
  color: #518607;
  border: 0px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 18px;
  content: "+";
  background-color: #fff;
}

table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > th:first-child:before {
  content: "-";
  color: #ed362c;
}

table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
  display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}

table.dataTable.dtr-inline.collapsed.compact
  > tbody
  > tr
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact
  > tbody
  > tr
  > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}

table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #31b131;
}

table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}

table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}

table.dataTable > tbody > tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table.dataTable > tbody > tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}

table.dataTable > tbody > tr.child ul li:first-child {
  padding-top: 0;
}

table.dataTable > tbody > tr.child ul li:last-child {
  border-bottom: none;
}

table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}
div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}
div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}
div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
}

svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #cdcdcd;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat
    url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/*!
 * FullCalendar v3.1.0 Stylesheet
 * Docs & License: http://fullcalendar.io/
 * (c) 2016 Adam Shaw
 */
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc {
  /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #ffffff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
  background: #e3e3e3;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666666;
}

.fc-unthemed .fc-today {
  background: #f5f5f5;
}

.fc-highlight {
  /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
  filter: alpha(opacity=30);
  /* for IE */
}

.fc-bgevent {
  /* default look for background events */
  background: #8fdf82;
  opacity: 0.3;
  filter: alpha(opacity=30);
  /* for IE */
}

.fc-nonbusiness {
  /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  font-size: 1em;
  text-align: center;
  overflow: hidden;
  font-family: "Courier New", Courier, monospace;
  /* don't allow browser text-selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/*
Acceptable font-family overrides for individual icons:
	"Arial", sans-serif
	"Times New Roman", serif

NOTE: use percentage font sizes or else old IE chokes
*/
.fc-icon:after {
  position: relative;
  margin: 0 -1em;
  /* ensures character will be centered, regardless of width */
}

.fc-icon-left-single-arrow:after {
  content: "\\02039";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: 3%;
}

.fc-icon-right-single-arrow:after {
  content: "\\0203A";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: -3%;
}

.fc-icon-left-double-arrow:after {
  content: "\\000AB";
  font-size: 160%;
  top: -7%;
}

.fc-icon-right-double-arrow:after {
  content: "\\000BB";
  font-size: 160%;
  top: -7%;
}

.fc-icon-left-triangle:after {
  content: "\\25C4";
  font-size: 125%;
  top: 3%;
  left: -2%;
}

.fc-icon-right-triangle:after {
  content: "\\25BA";
  font-size: 125%;
  top: 3%;
  left: 2%;
}

.fc-icon-down-triangle:after {
  content: "\\25BC";
  font-size: 125%;
  top: 2%;
}

.fc-icon-x:after {
  content: "\\000D7";
  font-size: 200%;
  top: 6%;
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
  border-radius: 20px;
  box-sizing: border-box;
  border-width: 2px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  padding: 0.5rem 0.7rem;
  background-color: #66615b;
  color: #ffffff;
  transition: all 150ms linear;
}
.fc button:hover,
.fc button:focus,
.fc button:active,
.fc button.active,
.fc button:active:focus,
.fc button:active:hover,
.fc button.active:focus,
.fc button.active:hover,
.show > .fc button.dropdown-toggle,
.show > .fc button.dropdown-toggle:focus,
.show > .fc button.dropdown-toggle:hover {
  background-color: #403d39 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.fc button:not([data-action]):hover {
  box-shadow: none;
}
.fc button.disabled,
.fc button.disabled:hover,
.fc button.disabled:focus,
.fc button.disabled.focus,
.fc button.disabled:active,
.fc button.disabled.active,
.fc button:disabled,
.fc button:disabled:hover,
.fc button:disabled:focus,
.fc button:disabled.focus,
.fc button:disabled:active,
.fc button:disabled.active,
.fc button[disabled],
.fc button[disabled]:hover,
.fc button[disabled]:focus,
.fc button[disabled].focus,
.fc button[disabled]:active,
.fc button[disabled].active,
fieldset[disabled] .fc button,
fieldset[disabled] .fc button:hover,
fieldset[disabled] .fc button:focus,
fieldset[disabled] .fc button.focus,
fieldset[disabled] .fc button:active,
fieldset[disabled] .fc button.active {
  background-color: #66615b;
  border-color: #66615b;
}
.fc button.btn-simple {
  color: #66615b;
  border-color: #66615b;
}
.fc button.btn-simple:hover,
.fc button.btn-simple:focus,
.fc button.btn-simple:active {
  background-color: transparent;
  color: #403d39;
  border-color: #403d39;
  box-shadow: none;
}
.fc button.btn-link {
  color: #66615b;
}
.fc button.btn-link:hover,
.fc button.btn-link:focus,
.fc button.btn-link:active,
.fc button.btn-link:active:focus {
  background-color: transparent;
  color: #403d39;
  text-decoration: none;
  box-shadow: none;
}
.fc button:hover,
.fc button:focus {
  outline: 0 !important;
}
.fc button:active,
.fc button.active,
.open > .fc button.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.fc button.btn-icon {
  border-radius: 25px;
  padding: 6px 10px;
}
.fc button.btn-icon i {
  margin-right: 0px;
}

/* Firefox has an annoying inner border */
.fc button::-moz-focus-inner {
  margin: 0;
  padding: 0;
}

.fc-state-default {
  /* non-theme */
  border: 1px solid;
}

/* icons in buttons */
.fc button .fc-icon {
  /* non-theme */
  position: relative;
  top: -0.05em;
  /* seems to be a good adjustment across browsers */
  margin: 0 0.2em;
  vertical-align: middle;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-hover,
.fc-state-active,
.fc-state-disabled {
  color: #2c2c2c;
  background-color: #e6e6e6;
}

.fc button[disabled],
.fc button[disabled]:focus,
.fc button[disabled]:hover {
  background-color: #e3e3e3;
  border-color: #e3e3e3;
  cursor: default;
  opacity: 0.65;
  filter: alpha(opacity=65);
  color: #66615b;
}

.fc-state-hover {
  background-color: #f5f5f5;
}

.fc .fc-state-active,
.fc .fc-state-active:focus,
.fc .fc-state-active:hover,
.fc .fc-state-active:active:focus,
.fc .fc-state-active:active:hover,
.fc .fc-state-active:active {
  background-color: #66615b;
  color: #ffffff;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * {
  /* extra precedence b/c buttons have margin set to zero */
  float: left;
  margin: 0 2px 0 0;
}

.fc .fc-button-group > :first-child {
  /* same */
  margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
}

.fc-popover .fc-header {
  /* TODO: be more consistent with fc-head/fc-body */
  padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
  float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
  float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  font-size: 0.9em;
  margin-top: 2px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
  border-top: 0;
  /* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px;
  /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-clear {
  clear: both;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-helper-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0;
  /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%;
  /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: right;
  border-bottom-width: 1px;
  font-size: 1em;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
  padding-bottom: 3px;
}

.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double;
  /* overcome neighboring borders */
}

.fc .fc-widget-header {
  border: 0;
}

.fc .fc-head .fc-widget-header {
  margin-top: 15px;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row {
  /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
	   the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent;
  /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px;
  /* matches the space above the events */
}

.fc-row .fc-helper-skeleton {
  z-index: 5;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
  /* see-through to the background below */
  background: none;
  /* in case <td>s are globally styled */
  border-color: transparent;
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller {
  /* this class goes on elements for guaranteed vertical scrollbars */
  overflow-y: scroll;
  overflow-x: hidden;
}

.fc-scroller > * {
  /* we expect an immediate inner element */
  position: relative;
  /* re-scope all positions */
  width: 100%;
  /* hack to force re-sizing this inner element when scrollbars appear/disappear */
  overflow: hidden;
  /* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative;
  /* for resize handle and other inner positioning */
  display: block;
  /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 2px;
  background-color: rgba(81, 203, 206, 0.2);
  /* default BACKGROUND color */
  font-weight: normal;
  /* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
  background-color: rgba(81, 188, 218, 0.2);
}
.fc-event.event-green {
  background-color: rgba(107, 208, 152, 0.2);
}
.fc-event.event-orange {
  background-color: rgba(251, 198, 88, 0.2);
}
.fc-event.event-red {
  background-color: rgba(239, 129, 87, 0.2);
}

/* overpower some of bootstrap's and jqui's styles on <a> tags */
.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
  color: #2c2c2c;
  /* default TEXT color */
  text-decoration: none;
  /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer;
  /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event {
  /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-bg {
  /* the generic .fc-bg already does position */
  z-index: 1;
  background: #ffffff;
  opacity: 0.25;
  filter: alpha(opacity=25);
  /* for IE */
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

.fc-event .fc-resizer {
  position: absolute;
  z-index: 3;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px;
  /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px;
  /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer */
.fc-h-event .fc-resizer {
  /* positioned it to overcome the event's borders */
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  width: 5px;
}

/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-ltr .fc-h-event .fc-start-resizer:before,
.fc-ltr .fc-h-event .fc-start-resizer:after,
.fc-rtl .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-end-resizer:before,
.fc-rtl .fc-h-event .fc-end-resizer:after {
  right: auto;
  /* ignore the right and only use the left */
  cursor: w-resize;
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-ltr .fc-h-event .fc-end-resizer:before,
.fc-ltr .fc-h-event .fc-end-resizer:after,
.fc-rtl .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-start-resizer:before,
.fc-rtl .fc-h-event .fc-start-resizer:after {
  left: auto;
  /* ignore the left and only use the right */
  cursor: e-resize;
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 2px 5px 0;
  /* spacing between events and edges */
  padding: 1px 2px;
}

.fc-day-grid-event .fc-content {
  /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

.fc-day-grid-event .fc-resizer {
  /* enlarge the default hit area */
  left: -3px;
  right: -3px;
  width: 7px;
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited {
  /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1;
  /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  text-align: center;
  margin-bottom: 1em;
}

.fc-toolbar .fc-left {
  float: left;
  min-width: 260px;
}

.fc-toolbar .fc-right {
  float: right;
}

.fc-toolbar .fc-center {
  display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * {
  /* extra precedence to override button border margins */
  float: left;
  margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child {
  /* extra precedence to override button border margins */
  margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
  margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
  position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
  z-index: 2;
}

.fc-toolbar .fc-state-down {
  z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
  z-index: 4;
}

.fc-toolbar button:focus {
  z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  box-sizing: content-box;
}

.fc-view,
.fc-view > table {
  /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
  /* we are sure there are no day numbers in these views, so... */
  padding-top: 1px;
  /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em;
  /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-basic-view .fc-body .fc-row {
  min-height: 4em;
  /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
  padding: 0 2px;
}

.fc-basic-view td.fc-week-number span,
.fc-basic-view td.fc-day-number {
  padding: 8px;
}

.fc-basic-view .fc-week-number {
  text-align: center;
}

.fc-basic-view .fc-week-number span {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
  text-align: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
  text-align: left;
}

.fc-day-number.fc-other-month {
  opacity: 0.3;
  filter: alpha(opacity=30);
  /* for IE */
  /* opacity with small font can sometimes look too faded
	   might want to set the 'color' property instead
	   making day-numbers bold also fixes the problem */
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid {
  position: relative;
  z-index: 2;
  /* so the "more.." popover will be over the time grid */
}

.fc-agenda-view .fc-day-grid .fc-row {
  min-height: 3em;
  /* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-top: 1px;
  /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em;
  /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis {
  /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

.ui-widget td.fc-axis {
  font-weight: normal;
  /* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid {
  /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%;
  /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table {
  /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr {
  /* the <hr> AgendaView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-bgevent-skeleton,
.fc-time-grid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-time-grid .fc-bgevent-skeleton {
  z-index: 3;
}

.fc-time-grid .fc-highlight-skeleton {
  z-index: 4;
}

.fc-time-grid .fc-content-skeleton {
  z-index: 5;
}

.fc-time-grid .fc-helper-skeleton {
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0;
  /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

.fc-time-grid .fc-slats .ui-widget-content {
  /* for jqui theme */
  background: none;
  /* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container {
  /* a div within a cell within the fc-highlight-skeleton */
  position: relative;
  /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container,
.fc-time-grid .fc-bgevent-container {
  /* a div within a cell within the fc-bgevent-skeleton */
  position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container {
  /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container {
  /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1;
  /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* Generic Vertical Event
--------------------------------------------------------------------------------------------------*/
.fc-v-event.fc-not-start {
  /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  overflow: hidden;
  /* don't let the bg flow over rounded corners */
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none;
  /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start);
  /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  content: "\\000A0-\\000A0";
  /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em;
  /* make the title text the same size as the time */
  padding: 0;
  /* undo padding from above */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
  content: "=";
}

.card-calendar .content {
  padding: 0 !important;
}

.card-calendar .fc-toolbar {
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}

.card-calendar .fc td:first-child {
  border-left: 0;
}

.card-calendar .fc td:last-child {
  border-right: 0;
}

.card-calendar .fc-basic-view td:last-child.fc-week-number span,
.card-calendar .fc-basic-view td:last-child.fc-day-number {
  padding-right: 15px;
}

.card-calendar .fc .fc-day-header:last-child {
  padding-right: 15px;
}

.card-calendar .fc .fc-row:last-child td {
  border-bottom: 0;
}

.card-calendar .fc .fc-body .fc-widget-content {
  border-bottom: 0;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}

@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alert-circle-i::before {
  content: "\\ea04";
}

.nc-align-center::before {
  content: "\\ea03";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-app::before {
  content: "\\ea07";
}

.nc-atom::before {
  content: "\\ea08";
}

.nc-badge::before {
  content: "\\ea09";
}

.nc-bag-16::before {
  content: "\\ea0a";
}

.nc-bank::before {
  content: "\\ea0b";
}

.nc-basket::before {
  content: "\\ea0c";
}

.nc-bell-55::before {
  content: "\\ea0d";
}

.nc-bold::before {
  content: "\\ea0e";
}

.nc-book-bookmark::before {
  content: "\\ea0f";
}

.nc-bookmark-2::before {
  content: "\\ea10";
}

.nc-box-2::before {
  content: "\\ea11";
}

.nc-box::before {
  content: "\\ea12";
}

.nc-briefcase-24::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-calendar-60::before {
  content: "\\ea1a";
}

.nc-camera-compact::before {
  content: "\\ea1b";
}

.nc-caps-small::before {
  content: "\\ea1c";
}

.nc-cart-simple::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-36::before {
  content: "\\ea1f";
}

.nc-chat-33::before {
  content: "\\ea20";
}

.nc-check-2::before {
  content: "\\ea21";
}

.nc-circle-10::before {
  content: "\\ea22";
}

.nc-cloud-download-93::before {
  content: "\\ea23";
}

.nc-cloud-upload-94::before {
  content: "\\ea24";
}

.nc-compass-05::before {
  content: "\\ea25";
}

.nc-controller-modern::before {
  content: "\\ea26";
}

.nc-credit-card::before {
  content: "\\ea27";
}

.nc-delivery-fast::before {
  content: "\\ea28";
}

.nc-diamond::before {
  content: "\\ea29";
}

.nc-email-85::before {
  content: "\\ea2a";
}

.nc-favourite-28::before {
  content: "\\ea2b";
}

.nc-glasses-2::before {
  content: "\\ea2c";
}

.nc-globe-2::before {
  content: "\\ea2d";
}

.nc-globe::before {
  content: "\\ea2e";
}

.nc-hat-3::before {
  content: "\\ea2f";
}

.nc-headphones::before {
  content: "\\ea30";
}

.nc-html5::before {
  content: "\\ea31";
}

.nc-image::before {
  content: "\\ea32";
}

.nc-istanbul::before {
  content: "\\ea33";
}

.nc-key-25::before {
  content: "\\ea34";
}

.nc-laptop::before {
  content: "\\ea35";
}

.nc-layout-11::before {
  content: "\\ea36";
}

.nc-lock-circle-open::before {
  content: "\\ea37";
}

.nc-map-big::before {
  content: "\\ea38";
}

.nc-minimal-down::before {
  content: "\\ea39";
}

.nc-minimal-left::before {
  content: "\\ea3a";
}

.nc-minimal-right::before {
  content: "\\ea3b";
}

.nc-minimal-up::before {
  content: "\\ea3c";
}

.nc-mobile::before {
  content: "\\ea3d";
}

.nc-money-coins::before {
  content: "\\ea3e";
}

.nc-note-03::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-refresh-69::before {
  content: "\\ea44";
}

.nc-ruler-pencil::before {
  content: "\\ea45";
}

.nc-satisfied::before {
  content: "\\ea46";
}

.nc-scissors::before {
  content: "\\ea47";
}

.nc-send::before {
  content: "\\ea48";
}

.nc-settings-gear-65::before {
  content: "\\ea49";
}

.nc-settings::before {
  content: "\\ea4a";
}

.nc-share-66::before {
  content: "\\ea4b";
}

.nc-shop::before {
  content: "\\ea4c";
}

.nc-simple-add::before {
  content: "\\ea4d";
}

.nc-simple-delete::before {
  content: "\\ea4e";
}

.nc-simple-remove::before {
  content: "\\ea4f";
}

.nc-single-02::before {
  content: "\\ea50";
}

.nc-single-copy-04::before {
  content: "\\ea51";
}

.nc-sound-wave::before {
  content: "\\ea52";
}

.nc-spaceship::before {
  content: "\\ea53";
}

.nc-sun-fog-29::before {
  content: "\\ea54";
}

.nc-support-17::before {
  content: "\\ea55";
}

.nc-tablet-2::before {
  content: "\\ea56";
}

.nc-tag-content::before {
  content: "\\ea57";
}

.nc-tap-01::before {
  content: "\\ea58";
}

.nc-tie-bow::before {
  content: "\\ea59";
}

.nc-tile-56::before {
  content: "\\ea5a";
}

.nc-time-alarm::before {
  content: "\\ea5b";
}

.nc-touch-id::before {
  content: "\\ea5c";
}

.nc-trophy::before {
  content: "\\ea5d";
}

.nc-tv-2::before {
  content: "\\ea5e";
}

.nc-umbrella-13::before {
  content: "\\ea5f";
}

.nc-user-run::before {
  content: "\\ea60";
}

.nc-vector::before {
  content: "\\ea61";
}

.nc-watch-time::before {
  content: "\\ea62";
}

.nc-world-2::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 600;
  font-size: 0.8571em;
  line-height: 1.35em;
  text-transform: uppercase;
  border: none;
  margin: 10px 1px;
  border-radius: 3px;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #0fa0cf;
  color: #ffffff;
  transition: all 150ms linear;
}
.btn:hover,
.btn:focus,
.btn:active,
.btn.active,
.btn:active:focus,
.btn:active:hover,
.btn.active:focus,
.btn.active:hover,
.show > .btn.dropdown-toggle,
.show > .btn.dropdown-toggle:focus,
.show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
  background-color: #45bd5b;
  color: #ffffff;
  box-shadow: none;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: none;
}
.btn.disabled,
.btn.disabled:hover,
.btn.disabled:focus,
.btn.disabled.focus,
.btn.disabled:active,
.btn.disabled.active,
.btn:disabled,
.btn:disabled:hover,
.btn:disabled:focus,
.btn:disabled.focus,
.btn:disabled:active,
.btn:disabled.active,
.btn[disabled],
.btn[disabled]:hover,
.btn[disabled]:focus,
.btn[disabled].focus,
.btn[disabled]:active,
.btn[disabled].active,
fieldset[disabled] .btn,
fieldset[disabled] .btn:hover,
fieldset[disabled] .btn:focus,
fieldset[disabled] .btn.focus,
fieldset[disabled] .btn:active,
fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #66615b;
  border-color: #66615b;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #66615b;
  border-color: #66615b;
}
.btn.btn-simple:hover,
.btn.btn-simple:focus,
.btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active {
  background-color: transparent;
  color: #403d39;
  border-color: #403d39;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #66615b;
}
.btn.btn-link:hover,
.btn.btn-link:focus,
.btn.btn-link:active,
.btn.btn-link:active:focus,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:active:focus {
  background-color: transparent;
  color: #403d39;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover,
.btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active,
.btn.active,
.open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa,
.btn.btn-icon.btn-sm .far,
.btn.btn-icon.btn-sm .fas,
.btn.btn-icon.btn-sm .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa,
.btn.btn-icon.btn-lg .far,
.btn.btn-icon.btn-lg .fas,
.btn.btn-icon.btn-lg .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .nc-icon,
.btn.btn-icon:not(.btn-footer) .fa,
.btn.btn-icon:not(.btn-footer) .far,
.btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn.btn-icon.btn-neutral,
.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {
  font-size: 20px;
}
.btn:not(.btn-icon) .nc-icon,
.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {
  position: relative;
  top: 1px;
}

.btn-primary {
  background-color: #51cbce;
  color: #ffffff;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.btn-primary.active:focus,
.btn-primary.active:hover,
.show > .btn-primary.dropdown-toggle,
.show > .btn-primary.dropdown-toggle:focus,
.show > .btn-primary.dropdown-toggle:hover {
  background-color: #34b5b8 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-primary:not([data-action]):hover {
  box-shadow: none;
}
.btn-primary.disabled,
.btn-primary.disabled:hover,
.btn-primary.disabled:focus,
.btn-primary.disabled.focus,
.btn-primary.disabled:active,
.btn-primary.disabled.active,
.btn-primary:disabled,
.btn-primary:disabled:hover,
.btn-primary:disabled:focus,
.btn-primary:disabled.focus,
.btn-primary:disabled:active,
.btn-primary:disabled.active,
.btn-primary[disabled],
.btn-primary[disabled]:hover,
.btn-primary[disabled]:focus,
.btn-primary[disabled].focus,
.btn-primary[disabled]:active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary,
fieldset[disabled] .btn-primary:hover,
fieldset[disabled] .btn-primary:focus,
fieldset[disabled] .btn-primary.focus,
fieldset[disabled] .btn-primary:active,
fieldset[disabled] .btn-primary.active {
  background-color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple {
  color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple:hover,
.btn-primary.btn-simple:focus,
.btn-primary.btn-simple:active {
  background-color: transparent;
  color: #34b5b8;
  border-color: #34b5b8;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #51cbce;
}
.btn-primary.btn-link:hover,
.btn-primary.btn-link:focus,
.btn-primary.btn-link:active,
.btn-primary.btn-link:active:focus {
  background-color: transparent;
  color: #34b5b8;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background-color: #6bd098;
  color: #ffffff;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.btn-success:active:focus,
.btn-success:active:hover,
.btn-success.active:focus,
.btn-success.active:hover,
.show > .btn-success.dropdown-toggle,
.show > .btn-success.dropdown-toggle:focus,
.show > .btn-success.dropdown-toggle:hover {
  background-color: #44c47d !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-success:not([data-action]):hover {
  box-shadow: none;
}
.btn-success.disabled,
.btn-success.disabled:hover,
.btn-success.disabled:focus,
.btn-success.disabled.focus,
.btn-success.disabled:active,
.btn-success.disabled.active,
.btn-success:disabled,
.btn-success:disabled:hover,
.btn-success:disabled:focus,
.btn-success:disabled.focus,
.btn-success:disabled:active,
.btn-success:disabled.active,
.btn-success[disabled],
.btn-success[disabled]:hover,
.btn-success[disabled]:focus,
.btn-success[disabled].focus,
.btn-success[disabled]:active,
.btn-success[disabled].active,
fieldset[disabled] .btn-success,
fieldset[disabled] .btn-success:hover,
fieldset[disabled] .btn-success:focus,
fieldset[disabled] .btn-success.focus,
fieldset[disabled] .btn-success:active,
fieldset[disabled] .btn-success.active {
  background-color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple {
  color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple:hover,
.btn-success.btn-simple:focus,
.btn-success.btn-simple:active {
  background-color: transparent;
  color: #44c47d;
  border-color: #44c47d;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #6bd098;
}
.btn-success.btn-link:hover,
.btn-success.btn-link:focus,
.btn-success.btn-link:active,
.btn-success.btn-link:active:focus {
  background-color: transparent;
  color: #44c47d;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background-color: #0fa0cf;
  color: #ffffff;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.btn-info:active:focus,
.btn-info:active:hover,
.btn-info.active:focus,
.btn-info.active:hover,
.show > .btn-info.dropdown-toggle,
.show > .btn-info.dropdown-toggle:focus,
.show > .btn-info.dropdown-toggle:hover {
  background-color: #2ba9cd !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-info:not([data-action]):hover {
  box-shadow: none;
}
.btn-info.disabled,
.btn-info.disabled:hover,
.btn-info.disabled:focus,
.btn-info.disabled.focus,
.btn-info.disabled:active,
.btn-info.disabled.active,
.btn-info:disabled,
.btn-info:disabled:hover,
.btn-info:disabled:focus,
.btn-info:disabled.focus,
.btn-info:disabled:active,
.btn-info:disabled.active,
.btn-info[disabled],
.btn-info[disabled]:hover,
.btn-info[disabled]:focus,
.btn-info[disabled].focus,
.btn-info[disabled]:active,
.btn-info[disabled].active,
fieldset[disabled] .btn-info,
fieldset[disabled] .btn-info:hover,
fieldset[disabled] .btn-info:focus,
fieldset[disabled] .btn-info.focus,
fieldset[disabled] .btn-info:active,
fieldset[disabled] .btn-info.active {
  background-color: #0fa0cf;
  border-color: #0fa0cf;
}
.btn-info.btn-simple {
  color: #0fa0cf;
  border-color: #0fa0cf;
}
.btn-info.btn-simple:hover,
.btn-info.btn-simple:focus,
.btn-info.btn-simple:active {
  background-color: transparent;
  color: #2ba9cd;
  border-color: #2ba9cd;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #0fa0cf;
}
.btn-info.btn-link:hover,
.btn-info.btn-link:focus,
.btn-info.btn-link:active,
.btn-info.btn-link:active:focus {
  background-color: transparent;
  color: #2ba9cd;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background-color: #fbc658;
  color: #ffffff;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.btn-warning.active:focus,
.btn-warning.active:hover,
.show > .btn-warning.dropdown-toggle,
.show > .btn-warning.dropdown-toggle:focus,
.show > .btn-warning.dropdown-toggle:hover {
  background-color: #fab526 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-warning:not([data-action]):hover {
  box-shadow: none;
}
.btn-warning.disabled,
.btn-warning.disabled:hover,
.btn-warning.disabled:focus,
.btn-warning.disabled.focus,
.btn-warning.disabled:active,
.btn-warning.disabled.active,
.btn-warning:disabled,
.btn-warning:disabled:hover,
.btn-warning:disabled:focus,
.btn-warning:disabled.focus,
.btn-warning:disabled:active,
.btn-warning:disabled.active,
.btn-warning[disabled],
.btn-warning[disabled]:hover,
.btn-warning[disabled]:focus,
.btn-warning[disabled].focus,
.btn-warning[disabled]:active,
.btn-warning[disabled].active,
fieldset[disabled] .btn-warning,
fieldset[disabled] .btn-warning:hover,
fieldset[disabled] .btn-warning:focus,
fieldset[disabled] .btn-warning.focus,
fieldset[disabled] .btn-warning:active,
fieldset[disabled] .btn-warning.active {
  background-color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple {
  color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple:hover,
.btn-warning.btn-simple:focus,
.btn-warning.btn-simple:active {
  background-color: transparent;
  color: #fab526;
  border-color: #fab526;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #fbc658;
}
.btn-warning.btn-link:hover,
.btn-warning.btn-link:focus,
.btn-warning.btn-link:active,
.btn-warning.btn-link:active:focus {
  background-color: transparent;
  color: #fab526;
  text-decoration: none;
  box-shadow: none;
}

.btn-danger {
  background-color: #ef8157;
  color: #ffffff;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.btn-danger.active:focus,
.btn-danger.active:hover,
.show > .btn-danger.dropdown-toggle,
.show > .btn-danger.dropdown-toggle:focus,
.show > .btn-danger.dropdown-toggle:hover {
  background-color: #eb6532 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-danger:not([data-action]):hover {
  box-shadow: none;
}
.btn-danger.disabled,
.btn-danger.disabled:hover,
.btn-danger.disabled:focus,
.btn-danger.disabled.focus,
.btn-danger.disabled:active,
.btn-danger.disabled.active,
.btn-danger:disabled,
.btn-danger:disabled:hover,
.btn-danger:disabled:focus,
.btn-danger:disabled.focus,
.btn-danger:disabled:active,
.btn-danger:disabled.active,
.btn-danger[disabled],
.btn-danger[disabled]:hover,
.btn-danger[disabled]:focus,
.btn-danger[disabled].focus,
.btn-danger[disabled]:active,
.btn-danger[disabled].active,
fieldset[disabled] .btn-danger,
fieldset[disabled] .btn-danger:hover,
fieldset[disabled] .btn-danger:focus,
fieldset[disabled] .btn-danger.focus,
fieldset[disabled] .btn-danger:active,
fieldset[disabled] .btn-danger.active {
  background-color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple {
  color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple:hover,
.btn-danger.btn-simple:focus,
.btn-danger.btn-simple:active {
  background-color: transparent;
  color: #eb6532;
  border-color: #eb6532;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #ef8157;
}
.btn-danger.btn-link:hover,
.btn-danger.btn-link:focus,
.btn-danger.btn-link:active,
.btn-danger.btn-link:active:focus {
  background-color: transparent;
  color: #eb6532;
  text-decoration: none;
  box-shadow: none;
}

.btn-outline-default {
  background: transparent;
  border: 2px solid #66615b !important;
  color: #66615b;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-default:hover,
.btn-outline-default:focus,
.btn-outline-default:active,
.btn-outline-default:focus:active,
.btn-outline-default.active,
.open > .btn-outline-default.dropdown-toggle {
  background-color: #66615b !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #66615b !important;
}
.btn-outline-default:hover .caret,
.btn-outline-default:focus .caret,
.btn-outline-default:active .caret,
.btn-outline-default:focus:active .caret,
.btn-outline-default.active .caret,
.open > .btn-outline-default.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-default .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-default.disabled,
.btn-outline-default.disabled:hover,
.btn-outline-default.disabled:focus,
.btn-outline-default.disabled.focus,
.btn-outline-default.disabled:active,
.btn-outline-default.disabled.active,
.btn-outline-default:disabled,
.btn-outline-default:disabled:hover,
.btn-outline-default:disabled:focus,
.btn-outline-default:disabled.focus,
.btn-outline-default:disabled:active,
.btn-outline-default:disabled.active,
.btn-outline-default[disabled],
.btn-outline-default[disabled]:hover,
.btn-outline-default[disabled]:focus,
.btn-outline-default[disabled].focus,
.btn-outline-default[disabled]:active,
.btn-outline-default[disabled].active,
fieldset[disabled] .btn-outline-default,
fieldset[disabled] .btn-outline-default:hover,
fieldset[disabled] .btn-outline-default:focus,
fieldset[disabled] .btn-outline-default.focus,
fieldset[disabled] .btn-outline-default:active,
fieldset[disabled] .btn-outline-default.active {
  background-color: transparent !important;
  border-color: #66615b !important;
}

.btn-outline-primary {
  background: transparent;
  border: 2px solid #51cbce !important;
  color: #51cbce;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary:focus:active,
.btn-outline-primary.active,
.open > .btn-outline-primary.dropdown-toggle {
  background-color: #51cbce !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #51cbce !important;
}
.btn-outline-primary:hover .caret,
.btn-outline-primary:focus .caret,
.btn-outline-primary:active .caret,
.btn-outline-primary:focus:active .caret,
.btn-outline-primary.active .caret,
.open > .btn-outline-primary.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-primary .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-primary.disabled,
.btn-outline-primary.disabled:hover,
.btn-outline-primary.disabled:focus,
.btn-outline-primary.disabled.focus,
.btn-outline-primary.disabled:active,
.btn-outline-primary.disabled.active,
.btn-outline-primary:disabled,
.btn-outline-primary:disabled:hover,
.btn-outline-primary:disabled:focus,
.btn-outline-primary:disabled.focus,
.btn-outline-primary:disabled:active,
.btn-outline-primary:disabled.active,
.btn-outline-primary[disabled],
.btn-outline-primary[disabled]:hover,
.btn-outline-primary[disabled]:focus,
.btn-outline-primary[disabled].focus,
.btn-outline-primary[disabled]:active,
.btn-outline-primary[disabled].active,
fieldset[disabled] .btn-outline-primary,
fieldset[disabled] .btn-outline-primary:hover,
fieldset[disabled] .btn-outline-primary:focus,
fieldset[disabled] .btn-outline-primary.focus,
fieldset[disabled] .btn-outline-primary:active,
fieldset[disabled] .btn-outline-primary.active {
  background-color: transparent !important;
  border-color: #51cbce !important;
}

.btn-outline-success {
  background: transparent;
  border: 2px solid #6bd098 !important;
  color: #6bd098;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-success:hover,
.btn-outline-success:focus,
.btn-outline-success:active,
.btn-outline-success:focus:active,
.btn-outline-success.active,
.open > .btn-outline-success.dropdown-toggle {
  background-color: #6bd098 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #6bd098 !important;
}
.btn-outline-success:hover .caret,
.btn-outline-success:focus .caret,
.btn-outline-success:active .caret,
.btn-outline-success:focus:active .caret,
.btn-outline-success.active .caret,
.open > .btn-outline-success.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-success .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-success.disabled,
.btn-outline-success.disabled:hover,
.btn-outline-success.disabled:focus,
.btn-outline-success.disabled.focus,
.btn-outline-success.disabled:active,
.btn-outline-success.disabled.active,
.btn-outline-success:disabled,
.btn-outline-success:disabled:hover,
.btn-outline-success:disabled:focus,
.btn-outline-success:disabled.focus,
.btn-outline-success:disabled:active,
.btn-outline-success:disabled.active,
.btn-outline-success[disabled],
.btn-outline-success[disabled]:hover,
.btn-outline-success[disabled]:focus,
.btn-outline-success[disabled].focus,
.btn-outline-success[disabled]:active,
.btn-outline-success[disabled].active,
fieldset[disabled] .btn-outline-success,
fieldset[disabled] .btn-outline-success:hover,
fieldset[disabled] .btn-outline-success:focus,
fieldset[disabled] .btn-outline-success.focus,
fieldset[disabled] .btn-outline-success:active,
fieldset[disabled] .btn-outline-success.active {
  background-color: transparent !important;
  border-color: #6bd098 !important;
}

.btn-outline-info {
  background: transparent;
  border: 2px solid #0fa0cf !important;
  color: #0fa0cf;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-info:hover,
.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info:focus:active,
.btn-outline-info.active,
.open > .btn-outline-info.dropdown-toggle {
  background-color: #0fa0cf !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #0fa0cf !important;
}
.btn-outline-info:hover .caret,
.btn-outline-info:focus .caret,
.btn-outline-info:active .caret,
.btn-outline-info:focus:active .caret,
.btn-outline-info.active .caret,
.open > .btn-outline-info.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-info .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-info.disabled,
.btn-outline-info.disabled:hover,
.btn-outline-info.disabled:focus,
.btn-outline-info.disabled.focus,
.btn-outline-info.disabled:active,
.btn-outline-info.disabled.active,
.btn-outline-info:disabled,
.btn-outline-info:disabled:hover,
.btn-outline-info:disabled:focus,
.btn-outline-info:disabled.focus,
.btn-outline-info:disabled:active,
.btn-outline-info:disabled.active,
.btn-outline-info[disabled],
.btn-outline-info[disabled]:hover,
.btn-outline-info[disabled]:focus,
.btn-outline-info[disabled].focus,
.btn-outline-info[disabled]:active,
.btn-outline-info[disabled].active,
fieldset[disabled] .btn-outline-info,
fieldset[disabled] .btn-outline-info:hover,
fieldset[disabled] .btn-outline-info:focus,
fieldset[disabled] .btn-outline-info.focus,
fieldset[disabled] .btn-outline-info:active,
fieldset[disabled] .btn-outline-info.active {
  background-color: transparent !important;
  border-color: #0fa0cf !important;
}

.btn-outline-warning {
  background: transparent;
  border: 2px solid #fbc658 !important;
  color: #fbc658;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-warning:hover,
.btn-outline-warning:focus,
.btn-outline-warning:active,
.btn-outline-warning:focus:active,
.btn-outline-warning.active,
.open > .btn-outline-warning.dropdown-toggle {
  background-color: #fbc658 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #fbc658 !important;
}
.btn-outline-warning:hover .caret,
.btn-outline-warning:focus .caret,
.btn-outline-warning:active .caret,
.btn-outline-warning:focus:active .caret,
.btn-outline-warning.active .caret,
.open > .btn-outline-warning.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-warning .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-warning.disabled,
.btn-outline-warning.disabled:hover,
.btn-outline-warning.disabled:focus,
.btn-outline-warning.disabled.focus,
.btn-outline-warning.disabled:active,
.btn-outline-warning.disabled.active,
.btn-outline-warning:disabled,
.btn-outline-warning:disabled:hover,
.btn-outline-warning:disabled:focus,
.btn-outline-warning:disabled.focus,
.btn-outline-warning:disabled:active,
.btn-outline-warning:disabled.active,
.btn-outline-warning[disabled],
.btn-outline-warning[disabled]:hover,
.btn-outline-warning[disabled]:focus,
.btn-outline-warning[disabled].focus,
.btn-outline-warning[disabled]:active,
.btn-outline-warning[disabled].active,
fieldset[disabled] .btn-outline-warning,
fieldset[disabled] .btn-outline-warning:hover,
fieldset[disabled] .btn-outline-warning:focus,
fieldset[disabled] .btn-outline-warning.focus,
fieldset[disabled] .btn-outline-warning:active,
fieldset[disabled] .btn-outline-warning.active {
  background-color: transparent !important;
  border-color: #fbc658 !important;
}

.btn-outline-danger {
  background: transparent;
  border: 2px solid #ef8157 !important;
  color: #ef8157;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active,
.btn-outline-danger:focus:active,
.btn-outline-danger.active,
.open > .btn-outline-danger.dropdown-toggle {
  background-color: #ef8157 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #ef8157 !important;
}
.btn-outline-danger:hover .caret,
.btn-outline-danger:focus .caret,
.btn-outline-danger:active .caret,
.btn-outline-danger:focus:active .caret,
.btn-outline-danger.active .caret,
.open > .btn-outline-danger.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-danger .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-danger.disabled,
.btn-outline-danger.disabled:hover,
.btn-outline-danger.disabled:focus,
.btn-outline-danger.disabled.focus,
.btn-outline-danger.disabled:active,
.btn-outline-danger.disabled.active,
.btn-outline-danger:disabled,
.btn-outline-danger:disabled:hover,
.btn-outline-danger:disabled:focus,
.btn-outline-danger:disabled.focus,
.btn-outline-danger:disabled:active,
.btn-outline-danger:disabled.active,
.btn-outline-danger[disabled],
.btn-outline-danger[disabled]:hover,
.btn-outline-danger[disabled]:focus,
.btn-outline-danger[disabled].focus,
.btn-outline-danger[disabled]:active,
.btn-outline-danger[disabled].active,
fieldset[disabled] .btn-outline-danger,
fieldset[disabled] .btn-outline-danger:hover,
fieldset[disabled] .btn-outline-danger:focus,
fieldset[disabled] .btn-outline-danger.focus,
fieldset[disabled] .btn-outline-danger:active,
fieldset[disabled] .btn-outline-danger.active {
  background-color: transparent !important;
  border-color: #ef8157 !important;
}

.btn-outline-neutral {
  background: transparent;
  border: 2px solid #ffffff !important;
  color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-neutral:hover,
.btn-outline-neutral:focus,
.btn-outline-neutral:active,
.btn-outline-neutral:focus:active,
.btn-outline-neutral.active,
.open > .btn-outline-neutral.dropdown-toggle {
  background-color: #ffffff !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #ffffff !important;
}
.btn-outline-neutral:hover .caret,
.btn-outline-neutral:focus .caret,
.btn-outline-neutral:active .caret,
.btn-outline-neutral:focus:active .caret,
.btn-outline-neutral.active .caret,
.open > .btn-outline-neutral.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-neutral .caret {
  border-top-color: #ffffff !important;
}
.btn-outline-neutral.disabled,
.btn-outline-neutral.disabled:hover,
.btn-outline-neutral.disabled:focus,
.btn-outline-neutral.disabled.focus,
.btn-outline-neutral.disabled:active,
.btn-outline-neutral.disabled.active,
.btn-outline-neutral:disabled,
.btn-outline-neutral:disabled:hover,
.btn-outline-neutral:disabled:focus,
.btn-outline-neutral:disabled.focus,
.btn-outline-neutral:disabled:active,
.btn-outline-neutral:disabled.active,
.btn-outline-neutral[disabled],
.btn-outline-neutral[disabled]:hover,
.btn-outline-neutral[disabled]:focus,
.btn-outline-neutral[disabled].focus,
.btn-outline-neutral[disabled]:active,
.btn-outline-neutral[disabled].active,
fieldset[disabled] .btn-outline-neutral,
fieldset[disabled] .btn-outline-neutral:hover,
fieldset[disabled] .btn-outline-neutral:focus,
fieldset[disabled] .btn-outline-neutral.focus,
fieldset[disabled] .btn-outline-neutral:active,
fieldset[disabled] .btn-outline-neutral.active {
  background-color: transparent !important;
  border-color: #ffffff !important;
}
.btn-outline-neutral:hover,
.btn-outline-neutral:focus {
  color: #403d39;
  background-color: #ffffff;
}

.btn-neutral {
  background-color: #ffffff;
  color: #51cbce;
  color: #66615b;
}
.btn-neutral:hover,
.btn-neutral:focus,
.btn-neutral:active,
.btn-neutral.active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
  background-color: #ffffff !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: none;
}
.btn-neutral.disabled,
.btn-neutral.disabled:hover,
.btn-neutral.disabled:focus,
.btn-neutral.disabled.focus,
.btn-neutral.disabled:active,
.btn-neutral.disabled.active,
.btn-neutral:disabled,
.btn-neutral:disabled:hover,
.btn-neutral:disabled:focus,
.btn-neutral:disabled.focus,
.btn-neutral:disabled:active,
.btn-neutral:disabled.active,
.btn-neutral[disabled],
.btn-neutral[disabled]:hover,
.btn-neutral[disabled]:focus,
.btn-neutral[disabled].focus,
.btn-neutral[disabled]:active,
.btn-neutral[disabled].active,
fieldset[disabled] .btn-neutral,
fieldset[disabled] .btn-neutral:hover,
fieldset[disabled] .btn-neutral:focus,
fieldset[disabled] .btn-neutral.focus,
fieldset[disabled] .btn-neutral:active,
fieldset[disabled] .btn-neutral.active {
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral.btn-danger {
  color: #ef8157;
}
.btn-neutral.btn-danger:hover,
.btn-neutral.btn-danger:focus,
.btn-neutral.btn-danger:active,
.btn-neutral.btn-danger:active:focus {
  color: #eb6532 !important;
}
.btn-neutral.btn-info {
  color: #0fa0cf !important;
}
.btn-neutral.btn-info:hover,
.btn-neutral.btn-info:focus,
.btn-neutral.btn-info:active,
.btn-neutral.btn-info:active:focus {
  color: #2ba9cd !important;
}
.btn-neutral.btn-warning {
  color: #fbc658 !important;
}
.btn-neutral.btn-warning:hover,
.btn-neutral.btn-warning:focus,
.btn-neutral.btn-warning:active,
.btn-neutral.btn-warning:active:focus {
  color: #fab526 !important;
}
.btn-neutral.btn-success {
  color: #6bd098 !important;
}
.btn-neutral.btn-success:hover,
.btn-neutral.btn-success:focus,
.btn-neutral.btn-success:active,
.btn-neutral.btn-success:active:focus {
  color: #44c47d !important;
}
.btn-neutral.btn-default {
  color: #66615b !important;
}
.btn-neutral.btn-default:hover,
.btn-neutral.btn-default:focus,
.btn-neutral.btn-default:active,
.btn-neutral.btn-default:active:focus {
  color: #403d39 !important;
}
.btn-neutral.active,
.btn-neutral:active,
.btn-neutral:active:focus,
.btn-neutral:active:hover,
.btn-neutral.active:focus,
.btn-neutral.active:hover,
.show > .btn-neutral.dropdown-toggle,
.show > .btn-neutral.dropdown-toggle:focus,
.show > .btn-neutral.dropdown-toggle:hover {
  background-color: #ffffff !important;
  color: #34b5b8 !important;
  box-shadow: none !important;
}
.btn-neutral:hover,
.btn-neutral:focus {
  color: #34b5b8 !important;
}
.btn-neutral:hover:not(.nav-link),
.btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral.btn-simple:hover,
.btn-neutral.btn-simple:focus,
.btn-neutral.btn-simple:active {
  background-color: transparent;
  color: #ffffff;
  border-color: #ffffff;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #ffffff;
}
.btn-neutral.btn-link:hover,
.btn-neutral.btn-link:focus,
.btn-neutral.btn-link:active,
.btn-neutral.btn-link:active:focus {
  background-color: transparent;
  color: #ffffff;
  text-decoration: none;
  box-shadow: none;
}
.btn-neutral:hover,
.btn-neutral:focus {
  color: #403d39;
}
.btn-neutral.btn-border:hover,
.btn-neutral.btn-border:focus {
  color: #66615b;
}
.btn-neutral.btn-border:active,
.btn-neutral.btn-border.active,
.open > .btn-neutral.btn-border.dropdown-toggle {
  background-color: #ffffff;
  color: #66615b;
}
.btn-neutral.btn-link:active,
.btn-neutral.btn-link.active {
  background-color: transparent;
}

.btn:disabled,
.btn[disabled],
.btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #66615b;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled,
.btn-simple.disabled:hover,
.btn-simple.disabled:focus,
.btn-simple.disabled.focus,
.btn-simple.disabled:active,
.btn-simple.disabled.active,
.btn-simple:disabled,
.btn-simple:disabled:hover,
.btn-simple:disabled:focus,
.btn-simple:disabled.focus,
.btn-simple:disabled:active,
.btn-simple:disabled.active,
.btn-simple[disabled],
.btn-simple[disabled]:hover,
.btn-simple[disabled]:focus,
.btn-simple[disabled].focus,
.btn-simple[disabled]:active,
.btn-simple[disabled].active,
fieldset[disabled] .btn-simple,
fieldset[disabled] .btn-simple:hover,
fieldset[disabled] .btn-simple:focus,
fieldset[disabled] .btn-simple.focus,
fieldset[disabled] .btn-simple:active,
fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background-color: transparent;
}

.btn-link {
  border: 0;
  padding: 0.5rem 0.7rem;
  background-color: transparent;
}

.btn-lg {
  font-size: 1rem;
  border-radius: 6px;
  padding: 15px 48px;
}
.btn-lg.btn-simple {
  padding: 14px 47px;
}

.btn-sm {
  font-size: 0.8571em;
  border-radius: 3px;
  padding: 5px 15px;
}
.btn-sm.btn-simple {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-group .btn + .btn {
  margin-left: -3px;
}

.btn-group .btn:focus {
  background-color: #0fa0cf !important;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
  padding-right: 23px;
  padding-left: 23px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

.btn.btn-facebook {
  background-color: #3b5998;
  color: #ffffff;
}
.btn.btn-facebook:focus,
.btn.btn-facebook:active,
.btn.btn-facebook:hover {
  background-color: #344e86 !important;
  color: #ffffff !important;
}
.btn.btn-facebook.btn-simple {
  color: #3b5998;
  background-color: transparent;
  box-shadow: none;
  border-color: #3b5998;
}
.btn.btn-facebook.btn-simple:hover,
.btn.btn-facebook.btn-simple:focus,
.btn.btn-facebook.btn-simple:active {
  color: #344e86;
  border-color: #344e86;
}
.btn.btn-facebook.btn-neutral {
  color: #3b5998;
  background-color: #ffffff;
}
.btn.btn-facebook.btn-neutral:hover,
.btn.btn-facebook.btn-neutral:focus,
.btn.btn-facebook.btn-neutral:active {
  color: #344e86 !important;
}

.btn.btn-twitter {
  background-color: #55acee;
  color: #ffffff;
}
.btn.btn-twitter:focus,
.btn.btn-twitter:active,
.btn.btn-twitter:hover {
  background-color: #3ea1ec !important;
  color: #ffffff !important;
}
.btn.btn-twitter.btn-simple {
  color: #55acee;
  background-color: transparent;
  box-shadow: none;
  border-color: #55acee;
}
.btn.btn-twitter.btn-simple:hover,
.btn.btn-twitter.btn-simple:focus,
.btn.btn-twitter.btn-simple:active {
  color: #3ea1ec;
  border-color: #3ea1ec;
}
.btn.btn-twitter.btn-neutral {
  color: #55acee;
  background-color: #ffffff;
}
.btn.btn-twitter.btn-neutral:hover,
.btn.btn-twitter.btn-neutral:focus,
.btn.btn-twitter.btn-neutral:active {
  color: #3ea1ec !important;
}

.btn.btn-pinterest {
  background-color: #cc2127;
  color: #ffffff;
}
.btn.btn-pinterest:focus,
.btn.btn-pinterest:active,
.btn.btn-pinterest:hover {
  background-color: #dd2e34 !important;
  color: #ffffff !important;
}
.btn.btn-pinterest.btn-simple {
  color: #cc2127;
  background-color: transparent;
  box-shadow: none;
  border-color: #cc2127;
}
.btn.btn-pinterest.btn-simple:hover,
.btn.btn-pinterest.btn-simple:focus,
.btn.btn-pinterest.btn-simple:active {
  color: #dd2e34;
  border-color: #dd2e34;
}
.btn.btn-pinterest.btn-neutral {
  color: #cc2127;
  background-color: #ffffff;
}
.btn.btn-pinterest.btn-neutral:hover,
.btn.btn-pinterest.btn-neutral:focus,
.btn.btn-pinterest.btn-neutral:active {
  color: #dd2e34 !important;
}

.btn.btn-google {
  background-color: #dd4b39;
  color: #ffffff;
}
.btn.btn-google:focus,
.btn.btn-google:active,
.btn.btn-google:hover {
  background-color: #d73925 !important;
  color: #ffffff !important;
}
.btn.btn-google.btn-simple {
  color: #dd4b39;
  background-color: transparent;
  box-shadow: none;
  border-color: #dd4b39;
}
.btn.btn-google.btn-simple:hover,
.btn.btn-google.btn-simple:focus,
.btn.btn-google.btn-simple:active {
  color: #d73925;
  border-color: #d73925;
}
.btn.btn-google.btn-neutral {
  color: #dd4b39;
  background-color: #ffffff;
}
.btn.btn-google.btn-neutral:hover,
.btn.btn-google.btn-neutral:focus,
.btn.btn-google.btn-neutral:active {
  color: #d73925 !important;
}

.btn.btn-linkedin {
  background-color: #0077b5;
  color: #ffffff;
}
.btn.btn-linkedin:focus,
.btn.btn-linkedin:active,
.btn.btn-linkedin:hover {
  background-color: #00669c !important;
  color: #ffffff !important;
}
.btn.btn-linkedin.btn-simple {
  color: #0077b5;
  background-color: transparent;
  box-shadow: none;
  border-color: #0077b5;
}
.btn.btn-linkedin.btn-simple:hover,
.btn.btn-linkedin.btn-simple:focus,
.btn.btn-linkedin.btn-simple:active {
  color: #00669c;
  border-color: #00669c;
}
.btn.btn-linkedin.btn-neutral {
  color: #0077b5;
  background-color: #ffffff;
}
.btn.btn-linkedin.btn-neutral:hover,
.btn.btn-linkedin.btn-neutral:focus,
.btn.btn-linkedin.btn-neutral:active {
  color: #00669c !important;
}

.btn.btn-dribbble {
  background-color: #ea4c89;
  color: #ffffff;
}
.btn.btn-dribbble:focus,
.btn.btn-dribbble:active,
.btn.btn-dribbble:hover {
  background-color: #ed679b !important;
  color: #ffffff !important;
}
.btn.btn-dribbble.btn-simple {
  color: #ea4c89;
  background-color: transparent;
  box-shadow: none;
  border-color: #ea4c89;
}
.btn.btn-dribbble.btn-simple:hover,
.btn.btn-dribbble.btn-simple:focus,
.btn.btn-dribbble.btn-simple:active {
  color: #ed679b;
  border-color: #ed679b;
}
.btn.btn-dribbble.btn-neutral {
  color: #ea4c89;
  background-color: #ffffff;
}
.btn.btn-dribbble.btn-neutral:hover,
.btn.btn-dribbble.btn-neutral:focus,
.btn.btn-dribbble.btn-neutral:active {
  color: #ed679b !important;
}

.btn.btn-github {
  background-color: #333333;
  color: #ffffff;
}
.btn.btn-github:focus,
.btn.btn-github:active,
.btn.btn-github:hover {
  background-color: #424242 !important;
  color: #ffffff !important;
}
.btn.btn-github.btn-simple {
  color: #333333;
  background-color: transparent;
  box-shadow: none;
  border-color: #333333;
}
.btn.btn-github.btn-simple:hover,
.btn.btn-github.btn-simple:focus,
.btn.btn-github.btn-simple:active {
  color: #424242;
  border-color: #424242;
}
.btn.btn-github.btn-neutral {
  color: #333333;
  background-color: #ffffff;
}
.btn.btn-github.btn-neutral:hover,
.btn.btn-github.btn-neutral:focus,
.btn.btn-github.btn-neutral:active {
  color: #424242 !important;
}

.btn.btn-youtube {
  background-color: #e52d27;
  color: #ffffff;
}
.btn.btn-youtube:focus,
.btn.btn-youtube:active,
.btn.btn-youtube:hover {
  background-color: #e84842 !important;
  color: #ffffff !important;
}
.btn.btn-youtube.btn-simple {
  color: #e52d27;
  background-color: transparent;
  box-shadow: none;
  border-color: #e52d27;
}
.btn.btn-youtube.btn-simple:hover,
.btn.btn-youtube.btn-simple:focus,
.btn.btn-youtube.btn-simple:active {
  color: #e84842;
  border-color: #e84842;
}
.btn.btn-youtube.btn-neutral {
  color: #e52d27;
  background-color: #ffffff;
}
.btn.btn-youtube.btn-neutral:hover,
.btn.btn-youtube.btn-neutral:focus,
.btn.btn-youtube.btn-neutral:active {
  color: #e84842 !important;
}

.btn.btn-instagram {
  background-color: #125688;
  color: #ffffff;
}
.btn.btn-instagram:focus,
.btn.btn-instagram:active,
.btn.btn-instagram:hover {
  background-color: #1667a3 !important;
  color: #ffffff !important;
}
.btn.btn-instagram.btn-simple {
  color: #125688;
  background-color: transparent;
  box-shadow: none;
  border-color: #125688;
}
.btn.btn-instagram.btn-simple:hover,
.btn.btn-instagram.btn-simple:focus,
.btn.btn-instagram.btn-simple:active {
  color: #1667a3;
  border-color: #1667a3;
}
.btn.btn-instagram.btn-neutral {
  color: #125688;
  background-color: #ffffff;
}
.btn.btn-instagram.btn-neutral:hover,
.btn.btn-instagram.btn-neutral:focus,
.btn.btn-instagram.btn-neutral:active {
  color: #1667a3 !important;
}

.btn.btn-reddit {
  background-color: #ff4500;
  color: #ffffff;
}
.btn.btn-reddit:focus,
.btn.btn-reddit:active,
.btn.btn-reddit:hover {
  background-color: #ff5b1f !important;
  color: #ffffff !important;
}
.btn.btn-reddit.btn-simple {
  color: #ff4500;
  background-color: transparent;
  box-shadow: none;
  border-color: #ff4500;
}
.btn.btn-reddit.btn-simple:hover,
.btn.btn-reddit.btn-simple:focus,
.btn.btn-reddit.btn-simple:active {
  color: #ff5b1f;
  border-color: #ff5b1f;
}
.btn.btn-reddit.btn-neutral {
  color: #ff4500;
  background-color: #ffffff;
}
.btn.btn-reddit.btn-neutral:hover,
.btn.btn-reddit.btn-neutral:focus,
.btn.btn-reddit.btn-neutral:active {
  color: #ff5b1f !important;
}

.btn.btn-tumblr {
  background-color: #35465c;
  color: #ffffff;
}
.btn.btn-tumblr:focus,
.btn.btn-tumblr:active,
.btn.btn-tumblr:hover {
  background-color: #40556f !important;
  color: #ffffff !important;
}
.btn.btn-tumblr.btn-simple {
  color: #35465c;
  background-color: transparent;
  box-shadow: none;
  border-color: #35465c;
}
.btn.btn-tumblr.btn-simple:hover,
.btn.btn-tumblr.btn-simple:focus,
.btn.btn-tumblr.btn-simple:active {
  color: #40556f;
  border-color: #40556f;
}
.btn.btn-tumblr.btn-neutral {
  color: #35465c;
  background-color: #ffffff;
}
.btn.btn-tumblr.btn-neutral:hover,
.btn.btn-tumblr.btn-neutral:focus,
.btn.btn-tumblr.btn-neutral:active {
  color: #40556f !important;
}

.btn.btn-behance {
  background-color: #1769ff;
  color: #ffffff;
}
.btn.btn-behance:focus,
.btn.btn-behance:active,
.btn.btn-behance:hover {
  background-color: #367dff !important;
  color: #ffffff !important;
}
.btn.btn-behance.btn-simple {
  color: #1769ff;
  background-color: transparent;
  box-shadow: none;
  border-color: #1769ff;
}
.btn.btn-behance.btn-simple:hover,
.btn.btn-behance.btn-simple:focus,
.btn.btn-behance.btn-simple:active {
  color: #367dff;
  border-color: #367dff;
}
.btn.btn-behance.btn-neutral {
  color: #1769ff;
  background-color: #ffffff;
}
.btn.btn-behance.btn-neutral:hover,
.btn.btn-behance.btn-neutral:focus,
.btn.btn-behance.btn-neutral:active {
  color: #367dff !important;
}

.icon-property,
.btn-rotate i,
.btn-magnify i,
.btn-move-left i,
.btn-move-right i {
  transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  position: relative;
  display: inline-block;
}

#animated-buttons .btn i {
  position: relative;
  top: 3px;
  margin-top: -3px;
}

.btn-rotate:hover i,
.btn-rotate:focus i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(53deg);
}

.btn-magnify:hover i,
.btn-magnify:focus i {
  transform: scale(1.22);
}

.btn-move-left i {
  margin-right: 0;
}

.btn-move-left:hover i,
.btn-move-left:focus i {
  transform: translate3d(-5px, 0, 0);
}

.btn-move-right i {
  margin-right: 0;
}

.btn-move-right:hover i,
.btn-move-right:focus i {
  transform: translate3d(5px, 0, 0);
}

::-moz-placeholder {
  color: #9a9a9a;
}

:-ms-input-placeholder {
  color: #9a9a9a;
}

::-webkit-input-placeholder {
  color: #9a9a9a;
}

.form-control {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  color: #66615b;
  line-height: normal;
  font-size: 14px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  box-shadow: none;
}
.form-control:focus {
  border: 1px solid #9a9a9a;
  box-shadow: none;
  outline: 0 !important;
  color: #66615b;
}
.form-control:focus + .input-group-append .input-group-text,
.form-control:focus ~ .input-group-append .input-group-text,
.form-control:focus + .input-group-prepend .input-group-text,
.form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #ccc;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control,
.has-error .form-control,
.has-success .form-control:focus,
.has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control {
  border: 1px solid #ccc;
  color: #66615b;
}
.has-success .form-control.form-control-success {
  padding-right: 2.5em !important;
}
.has-success .form-control:focus {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.has-danger .form-control {
  background-color: #ffc0a4;
  border: 1px solid #ef8157;
  color: #ef8157;
}
.has-danger .form-control.form-control-danger {
  padding-right: 2.5em !important;
}
.has-danger .form-control:focus {
  background-color: #ffffff;
  border: 1px solid #ef8157;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 6px 6px 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text,
.form-control + .input-group-prepend .input-group-text {
  background-color: #ffffff;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 11px;
}

.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 11px;
}
.form-group.no-border.form-control-lg
  .form-control
  + .input-group-prepend
  .input-group-text,
.form-group.no-border.form-control-lg
  .form-control
  + .input-group-append
  .input-group-text,
.input-group.no-border.form-control-lg
  .form-control
  + .input-group-prepend
  .input-group-text,
.input-group.no-border.form-control-lg
  .form-control
  + .input-group-append
  .input-group-text {
  padding: 15px 11px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 10px;
}
.form-group.form-control-lg
  .form-control
  + .input-group-prepend
  .input-group-text,
.form-group.form-control-lg
  .form-control
  + .input-group-append
  .input-group-text,
.input-group.form-control-lg
  .form-control
  + .input-group-prepend
  .input-group-text,
.input-group.form-control-lg
  .form-control
  + .input-group-append
  .input-group-text {
  padding: 14px 10px 14px 0;
}

.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 10px;
}
.form-group.form-control-lg
  .input-group-prepend
  .input-group-text
  + .form-control,
.form-group.form-control-lg
  .input-group-append
  .input-group-text
  + .form-control,
.input-group.form-control-lg
  .input-group-prepend
  .input-group-text
  + .form-control,
.input-group.form-control-lg
  .input-group-append
  .input-group-text
  + .form-control {
  padding: 15px 10px 15px 8px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 11px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 11px 11px 0;
}

.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 11px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 10px 10px 10px;
}
.form-group .form-control + .input-group-prepend .input-group-text,
.form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 10px 10px 0;
}

.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 10px;
}
.form-group .input-group-prepend .input-group-text + .form-control,
.form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 11px 11px 8px;
}

.input-group.has-success .input-group-prepend .input-group-text,
.input-group.has-success .input-group-append .input-group-text {
  border: 1px solid #ccc;
  color: #66615b;
  background-color: #ffffff;
  border-right: none;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: medium none;
}
.form-group.no-border .form-control:focus,
.form-group.no-border .form-control:active,
.form-group.no-border .form-control:active,
.form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active {
  border: medium none;
  background-color: rgba(222, 222, 222, 0.5);
}

.form-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.form-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text,
.input-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.input-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}

.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}

.has-error .form-control-feedback,
.has-error .control-label {
  color: #ef8157;
}

.has-success .form-control-feedback,
.has-success .control-label {
  color: #6bd098;
}

.input-group.has-danger .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-danger .input-group-prepend .input-group-text {
  border: 1px solid #ef8157;
  border-right: none;
}

.input-group.has-danger .error {
  display: block;
  width: 100%;
  color: #ef8157;
  margin-top: 3px;
}

.input-group.has-success .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-success .input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #ffffff;
  border-color: #9a9a9a;
}

.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}

.input-group-focus.has-danger .input-group-append .input-group-text,
.input-group-focus.has-danger .input-group-prepend .input-group-text {
  background-color: #ffc0a4;
}

.input-group-focus.has-success .input-group-append .input-group-text,
.input-group-focus.has-success .input-group-prepend .input-group-text {
  background-color: #abf3cb;
  border: 1px solid #6bd098;
  border-right: none;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  color: #66615b;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text {
  background-color: #ffc0a4;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: #abf3cb;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: #ffffff;
  color: #ef8157;
}
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  background-color: #ffffff;
  color: #6bd098;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ef8157;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #6bd098;
}
.input-group-append .input-group-text + .form-control,
.input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend {
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}
.input-group.has-danger .error,
.form-group.has-danger .error {
  color: #ef8157;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #e3e3e3;
}

.input-group .form-control:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #e3e3e3;
  color: #66615b;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #dddddd;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  line-height: 2;
}

.has-success.form-group .form-control,
.has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 32px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type="file"] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.8571em;
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}

.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}

.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}

.form-horizontal .form-check-inline {
  margin-top: 6px;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
}

a {
  color: #51cbce;
}
a:hover,
a:focus {
  color: #51cbce;
}

h1,
.h1 {
  font-size: 3.5em;
  line-height: 1.15;
  margin-bottom: 30px;
}
h1 small,
.h1 small {
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.8;
}

h2,
.h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
}

h3,
.h3 {
  font-size: 2em;
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4,
.h4 {
  font-size: 1.714em;
  line-height: 1.45em;
  margin-top: 30px;
  margin-bottom: 15px;
}
h4 + .category,
h4.title + .category,
.h4 + .category,
.h4.title + .category {
  margin-top: -10px;
}

h5,
.h5 {
  font-size: 1.57em;
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6,
.h6 {
  font-size: 1em;
  font-weight: 700;
  text-transform: uppercase;
}

p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 700;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #2c2c2c;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #9a9a9a;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: #9a9a9a;
  font-size: 0.7142em;
}

.card-category {
  font-size: 1em;
}

.text-primary,
a.text-primary:focus,
a.text-primary:hover {
  color: #51cbce !important;
}

.text-info,
a.text-info:focus,
a.text-info:hover {
  color: #0fa0cf !important;
}

.text-success,
a.text-success:focus,
a.text-success:hover {
  color: #6bd098 !important;
}

.text-warning,
a.text-warning:focus,
a.text-warning:hover {
  color: #fbc658 !important;
}

.text-danger,
a.text-danger:focus,
a.text-danger:hover {
  color: #ef8157 !important;
}

.text-gray,
a.text-gray:focus,
a.text-gray:hover {
  color: #e3e3e3 !important;
}

.blockquote {
  border-left: none;
  border: 1px solid #66615b;
  padding: 20px;
  font-size: 1.1em;
  line-height: 1.8;
}
.blockquote small {
  color: #66615b;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #51cbce;
  color: #51cbce;
}
.blockquote.blockquote-primary small {
  color: #51cbce;
}
.blockquote.blockquote-danger {
  border-color: #ef8157;
  color: #ef8157;
}
.blockquote.blockquote-danger small {
  color: #ef8157;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #ffffff;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.main {
  position: relative;
  background: #ffffff;
}

/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.animation-transition-general,
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.card-collapse .card .card-header a[data-toggle="collapse"] i,
.tag,
.tag [data-role="remove"],
.animation-transition-general,
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.card-collapse .card .card-header a[data-toggle="collapse"] i {
  transition: all 300ms ease 0s;
}

.dropdown-toggle:after,
.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded="true"]:after,
a[data-toggle="collapse"][aria-expanded="true"] .caret,
.card-collapse .card a[data-toggle="collapse"][aria-expanded="true"] i,
.card-collapse .card a[data-toggle="collapse"].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.button-bar {
  display: block;
  position: relative;
  width: 22px;
  height: 1px;
  border-radius: 1px;
  background: #ffffff;
}
.button-bar + .button-bar {
  margin-top: 7px;
}
.button-bar:nth-child(2) {
  width: 17px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.offline-doc .navbar.navbar-transparent {
  padding-top: 25px;
  border-bottom: none;
}
.offline-doc .navbar.navbar-transparent .navbar-minimize {
  display: none;
}
.offline-doc .navbar.navbar-transparent .navbar-brand,
.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {
  color: #ffffff !important;
}

.offline-doc .footer {
  z-index: 3 !important;
}

.offline-doc .page-header .container {
  z-index: 3;
}

.offline-doc .page-header:after {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.fixed-plugin .dropdown-menu li {
  padding: 2px !important;
}

.badge.badge-default {
  border-color: #66615b;
  background-color: #66615b;
}

.badge.badge-primary {
  border-color: #51cbce;
  background-color: #51cbce;
}

.badge.badge-info {
  border-color: #0fa0cf;
  background-color: #0fa0cf;
}

.badge.badge-success {
  border-color: #6bd098;
  background-color: #6bd098;
}

.badge.badge-warning {
  border-color: #fbc658;
  background-color: #fbc658;
}

.badge.badge-danger {
  border-color: #ef8157;
  background-color: #ef8157;
}

.badge.badge-neutral {
  border-color: #ffffff;
  background-color: #ffffff;
  color: inherit;
}

.card-user form .form-group {
  margin-bottom: 20px;
}

.ct-label.ct-horizontal.ct-end,
.ct-label.ct-vertical.ct-start {
  font-size: 14px;
}

.ct-chart.ct-perfect-fourth .ct-chart-pie .ct-label {
  font-size: 14px;
}

.card .card-footer .footer-line {
  padding-top: 3px;
}

.card.bootstrap-table .dropdown-item.active {
  background-color: #66615b;
  color: #ffffff;
}

.card .team-members .avatar {
  margin-top: 5px;
}

.card .team-members .text-right .btn {
  margin-top: 5px;
}

.btn-group-sm .btn-round {
  border-radius: 30px;
}

.heart {
  color: #eb5e28;
  animation: hearthing 1s ease infinite;
}

@keyframes hearthing {
  0% {
    transform: scale(0.75);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.75);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.75);
  }
}

.datepicker .table-condensed tbody > tr:first-of-type .day {
  padding-top: 5px;
}

.navbar {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  min-height: 53px;
  margin-bottom: 20px;
}
.navbar a {
  vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
  color: #ffffff;
}
.navbar a.dropdown-item {
  color: #66615b;
}
.navbar.bg-white .input-group .form-control,
.navbar.bg-white .input-group.no-border .form-control {
  color: #66615b;
}
.navbar.bg-white .input-group .form-control::-moz-placeholder,
.navbar.bg-white .input-group.no-border .form-control::-moz-placeholder {
  color: #66615b;
}
.navbar.bg-white .input-group .form-control:-ms-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control:-ms-input-placeholder {
  color: #66615b;
}
.navbar.bg-white .input-group .form-control::-webkit-input-placeholder,
.navbar.bg-white
  .input-group.no-border
  .form-control::-webkit-input-placeholder {
  color: #66615b;
}
.navbar.bg-white .input-group-prepend .input-group-text i,
.navbar.bg-white .input-group-append .input-group-text i {
  color: #66615b;
  opacity: 0.5;
}
.navbar .form-group,
.navbar .input-group {
  margin: 0;
  margin-left: -3px;
  margin-right: 5px;
}
.navbar .form-group .form-group-addon,
.navbar .form-group .input-group-prepend .input-group-text,
.navbar .form-group .input-group-append .input-group-text,
.navbar .input-group .form-group-addon,
.navbar .input-group .input-group-prepend .input-group-text,
.navbar .input-group .input-group-append .input-group-text {
  color: #66615b;
}
.navbar .form-group .form-group-addon i,
.navbar .form-group .input-group-prepend .input-group-text i,
.navbar .form-group .input-group-append .input-group-text i,
.navbar .input-group .form-group-addon i,
.navbar .input-group .input-group-prepend .input-group-text i,
.navbar .input-group .input-group-append .input-group-text i {
  opacity: 1;
}
.navbar .form-group.no-border .form-control,
.navbar .input-group.no-border .form-control {
  color: #66615b;
}
.navbar .form-group.no-border .form-control::-moz-placeholder,
.navbar .input-group.no-border .form-control::-moz-placeholder {
  color: #66615b;
}
.navbar .form-group.no-border .form-control:-ms-input-placeholder,
.navbar .input-group.no-border .form-control:-ms-input-placeholder {
  color: #66615b;
}
.navbar .form-group.no-border .form-control::-webkit-input-placeholder,
.navbar .input-group.no-border .form-control::-webkit-input-placeholder {
  color: #66615b;
}
.navbar p {
  display: inline-block;
  margin: 0;
  line-height: 1.8em;
  font-size: 1em;
  font-weight: 400;
}
.navbar.navbar-absolute {
  position: absolute;
  width: 100%;
  padding-top: 10px;
  z-index: 100;
}
.documentation .navbar.fixed-top {
  left: 0;
  width: auto;
  width: initial;
}
.navbar .navbar-wrapper {
  display: inline-flex;
  align-items: center;
}
.navbar .navbar-wrapper .navbar-minimize {
  padding-right: 10px;
}
.navbar .navbar-wrapper .navbar-minimize .btn {
  margin: 0;
}
.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {
  padding-left: 0;
}
.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {
  width: 22px;
}
.navbar .navbar-nav.navbar-logo {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 49px;
  top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
  padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
  padding: 15px 48px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
  padding: 5px 15px;
}
.navbar .navbar-nav .nav-link {
  text-transform: uppercase;
  font-size: 0.7142em;
  padding: 0.5rem 0.7rem;
  line-height: 1.625rem;
  margin-right: 3px;
}
.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 3px;
}
.navbar .navbar-nav .nav-link i.fa,
.navbar .navbar-nav .nav-link i.nc-icon {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}
.navbar .navbar-nav .nav-link i.nc-icon {
  top: 4px;
  font-size: 16px;
}
.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {
  width: 27px;
  height: 27px;
}
.navbar .navbar-nav .nav-link.disabled {
  opacity: 0.5;
  color: #ffffff;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
  border-radius: 3px;
  color: #66615b;
}
.navbar .logo-container {
  width: 27px;
  height: 27px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid transparent;
}
.navbar .navbar-brand {
  text-transform: capitalize;
  font-size: 20px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.625rem;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
  width: 17px;
}
.navbar.navbar-transparent {
  background-color: transparent !important;
  box-shadow: none;
  border-bottom: 1px solid #ddd;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {
  color: #66615b;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615b;
}
.navbar.navbar-transparent .button-bar {
  background: #66615b;
}
.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {
  color: #66615b;
}
.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {
  color: #51cbce;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn) {
  color: #66615b;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615b;
}
.navbar.bg-white .button-bar {
  background: #66615b;
}
.navbar.bg-white .nav-item.active .nav-link:not(.btn),
.navbar.bg-white .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white .nav-item .nav-link:not(.btn):active {
  color: #0fa0cf;
}
.navbar.bg-white .logo-container {
  border: 1px solid #66615b;
}
.navbar .navbar-collapse .nav-item a {
  font-size: 14px;
}

.bg-default {
  background-color: #66615b !important;
}

.bg-primary {
  background-color: #51cbce !important;
}

.bg-info {
  background-color: #0fa0cf !important;
}

.bg-success {
  background-color: #6bd098 !important;
}

.bg-danger {
  background-color: #ef8157 !important;
}

.bg-warning {
  background-color: #fbc658 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.dropdown .dropdown-menu,
.dropup .dropdown-menu,
.bootstrap-select .dropdown-menu {
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  visibility: hidden;
  position: absolute;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
    opacity 0.3s ease 0s, height 0s linear 0.35s;
}
.dropdown .dropdown-menu[x-placement="top-start"],
.dropup .dropdown-menu[x-placement="top-start"],
.bootstrap-select .dropdown-menu[x-placement="top-start"] {
  transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement="bottom-start"],
.dropup .dropdown-menu[x-placement="bottom-start"],
.bootstrap-select .dropdown-menu[x-placement="bottom-start"] {
  transform: translate3d(-20px, 0px, 0) !important;
}

.dropdown.show .dropdown-menu,
.dropup.show .dropdown-menu,
.bootstrap-select.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.dropdown.show .dropdown-menu[x-placement="top-start"],
.dropup.show .dropdown-menu[x-placement="top-start"],
.bootstrap-select.show .dropdown-menu[x-placement="top-start"] {
  transform: translate3d(-20px, -50px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement="bottom-start"],
.dropup.show .dropdown-menu[x-placement="bottom-start"],
.bootstrap-select.show .dropdown-menu[x-placement="bottom-start"] {
  transform: translate3d(-20px, 50px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}

.dropup .dropdown-menu,
.dropdown-btn .dropdown-menu {
  transform: translate3d(-20px, 0px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}

.dropup.show .dropdown-menu,
.dropdown-btn.show .dropdown-menu {
  opacity: 1;
  visibility: visible;
}
.dropup.show .dropdown-menu .dropdown-menu.inner,
.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {
  transform: translate3d(0, 0px, 0) !important;
}

.bootstrap-select.show .dropdown-menu.show[x-placement="top-start"] {
  transform: translate3d(-20px, -60px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}

.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {
  border-radius: 0 0 12px 12px;
}

.bootstrap-select.dropup.show:before {
  top: -1px !important;
}

.bootstrap-select.dropup.show:after {
  top: -2px !important;
}

.dropdown-menu {
  background-color: #ffffff;
  border: 0 none;
  border-radius: 12px;
  margin-top: 10px;
  padding: 0px;
}
.dropdown-menu .divider {
  background-color: #f1eae0;
  margin: 0px;
}
.dropdown-menu .dropdown-header {
  color: #9a9a9a;
  font-size: 0.8571em;
  padding: 10px 15px;
}
.dropdown-menu .no-notification {
  color: #9a9a9a;
  font-size: 1.2em;
  padding: 30px 30px;
  text-align: center;
}
.dropdown-menu .dropdown-item {
  color: #66615b;
  font-size: 14px;
  padding: 10px 45px 10px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.select .dropdown-menu .dropdown-item:first-child {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  color: #ffffff !important;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #66615b;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover,
.dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: #6dd3d6;
}
.dropdown-menu.dropdown-info .dropdown-item:hover,
.dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: #6ec7e0;
}
.dropdown-menu.dropdown-success .dropdown-item:hover,
.dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: #86d9ab;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover,
.dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: #fcd27b;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover,
.dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: #f29978;
}

.dropdown-divider {
  margin: 0 !important;
}

.btn-group.select.open {
  overflow: visible;
}

.dropdown-menu-right {
  right: -2px;
  left: auto;
}

.navbar-nav .dropdown-menu:before,
.dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.dropdown .dropdown-menu[x-placement="bottom-end"]:before,
.card.card-just-text .dropdown .dropdown-menu:before,
.card-just-text .dropdown .dropdown-menu:before,
.dropdown-btn .dropdown-menu:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -12px;
}

.navbar-nav .dropdown-menu:after,
.dropdown .dropdown-menu[x-placement="bottom-start"]:after,
.dropdown .dropdown-menu[x-placement="bottom-end"]:after,
.card.card-just-text .dropdown .dropdown-menu:after,
.card-just-text .dropdown .dropdown-menu:after,
.dropdown-btn .dropdown-menu:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement="top-start"]:before,
.dropdown
  .dropdown-menu.dropdown-notification[x-placement="bottom-start"]:before {
  left: 30px !important;
  right: auto;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement="top-start"]:after,
.dropdown
  .dropdown-menu.dropdown-notification[x-placement="bottom-start"]:after {
  left: 30px !important;
  right: auto;
}

@media screen and (min-width: 768px) {
  .navbar-form {
    margin-top: 21px;
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .navbar-search-form {
    display: none;
  }
  .navbar-nav .dropdown-item .dropdown-menu,
  .dropdown .dropdown-menu,
  .dropdown-btn .dropdown-menu {
    transform: translate3d(0px, -40px, 0px);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
      opacity 0.3s ease 0s, height 0s linear 0.35s;
  }
  .navbar-nav .dropdown-item.show .dropdown-menu,
  .dropdown.show .dropdown-menu,
  .dropdown-btn.show .dropdown-menu {
    transform: translate3d(0px, 0px, 0px);
    visibility: visible !important;
  }
  .bootstrap-select .dropdown-menu {
    transition: all 150ms linear;
  }
  .bootstrap-datetimepicker-widget {
    visibility: visible !important;
  }
  .bootstrap-select .show .dropdown-menu {
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
      opacity 0.3s ease 0s, height 0s linear 0.35s;
    transform: translate3d(0px, 0px, 0px);
  }
  .navbar-nav.navbar-right li .dropdown-menu:before,
  .navbar-nav.navbar-right li .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav ul li:first-child {
    margin-left: 0;
  }
  body > .navbar-collapse.collapse {
    display: none !important;
  }
}

.dropdown-sharing .dropup-item {
  color: #66615b;
  font-size: 14px;
}
.dropdown-sharing .dropup-item .social-line {
  line-height: 28px;
  padding: 10px 20px 5px 20px !important;
}
.dropdown-sharing .dropup-item .social-line [class*="icon-"] {
  font-size: 20px;
}
.dropdown-sharing .dropup-item:last-child {
  margin: 0 13px;
  display: block;
}
.dropdown-sharing .dropup-item .btn {
  margin: 10px;
}

.dropdown-sharing .dropup-item:hover .social-line,
.dropdown-sharing .dropup-item:hover .action-line,
.dropdown-sharing .dropup-item:focus .social-line,
.dropdown-sharing .dropup-item:focus .action-line {
  background-color: #ffffff;
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}

.show .dropdown-sharing,
.show .dropdown-actions {
  margin-bottom: 1px;
}

.dropdown-actions .dropdown-item {
  margin: -15px 35px;
}
.dropdown-actions .dropdown-item .action-line {
  padding: 5px 10px;
  line-height: 24px;
  font-weight: bold;
}
.dropdown-actions .dropdown-item .action-line [class*="icon-"] {
  font-size: 24px;
}
.dropdown-actions .dropdown-item .action-line .col-sm-9 {
  line-height: 34px;
}
.dropdown-actions .dropdown-item .link-danger {
  color: #ef8157;
}
.dropdown-actions .dropdown-item .link-danger:hover,
.dropdown-actions .dropdown-item .link-danger:active,
.dropdown-actions .dropdown-item .link-danger:focus {
  color: #ef8157;
}

.dropdown-actions li:hover a,
.dropdown-actions li:focus a {
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}

.dropdown-actions .action-line .icon-simple {
  margin-left: -15px;
}

.dropdown .dropdown-menu[x-placement="top-start"]:before,
.dropdown .dropdown-menu[x-placement="top-end"]:before,
.dropup .dropdown-menu:before {
  border-top: 11px solid #dcd9d1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}

.dropdown .dropdown-menu[x-placement="top-start"]:after,
.dropdown .dropdown-menu[x-placement="top-end"]:after,
.dropup .dropdown-menu:after {
  border-top: 11px solid #fff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
  margin-left: 0;
}

.dropdown-notification .dropdown-notification-list .notification-item {
  border-bottom: 1px solid #f1eae0;
  font-size: 16px;
  color: #66615b;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item
  .notification-text {
  padding-left: 40px;
  position: relative;
  min-width: 330px;
  min-height: 70px;
  white-space: normal;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item
  .notification-text
  .label {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  left: 7px;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item
  .notification-text
  .message {
  font-size: 0.9em;
  line-height: 0.7;
  margin-left: 10px;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item
  .notification-text
  .time {
  color: #9a9a9a;
  font-size: 0.7em;
  margin-left: 10px;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item
  .read-notification {
  font-size: 12px;
  opacity: 0;
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: -12px;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover {
  text-decoration: none;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item:hover
  .notification-text {
  color: #66615b;
  background-color: #f0efeb !important;
}
.dropdown-notification
  .dropdown-notification-list
  .notification-item:hover
  .read-notification {
  opacity: 1 !important;
}

.dropdown-notification .dropdown-footer {
  background-color: #e8e7e3;
  border-radius: 0 0 8px 8px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu {
  list-style: outside none none;
  padding: 0px 5px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li {
  display: inline-block;
  text-align: left;
  padding: 0 10px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {
  color: #9c9b99;
  font-size: 0.9em;
  line-height: 35px;
}

.alert {
  border: 0;
  border-radius: 3px;
  color: #ffffff;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  position: relative;
}
.alert.alert-success {
  background-color: #7ed6a5;
}
.alert.alert-danger {
  background-color: #f1926e;
}
.alert.alert-warning {
  background-color: #fccf71;
}
.alert.alert-info {
  background-color: #66c4de;
}
.alert.alert-primary {
  background-color: #65d1d4;
}
.alert .close {
  color: #ffffff;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert .close i.fa,
.alert .close i.nc-icon {
  font-size: 14px !important;
}
.alert .close:hover,
.alert .close:focus {
  opacity: 1;
}
.alert span[data-notify="icon"] {
  font-size: 27px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

img {
  max-width: 100%;
  border-radius: 3px;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}

.table .img-row {
  max-width: 60px;
  width: 60px;
}

.table .form-check {
  margin: 0;
}
.table .form-check label .form-check-sign::before,
.table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}

.table .btn {
  margin: 0;
}

.table small,
.table .small {
  font-weight: 300;
}

.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 0;
  padding-bottom: 0;
}

.table > thead > tr > th {
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 0;
  text-transform: uppercase;
  border: 0;
}

.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after,
.table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 7px;
  vertical-align: middle;
}

.table .th-description {
  max-width: 150px;
}

.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}

.table .td-total {
  font-weight: 700;
  font-size: 1.57em;
  padding-top: 20px;
  text-align: right;
}

.table .td-actions .btn {
  margin: 0px;
}

.table > tbody > tr {
  position: relative;
}

.table-shopping > thead > tr > th {
  font-size: 1em;
  text-transform: uppercase;
}

.table-shopping > tbody > tr > td {
  font-size: 1em;
}
.table-shopping > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}

.table-shopping .td-name {
  font-weight: 400;
  font-size: 1.5em;
}
.table-shopping .td-name small {
  color: #9a9a9a;
  font-size: 0.75em;
  font-weight: 300;
}

.table-shopping .td-number {
  font-weight: 300;
  font-size: 1.714em;
}

.table-shopping .td-name {
  min-width: 200px;
}

.table-shopping .td-number {
  text-align: right;
  min-width: 170px;
}
.table-shopping .td-number small {
  margin-right: 3px;
}

.table-shopping .img-container {
  width: 120px;
  max-height: 160px;
  overflow: hidden;
  display: block;
}
.table-shopping .img-container img {
  width: 100%;
}

.table-responsive {
  overflow: scroll;
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}

.footer {
  padding: 24px 0;
}
.footer.footer-default {
  background-color: #f2f2f2;
}
.footer nav {
  display: inline-block;
  float: left;
  padding-left: 0;
}
.footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer ul li {
  display: inline-block;
}
.footer ul li a {
  color: inherit;
  padding: 0.5rem;
  font-size: 0.8571em;
  text-transform: uppercase;
  text-decoration: none;
}
.footer ul li a:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.8571em;
  line-height: 1.8;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 10px;
  padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
  top: 2px;
  right: 10px;
  font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.badge-light {
  border: 1px solid #e3e3e3;
}
.fixed-plugin .badge.badge-light.active,
.fixed-plugin .badge.badge-light:hover {
  border: 3px solid #0bf;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}
.fixed-plugin .badge-blue {
  background-color: #0fa0cf;
}
.fixed-plugin .badge-green {
  background-color: #6bd098;
}
.fixed-plugin .badge-orange {
  background-color: #51cbce;
}
.fixed-plugin .badge-yellow {
  background-color: #fbc658;
}
.fixed-plugin .badge-red {
  background-color: #ef8157;
}
.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 15px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 35px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3c4858;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.7142em;
  color: #66615b;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #fff;
  border: 3px solid #fff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -27px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #ffffff;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -26px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 16px;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
  transform: translate3d(0, -60px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"] {
  transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:after {
  top: 100px;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="top-start"] {
  transform: translate3d(0, 100px, 0) !important;
}

.fixed-plugin
  .show-dropdown.show
  .dropdown-menu.show[x-placement="bottom-start"] {
  transform: translate3d(0, -60px, 0) !important;
}

.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement="top-start"] {
  transform: translate3d(0, 470px, 0) !important;
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check {
  padding-left: 0;
  margin-bottom: 0.5rem;
}
.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 0;
  cursor: pointer;
  border-radius: 6px;
  top: 0;
  background-color: #aaa7a4;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f00c";
  top: -1px;
  text-align: center;
  font-size: 15px;
  opacity: 0;
  color: #fff;
  border: 0;
  background-color: inherit;
}
.form-check.disabled .form-check-label {
  color: #9a9a9a;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type="checkbox"],
.form-check-radio input[type="radio"] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type="checkbox"]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type="checkbox"]:disabled + .form-check-sign::before,
.checkbox input[type="checkbox"]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check
  .form-check-label
  input[type="checkbox"]:disabled
  + .form-check-sign,
.form-check-radio input[type="radio"]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check-radio {
  margin-left: -3px;
}
.form-check-radio .form-check-label {
  padding-left: 2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9a9a9a;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 22px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 5px;
  top: -5px;
}

.form-check-label input[type="checkbox"]:checked + .form-check-sign:before {
  background-color: #66615b;
}

.form-check-radio input[type="radio"] + .form-check-sign:after,
.form-check-radio input[type="radio"] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
}

.form-check-radio input[type="radio"]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  top: -5px;
  position: absolute;
  left: 5px;
  opacity: 1;
  font-size: 22px;
}

.form-check-radio input[type="radio"]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type="radio"]:disabled + .form-check-sign::before,
.form-check-radio input[type="radio"]:disabled + .form-check-sign::after {
  color: #9a9a9a;
}

.progress {
  background-color: #dddddd;
  border-radius: 3px;
  box-shadow: none;
  height: 8px;
}

.progress-thin {
  height: 4px;
}

.progress-bar {
  background-color: #51cbce;
}

.progress-bar-primary {
  background-color: #51cbce;
}

.progress-bar-info {
  background-color: #0fa0cf;
}

.progress-bar-success {
  background-color: #6bd098;
}

.progress-bar-warning {
  background-color: #fbc658;
}

.progress-bar-danger {
  background-color: #ef8157;
}

/*           badges             */
.badge {
  padding: 4px 8px;
  text-transform: uppercase;
  font-size: 0.7142em;
  line-height: 12px;
  background-color: transparent;
  border: 1px solid;
  text-decoration: none;
  color: #ffffff;
  margin-bottom: 5px;
}
.badge:hover,
.badge:focus {
  text-decoration: none;
}

.badge-icon {
  padding: 0.4em 0.55em;
}
.badge-icon i {
  font-size: 0.8em;
}

.badge-default {
  border-color: #66615b;
  background-color: #66615b;
}

.badge-primary {
  border-color: #51cbce;
  background-color: #51cbce;
}

.badge-info {
  border-color: #0fa0cf;
  background-color: #0fa0cf;
}

.badge-success {
  border-color: #6bd098;
  background-color: #6bd098;
}

.badge-warning {
  border-color: #fbc658;
  background-color: #fbc658;
}

.badge-danger {
  border-color: #ef8157;
  background-color: #ef8157;
}

.badge-neutral {
  border-color: #ffffff;
  background-color: #ffffff;
  color: inherit;
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
  color: #ffffff;
  background-color: #45c7cb;
  border-color: #45c7cb;
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
  color: #ffffff;
  background-color: #fbc149;
  border-color: #fbc149;
}

.badge-info[href]:focus,
.badge-info[href]:hover {
  color: #ffffff;
  background-color: #44b7d7;
  border-color: #44b7d7;
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
  color: #ffffff;
  background-color: #ee7749;
  border-color: #ee7749;
}

.badge-success[href]:focus,
.badge-success[href]:hover {
  color: #ffffff;
  background-color: #5fcc90;
  border-color: #5fcc90;
}

.badge-default[href]:focus,
.badge-default[href]:hover {
  color: #ffffff;
  background-color: #5e5954;
  border-color: #5e5954;
}

.pagination .page-item .page-link {
  border: 0;
  border-radius: 30px !important;
  transition: all 0.3s;
  padding: 0px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #2c2c2c;
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  background: transparent;
  outline: none;
}
.pagination .page-item .page-link:hover,
.pagination .page-item .page-link:focus {
  color: #2c2c2c;
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}
.pagination .page-item .page-link:focus,
.pagination .page-item .page-link:active:focus {
  box-shadow: none;
}

.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
  position: absolute;
}

.pagination .arrow-margin-right {
  right: 0;
}

.pagination .arrow-margin-left {
  left: 0;
}

.pagination .page-item.active > .page-link {
  color: #ffffff;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.pagination .page-item.active > .page-link,
.pagination .page-item.active > .page-link:focus,
.pagination .page-item.active > .page-link:hover {
  background-color: #51cbce;
  border-color: #51cbce;
  color: #ffffff;
}

.pagination .page-item.disabled > .page-link {
  opacity: 0.5;
}

.pagination.pagination-info .page-item.active > .page-link,
.pagination.pagination-info .page-item.active > .page-link:focus,
.pagination.pagination-info .page-item.active > .page-link:hover {
  background-color: #0fa0cf;
  border-color: #0fa0cf;
}

.pagination.pagination-success .page-item.active > .page-link,
.pagination.pagination-success .page-item.active > .page-link:focus,
.pagination.pagination-success .page-item.active > .page-link:hover {
  background-color: #6bd098;
  border-color: #6bd098;
}

.pagination.pagination-primary .page-item.active > .page-link,
.pagination.pagination-primary .page-item.active > .page-link:focus,
.pagination.pagination-primary .page-item.active > .page-link:hover {
  background-color: #51cbce;
  border-color: #51cbce;
}

.pagination.pagination-warning .page-item.active > .page-link,
.pagination.pagination-warning .page-item.active > .page-link:focus,
.pagination.pagination-warning .page-item.active > .page-link:hover {
  background-color: #fbc658;
  border-color: #fbc658;
}

.pagination.pagination-danger .page-item.active > .page-link,
.pagination.pagination-danger .page-item.active > .page-link:focus,
.pagination.pagination-danger .page-item.active > .page-link:hover {
  background-color: #ef8157;
  border-color: #ef8157;
}

.pagination.pagination-neutral .page-item > .page-link {
  color: #ffffff;
}
.pagination.pagination-neutral .page-item > .page-link:focus,
.pagination.pagination-neutral .page-item > .page-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.pagination.pagination-neutral .page-item.active > .page-link,
.pagination.pagination-neutral .page-item.active > .page-link:focus,
.pagination.pagination-neutral .page-item.active > .page-link:hover {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #51cbce;
}

.info.info-hover .info-title {
  transition: color 0.4s;
}

.info.info-hover:hover .icon {
  transform: translate3d(0, -0.5rem, 0) !important;
}
.info.info-hover:hover .icon.icon-primary.icon-circle {
  box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);
}
.info.info-hover:hover .icon.icon-info.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);
}
.info.info-hover:hover .icon.icon-success.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);
}
.info.info-hover:hover .icon.icon-warning.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);
}
.info.info-hover:hover .icon.icon-danger.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);
}
.info.info-hover:hover .icon.icon-info + .info-title {
  color: #0fa0cf;
}
.info.info-hover:hover .icon.icon-warning + .info-title {
  color: #fbc658;
}
.info.info-hover:hover .icon.icon-danger + .info-title {
  color: #ef8157;
}
.info.info-hover:hover .icon.icon-primary + .info-title {
  color: #51cbce;
}
.info.info-hover:hover .icon.icon-success + .info-title {
  color: #6bd098;
}

.info .icon {
  color: #66615b;
  transition: transform 0.4s, box-shadow 0.4s;
}
.info .icon > i {
  font-size: 2.3em;
}
.info .icon.icon-circle {
  max-width: 70px;
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
  font-size: 0.7142em;
  background-color: #ffffff;
  position: relative;
}
.info .icon.icon-circle i {
  line-height: 2.6em;
}

.info .info-title {
  margin: 15px 0 5px;
  padding: 0 15px;
  color: #2c2c2c;
  font-weight: 700;
}

.info p {
  color: #66615b;
  padding: 0 15px;
  font-size: 1.1em;
}

.info-horizontal {
  text-align: left !important;
}
.info-horizontal .icon {
  float: left;
  margin-top: 23px;
  margin-right: 10px;
}
.info-horizontal .icon > i {
  font-size: 2em;
}
.info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.info-horizontal .description {
  overflow: hidden;
}

.icon.icon-primary {
  color: #51cbce;
}
.icon.icon-primary.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(81, 203, 206, 0.5);
}

.icon.icon-info {
  color: #0fa0cf;
}
.icon.icon-info.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(81, 188, 218, 0.5);
}

.icon.icon-success {
  color: #6bd098;
}
.icon.icon-success.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(107, 208, 152, 0.5);
}

.icon.icon-warning {
  color: #fbc658;
}
.icon.icon-warning.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(251, 198, 88, 0.5);
}

.icon.icon-danger {
  color: #ef8157;
}
.icon.icon-danger.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(239, 129, 87, 0.5);
}

.icon.icon-white {
  color: #ffffff;
}

/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
  margin-left: 0;
}

.nav-pills .nav-item .nav-link {
  border: 1px solid #66615b;
  border-radius: 0;
  color: #66615b;
  font-weight: 700;
  margin-left: -1px;
  padding: 10px 25px;
}

.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
  background-color: #66615b;
  color: #ffffff;
}

.nav-pills .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px !important;
  margin: 0;
}

.nav-pills .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0 !important;
}

.nav-pills .nav-item .nav-link.active {
  background-color: #66615b;
  color: #ffffff;
}

.nav-pills-primary .nav-item .nav-link {
  border: 1px solid #51cbce;
  color: #51cbce;
}
.nav-pills-primary .nav-item .nav-link.active {
  border: 1px solid #51cbce;
  background: #51cbce;
  color: #ffffff;
}

.nav-pills-danger .nav-item .nav-link {
  border: 1px solid #ef8157;
  color: #ef8157;
}
.nav-pills-danger .nav-item .nav-link.active {
  border: 1px solid #ef8157;
  background: #ef8157;
  color: #ffffff;
}

.nav-pills-info .nav-item .nav-link {
  border: 1px solid #0fa0cf;
  color: #0fa0cf;
}
.nav-pills-info .nav-item .nav-link.active {
  border: 1px solid #0fa0cf;
  background: #0fa0cf;
  color: #ffffff;
}

.nav-pills-success .nav-item .nav-link {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.nav-pills-success .nav-item .nav-link.active {
  border: 1px solid #6bd098;
  background: #6bd098;
  color: #ffffff;
}

.nav-pills-warning .nav-item .nav-link {
  border: 1px solid #fbc658;
  color: #fbc658;
}
.nav-pills-warning .nav-item .nav-link.active {
  border: 1px solid #fbc658;
  background: #fbc658;
  color: #ffffff;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
  background-color: #66615b !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
  background-color: #51cbce !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
  background-color: #0fa0cf !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
  background-color: #fbc658 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
  background-color: #6bd098 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
  background-color: #ef8157 !important;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
  text-align: center;
  border-bottom: 1px solid #f1eae0;
  margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
  padding-bottom: 20px;
}

.nav-tabs-wrapper {
  display: inline-block;
  margin-bottom: -6px;
  margin-left: 1.25%;
  margin-right: 1.25%;
  position: relative;
  width: auto;
}

.nav-tabs {
  border-bottom: 0 none;
  font-size: 14px;
  font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
  border: 0 none;
  color: #a49e93;
  background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
  color: #66615b;
}
.nav-tabs .nav-item .nav-link.active {
  color: #66615b;
}
.nav-tabs .nav-item {
  color: #66615b;
  position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
  background-color: transparent;
  border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: -6px;
  margin-left: -46px;
  border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
  color: #ffffff;
  background-color: #68b3c8;
}
.nav-tabs .dropdown-menu :before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.nav-tabs .dropdown-menu :after {
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -10px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}

.profile-content .tab-content #tweets,
.profile-content .tab-content #connections,
.profile-content .tab-content #media {
  height: 100%;
}

.nav-text,
.nav-icons {
  margin: 0 0 10px 0;
}
.nav-text > li > a,
.nav-icons > li > a {
  display: block;
  padding: 0px 0.7rem;
  color: #9a9a9a;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text > li > a:hover,
.nav-text > li > a:focus,
.nav-icons > li > a:hover,
.nav-icons > li > a:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text > li:first-child a,
.nav-icons > li:first-child a {
  padding-left: 0;
}
.nav-text > li.active a,
.nav-icons > li.active a {
  color: #0fa0cf;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.714em;
  margin-bottom: 10px;
  width: 1.714em;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #51cbce;
}

.nav-azure > li.active a {
  color: #0fa0cf;
}

.nav-green > li.active a {
  color: #6bd098;
}

.nav-orange > li.active a {
  color: #fbc658;
}

.nav-red > li.active a {
  color: #ef8157;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 1em;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 600;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}

.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-space {
  padding: 20px 0 50px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
  border-right: 11px solid #f1eae0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
  border-right: 11px solid #ffffff;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: -1px;
  bottom: 20px;
}

#second-tabs {
  margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
  border-right: 1px solid #f1eae0;
  font-size: 16px;
  padding: 0 37px;
  border-bottom: none;
}

.popover {
  font-size: 14px;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border: none;
  line-height: 1.7;
  max-width: 240px;
}
.popover.bs-popover-top .arrow:before,
.popover.bs-popover-left .arrow:before,
.popover.bs-popover-right .arrow:before,
.popover.bs-popover-bottom .arrow:before {
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.popover .popover-header {
  color: rgba(182, 182, 182, 0.6);
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 600;
  margin: 0;
  margin-top: 5px;
  border: none;
  background-color: transparent;
}
.popover:before {
  display: none;
}
.popover.bs-tether-element-attached-top:after {
  border-bottom-color: #ffffff;
  top: -9px;
}
.popover.popover-primary {
  background-color: #51cbce;
}
.popover.popover-primary .popover-body {
  color: #ffffff;
}
.popover.popover-primary.bs-popover-right .arrow:after {
  border-right-color: #51cbce;
}
.popover.popover-primary.bs-popover-top .arrow:after {
  border-top-color: #51cbce;
}
.popover.popover-primary.bs-popover-bottom .arrow:after {
  border-bottom-color: #51cbce;
}
.popover.popover-primary.bs-popover-left .arrow:after {
  border-left-color: #51cbce;
}
.popover.popover-primary .popover-header {
  color: #ffffff;
  opacity: 0.6;
}
.popover.popover-info {
  background-color: #0fa0cf;
}
.popover.popover-info .popover-body {
  color: #ffffff;
}
.popover.popover-info.bs-popover-right .arrow:after {
  border-right-color: #0fa0cf;
}
.popover.popover-info.bs-popover-top .arrow:after {
  border-top-color: #0fa0cf;
}
.popover.popover-info.bs-popover-bottom .arrow:after {
  border-bottom-color: #0fa0cf;
}
.popover.popover-info.bs-popover-left .arrow:after {
  border-left-color: #0fa0cf;
}
.popover.popover-info .popover-header {
  color: #ffffff;
  opacity: 0.6;
}
.popover.popover-warning {
  background-color: #fbc658;
}
.popover.popover-warning .popover-body {
  color: #ffffff;
}
.popover.popover-warning.bs-popover-right .arrow:after {
  border-right-color: #fbc658;
}
.popover.popover-warning.bs-popover-top .arrow:after {
  border-top-color: #fbc658;
}
.popover.popover-warning.bs-popover-bottom .arrow:after {
  border-bottom-color: #fbc658;
}
.popover.popover-warning.bs-popover-left .arrow:after {
  border-left-color: #fbc658;
}
.popover.popover-warning .popover-header {
  color: #ffffff;
  opacity: 0.6;
}
.popover.popover-danger {
  background-color: #ef8157;
}
.popover.popover-danger .popover-body {
  color: #ffffff;
}
.popover.popover-danger.bs-popover-right .arrow:after {
  border-right-color: #ef8157;
}
.popover.popover-danger.bs-popover-top .arrow:after {
  border-top-color: #ef8157;
}
.popover.popover-danger.bs-popover-bottom .arrow:after {
  border-bottom-color: #ef8157;
}
.popover.popover-danger.bs-popover-left .arrow:after {
  border-left-color: #ef8157;
}
.popover.popover-danger .popover-header {
  color: #ffffff;
  opacity: 0.6;
}
.popover.popover-success {
  background-color: #6bd098;
}
.popover.popover-success .popover-body {
  color: #ffffff;
}
.popover.popover-success.bs-popover-right .arrow:after {
  border-right-color: #6bd098;
}
.popover.popover-success.bs-popover-top .arrow:after {
  border-top-color: #6bd098;
}
.popover.popover-success.bs-popover-bottom .arrow:after {
  border-bottom-color: #6bd098;
}
.popover.popover-success.bs-popover-left .arrow:after {
  border-left-color: #6bd098;
}
.popover.popover-success .popover-header {
  color: #ffffff;
  opacity: 0.6;
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #ffffff;
}

.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #ffffff;
}

.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #ffffff;
}

.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #ffffff;
}

.tooltip-inner {
  padding: 0.5rem 0.7rem;
  min-width: 130px;
  background-color: #ffffff;
  font-size: 14px;
  color: inherit;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.modal-header {
  border-bottom: 1px solid #dddddd;
  padding: 20px;
  text-align: center;
  display: block !important;
}
.modal-header.no-border-header {
  border-bottom: 0 none !important;
}
.modal-header.no-border-header .modal-title {
  margin-top: 20px;
}
.modal-header button.close:focus {
  outline: none;
}
.modal-header .modal-profile {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  text-align: center;
  line-height: 6.4;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.modal-header .modal-profile i {
  font-size: 30px;
}

.modal-dialog.modal-sm .modal-header button.close,
.modal-dialog.modal-register .modal-header button.close {
  margin-top: 0;
}

.modal-content {
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}
.modal-content .modal-header h6 {
  margin-top: 10px;
}

.modal-dialog {
  padding-top: 60px;
}

.modal-body {
  padding: 20px 50px;
  color: #000;
}

.modal-footer {
  border-top: 1px solid #dddddd;
  padding: 0px;
}
.modal-footer.no-border-footer {
  border-top: 0 none;
}

.modal-footer .left-side,
.modal-footer .right-side {
  display: inline-block;
  text-align: center;
  width: 50%;
  padding: 5px;
}

.modal-footer .btn-link {
  padding: 20px;
  width: 100%;
  margin: 0;
}

.modal-footer .divider {
  background-color: #dddddd;
  display: inline-block;
  float: inherit;
  height: 63px;
  margin: 0px -3px;
  width: 1px;
}

.modal-register .modal-footer {
  text-align: center;
  margin-bottom: 25px;
  padding: 20px 0 15px;
}
.modal-register .modal-footer span {
  width: 100%;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel .carousel-inner {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.carousel .nc-icon {
  font-size: 2em;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar,
.off-canvas-sidebar {
  position: fixed;
  top: 0;
  height: 100%;
  bottom: 0;
  width: 260px;
  left: 0;
  z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  position: relative;
  height: calc(100vh - 75px);
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}

:not(.dates-container)::-webkit-scrollbar {
  display: none;
}

.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span {
  display: inline-block;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 20px;
  z-index: 1;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal {
  text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle="collapse"] ~ div > ul > li > a i,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 8px;
  line-height: 30px;
  opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
  padding: 5px 8px;
}
.sidebar .nav li.active > a,
.sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
  opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a,
.sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar .nav li.active > a[data-toggle="collapse"] >,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] > {
  background-color: transparent;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.sidebar .nav li.active > a[data-toggle="collapse"],
.sidebar .nav li.active > a[data-toggle="collapse"] i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"],
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] i,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #ef8157;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a,
.sidebar .nav li.active > a[data-toggle="collapse"] i + div .nav .active a,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a {
  background-color: transparent;
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a:after {
  content: "";
  position: absolute;
  width: calc(100% - 5px);
  z-index: 0;
}
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav {
  margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
  font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 24px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
  margin-top: 0;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: #ffffff;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 7px 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 0;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 10px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  padding: 11px 0 8px;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:before,
.sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
  display: block;
  content: "";
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
  /* background: #66615B;
    background: -webkit-linear-gradient(#66615B 0%, #000 80%);
    background: -o-linear-gradient(#66615B 0%, #000 80%);
    background: -moz-linear-gradient(#66615B 0%, #000 80%);
    background: linear-gradient(#66615B 0%, #000 80%); */
  z-index: 3;
}
.sidebar[data-color="white"]:after,
.off-canvas-sidebar[data-color="white"]:after {
  background: #ffffff;
}
.sidebar[data-color="white"] .nav li a,
.sidebar[data-color="white"] .nav li a i,
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  .sidebar-mini-icon,
.sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a,
.off-canvas-sidebar[data-color="white"] .nav li a,
.off-canvas-sidebar[data-color="white"] .nav li a i,
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.off-canvas-sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a {
  color: #66615b;
  opacity: 0.7;
}
.sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.sidebar[data-color="white"] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar[data-color="white"] .logo .simple-text,
.off-canvas-sidebar[data-color="white"] .logo .simple-text {
  color: #66615b;
}
.sidebar[data-color="white"] .logo:after,
.off-canvas-sidebar[data-color="white"] .logo:after {
  background-color: #66615b;
  opacity: 0.4;
}
.sidebar[data-color="white"] .user .info a span,
.sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.sidebar[data-color="white"] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color="white"] .user .info a span,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-normal {
  color: #66615b !important;
}
.sidebar[data-color="white"] .user:after,
.off-canvas-sidebar[data-color="white"] .user:after {
  background-color: #66615b;
  opacity: 0.4;
}
.sidebar[data-color="brown"]:after,
.off-canvas-sidebar[data-color="brown"]:after {
  background: #66615b;
}
.sidebar[data-active-color="primary"] .nav li.active > a,
.sidebar[data-active-color="primary"] .nav li.active > a i,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #51cbce;
  opacity: 1;
}
.sidebar[data-active-color="info"] .nav li.active > a,
.sidebar[data-active-color="info"] .nav li.active > a i,
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"] i,
.sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #0fa0cf;
  opacity: 1;
}
.sidebar[data-active-color="success"] .nav li.active > a,
.sidebar[data-active-color="success"] .nav li.active > a i,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #6bd098;
  opacity: 1;
}
.sidebar[data-active-color="warning"] .nav li.active > a,
.sidebar[data-active-color="warning"] .nav li.active > a i,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #fbc658;
  opacity: 1;
}
.sidebar[data-active-color="danger"] .nav li.active > a,
.sidebar[data-active-color="danger"] .nav li.active > a i,
.sidebar[data-active-color="danger"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #ef8157;
  opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #ffffff;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #ffffff;
}

.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: calc(100% - 260px);
  background-color: #eef2f3;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
  padding: 0 30px 30px;
  min-height: calc(100vh - 123px);
  margin-top: 93px;
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar,
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 80px;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 999;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini
    .sidebar
    .sidebar-wrapper
    > .nav
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini
    .sidebar
    .sidebar-wrapper
    .user
    .info
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini
    .sidebar:hover
    .sidebar-wrapper
    > .nav
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini
    .sidebar:hover
    .sidebar-wrapper
    .user
    .info
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
}

.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141e30;
  /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #ffffff;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #ffffff;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

.sidebar .logo .simple-text .logo-img {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  background: #ffffff;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.sidebar .logo .simple-text .logo-img img {
  width: 51%;
  vertical-align: baseline;
  vertical-align: initial;
  height: 55px;
}

.sidebar[data-color="white"] {
  border-right: 1px solid #ddd;
}

.card-timeline .timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
}
.card-timeline .timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #dbdbdb;
  left: 50%;
  margin-left: -1.5px;
}
.card-timeline .timeline .timeline-footer .btn {
  margin: 0;
}
.card-timeline .timeline h6 {
  color: #9a9a9a;
  font-weight: 400;
  margin: 10px 0px 0px;
}
.card-timeline .timeline.timeline-simple:before {
  left: 5%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-panel {
  width: 86%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-badge {
  left: 5%;
}
.card-timeline .timeline > li {
  margin-bottom: 20px;
  position: relative;
}
.card-timeline .timeline > li:before,
.card-timeline .timeline > li:after {
  content: " ";
  display: table;
}
.card-timeline .timeline > li:after {
  clear: both;
}
.card-timeline .timeline > li > .timeline-panel {
  width: 45%;
  float: left;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  background-color: #ffffff;
  color: #2c2c2c;
  margin-bottom: 20px;
  position: relative;
}
.card-timeline .timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #e3e3e3;
  border-right: 0 solid #e3e3e3;
  border-bottom: 15px solid transparent;
  content: " ";
}
.card-timeline .timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #ffffff;
  border-right: 0 solid #ffffff;
  border-bottom: 14px solid transparent;
  content: " ";
}
.card-timeline .timeline > li > .timeline-badge {
  color: #ffffff;
  width: 50px;
  height: 50px;
  text-align: center;
  position: absolute;
  top: 16px;
  left: 50%;
  margin-left: -25px;
  background-color: #9a9a9a;
  z-index: 100;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  border: 3px solid #eef2f3;
}
.card-timeline .timeline > li > .timeline-badge [class^="fa-"],
.card-timeline .timeline > li > .timeline-badge [class*=" fa-"] {
  line-height: inherit;
}
.card-timeline .timeline > li > .timeline-badge .nc-icon {
  line-height: 2.1;
  width: 25px;
  text-align: center;
  font-size: 21px;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel {
  float: right;
  background-color: #fff;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}

.card-timeline .timeline-heading {
  margin-bottom: 15px;
}

.card-timeline .timeline-badge.primary {
  background-color: #0fa0cf !important;
}

.card-timeline .timeline-badge.info {
  background-color: #0fa0cf !important;
}

.card-timeline .timeline-badge.success {
  background-color: #6bd098 !important;
}

.card-timeline .timeline-badge.warning {
  background-color: #fbc658 !important;
}

.card-timeline .timeline-badge.danger {
  background-color: #ef8157 !important;
}

.card-timeline .timeline-title {
  margin-top: 0;
  color: inherit;
}

.card-timeline .timeline-body > p,
.card-timeline .timeline-body > ul {
  margin-bottom: 0;
}

.card-timeline .timeline-body > p + p {
  margin-top: 5px;
}

.card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  border: 0 none;
  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header .card-title {
  margin-top: 10px;
}
.card .map {
  border-radius: 3px;
}
.card .map.map-big {
  height: 400px;
}
.card[data-background-color="orange"] {
  background-color: #51cbce;
}
.card[data-background-color="orange"] .card-header {
  background-color: #51cbce;
}
.card[data-background-color="orange"] .card-footer .stats {
  color: #ffffff;
}
.card[data-background-color="red"] {
  background-color: #ef8157;
}
.card[data-background-color="yellow"] {
  background-color: #fbc658;
}
.card[data-background-color="blue"] {
  background-color: #0fa0cf;
}
.card[data-background-color="green"] {
  background-color: #6bd098;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card .numbers {
  font-size: 2em;
}
.card .big-title {
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  padding-bottom: 15px;
}
.card label {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9a9a9a;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
  top: 0px;
  color: #66615b;
}
.card .card-footer .btn {
  margin: 0;
}
.card.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card.card-plain .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card.card-plain img {
  border-radius: 12px;
}

.card-chart .card-header .card-title {
  margin-top: 10px;
  margin-bottom: 0;
}

.card-chart .card-header .card-category {
  margin-bottom: 5px;
}

.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid #e9ecef;
}

.card-chart .card-progress {
  margin-top: 30px;
}

.card-chart .chart-area {
  height: 190px;
  width: calc(100% + 30px);
  margin-left: -15px;
  margin-right: -15px;
}

.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #9a9a9a;
}

.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}

.map {
  height: 500px;
}

.card-user .image {
  height: 130px;
}
.card-user .image img {
  border-radius: 12px;
}

.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -77px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}

.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 1px solid #ffffff;
  position: relative;
}

.card-user .card-body {
  min-height: 240px;
}

.card-user hr {
  margin: 5px 15px 15px;
}

.card-user .card-body + .card-footer {
  padding-top: 0;
}

.card-user .card-footer h5 {
  font-size: 1.25em;
  margin-bottom: 0;
}

.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}

.card-background {
  background-position: center center;
  background-size: cover;
  text-align: center;
}
.card-background .card-body {
  position: relative;
  z-index: 2;
  min-height: 370px;
  max-width: 530px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 60px;
}
.card-background .card-footer {
  position: relative;
  z-index: 2;
}
.card-background.card-background-product .card-body {
  max-width: 400px;
}
.card-background.card-background-product .card-body .card-title {
  margin-top: 30px;
}
.card-background .stats {
  color: #ffffff;
}
.card-background .card-footer .stats-link > a {
  color: #ffffff;
  line-height: 1.9;
}
.card-background .category,
.card-background .card-description,
.card-background small {
  color: rgba(255, 255, 255, 0.8);
}
.card-background .card-title {
  color: #ffffff;
  margin-top: 130px;
}
.card-background:not(.card-pricing) .btn {
  margin-bottom: 0;
}
.card-background::after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.63);
  border-radius: 6px;
}

.card-collapse {
  padding-bottom: 10px;
}
.card-collapse .card {
  margin-bottom: 0px;
}
.card-collapse .card .card-header {
  position: relative;
  padding: 20px 0;
}
.card-collapse .card .card-header a[data-toggle="collapse"] {
  display: block;
  color: #444;
}
.card-collapse .card .card-header a[data-toggle="collapse"] i {
  float: right;
  position: relative;
  color: #f96332;
  top: 3px;
  right: 5px;
}
.card-collapse .card .card-header:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #e3e3e3;
}
.card-collapse .card .card-body {
  padding: 20px 15px;
}

.card-contributions .card-description {
  max-width: 350px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.card-contributions .card-title {
  padding-top: 35px;
}

.card-contributions .card-stats {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 11px;
}

.card-contributions .card-footer [class*="col-"]:not(:first-child):before {
  content: "";
  position: absolute;
  left: 0;
  width: 1px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.card-contributions .bootstrap-switch {
  margin: 0;
}

.card-contributions span {
  padding-left: 15px;
  text-align: left;
  max-width: 125px;
}

.card .info-area {
  padding: 40px 0 40px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.card-lock .card-header img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-top: -70px;
}

.card-pricing {
  text-align: center;
}
.card-pricing .card-body {
  padding: 15px !important;
}
.card-pricing .card-category {
  margin: 10px 0 10px;
  color: #2c2c2c;
}
.card-pricing .card-icon {
  padding: 15px 0 5px;
  transform: translateY(0%);
  color: #2c2c2c;
}
.card-pricing .card-icon.icon-info {
  color: #0fa0cf;
}
.card-pricing .card-icon.icon-danger {
  color: #ef8157;
}
.card-pricing .card-icon.icon-primary {
  color: #51cbce;
}
.card-pricing .card-icon.icon-success {
  color: #6bd098;
}
.card-pricing .card-icon.icon-warning {
  color: #fbc658;
}
.card-pricing .card-icon i {
  font-size: 40px;
  width: 105px;
  border: 2px solid #ccc;
  border-radius: 50%;
  height: 105px;
  line-height: 105px;
}
.card-pricing .card-title {
  margin-top: 30px !important;
}
.card-pricing ul {
  list-style: none;
  padding: 0;
  max-width: 240px;
  margin: 20px auto;
}
.card-pricing ul li {
  padding: 5px 0;
  list-style-type: none;
}
.card-pricing ul li b {
  font-weight: 600;
  color: #2c2c2c;
}
.card-pricing .btn-neutral {
  color: #66615b;
}
.card-pricing .btn-neutral:hover,
.card-pricing .btn-neutral :focus {
  color: #403d39;
}
.card-pricing.card-background-image ul li {
  color: #ffffff;
  text-align: center;
  border-color: rgba(255, 255, 255, 0.3);
}
.card-pricing.card-background-image ul li b {
  color: #ffffff !important;
}
.card-pricing.card-background-image .card-description {
  color: #ffffff !important;
}
.card-pricing.card-background-image .card-title small {
  color: rgba(255, 255, 255, 0.6);
}

.card-pricing.card-plain .card-category,
.card-pricing.card-plain .card-title {
  color: #2c2c2c;
}

.card-pricing.card-plain ul li b {
  font-weight: 600;
  color: #2c2c2c;
}

.card[data-background="image"] .card-icon i,
.card[data-background="color"] .card-icon i,
.card[data-color] .card-icon i {
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.card-profile {
  margin-top: 30px;
  text-align: center;
}
.card-profile .card-body .card-title {
  margin-top: 0;
}
.card-profile [class*="col-"] .card-description {
  margin-bottom: 0;
}
.card-profile [class*="col-"] .card-description + .card-footer {
  margin-top: 8px;
}
.card-profile .card-header-avatar {
  max-width: 130px;
  max-height: 130px;
  margin: -60px auto 0;
}
.card-profile .card-header-avatar img {
  border-radius: 50% !important;
}
.card-profile .card-header-avatar + .card-body {
  margin-top: 15px;
}
.card-plain.card-profile .card-header-avatar {
  margin-top: 0;
}
.card-profile .card-body .card-avatar {
  margin: 0 auto 30px;
}

.card-signup .header {
  margin-left: 20px;
  margin-right: 20px;
  padding: 30px 0;
}

.card-signup .text-divider {
  margin-top: 30px;
  margin-bottom: 0px;
  text-align: center;
}

.card-signup .content {
  padding: 0px 30px;
}

.card-signup .form-check {
  margin-top: 20px;
}
.card-signup .form-check label {
  margin-left: 7px;
  padding-left: 38px;
}

.card-signup .social-line {
  margin-top: 20px;
  text-align: center;
}
.card-signup .social-line .btn.btn-icon,
.card-signup .social-line .btn.btn-icon .btn-icon {
  margin-left: 5px;
  margin-right: 5px;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}

.card-signup .card-footer {
  margin-bottom: 10px;
  margin-top: 24px;
}

.card-stats-mini.card-background::after {
  background-image: linear-gradient(to right, #434343 0%, black 100%);
  opacity: 0.94;
}

.card-stats-mini .card-body::after {
  clear: both;
  content: "";
  display: block;
}

.card-stats-mini .card-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0 15px;
}

.card-stats-mini.card-background .card-body {
  min-height: auto;
  padding-top: 15px;
  padding-bottom: 15px;
}

.card-stats-mini .card-title {
  margin-top: 0;
  margin-bottom: 5px;
}

.card-stats-mini .info-area {
  text-align: left;
  width: 40%;
  float: left;
  padding: 15px 0;
}
.card-stats-mini .info-area .icon > i {
  font-size: 2em;
}

.card-stats-mini .chart-area {
  float: left;
  width: 60%;
}

.card-stats-mini .stats {
  text-align: left;
  color: #ffffff;
}

.card-contributions hr {
  margin: 5px 15px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  text-align: right;
  font-size: 2em;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-body .numbers .card-category {
  color: #9a9a9a;
  font-size: 15px;
  line-height: 1.4em;
}

.card-stats .card-footer {
  padding: 0px 15px 15px;
}
.card-stats .card-footer .stats {
  color: #9a9a9a;
}
.card-stats .card-footer hr {
  margin-top: 10px;
  margin-bottom: 15px;
}

.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  line-height: 59px;
}

.card-subcategories .card-body {
  padding-bottom: 30px;
}

.card-testimonial {
  margin-top: 30px;
  text-align: center;
}
.card-testimonial .icon {
  padding: 0;
}
.card-testimonial .icon i {
  font-size: 30px;
  border: 0;
  display: block;
  line-height: 100px;
  margin: 0px auto;
  margin-bottom: 0px;
}
.card-testimonial .card-body {
  padding: 15px 30px;
}
.card-testimonial .card-body .card-description {
  font-style: italic;
  font-size: 16px;
}
.card-testimonial .card-body .card-category {
  margin-bottom: 20px;
}
.card-testimonial .card-body + .card-footer {
  padding-top: 0;
  margin-top: -20px;
}
.card-testimonial .card-avatar {
  margin-top: 0;
}
.card-testimonial .card-avatar .img {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
.card-testimonial .card-footer .card-title {
  color: #2c2c2c;
  text-align: center;
}
.card-testimonial .card-footer .card-category {
  color: #9a9a9a;
}
.card-testimonial .card-footer .card-avatar {
  margin-top: 20px;
}
.card-testimonial .card-footer .card-avatar .img {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.card-testimonial .card-description + .card-title {
  margin-top: 30px;
}
.card-testimonial .card-description + .card-title .card-image .img {
  border-radius: 12px;
}
.card-testimonial .card-description + .card-title .card-image .card-title {
  text-align: center;
}

.card-tasks {
  text-align: left;
}
.card-tasks .table tbody td:last-child {
  padding-right: 0;
  display: inline-flex;
}
.card-tasks .table tbody td:last-child .btn {
  padding: 3px;
}
.card-tasks .table tbody td:first-child {
  padding-left: 0;
}
.card-tasks .table tbody td {
  padding: 12px 8px !important;
}
.card-tasks .table-full-width {
  padding-bottom: 0 !important;
}
.card-tasks .card-footer {
  padding-top: 0;
}
.card-tasks .table {
  margin-bottom: 0 !important;
}

.login-page .content .container {
  margin-top: 8vh;
}

.login-page .card-login {
  border-radius: 6px;
  padding-bottom: 0.7rem;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #ffffff;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group-focus
  .input-group-append
  .input-group-text {
  background-color: transparent;
  border-color: #ffffff;
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border.input-group-focus
  .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border.input-group-focus
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}

.login-page .link {
  font-size: 10px;
  color: #ffffff;
  text-decoration: none;
}

.full-page > .content,
.full-page > .footer {
  position: relative;
  z-index: 4;
}

.full-page.section-image {
  position: static;
  position: initial;
}

.full-page > .content {
  padding-top: 21vh;
}

.full-page .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.full-page .footer .container {
  color: #ffffff;
}

.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}

.full-page:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
}

.full-page.pricing-page .description {
  margin-bottom: 65px;
}

.full-page.register-page .content > .container {
  margin-top: 5vh;
}

.full-page.register-page .info-horizontal {
  padding: 0px 0px 20px;
}

.full-page.register-page .info-horizontal {
  text-align: left !important;
}
.full-page.register-page .info-horizontal .icon {
  margin-top: 0;
}
.full-page.register-page .info-horizontal .icon > i {
  font-size: 2em;
}
.full-page.register-page .info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.full-page.register-page .info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.full-page.register-page .info-horizontal .description {
  overflow: hidden;
}

.full-page.lock-page .content > .container {
  margin-top: 10vh;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
  text-transform: capitalize;
  color: #ffffff !important;
}

.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
  border-bottom: 1px solid transparent;
  margin-top: 25px;
}

.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
  color: #ffffff !important;
}

@media screen and (max-width: 991px) {
  .register-page
    .navbar.bg-white
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #66615b !important;
  }
  .register-page
    .navbar.bg-white
    .navbar-collapse
    .navbar-nav
    .nav-item
    .nav-link,
  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
    color: #66615b !important;
  }
  .register-page .navbar.bg-white .navbar-brand,
  .login-page .navbar.bg-white .navbar-brand,
  .lock-page .navbar.bg-white .navbar-brand {
    color: #66615b !important;
  }
  .register-page .navbar.navbar-transparent .navbar-toggle,
  .login-page .navbar.navbar-transparent .navbar-toggle,
  .lock-page .navbar.navbar-transparent .navbar-toggle {
    display: none;
  }
  .register-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .login-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .lock-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab {
    background: #ffffff !important;
  }
}

.section {
  padding: 70px 0;
  position: relative;
  background: #ffffff;
}
.section .row + .category {
  margin-top: 15px;
}

.section-navbars {
  padding-bottom: 0;
}

.section-full-screen {
  height: 100vh;
}

.section-signup {
  padding-top: 20vh;
}

.parallax-s {
  overflow: hidden;
  height: 500px;
  width: 100%;
}

.section-image {
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
}
.section-image .title,
.section-image .card-plain .card-title {
  color: #ffffff;
}
.section-image .nav-pills .nav-link {
  background-color: #ffffff;
}
.section-image .nav-pills .nav-link:hover,
.section-image .nav-pills .nav-link:focus {
  background-color: #ffffff;
}
.section-image .info-title,
.section-image .info-area.info-horizontal .icon i,
.section-image .card-pricing.card-plain ul li {
  color: #ffffff;
}
.section-image .description,
.section-image .info-area .icon:not(.icon-circle) {
  color: rgba(255, 255, 255, 0.8);
}
.section-image .card:not(.card-plain) .info-title {
  color: #2c2c2c;
}
.section-image .card:not(.card-plain) .info-area p,
.section-image .card:not(.card-plain) .info-area .icon,
.section-image .card:not(.card-plain) .description {
  color: #9a9a9a;
}
.section-image .footer {
  color: #ffffff;
}
.section-image .card-plain [class*="text-"],
.section-image .card-plain ul li b {
  color: #ffffff;
}
.section-image .card-plain .category {
  color: rgba(255, 255, 255, 0.5);
}
.section-image:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.7);
}
.section-image .container {
  z-index: 2;
  position: relative;
}

.page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: #ffffff;
  position: relative;
}
.page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #ffffff;
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.page-header .container {
  height: 100%;
  z-index: 1;
}
.page-header .category,
.page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.page-header.page-header-mini {
  min-height: 40vh;
  max-height: 340px;
}
.page-header .title {
  margin-bottom: 15px;
}
.page-header .title + h4 {
  margin-top: 10px;
}
.page-header:after,
.page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}
.page-header:before {
  background-color: rgba(0, 0, 0, 0.3);
}
.page-header[filter-color="orange"] {
  background: rgba(44, 44, 44, 0.2);
  /* For browsers that do not support gradients */
  /* For Safari 5.1 to 6.0 */
  /* For Opera 11.1 to 12.0 */
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    0deg,
    rgba(44, 44, 44, 0.2),
    rgba(224, 23, 3, 0.6)
  );
  /* Standard syntax */
}

.clear-filter:after,
.clear-filter:before {
  display: none;
}

.section-story-overview {
  padding: 50px 0;
}
.section-story-overview .image-container {
  height: 335px;
  position: relative;
  background-position: center center;
  background-size: cover;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.25rem;
}
.section-story-overview .image-container + .category {
  padding-top: 15px;
}
.section-story-overview .image-container.image-right {
  z-index: 2;
}
.section-story-overview .image-container.image-right + h3.title {
  margin-top: 120px;
}
.section-story-overview .image-container.image-left {
  z-index: 1;
}
.section-story-overview .image-container img {
  width: 100%;
  left: 0;
  top: 0;
  height: auto;
  position: absolute;
}
.section-story-overview .image-container:nth-child(2) {
  margin-top: 420px;
  margin-left: -105px;
}
.section-story-overview p.blockquote {
  width: 220px;
  min-height: 180px;
  text-align: left;
  position: absolute;
  top: 376px;
  right: 155px;
  z-index: 0;
}

.section-nucleo-icons .nucleo-container img {
  width: auto;
  left: 0;
  top: 0;
  height: 100%;
  position: absolute;
}

.section-nucleo-icons .nucleo-container {
  height: 335px;
  position: relative;
}

.section-nucleo-icons h5 {
  margin-bottom: 35px;
}

.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 450px;
  height: 300px;
  max-height: 300px;
  margin: 0 auto;
}

.section-nucleo-icons .icons-container i {
  font-size: 34px;
  position: absolute;
  left: 0;
  top: 0;
}

.section-nucleo-icons .icons-container i:nth-child(1) {
  top: 5%;
  left: 7%;
}

.section-nucleo-icons .icons-container i:nth-child(2) {
  top: 28%;
  left: 24%;
}

.section-nucleo-icons .icons-container i:nth-child(3) {
  top: 40%;
}

.section-nucleo-icons .icons-container i:nth-child(4) {
  top: 18%;
  left: 62%;
}

.section-nucleo-icons .icons-container i:nth-child(5) {
  top: 74%;
  left: 3%;
}

.section-nucleo-icons .icons-container i:nth-child(6) {
  top: 36%;
  left: 44%;
  font-size: 65px;
  color: #f96332;
  padding: 1px;
}

.section-nucleo-icons .icons-container i:nth-child(7) {
  top: 59%;
  left: 26%;
}

.section-nucleo-icons .icons-container i:nth-child(8) {
  top: 60%;
  left: 69%;
}

.section-nucleo-icons .icons-container i:nth-child(9) {
  top: 72%;
  left: 47%;
}

.section-nucleo-icons .icons-container i:nth-child(10) {
  top: 88%;
  left: 27%;
}

.section-nucleo-icons .icons-container i:nth-child(11) {
  top: 31%;
  left: 80%;
}

.section-nucleo-icons .icons-container i:nth-child(12) {
  top: 88%;
  left: 68%;
}

.section-nucleo-icons .icons-container i:nth-child(13) {
  top: 5%;
  left: 81%;
}

.section-nucleo-icons .icons-container i:nth-child(14) {
  top: 58%;
  left: 90%;
}

.section-nucleo-icons .icons-container i:nth-child(15) {
  top: 6%;
  left: 40%;
}

.section-images {
  max-height: 670px;
  height: 670px;
}
.section-images .hero-images-container,
.section-images .hero-images-container-1,
.section-images .hero-images-container-2 {
  margin-top: -38vh;
}
.section-images .hero-images-container {
  max-width: 670px;
}
.section-images .hero-images-container-1 {
  max-width: 390px;
  position: absolute;
  top: 55%;
  right: 18%;
}
.section-images .hero-images-container-2 {
  max-width: 225px;
  position: absolute;
  top: 68%;
  right: 12%;
}

[data-background-color="gray"] {
  background-color: #cac7c3;
}

[data-background-color="orange"] {
  background-color: #e95e38;
}

[data-background-color="black"] {
  background-color: #2c2c2c;
}

[data-background-color]:not([data-background-color="gray"]) {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .separator-line {
  background-color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color="gray"])
  .footer.footer-white
  .footer-brand,
[data-background-color]:not([data-background-color="gray"])
  .footer.footer-white
  ul
  li
  > a.nav-link:not(.btn-icon) {
  color: #000;
  color: initial;
}
[data-background-color]:not([data-background-color="gray"])
  .pagination
  .page-item.disabled
  > .page-link {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .category,
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .card-description,
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .category,
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .category {
  color: #9a9a9a;
}
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .card-title,
[data-background-color]:not([data-background-color="gray"])
  .card:not(.card-plain)
  .card-title {
  color: #000;
  color: initial;
}
[data-background-color]:not([data-background-color="gray"])
  .carousel
  .carousel-inner {
  box-shadow: none;
}
[data-background-color]:not([data-background-color="gray"]) .title,
[data-background-color]:not([data-background-color="gray"])
  .social-description
  h2,
[data-background-color]:not([data-background-color="gray"]) p,
[data-background-color]:not([data-background-color="gray"]) p.blockquote,
[data-background-color]:not([data-background-color="gray"]) p.blockquote small,
[data-background-color]:not([data-background-color="gray"]) h1,
[data-background-color]:not([data-background-color="gray"]) h2,
[data-background-color]:not([data-background-color="gray"]) h3,
[data-background-color]:not([data-background-color="gray"]) h4,
[data-background-color]:not([data-background-color="gray"]) h5,
[data-background-color]:not([data-background-color="gray"]) h6,
[data-background-color]:not([data-background-color="gray"])
  a:not(.btn):not(.dropdown-item):not(.card-link),
[data-background-color]:not([data-background-color="gray"]) .icons-container i,
[data-background-color]:not([data-background-color="gray"]).card-pricing ul li,
[data-background-color]:not([data-background-color="gray"])
  .info.info-horizontal
  .icon
  i,
[data-background-color]:not([data-background-color="gray"])
  .card-pricing.card-plain
  ul
  li {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).card
  a:not(.btn):not(.dropdown-item) {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).card
  a:not(.btn):not(.dropdown-item):hover,
[data-background-color]:not([data-background-color="gray"]).card
  a:not(.btn):not(.dropdown-item):focus {
  border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).footer hr,
[data-background-color]:not([data-background-color="gray"]).card-pricing
  .icon
  i,
[data-background-color]:not([data-background-color="gray"]).card-pricing ul li {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
  .card-footer
  .stats
  i,
[data-background-color]:not([data-background-color="gray"]).card-plain
  .category,
[data-background-color]:not([data-background-color="gray"])
  .card-plain
  .category,
[data-background-color]:not([data-background-color="gray"]) .card-header:after {
  color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color="gray"]).card-pricing
  ul
  li
  i,
[data-background-color]:not([data-background-color="gray"]).card-pricing
  ul
  li
  b,
[data-background-color]:not([data-background-color="gray"])
  .card-pricing.card-plain
  ul
  li
  b,
[data-background-color]:not([data-background-color="gray"]) .card-category,
[data-background-color]:not([data-background-color="gray"]) .author span,
[data-background-color]:not([data-background-color="gray"])
  .card-pricing.card-plain
  ul
  li
  i {
  color: rgba(255, 255, 255, 0.8) !important;
}
[data-background-color]:not([data-background-color="gray"]) .separator {
  background-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .navbar.bg-white p {
  color: #66615b;
}
[data-background-color]:not([data-background-color="gray"]) .description,
[data-background-color]:not([data-background-color="gray"])
  .social-description
  p {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color="gray"]) p.blockquote {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
  .checkbox
  label::before,
[data-background-color]:not([data-background-color="gray"])
  .checkbox
  label::after,
[data-background-color]:not([data-background-color="gray"])
  .radio
  label::before,
[data-background-color]:not([data-background-color="gray"])
  .radio
  label::after {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color="gray"])
  .checkbox
  label::after,
[data-background-color]:not([data-background-color="gray"]) .checkbox label,
[data-background-color]:not([data-background-color="gray"]) .radio label {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .checkbox
  input[type="checkbox"]:disabled
  + label,
[data-background-color]:not([data-background-color="gray"])
  .radio
  input[type="radio"]:disabled
  + label {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .radio
  input[type="radio"]:not(:disabled):hover
  + label::after,
[data-background-color]:not([data-background-color="gray"])
  .radio
  input[type="radio"]:checked
  + label::after {
  background-color: #ffffff;
  border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
  .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
  .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"])
  .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color="gray"]) .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .has-success:after,
[data-background-color]:not([data-background-color="gray"]) .has-danger:after {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .has-danger
  .form-control {
  background-color: transparent;
}
[data-background-color]:not([data-background-color="gray"])
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group-append
  .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .input-group-focus
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group-focus
  .input-group-append
  .input-group-text {
  background-color: transparent;
  border-color: #ffffff;
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control:focus,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control:active,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control:focus,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .input-group-append
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border.input-group-focus
  .input-group-append
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border.input-group-focus
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]) .input-group-addon,
[data-background-color]:not([data-background-color="gray"])
  .form-group.no-border
  .input-group-addon,
[data-background-color]:not([data-background-color="gray"])
  .input-group.no-border
  .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color="gray"])
  .subscribe-line
  .form-control {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  color: #2c2c2c;
}
[data-background-color]:not([data-background-color="gray"])
  .subscribe-line
  .form-control:last-child {
  border-left: 0 none;
}
[data-background-color]:not([data-background-color="gray"])
  .subscribe-line
  .input-group-addon,
[data-background-color]:not([data-background-color="gray"])
  .subscribe-line
  .form-group.no-border
  .input-group-addon,
[data-background-color]:not([data-background-color="gray"])
  .subscribe-line
  .input-group.no-border
  .input-group-addon {
  color: #555555;
  border: 1px solid #e3e3e3;
}
[data-background-color]:not([data-background-color="gray"]) .btn.btn-simple {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .btn.btn-simple:hover,
[data-background-color]:not([data-background-color="gray"])
  .btn.btn-simple:hover,
[data-background-color]:not([data-background-color="gray"])
  .btn.btn-simple:focus,
[data-background-color]:not([data-background-color="gray"])
  .btn.btn-simple:active {
  background-color: transparent;
  border-color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"])
  .nav-tabs
  > .nav-item
  > .nav-link
  i.nc-icon {
  color: #ffffff;
}
[data-background-color]:not([data-background-color="gray"]).section-nucleo-icons
  .icons-container
  i:nth-child(6) {
  color: #ffffff;
}

@media screen and (max-width: 991px) {
  .navbar {
    padding: 0;
  }
  .navbar.navbar-absolute {
    padding-top: 0;
  }
  .navbar .navbar-brand {
    font-size: 16px;
    margin-right: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #minimizeSidebar {
    display: none;
  }
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .nav-item:first-child {
    margin-top: 10px;
  }
  .navbar .navbar-nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
    box-shadow: none;
    position: static;
    padding-left: 10px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #ffffff;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus,
  .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #66615b;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #66615b;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 3px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #66615b;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    right: 260px;
    left: auto;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .sidebar,
  .bootstrap-navbar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
  .main-panel {
    width: 100%;
  }
  .timeline:before {
    left: 5% !important;
  }
  .timeline > li > .timeline-badge {
    left: 5% !important;
  }
  .timeline > li > .timeline-panel {
    float: right !important;
    width: 82% !important;
  }
  .timeline > li > .timeline-panel:before {
    border-left-width: 0 !important;
    border-right-width: 15px !important;
    left: -15px !important;
    right: auto !important;
  }
  .timeline > li > .timeline-panel:after {
    border-left-width: 0 !important;
    border-right-width: 14px !important;
    left: -14px !important;
    right: auto !important;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0px 2px;
  }
}

@media screen and (min-width: 768px) {
  .footer .footer-nav {
    padding-left: 21px;
  }
  .footer .credits {
    padding-right: 15px;
  }
}

@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
  }
  .footer .copyright {
    float: right;
    padding-right: 15px;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):before,
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li:before {
    border-right: 17px solid #dddddd;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -16px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):after,
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li:after {
    border-right: 17px solid #eef2f3;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -17px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li
    a:before,
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li
    a:after {
    top: 0;
  }
}

@media screen and (max-width: 768px) {
  .card-stats [class*="col-"] .statistics::after {
    display: none;
  }
  /* .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  } */
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .card .form-horizontal .col-md-3.col-form-label {
    text-align: left;
  }
}

@media screen and (max-width: 767px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0 28px;
  }
  .typography-line {
    padding-left: 23% !important;
  }
  .typography-line span {
    width: 60px !important;
  }
  .login-page .navbar,
  .lock-page .navbar,
  .register-page .navbar {
    padding: 0.5rem 1rem;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto !important;
  }
  .footer .footer-nav {
    margin-bottom: 10px !important;
  }
  .register-page .content {
    padding-top: 5vh;
  }
  .register-page .footer {
    position: relative;
  }
  .register-page .info-area.info-horizontal {
    margin-top: 0;
  }
}

@media screen and (max-width: 374px) {
  .login-page .content {
    padding-top: 10vh;
  }
}

@media screen and (max-width: 413px) {
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
    width: 225px !important;
  }
  .fixed-plugin
    .dropdown.show-dropdown.show
    .dropdown-menu.show[x-placement="top-start"] {
    transform: translate3d(0, 400px, 0) !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
    bottom: 360px !important;
  }
}

@media screen and (max-width: 576px) {
  .navbar[class*="navbar-toggleable-"] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .card-timeline .timeline .timeline-panel {
    width: 38%;
    padding: 15px;
  }
}

.alert .close {
  font-size: 1.8rem;
  font-weight: 300;
}

/*           badges             */
.badge + .badge {
  margin-left: 5px;
}

.btn i,
.navbar .navbar-nav > a.btn i {
  margin-right: 3px;
}

.table not(.btn-group) .btn + .btn,
.table .btn-group + .btn-group {
  margin-left: 4px;
}

.btn + .btn,
.btn-group + .btn-group {
  margin-left: 5px;
}

.card .card-footer .stats i {
  margin-right: 9px;
}

.card .card-footer .legend i {
  margin-right: 4px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
  margin-left: 3px;
}

.login-page .card-login {
  border-radius: 6px;
  padding-bottom: 0.7rem;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #ffffff;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group-focus
  .input-group-append
  .input-group-text {
  background-color: transparent;
  border-color: #ffffff;
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-prepend
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:focus,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control
  + .input-group-append
  .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control:focus
  + .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .form-control:focus
  + .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border
  .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
}
.login-page
  .card-login.card-plain
  .form-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .form-group.no-border.input-group-focus
  .input-group-append
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border.input-group-focus
  .input-group-prepend
  .input-group-text,
.login-page
  .card-login.card-plain
  .input-group.no-border.input-group-focus
  .input-group-append
  .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}

.login-page .link {
  font-size: 10px;
  color: #ffffff;
  text-decoration: none;
}

.full-page {
  align-items: center;
  min-height: 100vh;
  padding: 100px 0 120px;
}
.full-page > .footer {
  position: relative;
  z-index: 4;
}
.full-page .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.full-page .footer .container {
  color: #ffffff;
}
.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
}
.full-page .pricing-page .description {
  margin-bottom: 65px;
}
.full-page .register-page > .container {
  margin-top: 5vh;
}
.full-page .register-page .info-horizontal {
  padding: 0px 0px 20px;
}
.full-page .register-page .info-horizontal {
  text-align: left !important;
}
.full-page .register-page .info-horizontal .icon {
  margin-top: 0;
}
.full-page .register-page .info-horizontal .icon > i {
  font-size: 2em;
}
.full-page .register-page .info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.full-page .register-page .info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.full-page .register-page .info-horizontal .description {
  overflow: hidden;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
  text-transform: capitalize;
  color: #ffffff !important;
}
.register-page .navbar .navbar-collapse .nav-item .nav-link i,
.login-page .navbar .navbar-collapse .nav-item .nav-link i,
.lock-page .navbar .navbar-collapse .nav-item .nav-link i {
  margin-right: 4px;
}

.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
  border-bottom: 1px solid transparent;
  margin-top: 25px;
}

.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
  color: #ffffff !important;
}

.register-page,
.login-page,
.lock-page {
  width: 100%;
}

@media screen and (max-width: 991px) {
  .register-page
    .navbar.bg-white
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #66615b !important;
  }
  .register-page
    .navbar.bg-white
    .navbar-collapse
    .navbar-nav
    .nav-item
    .nav-link,
  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
    color: #66615b !important;
  }
  .register-page .navbar.bg-white .navbar-brand,
  .login-page .navbar.bg-white .navbar-brand,
  .lock-page .navbar.bg-white .navbar-brand {
    color: #66615b !important;
  }
  .register-page .navbar.navbar-transparent .navbar-toggle,
  .login-page .navbar.navbar-transparent .navbar-toggle,
  .lock-page .navbar.navbar-transparent .navbar-toggle {
    display: none;
  }
  .register-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .login-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab,
  .lock-page
    .navbar.navbar-transparent
    .navbar-toggler
    .navbar-toggler-bar.navbar-kebab {
    background: #ffffff !important;
  }
}

.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}
.fileinput input[type="file"] {
  display: none;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #fbc658;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #fbc658;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #ef8157;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #ef8157;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #6bd098;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #6bd098;
}

.input-group-addon:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 3px;
  padding: 0;
}

.picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}

.picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #e3e3e3;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.picture:hover {
  border-color: #2ca8ff;
}

.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}

.picture-src {
  width: 100%;
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 10px;
  padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
  top: 2px;
  right: 10px;
  font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.badge-light {
  border-color: #f5f5f5;
  background-color: #f5f5f5;
  border: 3px solid #ffffff;
}
.fixed-plugin .badge.badge-dark {
  border-color: #2c2c2c;
  background-color: #2c2c2c;
  border: 3px solid #ffffff;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}
.fixed-plugin .badge-blue {
  background-color: #0fa0cf;
}
.fixed-plugin .badge-green {
  background-color: #6bd098;
}
.fixed-plugin .badge-orange {
  background-color: #51cbce;
}
.fixed-plugin .badge-yellow {
  background-color: #fbc658;
}
.fixed-plugin .badge-red {
  background-color: #ef8157;
}
.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 15px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 35px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3c4858;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.7142em;
  color: #66615b;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #fff;
  border: 3px solid #fff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -27px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #ffffff;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -26px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 16px;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
  transform: translate3d(0, -60px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"] {
  transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:before,
.fixed-plugin .show-dropdown .dropdown-menu[x-placement="bottom-start"]:after {
  top: 100px;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement="top-start"] {
  transform: translate3d(0, 100px, 0) !important;
}

.fixed-plugin
  .show-dropdown.show
  .dropdown-menu.show[x-placement="bottom-start"] {
  transform: translate3d(0, -60px, 0) !important;
}

.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement="top-start"] {
  transform: translate3d(0, 470px, 0) !important;
}

.form-control {
  height: auto;
  height: initial;
}

.form-group input[type="file"] {
  opacity: 1;
  position: static;
  position: initial;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  height: initial;
  z-index: auto;
  z-index: initial;
}

.modal-footer .left-side,
.modal-footer .right-side {
  display: flex;
  flex: 1 1;
  text-align: center;
  width: auto;
  width: initial;
  padding: 5px;
}

.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 7px;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* all icon font classes list here */
/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
  margin-left: 0;
}

.nav-pills .nav-item .nav-link {
  border: 1px solid #66615b;
  border-radius: 0;
  color: #66615b;
  font-weight: 700;
  margin-left: -1px;
  padding: 10px 25px;
}

.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
  background-color: #66615b;
  color: #ffffff;
}

.nav-pills:not(.flex-column) .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px !important;
  margin: 0;
}

.nav-pills:not(.flex-column) .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0 !important;
}

.nav-pills.flex-column .nav-item .nav-link {
  border-radius: 30px !important;
  margin-bottom: 15px;
}

.nav-pills .nav-item .nav-link.active {
  background-color: #66615b;
  color: #ffffff;
}

.nav-pills-primary .nav-item .nav-link {
  border: 1px solid #51cbce;
  color: #51cbce;
}
.nav-pills-primary .nav-item .nav-link.active {
  border: 1px solid #51cbce;
  background: #51cbce;
  color: #ffffff;
}

.nav-pills-danger .nav-item .nav-link {
  border: 1px solid #ef8157;
  color: #ef8157;
}
.nav-pills-danger .nav-item .nav-link.active {
  border: 1px solid #ef8157;
  background: #ef8157;
  color: #ffffff;
}

.nav-pills-info .nav-item .nav-link {
  border: 1px solid #0fa0cf;
  color: #0fa0cf;
}
.nav-pills-info .nav-item .nav-link.active {
  border: 1px solid #0fa0cf;
  background: #0fa0cf;
  color: #ffffff;
}

.nav-pills-success .nav-item .nav-link {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.nav-pills-success .nav-item .nav-link.active {
  border: 1px solid #6bd098;
  background: #6bd098;
  color: #ffffff;
}

.nav-pills-warning .nav-item .nav-link {
  border: 1px solid #fbc658;
  color: #fbc658;
}
.nav-pills-warning .nav-item .nav-link.active {
  border: 1px solid #fbc658;
  background: #fbc658;
  color: #ffffff;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
  background-color: #66615b !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
  background-color: #51cbce !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
  background-color: #0fa0cf !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
  background-color: #fbc658 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
  background-color: #6bd098 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
  background-color: #ef8157 !important;
}

@media screen and (max-width: 991px) {
  .navbar {
    padding: 0;
  }
  .navbar.navbar-absolute {
    padding-top: 0;
  }
  .navbar .navbar-brand {
    font-size: 16px;
    margin-right: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #minimizeSidebar {
    display: none;
  }
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .nav-item:first-child {
    margin-top: 10px;
  }
  .navbar .navbar-nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block !important;
    transform: translate3d(0px, 0px, 0px) !important;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
    box-shadow: none;
    position: static !important;
    padding-left: 10px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #ffffff;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus,
  .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #66615b;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #66615b;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 3px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #66615b;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    left: auto;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .sidebar,
  .bootstrap-navbar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
  .main-panel {
    width: 100%;
  }
  .timeline:before {
    left: 5% !important;
  }
  .timeline > li > .timeline-badge {
    left: 5% !important;
  }
  .timeline > li > .timeline-panel {
    float: right !important;
    width: 82% !important;
  }
  .timeline > li > .timeline-panel:before {
    border-left-width: 0 !important;
    border-right-width: 15px !important;
    left: -15px !important;
    right: auto !important;
  }
  .timeline > li > .timeline-panel:after {
    border-left-width: 0 !important;
    border-right-width: 14px !important;
    left: -14px !important;
    right: auto !important;
  }
  .fixed-plugin {
    width: 54px;
  }
  .fixed-plugin .dropdown-menu {
    max-width: 230px;
    right: 80px;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0px 2px;
  }
}

@media screen and (min-width: 768px) {
  .footer .footer-nav {
    padding-left: 21px;
  }
  .footer .credits {
    padding-right: 15px;
  }
}

@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
  }
  .footer .copyright {
    float: right;
    padding-right: 15px;
  }
  .sidebar
    .sidebar-wrapper
    li
    > [data-toggle="collapse"]
    + div
    .nav
    li.active
    a:before {
    top: -2px;
  }
  .sidebar
    .sidebar-wrapper
    li
    > [data-toggle="collapse"]
    + div
    .nav
    li.active
    a:after {
    top: -1px;
  }
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li:before,
  .sidebar
    .sidebar-wrapper
    li.active
    > [data-toggle="collapse"]
    + div
    .nav
    li:after {
    display: none !important;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):before {
    border-right: 18px solid #dddddd;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -15px;
    opacity: 1;
    top: 6px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle="collapse"]):after {
    border-right: 17px solid #eef2f3;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -15px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
}

@media screen and (max-width: 768px) {
  .card-stats [class*="col-"] .statistics::after {
    display: none;
  }
  /* .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  } */
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .card .form-horizontal .col-md-3.col-form-label {
    text-align: left;
  }
}

@media screen and (max-width: 767px) {
  .typography-line {
    padding-left: 23% !important;
  }
  .typography-line span {
    width: 60px !important;
  }
  .login-page .navbar,
  .lock-page .navbar,
  .register-page .navbar {
    padding: 0.5rem 1rem;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto !important;
  }
  .footer .footer-nav {
    margin-bottom: 10px !important;
  }
  .register-page .content {
    padding-top: 5vh;
  }
  .register-page .footer {
    position: relative;
  }
  .register-page .info-area.info-horizontal {
    margin-top: 0;
  }
}

@media screen and (max-width: 413px) {
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
    width: 225px !important;
  }
  .fixed-plugin
    .dropdown.show-dropdown.show
    .dropdown-menu.show[x-placement="top-start"] {
    transform: translate3d(0, 400px, 0) !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
    bottom: 360px !important;
  }
}

@media screen and (max-width: 576px) {
  .navbar[class*="navbar-toggleable-"] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .card-timeline .timeline .timeline-panel {
    width: 38%;
    padding: 15px;
  }
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
  overflow-x: hidden;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar,
.off-canvas-sidebar {
  position: fixed;
  top: 0;
  height: 100%;
  bottom: 0;
  width: 260px;
  left: 0;
  z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  position: relative;
  height: calc(100vh - 75px);
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  span {
  display: inline-block;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 20px;
  z-index: 1;
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal {
  text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle="collapse"] ~ div > ul > li > a i,
.sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i,
.off-canvas-sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i,
.off-canvas-sidebar
  .sidebar-wrapper
  .user
  .info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 8px;
  line-height: 30px;
  opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
  padding: 5px 8px;
}
.sidebar .nav li.active > a,
.sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
  opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a,
.sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar .nav li.active > a[data-toggle="collapse"] >,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] > {
  background-color: transparent;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.sidebar .nav li.active > a[data-toggle="collapse"],
.sidebar .nav li.active > a[data-toggle="collapse"] i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active i,
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"],
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] i,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #ef8157;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a,
.sidebar .nav li.active > a[data-toggle="collapse"] i + div .nav .active a,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a {
  background-color: transparent;
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle="collapse"] + div .nav .active a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a:after,
.sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  i
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  i
  + div
  .nav
  .active
  a:after,
.off-canvas-sidebar
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a
  + div
  .nav
  .active
  a:after {
  content: "";
  position: absolute;
  width: calc(100% - 5px);
  z-index: 0;
}
.sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle="collapse"] ~ div > .nav {
  margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
  font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 24px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
  margin-top: 0;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: #ffffff;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 7px 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 0;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 12px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  padding: 11px 0 8px;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:before,
.sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
  display: block;
  content: "";
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
  /* background: #66615B;
    background: -webkit-linear-gradient(#66615B 0%, #000 80%);
    background: -o-linear-gradient(#66615B 0%, #000 80%);
    background: -moz-linear-gradient(#66615B 0%, #000 80%);
    background: linear-gradient(#66615B 0%, #000 80%); */
  z-index: 3;
}
.sidebar[data-color="white"]:after,
.off-canvas-sidebar[data-color="white"]:after {
  background: #ffffff;
}
.sidebar[data-color="white"] .nav li a,
.sidebar[data-color="white"] .nav li a i,
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  .sidebar-mini-icon,
.sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a,
.off-canvas-sidebar[data-color="white"] .nav li a,
.off-canvas-sidebar[data-color="white"] .nav li a i,
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"],
.off-canvas-sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i,
.off-canvas-sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"]
  .nav
  li
  a[data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a {
  color: #66615b;
  opacity: 0.7;
}
.sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.sidebar[data-color="white"] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color="white"] .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar[data-color="white"] .logo .simple-text,
.off-canvas-sidebar[data-color="white"] .logo .simple-text {
  color: #66615b;
}
.sidebar[data-color="white"] .logo:after,
.off-canvas-sidebar[data-color="white"] .logo:after {
  background-color: #66615b;
  opacity: 0.4;
}
.sidebar[data-color="white"] .user .info a span,
.sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.sidebar[data-color="white"] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color="white"] .user .info a span,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color="white"] .user .nav .sidebar-normal {
  color: #66615b !important;
}
.sidebar[data-color="white"] .user:after,
.off-canvas-sidebar[data-color="white"] .user:after {
  background-color: #66615b;
  opacity: 0.4;
}
.sidebar[data-color="brown"]:after,
.off-canvas-sidebar[data-color="brown"]:after {
  background: #66615b;
}
.sidebar[data-active-color="primary"] .nav li.active > a,
.sidebar[data-active-color="primary"] .nav li.active > a i,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="primary"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="primary"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #51cbce;
  opacity: 1;
}
.sidebar[data-active-color="info"] .nav li.active > a,
.sidebar[data-active-color="info"] .nav li.active > a i,
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="info"] .nav li.active > a[data-toggle="collapse"] i,
.sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="info"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="info"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #0fa0cf;
  opacity: 1;
}
.sidebar[data-active-color="success"] .nav li.active > a,
.sidebar[data-active-color="success"] .nav li.active > a i,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="success"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="success"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #6bd098;
  opacity: 1;
}
.sidebar[data-active-color="warning"] .nav li.active > a,
.sidebar[data-active-color="warning"] .nav li.active > a i,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="warning"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="warning"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #fbc658;
  opacity: 1;
}
.sidebar[data-active-color="danger"] .nav li.active > a,
.sidebar[data-active-color="danger"] .nav li.active > a i,
.sidebar[data-active-color="danger"] .nav li.active > a[data-toggle="collapse"],
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a,
.off-canvas-sidebar[data-active-color="danger"] .nav li.active > a i,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"],
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  i,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color="danger"]
  .nav
  li.active
  > a[data-toggle="collapse"]
  ~ div
  > ul
  > li.active
  > a {
  color: #ef8157;
  opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 12px;
  border-radius: 50%;
  margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #ffffff;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #ffffff;
}

.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  background-color: #eef2f3;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
  padding: 0 30px 30px;
  min-height: calc(100vh - 123px);

  margin-top: 93px;
}
.main-panel > .map-content {
  min-height: calc(100vh - 123px);
  margin-top: 63px;
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar,
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 80px;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 999;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini
    .sidebar
    .sidebar-wrapper
    > .nav
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini
    .sidebar
    .sidebar-wrapper
    .user
    .info
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini
    .sidebar:hover
    .sidebar-wrapper
    > .nav
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini
    .sidebar:hover
    .sidebar-wrapper
    .user
    .info
    [data-toggle="collapse"]
    ~ div
    > ul
    > li
    > a
    .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
}

.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141e30;
  /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #ffffff;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #ffffff;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

.sidebar .logo .simple-text .logo-img {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  background: #ffffff;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.sidebar .logo .simple-text .logo-img img {
  width: 51%;
  vertical-align: baseline;
  vertical-align: initial;
  height: 51%;
}

.sidebar[data-color="white"] {
  border-right: 1px solid #ddd;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
  text-align: center;
  border-bottom: 1px solid #f1eae0;
  margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
  padding-bottom: 20px;
}

.nav-tabs-wrapper {
  display: inline-block;
  margin-bottom: -6px;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.nav-tabs {
  justify-content: center;
  border-bottom: 0 none;
  font-size: 14px;
  font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
  border: 0 none;
  color: #a49e93;
  background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
  color: #66615b;
}
.nav-tabs .nav-item .nav-link.active {
  color: #66615b;
}
.nav-tabs .nav-item {
  color: #66615b;
  position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
  background-color: transparent;
  border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: -6px;
  margin-left: -46px;
  border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
  color: #ffffff;
  background-color: #68b3c8;
}
.nav-tabs .dropdown-menu :before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.nav-tabs .dropdown-menu :after {
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -10px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}

.profile-content .tab-content #tweets,
.profile-content .tab-content #connections,
.profile-content .tab-content #media {
  height: 100%;
}

.nav-text,
.nav-icons {
  margin: 0 0 10px 0;
}
.nav-text > li > a,
.nav-icons > li > a {
  display: block;
  padding: 0px 0.7rem;
  color: #9a9a9a;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text > li > a:hover,
.nav-text > li > a:focus,
.nav-icons > li > a:hover,
.nav-icons > li > a:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text > li:first-child a,
.nav-icons > li:first-child a {
  padding-left: 0;
}
.nav-text > li.active a,
.nav-icons > li.active a {
  color: #0fa0cf;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.714em;
  margin-bottom: 10px;
  width: 1.714em;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #51cbce;
}

.nav-azure > li.active a {
  color: #0fa0cf;
}

.nav-green > li.active a {
  color: #6bd098;
}

.nav-orange > li.active a {
  color: #fbc658;
}

.nav-red > li.active a {
  color: #ef8157;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 1em;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 600;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}

.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-space {
  padding: 20px 0 50px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active:focus:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
  border-right: 11px solid #f1eae0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active:focus:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
  border-right: 11px solid #ffffff;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: -1px;
  bottom: 20px;
}

#second-tabs {
  margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
  border-right: 1px solid #f1eae0;
  font-size: 16px;
  border-bottom: none;
}

.card-timeline .timeline h6 i {
  margin-right: 4px;
}

/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */
/* Functional styling;
* These styles are required for noUiSlider to function.
* You don't need to change these rules to apply your design.
*/
/*

This file was modified by Creative-Tim

*/
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
*/
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform-origin: 0 0;
}

/* Offset direction
*/
html:not([dir="rtl"]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
* connect elements.
*/
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  position: absolute;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
*/
.noUi-horizontal {
  height: 8px;
}

.noUi-horizontal .noUi-handle {
  background: #fff;
  background: linear-gradient(180deg, #fff 0, #f1f1f2);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="\$white-color",endColorstr="#f1f1f2",GradientType=0);
  border-radius: 50%;
  box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -4px;
}

.noUi-vertical {
  width: 8px;
}

.noUi-vertical .noUi-handle {
  background: #fff;
  background: linear-gradient(180deg, #fff 0, #f1f1f2);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="\$white-color",endColorstr="#f1f1f2",GradientType=0);
  border-radius: 50%;
  box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  width: 15px;
  height: 15px;
  left: -4px;
  top: -10px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
  right: -5px;
  left: auto;
}

/* Styling;
* Giving the connect element a border radius causes issues with using transform: scale
*/
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #888;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
*/
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}
.noUi-handle:focus {
  outline: none;
}

.noUi-active {
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}

/* Disabled state;
*/
[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
*
*/
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
*
*/
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
*
*/
.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  background: #aaa;
}

.noUi-marker-large {
  background: #aaa;
}

/* Horizontal layout;
*
*/
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
*
*/
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-neutral .noUi-connect,
.slider.slider-neutral.noUi-connect {
  background-color: #ffffff;
}

.slider.slider-neutral.noUi-target {
  background-color: rgba(255, 255, 255, 0.3);
}

.slider.slider-neutral .noUi-handle {
  background-color: #ffffff;
}

.slider.slider-primary .noUi-connect,
.slider.slider-primary.noUi-connect {
  background-color: #51cbce;
}

.slider.slider-info .noUi-connect,
.slider.slider-info.noUi-connect {
  background-color: #0fa0cf;
}

.slider.slider-success .noUi-connect,
.slider.slider-success.noUi-connect {
  background-color: #6bd098;
}

.slider.slider-warning .noUi-connect,
.slider.slider-warning.noUi-connect {
  background-color: #fbc658;
}

.slider.slider-danger .noUi-connect,
.slider.slider-danger.noUi-connect {
  background-color: #ef8157;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #333333;
  opacity: 0.3;
}

.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: right;
  vertical-align: middle;
  font-weight: bold;
  font-size: 1em;
  min-height: 0;
  border-bottom: 1px solid #ddd;
  color: #999999;
}
.rbc-header:last-child span {
  padding-right: 15px;
}

.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
  min-height: 153px;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  font-family: inherit;
  line-height: 1.5em;
  color: inherit;
  font-weight: 500;
  margin: 0;
  font-size: 2.5em;
}

.rbc-toolbar button {
  background-color: #66615b;
  color: #ffffff;
  border-width: 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 5px 1px;
  border: none;
  margin: 10px 1px;
  border-radius: 30px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
}
.rbc-toolbar button:hover,
.rbc-toolbar button:focus,
.rbc-toolbar button:active,
.rbc-toolbar button.active,
.rbc-toolbar button:active:focus,
.rbc-toolbar button:active:hover,
.rbc-toolbar button.active:focus,
.rbc-toolbar button.active:hover,
.show > .rbc-toolbar button.dropdown-toggle,
.show > .rbc-toolbar button.dropdown-toggle:focus,
.show > .rbc-toolbar button.dropdown-toggle:hover {
  background-color: #403d39 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.rbc-toolbar button:not([data-action]):hover {
  box-shadow: none;
}
.rbc-toolbar button.disabled,
.rbc-toolbar button.disabled:hover,
.rbc-toolbar button.disabled:focus,
.rbc-toolbar button.disabled.focus,
.rbc-toolbar button.disabled:active,
.rbc-toolbar button.disabled.active,
.rbc-toolbar button:disabled,
.rbc-toolbar button:disabled:hover,
.rbc-toolbar button:disabled:focus,
.rbc-toolbar button:disabled.focus,
.rbc-toolbar button:disabled:active,
.rbc-toolbar button:disabled.active,
.rbc-toolbar button[disabled],
.rbc-toolbar button[disabled]:hover,
.rbc-toolbar button[disabled]:focus,
.rbc-toolbar button[disabled].focus,
.rbc-toolbar button[disabled]:active,
.rbc-toolbar button[disabled].active,
fieldset[disabled] .rbc-toolbar button,
fieldset[disabled] .rbc-toolbar button:hover,
fieldset[disabled] .rbc-toolbar button:focus,
fieldset[disabled] .rbc-toolbar button.focus,
fieldset[disabled] .rbc-toolbar button:active,
fieldset[disabled] .rbc-toolbar button.active {
  background-color: #66615b;
  border-color: #66615b;
}
.rbc-toolbar button.btn-simple {
  color: #66615b;
  border-color: #66615b;
}
.rbc-toolbar button.btn-simple:hover,
.rbc-toolbar button.btn-simple:focus,
.rbc-toolbar button.btn-simple:active {
  background-color: transparent;
  color: #403d39;
  border-color: #403d39;
  box-shadow: none;
}
.rbc-toolbar button.btn-link {
  color: #66615b;
}
.rbc-toolbar button.btn-link:hover,
.rbc-toolbar button.btn-link:focus,
.rbc-toolbar button.btn-link:active,
.rbc-toolbar button.btn-link:active:focus {
  background-color: transparent;
  color: #403d39;
  text-decoration: none;
  box-shadow: none;
}

.rbc-toolbar button:focus {
  outline: none;
}

.rbc-btn-group {
  display: inline-block;
}

.rbc-btn-group button {
  margin: 0 0 0 2px;
  border-radius: 30px;
}

@media screen and (max-width: 526px) {
  .rbc-btn-group button {
    margin: 2px !important;
  }
}

.rbc-btn-group button + button {
  margin: 0 0 0 2px;
  border-radius: 30px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}

.rbc-event.rbc-selected {
  background-color: #265985;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 2px 6px 1px;
}

.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
  border-left: none;
  border-right: none;
}

.rbc-month-view {
  border-top: none;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  -ms-flex-preferred-size: 0px;
  overflow: hidden;
  height: 100%;
}

.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #ddd;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-left: 5px;
  text-align: left;
}

.rbc-date-cell.rbc-now {
  font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}

.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #ddd;
  border-spacing: 0;
  border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #ddd;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}

.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 10px;
  top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}

.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}

.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
  font-weight: bold;
  box-sizing: content-box;
  color: #fff;
  white-space: nowrap;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
  border-top: 1px dotted #ddd;
}

.rbc-time-slot {
  flex: 1 0;
}

.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #ddd;
  min-height: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  position: relative;
}

.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}

.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #ddd;
}

.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header-content {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #ddd;
  overflow-y: auto;
  position: relative;
}

.rbc-time-content > .rbc-time-gutter {
  flex: none;
}

.rbc-time-content > * + * > * {
  border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-event {
  width: 100%;
  position: relative;
  /* for resize handle and other inner positioning */
  display: block;
  /* make the <a> tag block */
  font-size: 0.85em;
  border-radius: 2px;
  padding: 0;
  background-color: rgba(81, 203, 206, 0.2);
  /* default BACKGROUND color */
  font-weight: normal;
  /* undo jqui's ui-widget-header bold */
  text-align: left;
  border: none;
  padding-bottom: 1px;
  line-height: 1.2;
}
.rbc-event.event-azure {
  background-color: rgba(81, 188, 218, 0.2);
}
.rbc-event.event-green {
  background-color: rgba(107, 208, 152, 0.2);
}
.rbc-event.event-orange {
  background-color: rgba(251, 198, 88, 0.2);
}
.rbc-event.event-red {
  background-color: rgba(239, 129, 87, 0.2);
}
.rbc-event .rbc-event-content {
  position: relative;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  padding: 0 5px;
}

.rbc-day-slot .rbc-event {
  display: block !important;
  height: auto !important;
  height: initial !important;
  max-height: none !important;
  max-height: initial !important;
}

.rbc-today {
  background-color: #f5f5f5;
}

@media screen and (max-width: 1373px) {
  .rbc-toolbar {
    display: block;
  }
  .rbc-toolbar .rbc-btn-group {
    display: block;
    text-align: center;
  }
  .rbc-toolbar .rbc-toolbar-label {
    display: block;
    flex-grow: initial;
    padding: 0;
  }
}

.sweet-alert:focus {
  outline: none;
}

.sweet-alert {
  margin: auto !important;
}

.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #66615b;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #7a9e9f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #68b3c8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #7ac29a;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #f3bb45;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #eb5e28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
  background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type="radio"],
.bootstrap-switch input[type="checkbox"] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type="radio"].form-control,
.bootstrap-switch input[type="checkbox"].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
  background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
  background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #eb5e28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #f3bb45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #7ac29a;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #7a9e9f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #68b3c8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #66615b;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

.bootstrap-switch.wrapper {
  min-height: auto;
  height: auto;
}

.card-wizard {
  min-height: 410px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  opacity: 0;
  transition: all 300ms linear;
}
.card-wizard[data-color="primary"] .moving-tab {
  color: #51cbce;
}
.card-wizard[data-color="primary"] .picture:hover {
  border-color: #51cbce;
}
.card-wizard[data-color="primary"] .choice:hover .icon,
.card-wizard[data-color="primary"] .choice.active .icon {
  border-color: #51cbce;
  color: #51cbce;
}
.card-wizard[data-color="primary"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #51cbce;
}
.card-wizard[data-color="primary"] .radio input[type="radio"]:checked ~ .check {
  background-color: #51cbce;
}
.card-wizard[data-color="primary"]
  .radio
  input[type="radio"]:checked
  ~ .circle {
  border-color: #51cbce;
}
.card-wizard[data-color="white"] .moving-tab {
  color: #ffffff;
}
.card-wizard[data-color="white"] .picture:hover {
  border-color: #ffffff;
}
.card-wizard[data-color="white"] .choice:hover .icon,
.card-wizard[data-color="white"] .choice.active .icon {
  border-color: #ffffff;
  color: #ffffff;
}
.card-wizard[data-color="white"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .check {
  background-color: #ffffff;
}
.card-wizard[data-color="white"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #ffffff;
}
.card-wizard[data-color="green"] .moving-tab {
  color: #6bd098;
}
.card-wizard[data-color="green"] .picture:hover {
  border-color: #6bd098;
}
.card-wizard[data-color="green"] .choice:hover .icon,
.card-wizard[data-color="green"] .choice.active .icon {
  border-color: #6bd098;
  color: #6bd098;
}
.card-wizard[data-color="green"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #6bd098;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .check {
  background-color: #6bd098;
}
.card-wizard[data-color="green"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #6bd098;
}
.card-wizard[data-color="blue"] .moving-tab {
  color: #0fa0cf;
}
.card-wizard[data-color="blue"] .picture:hover {
  border-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .choice:hover .icon,
.card-wizard[data-color="blue"] .choice.active .icon {
  border-color: #0fa0cf;
  color: #0fa0cf;
}
.card-wizard[data-color="blue"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .check {
  background-color: #0fa0cf;
}
.card-wizard[data-color="blue"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #0fa0cf;
}
.card-wizard[data-color="orange"] .moving-tab {
  color: #fbc658;
}
.card-wizard[data-color="orange"] .picture:hover {
  border-color: #fbc658;
}
.card-wizard[data-color="orange"] .choice:hover .icon,
.card-wizard[data-color="orange"] .choice.active .icon {
  border-color: #fbc658;
  color: #fbc658;
}
.card-wizard[data-color="orange"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #fbc658;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .check {
  background-color: #fbc658;
}
.card-wizard[data-color="orange"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #fbc658;
}
.card-wizard[data-color="red"] .moving-tab {
  color: #ef8157;
}
.card-wizard[data-color="red"] .picture:hover {
  border-color: #ef8157;
}
.card-wizard[data-color="red"] .choice:hover .icon,
.card-wizard[data-color="red"] .choice.active .icon {
  border-color: #ef8157;
  color: #ef8157;
}
.card-wizard[data-color="red"]
  .checkbox
  input[type="checkbox"]:checked
  + .checkbox-material
  .check {
  background-color: #ef8157;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .check {
  background-color: #ef8157;
}
.card-wizard[data-color="red"] .radio input[type="radio"]:checked ~ .circle {
  border-color: #ef8157;
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
  background-color: transparent;
}
.card-wizard .card-header .card-title {
  color: #252422;
}
.card-wizard .card-header .card-title + .description {
  color: #9a9a9a;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .moving-tab i {
  margin-right: 9px;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #e3e3e3;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 12px;
  font-size: 12px;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #66615b;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #ffffff !important;
  cursor: pointer;
  font-weight: 500;
}
.card-wizard .picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #66615b;
  margin: 0 auto 20px;
  border: 1px solid #e3e3e3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon,
.card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type="radio"],
.card-wizard .choice input[type="checkbox"] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #9a9a9a;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #ffffff !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0) !important;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #ffffff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive,
.rdtDay.rdtActive,
.rdtDay.rdtActive:hover {
  background-color: #51cbce !important;
  color: #ffffff;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
}

.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #dddddd;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #51cbce;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  /* Konqueror */
  /* Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}

.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #51cbce;
  border-radius: 50%;
  border: 1px solid #51cbce;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #dddddd;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  /* Konqueror */
  /* Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #51cbce !important;
  color: #ffffff;
}

svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #cdcdcd;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat
    url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select .react-select__menu {
  top: 105%;
  max-width: 94%;
  width: 94%;
  right: 3%;
  border-radius: 12px;
  border: 0;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,
    opacity 0.3s ease 0s, height 0s linear 0.35s;
  background-color: #ffffff;
  box-sizing: border-box;
  max-height: 200px;
  position: absolute;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  margin-bottom: 0;
  margin-bottom: initial;
  margin-top: 0;
  margin-top: initial;
}
.react-select .react-select__menu:before {
  border-bottom: 11px solid #f1eae0;
  top: -11px;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}
.react-select .react-select__menu:after {
  top: -10px;
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}

.react-select .react-select__menu-list {
  max-height: 198px;
  overflow-y: auto;
  padding-bottom: 0;
  padding-bottom: initial;
  padding-top: 0;
  padding-top: initial;
  position: relative;
}

.react-select .react-select__option {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: block;
  outline: none;
  color: #292b2c;
}

.react-select .react-select__menu .react-select__option,
.react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}

.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-selected,
.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-selected:active,
.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-selected.react-select__option--is-focused,
.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {
  background-color: #dddddd;
}

.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-focused,
.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-focused:active {
  background-color: #f5f5f5;
}

.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-disabled,
.react-select
  .react-select__menu
  .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}

.react-select .react-select__control {
  border-radius: 4px;
  min-height: 40px;
  height: 40px;
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control,
.react-select .react-select__control:hover {
  border: 1px solid #e3e3e3;
  box-shadow: none;
  background-color: transparent;
}
.react-select
  .react-select__control.react-select__control--is-focused
  .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused,
.react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #51cbce;
  box-shadow: none;
}
.react-select
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value {
  display: inline-flex;
  border-radius: 4px;
  background-color: transparent;
}
.react-select
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value
  + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value
  .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value {
  top: 48%;
  color: #2c2c2c;
}
.react-select .react-select__control .react-select__placeholder {
  color: #9a9a9a;
  line-height: normal;
  font-size: 0.8571em;
  top: 48%;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__indicator-separator {
  display: none;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__dropdown-indicator
  > * {
  display: none;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__clear-indicator:before {
  content: "\\D7";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select
  .react-select__control
  .react-select__indicators
  .react-select__clear-indicator
  > * {
  display: none;
}

.react-select.primary .react-select__control.react-select__control--is-focused,
.react-select.primary
  .react-select__control.react-select__control--is-focused:hover {
  border-color: #51cbce;
}

.react-select.primary
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value,
.react-select.primary
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value__label {
  color: #51cbce;
}

.react-select.primary .react-select__multi-value {
  border: 1px solid #51cbce;
}
.react-select.primary
  .react-select__multi-value
  .react-select__multi-value__remove {
  color: rgba(249, 99, 50, 0.3);
  border-left: 1px solid rgba(249, 99, 50, 0.3);
}
.react-select.primary
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #51cbce;
  background-color: transparent;
}

.react-select.success .react-select__control.react-select__control--is-focused,
.react-select.success
  .react-select__control.react-select__control--is-focused:hover {
  border-color: #6bd098;
}

.react-select.success
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value,
.react-select.success
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value__label {
  color: #6bd098;
}

.react-select.success .react-select__multi-value {
  border: 1px solid #6bd098;
}
.react-select.success
  .react-select__multi-value
  .react-select__multi-value__remove {
  color: rgba(24, 206, 15, 0.3);
  border-left: 1px solid rgba(24, 206, 15, 0.3);
}
.react-select.success
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #6bd098;
  background-color: transparent;
}

.react-select.info .react-select__control.react-select__control--is-focused,
.react-select.info
  .react-select__control.react-select__control--is-focused:hover {
  border-color: #0fa0cf;
}

.react-select.info
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value,
.react-select.info
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value__label {
  color: #0fa0cf;
}

.react-select.info .react-select__multi-value {
  border: 1px solid #0fa0cf;
}
.react-select.info
  .react-select__multi-value
  .react-select__multi-value__remove {
  color: rgba(44, 168, 255, 0.3);
  border-left: 1px solid rgba(44, 168, 255, 0.3);
}
.react-select.info
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #0fa0cf;
  background-color: transparent;
}

.react-select.warning .react-select__control.react-select__control--is-focused,
.react-select.warning
  .react-select__control.react-select__control--is-focused:hover {
  border-color: #fbc658;
}

.react-select.warning
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value,
.react-select.warning
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value__label {
  color: #fbc658;
}

.react-select.warning .react-select__multi-value {
  border: 1px solid #fbc658;
}
.react-select.warning
  .react-select__multi-value
  .react-select__multi-value__remove {
  color: rgba(255, 178, 54, 0.3);
  border-left: 1px solid rgba(255, 178, 54, 0.3);
}
.react-select.warning
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #fbc658;
  background-color: transparent;
}

.react-select.danger .react-select__control.react-select__control--is-focused,
.react-select.danger
  .react-select__control.react-select__control--is-focused:hover {
  border-color: #ef8157;
}

.react-select.danger
  .react-select__control
  .react-select__value-container--has-value
  .react-select__single-value,
.react-select.danger
  .react-select__control
  .react-select__value-container--has-value
  .react-select__multi-value__label {
  color: #ef8157;
}

.react-select.danger .react-select__multi-value {
  border: 1px solid #ef8157;
}
.react-select.danger
  .react-select__multi-value
  .react-select__multi-value__remove {
  color: rgba(255, 54, 54, 0.3);
  border-left: 1px solid rgba(255, 54, 54, 0.3);
}
.react-select.danger
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #ef8157;
  background-color: transparent;
}

.react-select .react-select__multi-value {
  border: 1px solid #9a9a9a;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: rgba(222, 222, 222, 0.8);
  border-left: 1px solid rgba(222, 222, 222, 0.8);
}
.react-select
  .react-select__multi-value
  .react-select__multi-value__remove:hover {
  color: #9a9a9a;
  background-color: transparent;
}

.react-select.react-select--is-disabled
  .react-select__multi-value--is-disabled
  .react-select__multi-value__remove {
  display: none;
}

.react-select.react-select--is-disabled
  .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}

.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}

.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}
.ReactTable.primary-pagination .-pagination .-btn {
  background-color: #51cbce;
  color: #ffffff;
}
.ReactTable.primary-pagination .-pagination .-btn:hover,
.ReactTable.primary-pagination .-pagination .-btn:focus,
.ReactTable.primary-pagination .-pagination .-btn:active,
.ReactTable.primary-pagination .-pagination .-btn.active,
.ReactTable.primary-pagination .-pagination .-btn:active:focus,
.ReactTable.primary-pagination .-pagination .-btn:active:hover,
.ReactTable.primary-pagination .-pagination .-btn.active:focus,
.ReactTable.primary-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
  > .ReactTable.primary-pagination
  .-pagination
  .-btn.dropdown-toggle:hover {
  background-color: #34b5b8 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.ReactTable.primary-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.disabled,
.ReactTable.primary-pagination .-pagination .-btn.disabled:hover,
.ReactTable.primary-pagination .-pagination .-btn.disabled:focus,
.ReactTable.primary-pagination .-pagination .-btn.disabled.focus,
.ReactTable.primary-pagination .-pagination .-btn.disabled:active,
.ReactTable.primary-pagination .-pagination .-btn.disabled.active,
.ReactTable.primary-pagination .-pagination .-btn:disabled,
.ReactTable.primary-pagination .-pagination .-btn:disabled:hover,
.ReactTable.primary-pagination .-pagination .-btn:disabled:focus,
.ReactTable.primary-pagination .-pagination .-btn:disabled.focus,
.ReactTable.primary-pagination .-pagination .-btn:disabled:active,
.ReactTable.primary-pagination .-pagination .-btn:disabled.active,
.ReactTable.primary-pagination .-pagination .-btn[disabled],
.ReactTable.primary-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.primary-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.primary-pagination .-pagination .-btn[disabled].focus,
.ReactTable.primary-pagination .-pagination .-btn[disabled]:active,
.ReactTable.primary-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.active {
  background-color: #51cbce;
  border-color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple {
  color: #51cbce;
  border-color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #34b5b8;
  border-color: #34b5b8;
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link {
  color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:active,
.ReactTable.primary-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #34b5b8;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.info-pagination .-pagination .-btn {
  background-color: #0fa0cf;
  color: #ffffff;
}
.ReactTable.info-pagination .-pagination .-btn:hover,
.ReactTable.info-pagination .-pagination .-btn:focus,
.ReactTable.info-pagination .-pagination .-btn:active,
.ReactTable.info-pagination .-pagination .-btn.active,
.ReactTable.info-pagination .-pagination .-btn:active:focus,
.ReactTable.info-pagination .-pagination .-btn:active:hover,
.ReactTable.info-pagination .-pagination .-btn.active:focus,
.ReactTable.info-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:focus,
.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #2ba9cd !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.ReactTable.info-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.disabled,
.ReactTable.info-pagination .-pagination .-btn.disabled:hover,
.ReactTable.info-pagination .-pagination .-btn.disabled:focus,
.ReactTable.info-pagination .-pagination .-btn.disabled.focus,
.ReactTable.info-pagination .-pagination .-btn.disabled:active,
.ReactTable.info-pagination .-pagination .-btn.disabled.active,
.ReactTable.info-pagination .-pagination .-btn:disabled,
.ReactTable.info-pagination .-pagination .-btn:disabled:hover,
.ReactTable.info-pagination .-pagination .-btn:disabled:focus,
.ReactTable.info-pagination .-pagination .-btn:disabled.focus,
.ReactTable.info-pagination .-pagination .-btn:disabled:active,
.ReactTable.info-pagination .-pagination .-btn:disabled.active,
.ReactTable.info-pagination .-pagination .-btn[disabled],
.ReactTable.info-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.info-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.info-pagination .-pagination .-btn[disabled].focus,
.ReactTable.info-pagination .-pagination .-btn[disabled]:active,
.ReactTable.info-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.active {
  background-color: #0fa0cf;
  border-color: #0fa0cf;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple {
  color: #0fa0cf;
  border-color: #0fa0cf;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.info-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.info-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #2ba9cd;
  border-color: #2ba9cd;
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link {
  color: #0fa0cf;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.info-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.info-pagination .-pagination .-btn.btn-link:active,
.ReactTable.info-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #2ba9cd;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.success-pagination .-pagination .-btn {
  background-color: #6bd098;
  color: #ffffff;
}
.ReactTable.success-pagination .-pagination .-btn:hover,
.ReactTable.success-pagination .-pagination .-btn:focus,
.ReactTable.success-pagination .-pagination .-btn:active,
.ReactTable.success-pagination .-pagination .-btn.active,
.ReactTable.success-pagination .-pagination .-btn:active:focus,
.ReactTable.success-pagination .-pagination .-btn:active:hover,
.ReactTable.success-pagination .-pagination .-btn.active:focus,
.ReactTable.success-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
  > .ReactTable.success-pagination
  .-pagination
  .-btn.dropdown-toggle:hover {
  background-color: #44c47d !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.ReactTable.success-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.disabled,
.ReactTable.success-pagination .-pagination .-btn.disabled:hover,
.ReactTable.success-pagination .-pagination .-btn.disabled:focus,
.ReactTable.success-pagination .-pagination .-btn.disabled.focus,
.ReactTable.success-pagination .-pagination .-btn.disabled:active,
.ReactTable.success-pagination .-pagination .-btn.disabled.active,
.ReactTable.success-pagination .-pagination .-btn:disabled,
.ReactTable.success-pagination .-pagination .-btn:disabled:hover,
.ReactTable.success-pagination .-pagination .-btn:disabled:focus,
.ReactTable.success-pagination .-pagination .-btn:disabled.focus,
.ReactTable.success-pagination .-pagination .-btn:disabled:active,
.ReactTable.success-pagination .-pagination .-btn:disabled.active,
.ReactTable.success-pagination .-pagination .-btn[disabled],
.ReactTable.success-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.success-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.success-pagination .-pagination .-btn[disabled].focus,
.ReactTable.success-pagination .-pagination .-btn[disabled]:active,
.ReactTable.success-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.active {
  background-color: #6bd098;
  border-color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple {
  color: #6bd098;
  border-color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.success-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.success-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #44c47d;
  border-color: #44c47d;
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link {
  color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.success-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.success-pagination .-pagination .-btn.btn-link:active,
.ReactTable.success-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #44c47d;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.warning-pagination .-pagination .-btn {
  background-color: #fbc658;
  color: #ffffff;
}
.ReactTable.warning-pagination .-pagination .-btn:hover,
.ReactTable.warning-pagination .-pagination .-btn:focus,
.ReactTable.warning-pagination .-pagination .-btn:active,
.ReactTable.warning-pagination .-pagination .-btn.active,
.ReactTable.warning-pagination .-pagination .-btn:active:focus,
.ReactTable.warning-pagination .-pagination .-btn:active:hover,
.ReactTable.warning-pagination .-pagination .-btn.active:focus,
.ReactTable.warning-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:focus,
.show
  > .ReactTable.warning-pagination
  .-pagination
  .-btn.dropdown-toggle:hover {
  background-color: #fab526 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.ReactTable.warning-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.disabled,
.ReactTable.warning-pagination .-pagination .-btn.disabled:hover,
.ReactTable.warning-pagination .-pagination .-btn.disabled:focus,
.ReactTable.warning-pagination .-pagination .-btn.disabled.focus,
.ReactTable.warning-pagination .-pagination .-btn.disabled:active,
.ReactTable.warning-pagination .-pagination .-btn.disabled.active,
.ReactTable.warning-pagination .-pagination .-btn:disabled,
.ReactTable.warning-pagination .-pagination .-btn:disabled:hover,
.ReactTable.warning-pagination .-pagination .-btn:disabled:focus,
.ReactTable.warning-pagination .-pagination .-btn:disabled.focus,
.ReactTable.warning-pagination .-pagination .-btn:disabled:active,
.ReactTable.warning-pagination .-pagination .-btn:disabled.active,
.ReactTable.warning-pagination .-pagination .-btn[disabled],
.ReactTable.warning-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.warning-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.warning-pagination .-pagination .-btn[disabled].focus,
.ReactTable.warning-pagination .-pagination .-btn[disabled]:active,
.ReactTable.warning-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.active {
  background-color: #fbc658;
  border-color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple {
  color: #fbc658;
  border-color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #fab526;
  border-color: #fab526;
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link {
  color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:active,
.ReactTable.warning-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #fab526;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.danger-pagination .-pagination .-btn {
  background-color: #ef8157;
  color: #ffffff;
}
.ReactTable.danger-pagination .-pagination .-btn:hover,
.ReactTable.danger-pagination .-pagination .-btn:focus,
.ReactTable.danger-pagination .-pagination .-btn:active,
.ReactTable.danger-pagination .-pagination .-btn.active,
.ReactTable.danger-pagination .-pagination .-btn:active:focus,
.ReactTable.danger-pagination .-pagination .-btn:active:hover,
.ReactTable.danger-pagination .-pagination .-btn.active:focus,
.ReactTable.danger-pagination .-pagination .-btn.active:hover,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:focus,
.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #eb6532 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.ReactTable.danger-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.disabled,
.ReactTable.danger-pagination .-pagination .-btn.disabled:hover,
.ReactTable.danger-pagination .-pagination .-btn.disabled:focus,
.ReactTable.danger-pagination .-pagination .-btn.disabled.focus,
.ReactTable.danger-pagination .-pagination .-btn.disabled:active,
.ReactTable.danger-pagination .-pagination .-btn.disabled.active,
.ReactTable.danger-pagination .-pagination .-btn:disabled,
.ReactTable.danger-pagination .-pagination .-btn:disabled:hover,
.ReactTable.danger-pagination .-pagination .-btn:disabled:focus,
.ReactTable.danger-pagination .-pagination .-btn:disabled.focus,
.ReactTable.danger-pagination .-pagination .-btn:disabled:active,
.ReactTable.danger-pagination .-pagination .-btn:disabled.active,
.ReactTable.danger-pagination .-pagination .-btn[disabled],
.ReactTable.danger-pagination .-pagination .-btn[disabled]:hover,
.ReactTable.danger-pagination .-pagination .-btn[disabled]:focus,
.ReactTable.danger-pagination .-pagination .-btn[disabled].focus,
.ReactTable.danger-pagination .-pagination .-btn[disabled]:active,
.ReactTable.danger-pagination .-pagination .-btn[disabled].active,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:hover,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:focus,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.focus,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:active,
fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.active {
  background-color: #ef8157;
  border-color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple {
  color: #ef8157;
  border-color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:hover,
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:focus,
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #eb6532;
  border-color: #eb6532;
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link {
  color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link:hover,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:focus,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:active,
.ReactTable.danger-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #eb6532;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}

.ReactTable .actions-right {
  text-align: right;
}

.ReactTable .actions-left {
  text-align: left;
}

.ReactTable .actions-center {
  text-align: center;
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 28px;
  background-color: inherit;
  padding-left: 0.8em;
}
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th:last-child {
  text-align: right;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
  opacity: 0.6;
  content: "\\F0DC";
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
}

.ReactTable
  .rt-thead
  .rt-th.-cursor-pointer.-sort-desc
  > div:first-of-type:after {
  content: "\\F0DD";
  top: -3px;
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 1;
}

.ReactTable
  .rt-thead
  .rt-th.-cursor-pointer.-sort-asc
  > div:first-of-type:after {
  content: "\\F0DE";
  top: 3px;
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 1;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  font-size: 1.063rem;
  text-align: left;
  font-weight: 300;
  line-height: 2.5em !important;
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 12px 7px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
  line-height: 2;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
}

.ReactTable .-pagination input,
.ReactTable .-pagination select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 28px;
  background-color: inherit;
  text-align: center;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.1);
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-th {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0;
}

.ReactTable .rt-table {
  border: 1px solid #dee2e6;
}

.ReactTable .rt-table .rt-td {
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.ReactTable .btn.btn-icon {
  margin: 0 3px;
  padding: 5px 8px;
}

.react-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
}

.react-tagsinput-tag {
  transition: all 0.17s linear;
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 4px 8px 3px 0.8em;
  border-radius: 12px;
  color: #fff;
  font-size: 0.75em;
  font-weight: 500;
  display: inline-block;
  line-height: 1.5em;
  text-transform: uppercase;
  border: 1px solid;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-tag a::before {
  font-family: "nucleo-icons";
  content: "\\ea4f";
  padding: 0px 2px;
}

.react-tagsinput-tag a {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 5px;
  width: 80px;
}

.react-tagsinput .react-tagsinput-tag {
  transition: all 300ms ease 0s;
  border-color: #66615b;
  background-color: #66615b;
}
.react-tagsinput .react-tagsinput-tag:hover {
  padding-right: 22px;
}
.react-tagsinput .react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}
.react-tagsinput .react-tagsinput-tag.primary {
  border-color: #51cbce;
  background-color: #51cbce;
}
.react-tagsinput .react-tagsinput-tag.info {
  border-color: #0fa0cf;
  background-color: #0fa0cf;
}
.react-tagsinput .react-tagsinput-tag.success {
  border-color: #6bd098;
  background-color: #6bd098;
}
.react-tagsinput .react-tagsinput-tag.warning {
  border-color: #fbc658;
  background-color: #fbc658;
}
.react-tagsinput .react-tagsinput-tag.danger {
  border-color: #ef8157;
  background-color: #ef8157;
}
.react-tagsinput .react-tagsinput-tag.neutral {
  border-color: #ffffff;
  background-color: #ffffff;
  color: inherit;
}

/*# sourceMappingURL=paper-dashboard.css.map */
`, "",{"version":3,"sources":["webpack://./src/assets/css/paper-dashboard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;EAaE;AACF;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EAGzB,iBAAiB;EACjB,sBAAsB;EAGtB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,MAAM;EACN,YAAY;EACZ,kBAAkB;EAElB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;EAKE,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EAEjB,0BAA0B;AAC5B;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;;;;;;;EASE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;EAIE;AACF;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yDAA4T;AAC9T;;AAEA;EACE,yDAAuQ;AACzQ;;AAEA;EACE,yDAAoQ;AACtQ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;;;EAGE;AACF;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,yBAAyB;EAEzB,kBAAkB;EAGlB,iBAAiB;EAEjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAGE,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;AACF;;EAGE,+BAA+B;AACjC;;AAEA;EACE;AACF;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EAEjB,WAAW;EAQX,oBAAoB;EAEpB,yBAAyB;EAEzB,iBAAiB;EAEjB,UAAU;EACV,8DAA8D;EAC9D,QAAQ;EACR,wHAAwH;EACxH,UAAU;EACV,kBAAkB;EAClB,iEAAiE;EACjE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;AACF;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAElB,4BAA4B;AAC9B;;AAEA;EACE;AACF;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE;AACF;EACE;AACF;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;AACZ;;AAEA;EAEE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EAEE,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EAEE,6BAA6B;EAC7B,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;CAKC;AACD;EAEE,sBAAsB;EAEtB,yBAAyB;AAC3B;;AAEA;EAEE,mCAAmC;AACrC;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;;EAGE,yBAAyB;AAC3B;;AAEA;;EAGE,yBAAyB;AAC3B;;AAyBA;EACE;;IAGE,+BAA+B;EACjC;EACA;;;;;IAME,mCAAmC;EACrC;EACA;;;;IAKE,kCAAkC;EACpC;AACF;;AAEA;EAEE,qBAAqB;AACvB;;AAeA;EACE;IACE,UAAU;IAEV,mCAAmC;EACrC;EACA;IACE,UAAU;IAEV,eAAe;EACjB;AACF;;AAEA;EAEE,0BAA0B;AAC5B;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEE,uBAAuB;AACzB;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEV,kCAAkC;EACpC;AACF;;AAEA;EAEE,2BAA2B;AAC7B;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEV,mCAAmC;EACrC;AACF;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EAIV,6DAA6D;EAC7D,WAAW;EACX,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EAGtB,kBAAkB;EAUlB;0DACwD;EAIxD,WAAW;EACX,8CAA8C;EAC9C,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EAIV,6DAA6D;EAC7D,QAAQ;EACR,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EAGtB,kBAAkB;EAUlB;0DACwD;EAIxD,UAAU;EACV,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;AACV;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,2DAA2D;EAC3D,kBAAkB;EAElB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EAEnB,wDAAwD;EACxD,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,yBAAyB;EAEzB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAElB,wDAAwD;AAC1D;;AAEA;EACE,SAAS;EACT,kBAAkB;EAElB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EAEb,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EAEd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EAEX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EAEzB,+CAA+C;EAG/C,8CAA8C;AAEhD;;AAEA;;;EAGE,gCAAgC;EAEhC,sCAAsC;AACxC;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EAEzB,2BAA2B;AAC7B;;AAcA;;;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAElB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;EAEb,wBAAwB;AAC1B;;AAEA;;EAEE,8BAA8B;EAC9B,SAAS;EACT,WAAW;EAEX,yBAAyB;EAEzB,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,UAAU;EACV,UAAU;EAEV,yBAAyB;EAEzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAElB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EAEV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EAET,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EAET,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAqBA;EACE;IAEE,qBAAqB;EACvB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,sBAAsB;EACxB;EACA;IAEE,mBAAmB;EACrB;AACF;;AAeA;EACE;IAEE,mBAAmB;IACnB,UAAU;EACZ;EACA;IAEE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,wCAAwC;AAC1C;;AAEA;EAEE,eAAe;AACjB;;AA8BA;EACE;IACE,QAAQ;IACR,SAAS;IACT,SAAS;EACX;EACA;IACE,QAAQ;IACR,SAAS;IACT,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;AACF;;AAyBA;EACE;IACE,QAAQ;IACR,WAAW;IACX,SAAS;EACX;EACA;IACE,QAAQ;IACR,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;AACF;;AAqBA;EACE;IAEE,yBAAyB;EAC3B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EAEE,0CAA0C;AAC5C;;AAeA;EACE;IAEE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IAEE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EAEE,kCAAkC;AACpC;;AA4BA;EACE;IAEE,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;EACZ;EACA;IAEE,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;EACZ;EACA;IAEE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IAEE,mBAAmB;IACnB,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EAEE,8BAA8B;AAChC;;AAaA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,UAAU;EAKV,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;;;;;;EAME,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EAEnB,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,mBAAoB;EAApB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,OAAO;EACP,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;EAME,4CAA4C;AAC9C;;AAEA;;;;EAIE;AACF;;;;;;;;;;;;;EAaE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EAKE,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EAGV,yEAAyE;EAKzE,8CAA8C;AAChD;AACA;EAKE,6CAA6C;EAC7C,UAAU;AACZ;AACA;EACE,UAAU;EACV,iEAAiE;EAKjE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EAKV,6CAA6C;EAC7C,iEAAiE;AACnE;AACA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;;;;;EAKE;AACF;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EAGf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EAEzB,+CAA+C;EAC/C,oBAAoB;EACpB,YAAY;EAGZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EAGX,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EAGX,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EAKE,0CAA0C;AAC5C;AACA;;EAEE,aAAa;AACf;;AAEA;EAKE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EAKE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,gDAAgD;EAChD,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE;AACF;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAIE,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;EAKE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT;2CACqtI;AACvtI;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE;AACF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;mGACmG;AACnG;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;mGACmG;AACnG;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,uCAAuC;EACvC,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;;;;;;CAMC;AACD;EACE,kBAAkB;EAClB,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,OAAO;AACT;;AAEA;mGACmG;AACnG;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EAKd,4BAA4B;AAC9B;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;EAIE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kDAAkD;EAClD,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;CAGC;AACD;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;EACzB,cAAc;AAChB;;AAEA;mGACmG;AACnG;EACE,qBAAqB;AACvB;;AAEA;;;CAGC;AACD;EACE,yDAAyD;EACzD,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;mGACmG;AACnG;EACE,kBAAkB;EAElB,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;mGACmG;AACnG;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,gEAAgE;EAChE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;mGACmG;AACnG;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;mGACmG;AACnG;EACE,mFAAmF;EACnF,+FAA+F;EAC/F,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;2CACyC;EACzC,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;mGACmG;AACnG;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;;EAEE,SAAS;EACT,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;CAGC;AACD;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,wCAAwC;EACxC,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;;EAEE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;mGACmG;AACnG;EACE,mEAAmE;EACnE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,gFAAgF;EAChF,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;mGACmG;AACnG;EACE,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;;AAEA,gEAAgE;AAChE;;;EAGE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,qEAAqE;AACvE;;AAEA;;EAEE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;mGACmG;AACnG,mGAAmG;AACnG;;EAEE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,kDAAkD;EAClD,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA,kBAAkB;AAClB;;;;;;EAME,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;;;;;;EAME,UAAU;EACV,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;;;CAIC;AACD;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;mGACmG;AACnG,8CAA8C;AAC9C;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4DAA4D;EAC5D,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;mGACmG;AACnG;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,uDAAuD;EACvD,WAAW;EACX,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,uDAAuD;EACvD,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;mGACmG;AACnG,iFAAiF;AACjF,iGAAiG;AACjG;;;EAKE,uBAAuB;AACzB;;AAEA;;EAEE,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;AACZ;;AAEA;mGACmG;AACnG,sBAAsB;AACtB;;EAEE,+DAA+D;EAC/D,gBAAgB;EAChB,gEAAgE;EAChE,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA,gGAAgG;AAChG;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA,gCAAgC;AAChC;;EAEE,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yEAAyE;EACzE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX;;oDAEkD;AACpD;;AAEA;mGACmG;AACnG;EACE,kBAAkB;EAClB,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,gEAAgE;EAChE,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;mGACmG;AACnG;EACE,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;mGACmG;AACnG;;EAEE,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;AACtE;;AAEA;EACE,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mEAAmE;EACnE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;mGACmG;AACnG;EACE,aAAa;EACb,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;mGACmG;AACnG;EACE,yDAAyD;EACzD,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,oCAAoC;AACtC;;AAEA;mGACmG;AACnG;;EAEE,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,OAAO;EACP,QAAQ;AACV;;AAEA;mGACmG;AACnG;EACE,gDAAgD;EAChD,sDAAsD;EACtD,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,iEAAiE;EACjE,mBAAmB;AACrB;;AAEA;;EAEE,4CAA4C;EAC5C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,UAAU;EACV,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;kCAKkC;AAClC;EACE,2BAA2B;EAC3B,4CAA0C;EAC1C;;;8DAG0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,qBAAqB;EACrB,gDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;0BAE0B;AAC1B;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;oCAEoC;AACpC;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EAGE,0CAA0C;AAC5C;;AAoBA;EACE;IAKE,uBAAuB;EACzB;EACA;IAKE,yBAAyB;EAC3B;AACF;;AAEA;;0BAE0B;AAC1B;EACE,gEAAgE;EAKhE,wBAAwB;AAC1B;;AAEA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;;AAEA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;;AAEA;;0BAE0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EAKd,4BAA4B;AAC9B;AACA;;;;;;;;;;;;;;;;;;;;;;EAsBE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;EAME,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;;;;;;EAOE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;;;;;EAQE,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;;;EAME,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;;;;;;EAME,qDAAqD;AACvD;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;EASE,sDAAsD;EACtD,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,gEAAgE;EAGhE,wBAAwB;AAC1B;;AAEA;;EAME,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAME,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAME,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EASf;qCACmC;EAEnC,gBAAgB;AAClB;AACA;EACE,yBAAyB;EAEzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;EAIE,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;;EAKE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;EAgBE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;EAgBE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;EAgBE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;AAC9B;AACA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;EAME,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;;;;;;EAgBE,0CAA0C;AAC5C;;AAEA;;;;EAIE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;EAS/B;qCACmC;AACrC;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,WAAW;AACb;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,8DAA8D;AAChE;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf;;qBAEmB;EACnB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,eAAe;AACf;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuHE,6BAA6B;AAC/B;;AAEA;;;EAOE,6BAA6B;AAC/B;;AAEA;;;;EAIE,gEAAgE;EAGhE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,YAAY;AACd;AACA;;EAEE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;EAME,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,OAAO;EACP,WAAc;EAAd,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,UAAU;EACV,wBAAwB;EAExB,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB;gDAC8C;AAChD;AACA;;;EAOE,gDAAgD;AAClD;AACA;;;EAOE,gDAAgD;AAClD;;AAEA;;;EAGE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;EAOE,kDAAkD;EAClD,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;;EAOE,iDAAiD;EACjD,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAME,gDAAgD;EAChD,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;AACA;;EAME,4CAA4C;AAC9C;;AAEA;EAKE,kDAAkD;EAClD,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,UAAU;EACV,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;EAME,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;EAME,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;;EAGE,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;;;IAGE,uCAAuC;IACvC;kDAC8C;EAChD;EACA;;;IAGE,qCAAqC;IACrC,8BAA8B;EAChC;EACA;IAKE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE;kDAC8C;IAC9C,qCAAqC;EACvC;EACA;;IAEE,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;;;EAGE,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,SAAS;AACX;AACA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;;;;EAIE,cAAc;EACd,oCAAoC;AACtC;AACA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;AACX;AACA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;EACV,UAAU;AACZ;;AAEA;;;;;;EAME,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;;AAEA;EAKE,+CAA+C;AACjD;AACA;;EAEE,UAAU;AACZ;;AAEA;EAKE,8CAA8C;AAChD;;AAEA;;;EAOE,8CAA8C;AAChD;;AAEA;EAKE,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EAKzB,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,WAAW;EACX,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EAKV,+BAA+B;EAC/B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;AACf;AACA;;EAEE,cAAc;EACd,0CAA0C;EAC1C,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAKE,gDAAgD;AAClD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;;;EAGE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;;;EAIE,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;;;EAGE,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;EAIE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wEAAwE;AAC1E;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,OAAO;EACP,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,+BAA+B;AACjC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,0BAA0B;AAC5B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;;;;;;;;;;;;;;;;;;;;;;EAsBE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2EE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,UAAU;EACV,mBAAmB;EAKnB,iCAAiC;AACnC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mDAAmD;AACrD;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;AACA;;EAEE;;;;wDAIsD;EACtD,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,cAAc;EACd,YAAY;AACd;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+CE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmDE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EAKzB,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;;;IAIE,uCAAuC;IAEvC,sCAAsC;IAEtC,gDAAgD;IAChD,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,UAAU;IAKV,mCAAmC;EACrC;EACA;IACE,UAAU;EACZ;EACA;;;;;;;;;;;;;;;;;;;;;;;IA2BE,mCAAmC;IACnC,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IAKV,+BAA+B;EACjC;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;;;;;;;;;;;;;;;;;;;;;;;IA2BE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAS9B,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,wBAAqB;EAArB,uBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EASd;yBACuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;AACA;;;;;;;;;;EAUE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;EAME,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,0CAA0C;AAC5C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;EAC1C,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;IAME,8BAA8B;EAChC;EACA;;;;;;;;IAQE,yBAAyB;EAC3B;EACA;;;IAGE,yBAAyB;EAC3B;EACA;;;IAGE,aAAa;EACf;EACA;;;;;;;;;;;;IAYE,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EAGV,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,+CAA+C;EAM/C,0BAA0B;EAM1B,2BAA2B;EAM3B,0BAA0B;EAC1B;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,0CAA0C;AAC5C;AACA;;;;;;;;EAQE,WAAc;EAAd,cAAc;AAChB;AACA;;;;EAIE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;EAME,WAAc;EAAd,cAAc;AAChB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;;EAKE,sCAAsC;AACxC;AACA;;;;;;;;;;EAUE,+BAA+B;AACjC;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,sCAAsC;AACxC;AACA;;;;;;;;;;;;EAYE,sCAAsC;AACxC;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;;;EAQE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;;;;EAME,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;EAME,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;EAkBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;AAC5C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4DE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;EAgBE,0CAA0C;EAC1C,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;EAgBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;EAOE,+BAA+B;AACjC;AACA;;;EAGE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;;;;;;;;;EAWE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;;IAEE,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IAKE,0DAA0D;EAC5D;EACA;IACE,QAAQ;IAKR,mCAAmC;EACrC;EACA;IAKE,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IAKE,oCAAoC;EACtC;EACA;;IAME,iCAAiC;EACnC;EACA;IAKE,oCAAoC;EACtC;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;IAKR,mCAAmC;EACrC;EACA;;;IAGE,8BAA8B;EAChC;EACA;IACE,QAAQ;IAGR,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,kCAAkC;IAGlC,6BAA6B;EAC/B;EACA;IACE,QAAQ;IAGR,4BAA4B;IAG5B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE;MACE,QAAQ;MACR,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;EAiCA;IACE;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,oBAAoB;IACtB;EACF;EAiCA;IACE;MACE,WAAW;MACX,uBAAuB;IACzB;IACA;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;EACF;EAiCA;IACE;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,WAAW;MACX,oBAAoB;IACtB;EACF;EAiDA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,QAAQ;IACR,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAK7B,0DAA0D;EAC5D;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,eAAe;IACf,cAAc;IACd,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IAKV,0DAA0D;IAK1D,oCAAoC;EACtC;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,+BAA+B;IAC/B,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;;;;;;;;IAQE,gCAAgC;IAChC,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,iCAAiC;EACnC;EACA;;;;;;;;IAQE,gCAAgC;IAChC,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,iCAAiC;EACnC;EACA;;;;;;;;;;;;;;;;IAgBE,MAAM;EACR;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;;;KAGG;EACH;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;;;IAGE,oBAAoB;EACtB;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;;;IAGE,8CAA8C;EAChD;EACA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;AACA;;;;;;;;;;EAUE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;EAME,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,0CAA0C;AAC5C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;EAC1C,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE;;;;;;IAME,8BAA8B;EAChC;EACA;;;;;;;;IAQE,yBAAyB;EAC3B;EACA;;;IAGE,yBAAyB;EAC3B;EACA;;;IAGE,aAAa;EACf;EACA;;;;;;;;;;;;IAYE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,OAAO;EACP,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;;AAEA;EAKE,+CAA+C;AACjD;AACA;;EAEE,UAAU;AACZ;;AAEA;EAKE,8CAA8C;AAChD;;AAEA;;;EAOE,8CAA8C;AAChD;;AAEA;EAKE,8CAA8C;AAChD;;AAEA;EACE,YAAa;EAAb,eAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAe;EAAf,iBAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAa;EAAb,eAAa;EACb,aAAc;EAAd,gBAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAO;EACP,kBAAkB;EAClB,WAAY;EAAZ,cAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;kCAKkC;AAClC;EACE,2BAA2B;EAC3B,4CAA0C;EAC1C;;;8DAG0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC,+CAA+C;AAC/C;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gDAAgD;EAClD;EACA;IACE,aAAa;EACf;EACA;;IAEE,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IAKE,0DAA0D;EAC5D;EACA;IACE,QAAQ;IAKR,mCAAmC;EACrC;EACA;IAKE,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IAKE,oCAAoC;EACtC;EACA;;IAME,iCAAiC;EACnC;EACA;IAKE,oCAAoC;EACtC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;IAKR,mCAAmC;EACrC;EACA;;;IAGE,8BAA8B;EAChC;EACA;IACE,QAAQ;IAGR,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,kCAAkC;IAGlC,6BAA6B;EAC/B;EACA;IACE,QAAQ;IAGR,4BAA4B;IAG5B,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IAGX,+BAA+B;IAG/B,6BAA6B;EAC/B;EACA;IACE;MACE,QAAQ;MACR,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;EAiCA;IACE;MACE,QAAQ;MACR,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,QAAQ;MACR,oBAAoB;IACtB;EACF;EAiCA;IACE;MACE,WAAW;MACX,uBAAuB;IACzB;IACA;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,0BAA0B;IAC5B;EACF;EAiCA;IACE;MACE,WAAW;MACX,0BAA0B;IAC5B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,WAAW;MACX,oBAAoB;IACtB;EACF;EAiDA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,QAAQ;IACR,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAK7B,0DAA0D;EAC5D;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,eAAe;IACf,cAAc;IACd,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IAKV,0DAA0D;IAK1D,oCAAoC;EACtC;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,+BAA+B;IAC/B,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;;;;;;;;IAQE,SAAS;EACX;EACA;;;;;;;;IAQE,SAAS;EACX;EACA;;;;;;;;;;;;;;IAcE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;IAChC,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,iCAAiC;EACnC;EACA;IACE,gCAAgC;IAChC,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;;;KAGG;EACH;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;;;IAGE,oBAAoB;EACtB;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;;;IAGE,8CAA8C;EAChD;EACA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,OAAO;EACP,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,+BAA+B;AACjC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,0BAA0B;AAC5B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;;;;;;;;;;;;;;;;;;;;;;EAsBE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2EE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,UAAU;EACV,mBAAmB;EAKnB,iCAAiC;AACnC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mDAAmD;AACrD;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;AACA;;EAEE;;;;wDAIsD;EACtD,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,cAAc;EACd,YAAY;AACd;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+CE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmDE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EAKzB,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,+BAA+B;;EAE/B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;;;IAIE,uCAAuC;IAEvC,sCAAsC;IAEtC,gDAAgD;IAChD,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,UAAU;IAKV,mCAAmC;EACrC;EACA;IACE,UAAU;EACZ;EACA;;;;;;;;;;;;;;;;;;;;;;;IA2BE,mCAAmC;IACnC,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IAKV,+BAA+B;EACjC;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;;;;;;;;;;;;;;;;;;;;;;;IA2BE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAS9B,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,wBAAqB;EAArB,uBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;;;EAGE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;;;EAIE,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;EAIE,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;EAIE,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;;;CAGC;AACD;;;;CAIC;AACD;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,yBAAyB;EAEzB,kBAAkB;EAGlB,iBAAiB;EAEjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;CACC;AACD;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EAGX,qBAAqB;AACvB;;AAEA;CACC;AACD;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;;CAEC;AACD;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;CACC;AACD;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,qHAAqH;EACrH,kBAAkB;EAClB,8DAA8D;EAC9D,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,qHAAqH;EACrH,kBAAkB;EAClB,8DAA8D;EAC9D,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAElB,4BAA4B;AAC9B;;AAEA;CACC;AACD;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;EAC5E,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;CACC;AACD;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;CAEC;AACD;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;AACZ;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EAEE,6BAA6B;EAC7B,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EAGZ,aAAa;EAGb,sBAAsB;EAGtB,oBAAoB;AACtB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAGhB,SAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAGlB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAGE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,aAAa;AACf;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EAGtB,aAAa;EAGb,sBAAsB;EAGtB,SAAW;EACX,WAAW;EAGX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EACb,kBAAkB;EAGlB,sBAAsB;EAGtB,SAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,SAAW;EACX,gBAAgB;AAClB;;AAEA;EAGE,SAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EAGE,aAAa;EAGb,sBAAsB;EAGtB,SAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,aAAa;EAGb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EAGE,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAGhB,aAAa;EAGb,wBAAwB;AAC1B;;AAEA;;EAIE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EAGE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAGhB,sBAAsB;EAGtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAGE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EAGjB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EAGX,SAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,SAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EAGE,aAAa;EAGb,sBAAsB;EAGtB,SAAO;EACP,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,cAAc;EAGd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EAGE,SAAO;EACP,YAAY;EAGZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EAGE,aAAa;EAGb,SAAY;EAGZ,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAGE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EAGX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAwB;EAAxB,0BAAwB;EACxB,2BAA4B;EAA5B,8BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EAGzB,iBAAiB;EACjB,sBAAsB;EAGtB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,MAAM;EACN,YAAY;EACZ,kBAAkB;EAElB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;EAKE,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EAEjB,0BAA0B;AAC5B;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;;;;;;;EASE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,UAAU;EAKV,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;;;;;EAME,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EAEnB,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,mBAAoB;EAApB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,OAAO;EACP,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;EAME,4CAA4C;AAC9C;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;AACA;EAKE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gDAAgD;EAChD,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;EAKE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EAExB,cAAc;EAEd,YAAY;EAEZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EAKd,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EAExB,cAAc;EAEd,YAAY;EAEZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;AACA;;;;EAIE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;EAIE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT;2CACqtI;AACvtI;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;;;CAMC;AACD;;CAEC;AACD;EACE,SAAS;EACT,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,gDAAgD;EAChD;gDAC8C;EAC9C,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,oBAAoB;EACpB,gBAAoB;EAApB,sBAAoB;EACpB,aAAiB;EAAjB,mBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,UAAU;EACV,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAqB;EAArB,uBAAqB;EACrB,cAAkB;EAAlB,oBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EAKf,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;EAYE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;;;;EAKE,oBAAoB;AACtB;AACA;;;;;EAKE,gBAAgB;AAClB;AACA;;;;EAIE,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,UAAU;EACV,qBAAqB;AACvB;AACA;;;;EAIE,6BAA6B;EAC7B,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;EAIE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;;EAKE,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;;;EAGE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,YAAY;EAGZ,aAAa;EAIb,sBAAsB;EAGtB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mEAAmE;EACnE,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EAGE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EAGtB,oBAAoB;AACtB;;AAEA;EAGE,cAAc;EAGd,oBAAoB;AACtB;;AAEA;;EAIE,SAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EAET,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EAEE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EAGV,aAAa;EAGb,8BAA8B;EAG9B,oBAAoB;EAEpB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;EAExB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAIE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EAGE,WAAS;EACT,kBAAkB;EAClB,gBAAgB;EAGhB,aAAa;EAIb,mBAAmB;EAEnB,eAAe;EAGf,mBAAmB;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAER,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,eAAe;EACf,yBAAyB;EAEzB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EAKE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8CAA8C","sourcesContent":["@charset \"UTF-8\";\n/*!\n\n =========================================================\n * Paper Dashboard PRO React - v1.2.0 based on Paper Dashboard 2 Pro - v2.0.1\n =========================================================\n\n * Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react\n * Copyright 2020 Creative Tim (http://www.creative-tim.com)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out 0.15s,\n    box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block !important;\n  height: 100%;\n  color: #fff;\n  padding: 6px 10px;\n  font-size: 11px;\n  text-indent: -5px;\n  line-height: 15px;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n.bootstrap-switch .bootstrap-switch-handle-on i,\n.bootstrap-switch .bootstrap-switch-handle-off i,\n.bootstrap-switch .bootstrap-switch-label i {\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: #66615b;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n  color: #fff;\n  background: #7a9e9f;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n  color: #fff;\n  background: #68b3c8;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n  color: #fff;\n  background: #7ac29a;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n  background: #f3bb45;\n  color: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n  color: #fff;\n  background: #eb5e28;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #fff;\n  background: #cfcfca;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #ffffff;\n  box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type=\"radio\"],\n.bootstrap-switch input[type=\"checkbox\"] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n.bootstrap-switch input[type=\"radio\"].form-control,\n.bootstrap-switch input[type=\"checkbox\"].form-control {\n  height: auto;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n  background-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n  background-color: #cfcfca;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {\n  background-color: #eb5e28;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {\n  background-color: #f3bb45;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {\n  background-color: #7ac29a;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {\n  background-color: #7a9e9f;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {\n  background-color: #68b3c8;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {\n  background-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n  background-color: #cfcfca;\n}\n\n/**\n * @author zhixin wen <wenzhixin2010@gmail.com>\n * version: 1.12.1\n * https://github.com/wenzhixin/bootstrap-table/\n */\n.bootstrap-table .table {\n  margin-bottom: 0 !important;\n  border-bottom: 1px solid #dddddd;\n  border-collapse: collapse !important;\n  border-radius: 1px;\n}\n\n.bootstrap-table .table:not(.table-condensed),\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,\n.bootstrap-table .table:not(.table-condensed) > thead > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {\n  padding: 8px;\n}\n\n.bootstrap-table .table.table-no-bordered > thead > tr > th,\n.bootstrap-table .table.table-no-bordered > tbody > tr > td {\n  border-right: 2px solid transparent;\n}\n\n.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {\n  border-right: none;\n}\n\n.fixed-table-container {\n  position: relative;\n  clear: both;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n\n.fixed-table-container.table-no-bordered {\n  border: 1px solid transparent;\n}\n\n.fixed-table-footer,\n.fixed-table-header {\n  overflow: hidden;\n}\n\n.fixed-table-footer {\n  border-top: 1px solid #dddddd;\n}\n\n.fixed-table-body {\n  overflow-x: auto;\n  overflow-y: auto;\n  height: 100%;\n}\n\n.fixed-table-container table {\n  width: 100%;\n}\n\n.fixed-table-container thead th {\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border-left: 1px solid #dddddd;\n}\n\n.fixed-table-container thead th:focus {\n  outline: 0 solid transparent;\n}\n\n.fixed-table-container thead th:first-child:not([data-not-first-th]) {\n  border-left: none;\n  border-top-left-radius: 4px;\n  -webkit-border-top-left-radius: 4px;\n  -moz-border-radius-topleft: 4px;\n}\n\n.fixed-table-container thead th .th-inner,\n.fixed-table-container tbody td .th-inner {\n  padding: 8px;\n  line-height: 24px;\n  vertical-align: top;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fixed-table-container thead th .sortable {\n  cursor: pointer;\n  background-position: right;\n  background-repeat: no-repeat;\n  padding-right: 30px;\n}\n\n.fixed-table-container thead th .both {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC\");\n}\n\n.fixed-table-container thead th .asc {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==\");\n}\n\n.fixed-table-container thead th .desc {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII= \");\n}\n\n.fixed-table-container th.detail {\n  width: 30px;\n}\n\n.fixed-table-container tbody td {\n  border-left: 1px solid #dddddd;\n}\n\n.fixed-table-container tbody tr:first-child td {\n  border-top: none;\n}\n\n.fixed-table-container tbody td:first-child {\n  border-left: none;\n}\n\n/* the same color with .active */\n.fixed-table-container tbody .selected td {\n  background-color: #f5f5f5;\n}\n\n.fixed-table-container .bs-checkbox {\n  text-align: center;\n}\n\n.fixed-table-container input[type=\"radio\"],\n.fixed-table-container input[type=\"checkbox\"] {\n  margin: 0 auto !important;\n}\n\n.fixed-table-container .no-records-found {\n  text-align: center;\n}\n\n.fixed-table-pagination div.pagination,\n.fixed-table-pagination .pagination-detail {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.fixed-table-pagination div.pagination .pagination {\n  margin: 0;\n}\n\n.fixed-table-pagination .pagination a {\n  padding: 6px 12px;\n  line-height: 1.428571429;\n}\n\n.fixed-table-pagination .pagination-info {\n  line-height: 34px;\n  margin-right: 5px;\n}\n\n.fixed-table-pagination .btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.fixed-table-pagination .dropup .dropdown-menu {\n  margin-bottom: 0;\n}\n\n.fixed-table-pagination .page-list {\n  display: inline-block;\n}\n\n.fixed-table-toolbar .columns-left {\n  margin-right: 5px;\n}\n\n.fixed-table-toolbar .columns-right {\n  margin-left: 5px;\n}\n\n.fixed-table-toolbar .columns label {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.428571429;\n}\n\n.fixed-table-toolbar .bs-bars,\n.fixed-table-toolbar .search,\n.fixed-table-toolbar .columns {\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  line-height: 34px;\n}\n\n.fixed-table-pagination li.disabled a {\n  pointer-events: none;\n  cursor: default;\n}\n\n.fixed-table-loading {\n  display: none;\n  position: absolute;\n  top: 42px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99;\n  background-color: #fff;\n  text-align: center;\n}\n\n.fixed-table-body .card-view .title {\n  font-weight: bold;\n  display: inline-block;\n  min-width: 30%;\n  text-align: left !important;\n}\n\n/* support bootstrap 2 */\n.fixed-table-body thead th .th-inner {\n  box-sizing: border-box;\n}\n\n.table th,\n.table td {\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n\n.fixed-table-toolbar .dropdown-menu {\n  text-align: left;\n  max-height: 300px;\n  overflow: auto;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group {\n  display: inline-block;\n  margin-left: -1px !important;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group > .btn {\n  border-radius: 0;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.bootstrap-table .table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 1px solid #ddd;\n}\n\n/* support bootstrap 3 */\n.bootstrap-table .table thead > tr > th {\n  padding: 0;\n  margin: 0;\n}\n\n.bootstrap-table .fixed-table-footer tbody > tr > td {\n  padding: 0 !important;\n}\n\n.bootstrap-table .fixed-table-footer .table {\n  border-bottom: none;\n  border-radius: 0;\n  padding: 0 !important;\n}\n\n.bootstrap-table .pull-right .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n/* calculate scrollbar width */\np.fixed-table-scroll-inner {\n  width: 100%;\n  height: 200px;\n}\n\ndiv.fixed-table-scroll-outer {\n  top: 0;\n  left: 0;\n  visibility: hidden;\n  width: 200px;\n  height: 150px;\n  overflow: hidden;\n}\n\n/* for get correct heights  */\n.fixed-table-toolbar:after,\n.fixed-table-pagination:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  width: 100% !important;\n  background: #fff;\n}\n\n.bootstrap-table .btn-group:last-child .btn {\n  border-top-right-radius: 30px !important;\n  border-bottom-right-radius: 30px !important;\n  margin-left: -2px;\n}\n\n/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n\n.noUi-base {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n  /* Fix 401 */\n}\n\n.noUi-connect {\n  position: absolute;\n  right: 0;\n  top: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.noUi-origin {\n  position: absolute;\n  height: 0;\n  width: 0;\n}\n\n.noUi-handle {\n  position: relative;\n  z-index: 1;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n}\n\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n\n/* Painting and performance;\n * Browsers can paint handles in their own layer.\n */\n.noUi-base,\n.noUi-handle {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 8px;\n}\n\n.noUi-horizontal .noUi-handle {\n  background: white;\n  /* Old browsers */\n  background: -moz-linear-gradient(top, white 0%, #f1f1f2 100%);\n  /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, white),\n    color-stop(100%, #f1f1f2)\n  );\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(top, white 0%, #f1f1f2 100%);\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(top, white 0%, #f1f1f2 100%);\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, white 0%, #f1f1f2 100%);\n  /* IE10+ */\n  background: linear-gradient(to bottom, white 0%, #f1f1f2 100%);\n  /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$white-color', endColorstr='#f1f1f2',GradientType=0 );\n  /* IE6-9 */\n  border-radius: 50%;\n  box-shadow: 0 1px 1px #ffffff inset, 0 1px 2px rgba(0, 0, 0, 0.4);\n  height: 15px;\n  width: 15px;\n  cursor: pointer;\n  margin-left: -10px;\n  margin-top: -4px;\n}\n\n.noUi-vertical {\n  width: 18px;\n}\n\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\n\n/* Styling;\n */\n.noUi-target {\n  background-color: #e5e5e5;\n  border-radius: 3px;\n}\n\n.noUi-connect {\n  background: #3fb8af;\n  border-radius: 3px;\n  -webkit-transition: background 450ms;\n  transition: background 450ms;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n\n.noUi-handle {\n  border-radius: 3px;\n  background: #fff;\n  cursor: default;\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\n}\n\n.noUi-active {\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;\n}\n\n/* Handle stripes;\n */\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  text-align: center;\n}\n\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #ccc;\n}\n\n.noUi-marker-sub {\n  background: #aaa;\n}\n\n.noUi-marker-large {\n  background: #aaa;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n.noUi-value-horizontal {\n  -webkit-transform: translate3d(-50%, 50%, 0);\n  transform: translate3d(-50%, 50%, 0);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n\n.noUi-value-vertical {\n  -webkit-transform: translate3d(0, 50%, 0);\n  transform: translate3d(0, 50%, 0);\n  padding-left: 25px;\n}\n\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n}\n\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.slider.slider-info .noUi-connect,\n.slider.slider-info.noUi-connect {\n  background-color: #0fa0cf;\n}\n\n.slider.slider-info .noUi-handle {\n  border-color: #0fa0cf;\n}\n\n.slider.slider-success .noUi-connect,\n.slider.slider-success.noUi-connect {\n  background-color: #6bd098;\n}\n\n.slider.slider-success .noUi-handle {\n  border-color: #6bd098;\n}\n\n.slider.slider-warning .noUi-connect,\n.slider.slider-warning.noUi-connect {\n  background-color: #fbc658;\n}\n\n.slider.slider-warning .noUi-handle {\n  border-color: #fbc658;\n}\n\n.slider.slider-danger .noUi-connect,\n.slider.slider-danger.noUi-connect {\n  background-color: #ef8157;\n}\n\n.slider.slider-danger .noUi-handle {\n  border-color: #ef8157;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n}\n\n@-webkit-keyframes shake {\n  from,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n\n/* perfect-scrollbar v0.6.13 */\n.ps-container {\n  -ms-touch-action: auto;\n  touch-action: auto;\n  overflow: hidden !important;\n  -ms-overflow-style: none;\n}\n\n@supports (-ms-overflow-style: none) {\n  .ps-container {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps-container {\n    overflow: auto !important;\n  }\n}\n\n.ps-container.ps-active-x > .ps-scrollbar-x-rail,\n.ps-container.ps-active-y > .ps-scrollbar-y-rail {\n  display: block;\n  background-color: transparent;\n}\n\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n  background-color: #999;\n  width: 11px;\n}\n\n.ps-container > .ps-scrollbar-x-rail {\n  display: none;\n  position: absolute;\n  /* please don't change 'position' */\n  opacity: 0;\n  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;\n  -o-transition: background-color 0.2s linear, opacity 0.2s linear;\n  -moz-transition: background-color 0.2s linear, opacity 0.2s linear;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  bottom: 0px;\n  /* there must be 'bottom' for ps-scrollbar-x-rail */\n  height: 15px;\n}\n\n.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n  position: absolute;\n  /* please don't change 'position' */\n  background-color: #aaa;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  -webkit-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n  -o-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n  -moz-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n    -moz-border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n    -webkit-border-radius 0.2s ease-in-out, -moz-border-radius 0.2s ease-in-out;\n  bottom: 2px;\n  /* there must be 'bottom' for ps-scrollbar-x */\n  height: 6px;\n}\n\n.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x,\n.ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {\n  height: 11px;\n}\n\n.ps-container > .ps-scrollbar-y-rail {\n  display: none;\n  position: absolute;\n  /* please don't change 'position' */\n  opacity: 0;\n  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;\n  -o-transition: background-color 0.2s linear, opacity 0.2s linear;\n  -moz-transition: background-color 0.2s linear, opacity 0.2s linear;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  right: 0;\n  /* there must be 'right' for ps-scrollbar-y-rail */\n  width: 15px;\n}\n\n.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n  position: absolute;\n  /* please don't change 'position' */\n  background-color: #aaa;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  -webkit-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, -webkit-border-radius 0.2s ease-in-out;\n  -o-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n  -moz-transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n    -moz-border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out;\n  transition: background-color 0.2s linear, height 0.2s linear,\n    width 0.2s ease-in-out, border-radius 0.2s ease-in-out,\n    -webkit-border-radius 0.2s ease-in-out, -moz-border-radius 0.2s ease-in-out;\n  right: 2px;\n  /* there must be 'right' for ps-scrollbar-y */\n  width: 6px;\n}\n\n.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y,\n.ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {\n  width: 11px;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-x\n  > .ps-scrollbar-x-rail\n  > .ps-scrollbar-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container:hover.ps-in-scrolling.ps-y\n  > .ps-scrollbar-y-rail\n  > .ps-scrollbar-y {\n  background-color: #999;\n  width: 11px;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail,\n.ps-container:hover > .ps-scrollbar-y-rail {\n  opacity: 0.6;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail:hover {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n  background-color: #999;\n}\n\n.ps-container:hover > .ps-scrollbar-y-rail:hover {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n  background-color: #999;\n}\n\nbody.swal2-shown {\n  overflow-y: hidden;\n}\n\nbody.swal2-iosfix {\n  position: fixed;\n  left: 0;\n  right: 0;\n}\n\n.swal2-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 10px;\n  background-color: transparent;\n  z-index: 1060;\n}\n\n.swal2-container.swal2-fade {\n  -webkit-transition: background-color 0.1s;\n  transition: background-color 0.1s;\n}\n\n.swal2-container.swal2-shown {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.swal2-modal {\n  background-color: #fff;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  border-radius: 5px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  text-align: center;\n  margin: auto;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: none;\n  position: relative;\n  max-width: 100%;\n}\n\n.swal2-modal:focus {\n  outline: none;\n}\n\n.swal2-modal.swal2-loading {\n  overflow-y: hidden;\n}\n\n.swal2-modal .swal2-title {\n  color: #595959;\n  font-size: 30px;\n  text-align: center;\n  font-weight: 600;\n  text-transform: none;\n  position: relative;\n  margin: 0 0 0.4em;\n  padding: 0;\n  display: block;\n  word-wrap: break-word;\n}\n\n.swal2-modal .swal2-buttonswrapper {\n  margin-top: 15px;\n}\n\n.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {\n  opacity: 0.4;\n  cursor: no-drop;\n}\n\n.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 4px solid transparent;\n  border-color: transparent;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin: 7.5px;\n  vertical-align: top;\n  background-color: transparent !important;\n  color: transparent;\n  cursor: default;\n  border-radius: 100%;\n  -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n  animation: rotate-loading 1.5s linear 0s infinite normal;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.swal2-modal\n  .swal2-buttonswrapper.swal2-loading\n  :not(.swal2-styled).swal2-confirm::after {\n  display: inline-block;\n  content: \"\";\n  margin-left: 5px;\n  vertical-align: -1px;\n  height: 15px;\n  width: 15px;\n  border: 3px solid #999999;\n  -webkit-box-shadow: 1px 1px 1px #fff;\n  box-shadow: 1px 1px 1px #fff;\n  border-right-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n  animation: rotate-loading 1.5s linear 0s infinite normal;\n}\n\n.swal2-modal .swal2-styled {\n  border: 0;\n  border-radius: 3px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 17px;\n  font-weight: 500;\n  margin: 15px 5px 0;\n  padding: 10px 32px;\n}\n\n.swal2-modal .swal2-styled:focus {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n}\n\n.swal2-modal .swal2-image {\n  margin: 20px auto;\n  max-width: 100%;\n}\n\n.swal2-modal .swal2-close {\n  background: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  width: 38px;\n  height: 40px;\n  font-size: 36px;\n  line-height: 40px;\n  font-family: serif;\n  position: absolute;\n  top: 5px;\n  right: 8px;\n  cursor: pointer;\n  color: #cccccc;\n  -webkit-transition: color 0.1s ease;\n  transition: color 0.1s ease;\n}\n\n.swal2-modal .swal2-close:hover {\n  color: #d55;\n}\n\n.swal2-modal > .swal2-input,\n.swal2-modal > .swal2-file,\n.swal2-modal > .swal2-textarea,\n.swal2-modal > .swal2-select,\n.swal2-modal > .swal2-radio,\n.swal2-modal > .swal2-checkbox {\n  display: none;\n}\n\n.swal2-modal .swal2-content {\n  font-size: 18px;\n  text-align: center;\n  font-weight: 300;\n  position: relative;\n  float: none;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  color: #545454;\n  word-wrap: break-word;\n}\n\n.swal2-modal .swal2-input,\n.swal2-modal .swal2-file,\n.swal2-modal .swal2-textarea,\n.swal2-modal .swal2-select,\n.swal2-modal .swal2-radio,\n.swal2-modal .swal2-checkbox {\n  margin: 20px auto;\n}\n\n.swal2-modal .swal2-input,\n.swal2-modal .swal2-file,\n.swal2-modal .swal2-textarea {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  font-size: 18px;\n  border-radius: 3px;\n  border: 1px solid #d9d9d9;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n  -webkit-transition: border-color 0.3s, -webkit-box-shadow 0.3s;\n  transition: border-color 0.3s, -webkit-box-shadow 0.3s;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  transition: border-color 0.3s, box-shadow 0.3s, -webkit-box-shadow 0.3s;\n}\n\n.swal2-modal .swal2-input.swal2-inputerror,\n.swal2-modal .swal2-file.swal2-inputerror,\n.swal2-modal .swal2-textarea.swal2-inputerror {\n  border-color: #f27474 !important;\n  -webkit-box-shadow: 0 0 2px #f27474 !important;\n  box-shadow: 0 0 2px #f27474 !important;\n}\n\n.swal2-modal .swal2-input:focus,\n.swal2-modal .swal2-file:focus,\n.swal2-modal .swal2-textarea:focus {\n  outline: none;\n  border: 1px solid #b4dbed;\n  -webkit-box-shadow: 0 0 3px #c4e6f5;\n  box-shadow: 0 0 3px #c4e6f5;\n}\n\n.swal2-modal .swal2-input::-webkit-input-placeholder,\n.swal2-modal .swal2-file::-webkit-input-placeholder,\n.swal2-modal .swal2-textarea::-webkit-input-placeholder {\n  color: #cccccc;\n}\n\n.swal2-modal .swal2-input:-ms-input-placeholder,\n.swal2-modal .swal2-file:-ms-input-placeholder,\n.swal2-modal .swal2-textarea:-ms-input-placeholder {\n  color: #cccccc;\n}\n\n.swal2-modal .swal2-input::placeholder,\n.swal2-modal .swal2-file::placeholder,\n.swal2-modal .swal2-textarea::placeholder {\n  color: #cccccc;\n}\n\n.swal2-modal .swal2-range input {\n  float: left;\n  width: 80%;\n}\n\n.swal2-modal .swal2-range output {\n  float: right;\n  width: 20%;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.swal2-modal .swal2-range input,\n.swal2-modal .swal2-range output {\n  height: 43px;\n  line-height: 43px;\n  vertical-align: middle;\n  margin: 20px auto;\n  padding: 0;\n}\n\n.swal2-modal .swal2-input {\n  height: 43px;\n  padding: 0 12px;\n}\n\n.swal2-modal .swal2-input[type=\"number\"] {\n  max-width: 150px;\n}\n\n.swal2-modal .swal2-file {\n  font-size: 20px;\n}\n\n.swal2-modal .swal2-textarea {\n  height: 108px;\n  padding: 12px;\n}\n\n.swal2-modal .swal2-select {\n  color: #545454;\n  font-size: inherit;\n  padding: 5px 10px;\n  min-width: 40%;\n  max-width: 100%;\n}\n\n.swal2-modal .swal2-radio {\n  border: 0;\n}\n\n.swal2-modal .swal2-radio label:not(:first-child) {\n  margin-left: 20px;\n}\n\n.swal2-modal .swal2-radio input,\n.swal2-modal .swal2-radio span {\n  vertical-align: middle;\n}\n\n.swal2-modal .swal2-radio input {\n  margin: 0 3px 0 0;\n}\n\n.swal2-modal .swal2-checkbox {\n  color: #545454;\n}\n\n.swal2-modal .swal2-checkbox input,\n.swal2-modal .swal2-checkbox span {\n  vertical-align: middle;\n}\n\n.swal2-modal .swal2-validationerror {\n  background-color: #f0f0f0;\n  margin: 0 -20px;\n  overflow: hidden;\n  padding: 10px;\n  color: gray;\n  font-size: 16px;\n  font-weight: 300;\n  display: none;\n}\n\n.swal2-modal .swal2-validationerror::before {\n  content: \"!\";\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #ea7d7d;\n  color: #fff;\n  line-height: 24px;\n  text-align: center;\n  margin-right: 10px;\n}\n\n@supports (-ms-accelerator: true) {\n  .swal2-range input {\n    width: 100% !important;\n  }\n  .swal2-range output {\n    display: none;\n  }\n}\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-range input {\n    width: 100% !important;\n  }\n  .swal2-range output {\n    display: none;\n  }\n}\n\n.swal2-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid transparent;\n  border-radius: 50%;\n  margin: 20px auto 30px;\n  padding: 0;\n  position: relative;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  cursor: default;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.swal2-icon.swal2-error {\n  border-color: rgba(255, 54, 54, 0.3);\n}\n\n.swal2-icon.swal2-error .swal2-x-mark {\n  position: relative;\n  display: block;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"] {\n  position: absolute;\n  height: 5px;\n  width: 47px;\n  background-color: #ff3636;\n  display: block;\n  top: 37px;\n  border-radius: 2px;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"][class$=\"left\"] {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  left: 17px;\n}\n\n.swal2-icon.swal2-error [class^=\"swal2-x-mark-line\"][class$=\"right\"] {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  right: 16px;\n}\n\n.swal2-icon.swal2-warning {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #ffb236;\n  border-color: #ffb236;\n  font-size: 60px;\n  line-height: 80px;\n  text-align: center;\n}\n\n.swal2-icon.swal2-info {\n  font-family: \"Open Sans\", sans-serif;\n  color: #3fc3ee;\n  border-color: #9de0f6;\n  font-size: 60px;\n  line-height: 80px;\n  text-align: center;\n}\n\n.swal2-icon.swal2-question {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #87adbd;\n  border-color: #c9dae1;\n  font-size: 60px;\n  line-height: 80px;\n  text-align: center;\n}\n\n.swal2-icon.swal2-success {\n  border-color: #a5dc86;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-circular-line\"] {\n  border-radius: 50%;\n  position: absolute;\n  width: 60px;\n  height: 120px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.swal2-icon.swal2-success\n  [class^=\"swal2-success-circular-line\"][class$=\"left\"] {\n  border-radius: 120px 0 0 120px;\n  top: -7px;\n  left: -33px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 60px 60px;\n  transform-origin: 60px 60px;\n}\n\n.swal2-icon.swal2-success\n  [class^=\"swal2-success-circular-line\"][class$=\"right\"] {\n  border-radius: 0 120px 120px 0;\n  top: -11px;\n  left: 30px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 0 60px;\n  transform-origin: 0 60px;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  width: 80px;\n  height: 80px;\n  border: 4px solid rgba(24, 206, 15, 0.3);\n  border-radius: 50%;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 2;\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n  width: 7px;\n  height: 90px;\n  position: absolute;\n  left: 28px;\n  top: 8px;\n  z-index: 1;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"] {\n  height: 5px;\n  background-color: #18ce0f;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 2;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"][class$=\"tip\"] {\n  width: 25px;\n  left: 14px;\n  top: 46px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"][class$=\"long\"] {\n  width: 47px;\n  right: 8px;\n  top: 38px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.swal2-progresssteps {\n  font-weight: 600;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.swal2-progresssteps li {\n  display: inline-block;\n  position: relative;\n}\n\n.swal2-progresssteps .swal2-progresscircle {\n  background: #3085d6;\n  border-radius: 2em;\n  color: #fff;\n  height: 2em;\n  line-height: 2em;\n  text-align: center;\n  width: 2em;\n  z-index: 20;\n}\n\n.swal2-progresssteps .swal2-progresscircle:first-child {\n  margin-left: 0;\n}\n\n.swal2-progresssteps .swal2-progresscircle:last-child {\n  margin-right: 0;\n}\n\n.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {\n  background: #3085d6;\n}\n\n.swal2-progresssteps\n  .swal2-progresscircle.swal2-activeprogressstep\n  ~ .swal2-progresscircle {\n  background: #add8e6;\n}\n\n.swal2-progresssteps\n  .swal2-progresscircle.swal2-activeprogressstep\n  ~ .swal2-progressline {\n  background: #add8e6;\n}\n\n.swal2-progresssteps .swal2-progressline {\n  background: #3085d6;\n  height: 0.4em;\n  margin: 0 -1px;\n  z-index: 10;\n}\n\n[class^=\"swal2\"] {\n  -webkit-tap-highlight-color: transparent;\n}\n\n@-webkit-keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n    transform: scale(0.7);\n  }\n  45% {\n    -webkit-transform: scale(1.05);\n    transform: scale(1.05);\n  }\n  80% {\n    -webkit-transform: scale(0.95);\n    transform: scale(0.95);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n    transform: scale(0.7);\n  }\n  45% {\n    -webkit-transform: scale(1.05);\n    transform: scale(1.05);\n  }\n  80% {\n    -webkit-transform: scale(0.95);\n    transform: scale(0.95);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n\n@keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n\n.swal2-show {\n  -webkit-animation: showSweetAlert 0.3s;\n  animation: showSweetAlert 0.3s;\n}\n\n.swal2-show.swal2-noanimation {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.swal2-hide {\n  -webkit-animation: hideSweetAlert 0.15s forwards;\n  animation: hideSweetAlert 0.15s forwards;\n}\n\n.swal2-hide.swal2-noanimation {\n  -webkit-animation: none;\n  animation: none;\n}\n\n@-webkit-keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@-webkit-keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n@keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  }\n  5% {\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  }\n  12% {\n    -webkit-transform: rotate(-405deg);\n    transform: rotate(-405deg);\n  }\n  100% {\n    -webkit-transform: rotate(-405deg);\n    transform: rotate(-405deg);\n  }\n}\n\n@keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  }\n  5% {\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  }\n  12% {\n    -webkit-transform: rotate(-405deg);\n    transform: rotate(-405deg);\n  }\n  100% {\n    -webkit-transform: rotate(-405deg);\n    transform: rotate(-405deg);\n  }\n}\n\n.swal2-animate-success-line-tip {\n  -webkit-animation: animate-success-tip 0.75s;\n  animation: animate-success-tip 0.75s;\n}\n\n.swal2-animate-success-line-long {\n  -webkit-animation: animate-success-long 0.75s;\n  animation: animate-success-long 0.75s;\n}\n\n.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n@-webkit-keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: rotateX(0deg);\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: rotateX(0deg);\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n.swal2-animate-error-icon {\n  -webkit-animation: animate-error-icon 0.5s;\n  animation: animate-error-icon 0.5s;\n}\n\n@-webkit-keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    -webkit-transform: scale(1.15);\n    transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    -webkit-transform: scale(1.15);\n    transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n\n.swal2-animate-x-mark {\n  -webkit-animation: animate-x-mark 0.5s;\n  animation: animate-x-mark 0.5s;\n}\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.card-wizard {\n  min-height: 410px;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  opacity: 0;\n  -webkit-transition: all 300ms linear;\n  -moz-transition: all 300ms linear;\n  -o-transition: all 300ms linear;\n  -ms-transition: all 300ms linear;\n  transition: all 300ms linear;\n}\n.card-wizard.active {\n  opacity: 1;\n}\n.card-wizard .card-header {\n  padding: 15px 0 !important;\n  padding-bottom: 40px;\n}\n.card-wizard .nav-pills .nav-item .nav-link {\n  padding: 12px;\n}\n.card-wizard .nav-pills .nav-item .nav-link,\n.card-wizard .nav-pills .nav-item .nav-link.active,\n.card-wizard .nav-pills .nav-item .nav-link:hover,\n.card-wizard .nav-pills .nav-item .nav-link:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:hover {\n  background-color: transparent;\n  box-shadow: none;\n}\n.card-wizard .picture-container {\n  position: relative;\n  cursor: pointer;\n  text-align: center;\n}\n.card-wizard .wizard-navigation {\n  position: relative;\n}\n.card-wizard .wizard-navigation .nav-link {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.card-wizard .wizard-navigation .nav-link i,\n.card-wizard .moving-tab i {\n  display: inline-block;\n  font-size: 19px;\n  line-height: initial;\n  margin-right: 6px;\n  padding: 0;\n  vertical-align: bottom;\n}\n.card-wizard .picture {\n  width: 106px;\n  height: 106px;\n  background-color: #999999;\n  border: 1px solid #e3e3e3;\n  color: #ffffff;\n  border-radius: 50%;\n  margin: 5px auto;\n  overflow: hidden;\n  transition: all 0.2s;\n  -webkit-transition: all 0.2s;\n}\n.card-wizard .picture:hover {\n  border-color: #2ca8ff;\n}\n.card-wizard .moving-tab {\n  position: absolute;\n  text-align: center;\n  padding: 12px;\n  font-size: 12px;\n  text-transform: uppercase;\n  -webkit-font-smoothing: subpixel-antialiased;\n  top: 0px;\n  left: 0px;\n  background-color: #66615b;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  color: #ffffff !important;\n  cursor: pointer;\n  font-weight: 500;\n}\n.card-wizard[data-color=\"primary\"] .moving-tab {\n  color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .picture:hover {\n  border-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .choice:hover .icon,\n.card-wizard[data-color=\"primary\"] .choice.active .icon {\n  border-color: #51cbce;\n  color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"]\n  .radio\n  input[type=\"radio\"]:checked\n  ~ .circle {\n  border-color: #51cbce;\n}\n.card-wizard[data-color=\"white\"] .moving-tab {\n  color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .picture:hover {\n  border-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .choice:hover .icon,\n.card-wizard[data-color=\"white\"] .choice.active .icon {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.card-wizard[data-color=\"white\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #ffffff;\n}\n.card-wizard[data-color=\"green\"] .moving-tab {\n  color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .picture:hover {\n  border-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .choice:hover .icon,\n.card-wizard[data-color=\"green\"] .choice.active .icon {\n  border-color: #6bd098;\n  color: #6bd098;\n}\n.card-wizard[data-color=\"green\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #6bd098;\n}\n.card-wizard[data-color=\"blue\"] .moving-tab {\n  color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .picture:hover {\n  border-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .choice:hover .icon,\n.card-wizard[data-color=\"blue\"] .choice.active .icon {\n  border-color: #0fa0cf;\n  color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #0fa0cf;\n}\n.card-wizard[data-color=\"orange\"] .moving-tab {\n  color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .picture:hover {\n  border-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .choice:hover .icon,\n.card-wizard[data-color=\"orange\"] .choice.active .icon {\n  border-color: #fbc658;\n  color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #fbc658;\n}\n.card-wizard[data-color=\"red\"] .moving-tab {\n  color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .picture:hover {\n  border-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .choice:hover .icon,\n.card-wizard[data-color=\"red\"] .choice.active .icon {\n  border-color: #ef8157;\n  color: #ef8157;\n}\n.card-wizard[data-color=\"red\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #ef8157;\n}\n.card-wizard .picture input[type=\"file\"] {\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  opacity: 0 !important;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.card-wizard .picture-src {\n  width: 100%;\n}\n.card-wizard .tab-content {\n  min-height: 355px;\n  padding: 20px 0;\n}\n.card-wizard .wizard-footer {\n  padding: 0 15px;\n}\n.card-wizard .wizard-footer .checkbox {\n  margin-top: 16px;\n}\n.card-wizard .disabled {\n  display: none;\n}\n.card-wizard .wizard-header {\n  text-align: center;\n  padding: 25px 0 35px;\n}\n.card-wizard .wizard-header h5 {\n  margin: 5px 0 0;\n}\n.card-wizard .nav-pills > li {\n  text-align: center;\n}\n.card-wizard .btn {\n  text-transform: uppercase;\n}\n.card-wizard .info-text {\n  text-align: center;\n  font-weight: 300;\n  margin: 10px 0 30px;\n}\n.card-wizard .choice {\n  text-align: center;\n  cursor: pointer;\n  margin-top: 20px;\n}\n.card-wizard .choice[disabled] {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.card-wizard .choice .icon {\n  text-align: center;\n  vertical-align: middle;\n  height: 116px;\n  width: 116px;\n  border-radius: 50%;\n  color: #66615b;\n  margin: 0 auto 20px;\n  border: 1px solid #e3e3e3;\n  transition: all 0.2s;\n  -webkit-transition: all 0.2s;\n}\n.card-wizard .choice i {\n  font-size: 30px;\n  line-height: 116px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.card-wizard .choice:hover .icon,\n.card-wizard .choice.active .icon {\n  border-color: #2ca8ff;\n}\n.card-wizard .choice input[type=\"radio\"],\n.card-wizard .choice input[type=\"checkbox\"] {\n  position: absolute;\n  left: -10000px;\n  z-index: -1;\n}\n.card-wizard .btn-finish {\n  display: none;\n}\n.card-wizard .card-title + .description {\n  font-size: 17px;\n  margin-bottom: 32px;\n}\n.card-wizard .wizard-title {\n  margin: 0;\n}\n.card-wizard .nav-pills {\n  background-color: #9a9a9a;\n}\n.card-wizard .nav-pills > li + li {\n  margin-left: 0;\n}\n.card-wizard .nav-pills > li > a {\n  border: 0 !important;\n  border-radius: 0;\n  line-height: 18px;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 100px;\n  text-align: center;\n  color: #ffffff !important;\n}\n.card-wizard .nav-pills > li.active > a,\n.card-wizard .nav-pills > li.active > a:hover,\n.card-wizard .nav-pills > li.active > a:focus,\n.card-wizard .nav-pills > li > a:hover,\n.card-wizard .nav-pills > li > a:focus {\n  background-color: inherit;\n  box-shadow: none;\n}\n.card-wizard .nav-pills > li i {\n  display: block;\n  font-size: 30px;\n  padding: 15px 0;\n}\n.card-wizard .form-group.select-wizard {\n  margin-top: 15px;\n}\n.card-wizard .dropdown.show .dropdown-menu,\n.card-wizard .dropup.show .dropdown-menu {\n  -webkit-transform: translate3d(0, 0px, 0) !important;\n  -moz-transform: translate3d(0, 0px, 0) !important;\n  -o-transform: translate3d(0, 0px, 0) !important;\n  -ms-transform: translate3d(0, 0px, 0) !important;\n  transform: translate3d(0, 0px, 0) !important;\n}\n\n/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n.sr-only,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\n.bootstrap-datetimepicker-widget .picker-switch::after,\n.bootstrap-datetimepicker-widget table th.prev::after,\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n\n.bootstrap-datetimepicker-widget a .btn:hover {\n  background-color: transparent;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  padding: 4px;\n  width: 16em;\n}\n\n@media (min-width: 768px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n\n@media (min-width: 992px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n\n@media (min-width: 1200px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  left: auto;\n  top: -12px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n  border-bottom: 11px solid #ffffff;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  left: auto;\n  top: -11px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\n  margin-top: auto;\n  margin-bottom: -20px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\n  margin-top: auto;\n  margin-bottom: 5px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 6px 0;\n  border-width: 0;\n  color: #66615b;\n  background-color: transparent;\n}\n\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\n  color: #429cb6 !important;\n}\n\n.bootstrap-datetimepicker-widget a[data-action]:hover {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-weight: 300;\n  font-size: 1.5em;\n  margin: 3px;\n  border-radius: 50%;\n}\n\n.bootstrap-datetimepicker-widget button[data-action] {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  content: \"Increment Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  content: \"Increment Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  content: \"Decrement Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  content: \"Decrement Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  content: \"Show Hours\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  content: \"Show Minutes\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  content: \"Toggle AM/PM\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  content: \"Clear the picker\";\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  content: \"Set the date to today\";\n}\n\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n  border-radius: 4px;\n}\n\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  content: \"Toggle Date and Time Screens\";\n}\n\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n\n.bootstrap-datetimepicker-widget .picker-switch td span {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n  border-radius: 4px;\n  margin: 2px 0px !important;\n}\n\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n}\n\n.bootstrap-datetimepicker-widget table td > div,\n.bootstrap-datetimepicker-widget table th > div {\n  text-align: center;\n}\n\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n\n.bootstrap-datetimepicker-widget table th.disabled,\n.bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget table th.prev span,\n.bootstrap-datetimepicker-widget table th.next span {\n  border-radius: 4px;\n  height: 27px;\n  width: 27px;\n  line-height: 28px;\n  font-size: 12px;\n  border-radius: 50%;\n  text-align: center;\n}\n\n.bootstrap-datetimepicker-widget table th.prev::after {\n  content: \"Previous Month\";\n}\n\n.bootstrap-datetimepicker-widget table th.next::after {\n  content: \"Next Month\";\n}\n\n.bootstrap-datetimepicker-widget table th.dow {\n  text-align: center;\n  border-bottom: 1px solid #e3e3e3;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9a9a9a;\n  font-weight: 400;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,\n.bootstrap-datetimepicker-widget\n  table\n  thead\n  tr:first-child\n  th.picker-switch:hover {\n  background: #e3e3e3;\n}\n\n.bootstrap-datetimepicker-widget table td > div {\n  border-radius: 4px;\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n  text-align: center;\n}\n\n.bootstrap-datetimepicker-widget table td.cw > div {\n  font-size: 0.8em;\n  height: 20px;\n  line-height: 20px;\n  color: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td.day > div {\n  height: 30px;\n  line-height: 31px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  margin: 0 auto;\n  z-index: -1;\n  position: relative;\n}\n\n.table-condensed .day:hover div {\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n}\n\n.bootstrap-datetimepicker-widget table td.minute > div,\n.bootstrap-datetimepicker-widget table td.hour > div {\n  border-radius: 50%;\n}\n\n.bootstrap-datetimepicker-widget table td.day:hover > div,\n.bootstrap-datetimepicker-widget table td.hour:hover > div,\n.bootstrap-datetimepicker-widget table td.minute:hover > div,\n.bootstrap-datetimepicker-widget table td.second:hover > div {\n  background: #e3e3e3;\n  cursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget table td.old > div,\n.bootstrap-datetimepicker-widget table td.new > div {\n  color: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td.today > div:before {\n  content: \"\";\n  display: inline-block;\n  border: 0 0 7px 7px solid transparent;\n  border-bottom-color: #68b3c8;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n\n.bootstrap-datetimepicker-widget table td.active > div,\n.bootstrap-datetimepicker-widget table td.active:hover > div {\n  background-color: #68b3c8;\n  color: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\n  border-bottom-color: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td.disabled > div,\n.bootstrap-datetimepicker-widget table td.disabled:hover > div {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget table td span {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  margin: 3px 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n\n.bootstrap-datetimepicker-widget table td span:hover {\n  background: #e3e3e3;\n}\n\n.bootstrap-datetimepicker-widget table td span.active {\n  background-color: #68b3c8;\n  color: #ffffff;\n}\n\n.bootstrap-datetimepicker-widget table td span.old {\n  color: #cfcfca;\n}\n\n.bootstrap-datetimepicker-widget table td span.disabled,\n.bootstrap-datetimepicker-widget table td span.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n\n.bootstrap-datetimepicker-widget .timepicker-picker span,\n.bootstrap-datetimepicker-widget .timepicker-hours span,\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\n  border-radius: 50% !important;\n}\n\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n\n.input-group.date .input-group-addon {\n  cursor: pointer;\n}\n\n.table-condensed > tbody > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > thead > tr > th {\n  padding: 1px;\n  text-align: center;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.bootstrap-datetimepicker-widget {\n  opacity: 0;\n  -webkit-box-shadow: 0 2px rgba(17, 16, 15, 0.1),\n    0 2px 10px rgba(17, 16, 15, 0.1);\n  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\n  -webkit-transform: translate3d(0, -10px, 0) !important;\n  -moz-transform: translate3d(0, -10px, 0) !important;\n  -o-transform: translate3d(0, -10px, 0) !important;\n  -ms-transform: translate3d(0, -10px, 0) !important;\n  transform: translate3d(0, -10px, 0) !important;\n}\n.bootstrap-datetimepicker-widget.top {\n  -webkit-transform: translate3d(0, 10px, 0) !important;\n  -moz-transform: translate3d(0, 10px, 0) !important;\n  -o-transform: translate3d(0, 10px, 0) !important;\n  -ms-transform: translate3d(0, 10px, 0) !important;\n  transform: translate3d(0, 10px, 0) !important;\n  opacity: 0;\n}\n.bootstrap-datetimepicker-widget.open {\n  opacity: 1;\n  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  -webkit-transform: translate3d(0, 2px, 0) !important;\n  -moz-transform: translate3d(0, 2px, 0) !important;\n  -o-transform: translate3d(0, 2px, 0) !important;\n  -ms-transform: translate3d(0, 2px, 0) !important;\n  transform: translate3d(0, 2px, 0) !important;\n}\n\n.bootstrap-datetimepicker-widget.top.open {\n  opacity: 1;\n  -webkit-transform: translate3d(0, -7px, 0) !important;\n  -moz-transform: translate3d(0, -7px, 0) !important;\n  -o-transform: translate3d(0, -7px, 0) !important;\n  -ms-transform: translate3d(0, -7px, 0) !important;\n  transform: translate3d(0, -7px, 0) !important;\n  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n}\n.bootstrap-datetimepicker-widget.top.open:before {\n  border-top: 11px solid #dcd9d1;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  bottom: -12px;\n}\n.bootstrap-datetimepicker-widget.top.open:after {\n  border-top: 11px solid #ffffff;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  bottom: -11px;\n}\n\n/*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */\nselect.bs-select-hidden,\nselect.selectpicker {\n  display: none !important;\n}\n\n.bootstrap-select {\n  width: 220px;\n  /*IE9 and below*/\n}\n.bootstrap-select > .dropdown-toggle {\n  width: 100%;\n  padding-right: 25px;\n  z-index: 1;\n}\n.bootstrap-select > select {\n  position: absolute !important;\n  bottom: 0;\n  left: 50%;\n  display: block !important;\n  width: 0.5px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  opacity: 0 !important;\n  border: none;\n}\n.bootstrap-select > select.mobile-device {\n  top: 0;\n  left: 0;\n  display: block !important;\n  width: 100% !important;\n  z-index: 2;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle {\n  border-color: #b94a48;\n}\n.bootstrap-select.fit-width {\n  width: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n  width: 150px;\n}\n\n.bootstrap-select.form-control {\n  margin-bottom: 0;\n  padding: 0;\n  border: none;\n}\n.bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n  z-index: auto;\n}\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)\n  > .btn {\n  border-radius: 0;\n}\n\n.bootstrap-select.btn-group:not(.input-group-btn),\n.bootstrap-select.btn-group[class*=\"col-\"] {\n  float: none;\n  display: inline-block;\n  margin-left: 0;\n}\n\n.bootstrap-select.btn-group.dropdown-menu-right,\n.bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right {\n  float: right;\n}\n\n.form-inline .bootstrap-select.btn-group,\n.form-horizontal .bootstrap-select.btn-group,\n.form-group .bootstrap-select.btn-group {\n  margin-bottom: 0;\n}\n\n.form-group-lg .bootstrap-select.btn-group.form-control,\n.form-group-sm .bootstrap-select.btn-group.form-control {\n  padding: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {\n  height: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n\n.form-inline .bootstrap-select.btn-group .form-control {\n  width: 100%;\n}\n\n.bootstrap-select.btn-group.disabled,\n.bootstrap-select.btn-group > .disabled {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group.disabled:focus,\n.bootstrap-select.btn-group > .disabled:focus {\n  outline: none !important;\n}\n\n.bootstrap-select.btn-group.bs-container {\n  position: absolute;\n  height: 0 !important;\n  padding: 0 !important;\n}\n.bootstrap-select.btn-group.bs-container .dropdown-menu {\n  z-index: 1060;\n}\n\n.bootstrap-select.btn-group .dropdown-toggle .filter-option {\n  display: inline-block;\n  overflow: hidden;\n  width: 100%;\n  text-align: left;\n}\n\n.bootstrap-select.btn-group[class*=\"col-\"] .dropdown-toggle {\n  width: 100%;\n}\n\n.bootstrap-select.btn-group .dropdown-menu {\n  min-width: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.bootstrap-select.btn-group .dropdown-menu.inner {\n  position: static;\n  float: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n.bootstrap-select.btn-group .dropdown-menu li {\n  position: relative;\n}\n.bootstrap-select.btn-group .dropdown-menu li.active small {\n  color: #fff;\n}\n.bootstrap-select.btn-group .dropdown-menu li.disabled a {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group .dropdown-menu li a {\n  color: #66615b;\n  font-size: 16px;\n  padding: 5px 45px 5px 15px;\n  clear: both;\n  white-space: nowrap;\n  width: 100%;\n  display: block;\n}\n.bootstrap-select.btn-group .dropdown-menu li a:hover {\n  background-color: #66615b;\n  color: rgba(255, 255, 255, 0.7);\n  opacity: 1;\n  text-decoration: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a.opt {\n  position: relative;\n  padding-left: 2.25em;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {\n  display: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.text {\n  display: inline-block;\n}\n.bootstrap-select.btn-group .dropdown-menu li small {\n  padding-left: 0.5em;\n}\n.bootstrap-select.btn-group .dropdown-menu .notify {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: whitesmoke;\n  border: 1px solid #e3e3e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  pointer-events: none;\n  opacity: 0.9;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.bootstrap-select.btn-group .no-results {\n  padding: 3px;\n  background: #f5f5f5;\n  margin: 0 5px;\n  white-space: nowrap;\n}\n\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {\n  position: static;\n}\n\n.bootstrap-select.btn-group.show-tick\n  .dropdown-menu\n  li.selected\n  a\n  span.check-mark {\n  position: absolute;\n  display: inline-block;\n  right: 15px;\n  margin-top: 5px;\n}\n\n.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {\n  margin-right: 34px;\n}\n\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {\n  z-index: 1061;\n}\n\n.bootstrap-select.show-menu-arrow .dropdown-toggle:before {\n  content: \"\";\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid rgba(204, 204, 204, 0.2);\n  position: absolute;\n  bottom: -4px;\n  left: 9px;\n  display: none;\n}\n\n.bootstrap-select.show-menu-arrow .dropdown-toggle:after {\n  content: \"\";\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  position: absolute;\n  bottom: -4px;\n  left: 10px;\n  display: none;\n}\n\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {\n  bottom: auto;\n  top: -3px;\n  border-top: 7px solid rgba(204, 204, 204, 0.2);\n  border-bottom: 0;\n}\n\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {\n  bottom: auto;\n  top: -3px;\n  border-top: 6px solid white;\n  border-bottom: 0;\n}\n\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {\n  right: 12px;\n  left: auto;\n}\n\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {\n  right: 13px;\n  left: auto;\n}\n\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:before,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:after {\n  display: block;\n}\n\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n  padding: 4px 8px;\n}\n\n.bs-actionsbox {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n  width: 50%;\n}\n\n.bs-donebutton {\n  float: left;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n  width: 100%;\n}\n\n.bs-searchbox + .bs-actionsbox {\n  padding: 0 8px 4px;\n}\n\n.bs-searchbox .form-control {\n  margin-bottom: 0;\n  width: 100%;\n  float: none;\n}\n\n.bootstrap-select.show:before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n  top: 50px;\n}\n\n.bootstrap-select.show:after {\n  border-bottom: 11px solid #fffcf5;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n  top: 51px;\n}\n\n.bootstrap-select.dropup.show:before {\n  border-top: 11px solid #dcd9d1;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  border-bottom: none;\n  right: 15px;\n  top: -11px;\n}\n\n.bootstrap-select.dropup.show:after {\n  border-top: 11px solid #ffffff;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  border-bottom: none;\n  right: 15px;\n  top: -12px;\n}\n\n.bootstrap-select .dropdown-menu .dropdown-menu {\n  -webkit-transform: translate3d(0, 0, 0) !important;\n  -moz-transform: translate3d(0, 0, 0) !important;\n  -o-transform: translate3d(0, 0, 0) !important;\n  -ms-transform: translate3d(0, 0, 0) !important;\n  transform: translate3d(0, 0, 0) !important;\n}\n.bootstrap-select .dropdown-menu .dropdown-menu:after,\n.bootstrap-select .dropdown-menu .dropdown-menu:before {\n  display: none;\n}\n\n.bootstrap-select.dropup .dropdown-menu.show {\n  -webkit-transform: translate3d(0, -60px, 0) !important;\n  -moz-transform: translate3d(0, -60px, 0) !important;\n  -o-transform: translate3d(0, -60px, 0) !important;\n  -ms-transform: translate3d(0, -60px, 0) !important;\n  transform: translate3d(0, -60px, 0) !important;\n}\n\n.btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  direction: ltr;\n}\n\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n}\n\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 250px;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.fileinput .thumbnail.img-circle {\n  border-radius: 50%;\n  max-width: 100px;\n}\n\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n\n.fileinput .btn {\n  vertical-align: middle;\n}\n\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n\n.fileinput.input-group {\n  display: table;\n}\n\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: #fbc658;\n}\n\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: #fbc658;\n}\n\n.form-group.has-error .fileinput .fileinput-preview {\n  color: #ef8157;\n}\n\n.form-group.has-error .fileinput .thumbnail {\n  border-color: #ef8157;\n}\n\n.form-group.has-success .fileinput .fileinput-preview {\n  color: #6bd098;\n}\n\n.form-group.has-success .fileinput .thumbnail {\n  border-color: #6bd098;\n}\n\n.input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n\n.thumbnail {\n  border: 0 none;\n  border-radius: 3px;\n  padding: 0;\n}\n\n.bootstrap-tagsinput {\n  background-color: transparent;\n  display: inline-block;\n  padding: 4px 6px;\n  vertical-align: middle;\n  border-radius: 4px;\n  width: 100%;\n  line-height: 22px;\n  cursor: text;\n}\n.bootstrap-tagsinput input {\n  border: none;\n  box-shadow: none;\n  outline: none;\n  background-color: transparent;\n  padding: 0 6px;\n  margin: 0;\n  width: auto;\n  max-width: inherit;\n}\n.bootstrap-tagsinput input:focus {\n  border: none;\n  box-shadow: none;\n}\n.bootstrap-tagsinput input::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.bootstrap-tagsinput input:-ms-input-placeholder {\n  color: #999;\n}\n.bootstrap-tagsinput input::-webkit-input-placeholder {\n  color: #999;\n}\n.bootstrap-tagsinput.form-control input::-moz-placeholder {\n  color: #999;\n}\n.bootstrap-tagsinput.form-control input:-ms-input-placeholder {\n  color: #999;\n}\n.bootstrap-tagsinput.form-control input::-webkit-input-placeholder {\n  color: #999;\n}\n.bootstrap-tagsinput .badge {\n  -webkit-transition: all 170ms linear;\n  -moz-transition: all 170ms linear;\n  -o-transition: all 170ms linear;\n  -ms-transition: all 170ms linear;\n  transition: all 170ms linear;\n}\n.bootstrap-tagsinput .badge {\n  cursor: pointer;\n  margin: 5px 3px 5px 0;\n  position: relative;\n  padding: 4px 8px 3px 0.8em;\n  border-radius: 12px;\n  color: #fff;\n  font-size: 0.75em;\n  font-weight: 500;\n  display: inline-block;\n  line-height: 1.5em;\n  text-transform: uppercase;\n}\n.bootstrap-tagsinput .badge:hover {\n  padding-right: 25px;\n}\n.bootstrap-tagsinput .badge:hover [data-role=\"remove\"] {\n  opacity: 1;\n  padding-right: 6px;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"] {\n  cursor: pointer;\n  position: absolute;\n  top: 3.5px;\n  right: 0;\n  opacity: 0;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"]:after {\n  content: \"\\f00d\";\n  padding: 0px 4px;\n  font-size: 18px;\n  font: normal normal normal 10px/1 FontAwesome;\n}\n.bootstrap-tagsinput .badge [data-role=\"remove\"]:hover:active {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  opacity: 1;\n}\n\n.badge-success {\n  background-color: #7ac29a;\n}\n\n/*\n * This combined file was created by the DataTables downloader builder:\n *   https://datatables.net/download\n *\n * To rebuild or modify this file with the latest versions of the included\n * software please visit:\n *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3\n *\n * Included libraries:\n *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3\n */\ntable.dataTable {\n  clear: both;\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n  max-width: none !important;\n  border-collapse: separate !important;\n}\n\ntable.dataTable td,\ntable.dataTable th {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n  text-align: center;\n}\n\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n  font-weight: normal;\n  text-align: left;\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length select {\n  width: 75px;\n  display: inline-block;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: right;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label {\n  font-weight: normal;\n  white-space: nowrap;\n  text-align: left;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter input {\n  margin-left: 0.5em;\n  display: inline-block;\n  width: auto;\n}\n\ndiv.dataTables_wrapper div.dataTables_info {\n  padding-top: 8px;\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n  margin: 0;\n  white-space: nowrap;\n  text-align: right;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin: 2px 0;\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_processing {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 200px;\n  margin-left: -100px;\n  margin-top: -26px;\n  text-align: center;\n  padding: 1em 0;\n}\n\ntable.dataTable thead > tr > th.sorting_asc,\ntable.dataTable thead > tr > th.sorting_desc,\ntable.dataTable thead > tr > th.sorting,\ntable.dataTable thead > tr > td.sorting_asc,\ntable.dataTable thead > tr > td.sorting_desc,\ntable.dataTable thead > tr > td.sorting {\n  padding-right: 30px;\n}\n\ntable.dataTable thead > tr > th:active,\ntable.dataTable thead > tr > td:active {\n  outline: none;\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  cursor: pointer;\n  position: relative;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  display: block;\n  font-family: \"Glyphicons Halflings\";\n  opacity: 0.5;\n}\n\ntable.dataTable thead .sorting:after {\n  opacity: 0.2;\n  content: \"\\e150\";\n  /* sort */\n}\n\ntable.dataTable thead .sorting_asc:after {\n  content: \"\\e155\";\n  /* sort-by-attributes */\n}\n\ntable.dataTable thead .sorting_desc:after {\n  content: \"\\e156\";\n  /* sort-by-attributes-alt */\n}\n\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  color: #eee;\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n  margin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table {\n  border-top: none;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n  display: none;\n}\n\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n  border-top: none;\n}\n\ndiv.dataTables_scrollFoot table {\n  margin-top: 0 !important;\n  border-top: none;\n}\n\n@media screen and (max-width: 767px) {\n  div.dataTables_wrapper div.dataTables_length,\n  div.dataTables_wrapper div.dataTables_filter,\n  div.dataTables_wrapper div.dataTables_info,\n  div.dataTables_wrapper div.dataTables_paginate {\n    text-align: center;\n  }\n}\n\ntable.dataTable.table-condensed > thead > tr > th {\n  padding-right: 20px;\n}\n\ntable.dataTable.table-condensed .sorting:after,\ntable.dataTable.table-condensed .sorting_asc:after,\ntable.dataTable.table-condensed .sorting_desc:after {\n  top: 6px;\n  right: 6px;\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n  border-left-width: 0;\n}\n\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n  border-right-width: 0;\n}\n\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n  border-bottom-width: 0;\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n  border-bottom-width: 0;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n  margin: 0;\n}\n\ndiv.table-responsive\n  > div.dataTables_wrapper\n  > div.row\n  > div[class^=\"col-\"]:first-child {\n  padding-left: 0;\n}\n\ndiv.table-responsive\n  > div.dataTables_wrapper\n  > div.row\n  > div[class^=\"col-\"]:last-child {\n  padding-right: 0;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  position: relative;\n  display: inline-block;\n  bottom: 0px;\n  right: -7px;\n  font-family: \"FontAwesome\";\n  opacity: 0.8;\n}\n\ntable.dataTable thead .disabled-sorting.sorting:after,\ntable.dataTable thead .disabled-sorting.sorting_asc:after,\ntable.dataTable thead .disabled-sorting.sorting_desc:after,\ntable.dataTable thead .disabled-sorting.sorting_asc_disabled:after,\ntable.dataTable thead .disabled-sorting.sorting_desc_disabled:after {\n  display: none;\n}\n\ntable.dataTable thead .sorting:after {\n  opacity: 0.4;\n  content: \"\\f0dc\";\n}\n\ntable.dataTable thead .sorting_asc:after {\n  content: \"\\f0de\";\n  top: 3px;\n}\n\ntable.dataTable thead .sorting_desc:after {\n  content: \"\\f0dd\";\n  top: -3px;\n}\n\ntable.dataTable .table-hover > tbody > tr:hover {\n  background-color: #fff4dc;\n}\n\ntable.dataTable .table > thead > tr > th,\ntable.dataTable .table > tbody > tr > th,\ntable.dataTable .table > tfoot > tr > th,\ntable.dataTable .table > thead > tr > td,\ntable.dataTable .table > tbody > tr > td,\ntable.dataTable .table > tfoot > tr > td {\n  padding: 8px !important;\n  outline: 0;\n}\n\ntable.dataTable .btn.btn-icon {\n  margin: 0 3px;\n  padding: 5px 8px;\n}\n\n.dataTables_paginate a {\n  outline: 0;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th.child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {\n  cursor: default !important;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {\n  display: none !important;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {\n  top: 50%;\n  margin-top: -9px;\n  left: 4px;\n  height: 18px;\n  width: 18px;\n  display: block;\n  position: absolute;\n  color: #518607;\n  border: 0px solid white;\n  border-radius: 14px;\n  box-shadow: 0 0 3px #444;\n  box-sizing: content-box;\n  text-align: center;\n  font-family: \"Courier New\", Courier, monospace;\n  line-height: 18px;\n  content: \"+\";\n  background-color: #fff;\n}\n\ntable.dataTable.dtr-inline.collapsed\n  > tbody\n  > tr.parent\n  > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed\n  > tbody\n  > tr.parent\n  > th:first-child:before {\n  content: \"-\";\n  color: #ed362c;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {\n  display: none;\n}\n\ntable.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,\ntable.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {\n  padding-left: 27px;\n}\n\ntable.dataTable.dtr-inline.collapsed.compact\n  > tbody\n  > tr\n  > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed.compact\n  > tbody\n  > tr\n  > th:first-child:before {\n  top: 5px;\n  left: 4px;\n  height: 14px;\n  width: 14px;\n  border-radius: 14px;\n  line-height: 14px;\n  text-indent: 3px;\n}\n\ntable.dataTable.dtr-column > tbody > tr > td.control,\ntable.dataTable.dtr-column > tbody > tr > th.control {\n  position: relative;\n  cursor: pointer;\n}\n\ntable.dataTable.dtr-column > tbody > tr > td.control:before,\ntable.dataTable.dtr-column > tbody > tr > th.control:before {\n  top: 50%;\n  left: 50%;\n  height: 16px;\n  width: 16px;\n  margin-top: -10px;\n  margin-left: -10px;\n  display: block;\n  position: absolute;\n  color: white;\n  border: 2px solid white;\n  border-radius: 14px;\n  box-shadow: 0 0 3px #444;\n  box-sizing: content-box;\n  text-align: center;\n  font-family: \"Courier New\", Courier, monospace;\n  line-height: 14px;\n  content: \"+\";\n  background-color: #31b131;\n}\n\ntable.dataTable.dtr-column > tbody > tr.parent td.control:before,\ntable.dataTable.dtr-column > tbody > tr.parent th.control:before {\n  content: \"-\";\n  background-color: #d33333;\n}\n\ntable.dataTable > tbody > tr.child {\n  padding: 0.5em 1em;\n}\n\ntable.dataTable > tbody > tr.child:hover {\n  background: transparent !important;\n}\n\ntable.dataTable > tbody > tr.child ul {\n  display: inline-block;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\ntable.dataTable > tbody > tr.child ul li {\n  border-bottom: 1px solid #efefef;\n  padding: 0.5em 0;\n}\n\ntable.dataTable > tbody > tr.child ul li:first-child {\n  padding-top: 0;\n}\n\ntable.dataTable > tbody > tr.child ul li:last-child {\n  border-bottom: none;\n}\n\ntable.dataTable > tbody > tr.child span.dtr-title {\n  display: inline-block;\n  min-width: 75px;\n  font-weight: bold;\n}\n\ndiv.dtr-modal {\n  position: fixed;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 100;\n  padding: 10em 1em;\n}\ndiv.dtr-modal div.dtr-modal-display {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 50%;\n  height: 50%;\n  overflow: auto;\n  margin: auto;\n  z-index: 102;\n  overflow: auto;\n  background-color: #f5f5f7;\n  border: 1px solid black;\n  border-radius: 0.5em;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n}\ndiv.dtr-modal div.dtr-modal-content {\n  position: relative;\n  padding: 1em;\n}\ndiv.dtr-modal div.dtr-modal-close {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 22px;\n  height: 22px;\n  border: 1px solid #eaeaea;\n  background-color: #f9f9f9;\n  text-align: center;\n  border-radius: 3px;\n  cursor: pointer;\n  z-index: 12;\n}\ndiv.dtr-modal div.dtr-modal-close:hover {\n  background-color: #eaeaea;\n}\ndiv.dtr-modal div.dtr-modal-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 101;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n@media screen and (max-width: 767px) {\n  div.dtr-modal div.dtr-modal-display {\n    width: 95%;\n  }\n}\n\nsvg {\n  touch-action: none;\n}\n\n.jvectormap-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  touch-action: none;\n}\n\n.jvectormap-tip {\n  position: absolute;\n  display: none;\n  border: solid 1px #cdcdcd;\n  border-radius: 3px;\n  background: #292929;\n  color: white;\n  font-family: sans-serif, Verdana;\n  font-size: smaller;\n  padding: 3px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n  position: absolute;\n  left: 10px;\n  border-radius: 3px;\n  background: #292929;\n  padding: 3px;\n  color: white;\n  cursor: pointer;\n  line-height: 10px;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 10px;\n  height: 10px;\n}\n\n.jvectormap-zoomin {\n  top: 10px;\n}\n\n.jvectormap-zoomout {\n  top: 30px;\n}\n\n.jvectormap-goback {\n  bottom: 10px;\n  z-index: 1000;\n  padding: 6px;\n}\n\n.jvectormap-spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: center no-repeat\n    url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n  font-weight: bold;\n  font-size: 14px;\n  text-align: center;\n}\n\n.jvectormap-legend-cnt {\n  position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n  bottom: 0;\n  right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n  top: 0;\n  right: 0;\n}\n\n.jvectormap-legend {\n  background: black;\n  color: white;\n  border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n  float: left;\n  margin: 0 10px 10px 0;\n  padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n  float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n  margin: 10px 10px 0 0;\n  padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n  width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n  font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n  text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 20px;\n  padding-left: 3px;\n}\n\n/*!\n * FullCalendar v3.1.0 Stylesheet\n * Docs & License: http://fullcalendar.io/\n * (c) 2016 Adam Shaw\n */\n.fc {\n  direction: ltr;\n  text-align: left;\n}\n\n.fc-rtl {\n  text-align: right;\n}\n\nbody .fc {\n  /* extra precedence to overcome jqui */\n  font-size: 1em;\n}\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n  border-color: #ddd;\n}\n\n.fc-unthemed .fc-popover {\n  background-color: #ffffff;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header {\n  background: #e3e3e3;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  color: #666666;\n}\n\n.fc-unthemed .fc-today {\n  background: #f5f5f5;\n}\n\n.fc-highlight {\n  /* when user is selecting cells */\n  background: #bce8f1;\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  /* for IE */\n}\n\n.fc-bgevent {\n  /* default look for background events */\n  background: #8fdf82;\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  /* for IE */\n}\n\n.fc-nonbusiness {\n  /* default look for non-business-hours areas */\n  /* will inherit .fc-bgevent's styles */\n  background: #d7d7d7;\n}\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n.fc-icon {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  line-height: 1em;\n  font-size: 1em;\n  text-align: center;\n  overflow: hidden;\n  font-family: \"Courier New\", Courier, monospace;\n  /* don't allow browser text-selection */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/*\nAcceptable font-family overrides for individual icons:\n\t\"Arial\", sans-serif\n\t\"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n.fc-icon:after {\n  position: relative;\n  margin: 0 -1em;\n  /* ensures character will be centered, regardless of width */\n}\n\n.fc-icon-left-single-arrow:after {\n  content: \"\\02039\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%;\n  left: 3%;\n}\n\n.fc-icon-right-single-arrow:after {\n  content: \"\\0203A\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%;\n  left: -3%;\n}\n\n.fc-icon-left-double-arrow:after {\n  content: \"\\000AB\";\n  font-size: 160%;\n  top: -7%;\n}\n\n.fc-icon-right-double-arrow:after {\n  content: \"\\000BB\";\n  font-size: 160%;\n  top: -7%;\n}\n\n.fc-icon-left-triangle:after {\n  content: \"\\25C4\";\n  font-size: 125%;\n  top: 3%;\n  left: -2%;\n}\n\n.fc-icon-right-triangle:after {\n  content: \"\\25BA\";\n  font-size: 125%;\n  top: 3%;\n  left: 2%;\n}\n\n.fc-icon-down-triangle:after {\n  content: \"\\25BC\";\n  font-size: 125%;\n  top: 2%;\n}\n\n.fc-icon-x:after {\n  content: \"\\000D7\";\n  font-size: 200%;\n  top: 6%;\n}\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n.fc button {\n  border-radius: 20px;\n  box-sizing: border-box;\n  border-width: 2px;\n  background-color: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 0.5rem 0.7rem;\n  background-color: #66615b;\n  color: #ffffff;\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n}\n.fc button:hover,\n.fc button:focus,\n.fc button:active,\n.fc button.active,\n.fc button:active:focus,\n.fc button:active:hover,\n.fc button.active:focus,\n.fc button.active:hover,\n.show > .fc button.dropdown-toggle,\n.show > .fc button.dropdown-toggle:focus,\n.show > .fc button.dropdown-toggle:hover {\n  background-color: #403d39 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.fc button:not([data-action]):hover {\n  box-shadow: none;\n}\n.fc button.disabled,\n.fc button.disabled:hover,\n.fc button.disabled:focus,\n.fc button.disabled.focus,\n.fc button.disabled:active,\n.fc button.disabled.active,\n.fc button:disabled,\n.fc button:disabled:hover,\n.fc button:disabled:focus,\n.fc button:disabled.focus,\n.fc button:disabled:active,\n.fc button:disabled.active,\n.fc button[disabled],\n.fc button[disabled]:hover,\n.fc button[disabled]:focus,\n.fc button[disabled].focus,\n.fc button[disabled]:active,\n.fc button[disabled].active,\nfieldset[disabled] .fc button,\nfieldset[disabled] .fc button:hover,\nfieldset[disabled] .fc button:focus,\nfieldset[disabled] .fc button.focus,\nfieldset[disabled] .fc button:active,\nfieldset[disabled] .fc button.active {\n  background-color: #66615b;\n  border-color: #66615b;\n}\n.fc button.btn-simple {\n  color: #66615b;\n  border-color: #66615b;\n}\n.fc button.btn-simple:hover,\n.fc button.btn-simple:focus,\n.fc button.btn-simple:active {\n  background-color: transparent;\n  color: #403d39;\n  border-color: #403d39;\n  box-shadow: none;\n}\n.fc button.btn-link {\n  color: #66615b;\n}\n.fc button.btn-link:hover,\n.fc button.btn-link:focus,\n.fc button.btn-link:active,\n.fc button.btn-link:active:focus {\n  background-color: transparent;\n  color: #403d39;\n  text-decoration: none;\n  box-shadow: none;\n}\n.fc button:hover,\n.fc button:focus {\n  outline: 0 !important;\n}\n.fc button:active,\n.fc button.active,\n.open > .fc button.dropdown-toggle {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0 !important;\n}\n.fc button.btn-icon {\n  border-radius: 25px;\n  padding: 6px 10px;\n}\n.fc button.btn-icon i {\n  margin-right: 0px;\n}\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner {\n  margin: 0;\n  padding: 0;\n}\n\n.fc-state-default {\n  /* non-theme */\n  border: 1px solid;\n}\n\n/* icons in buttons */\n.fc button .fc-icon {\n  /* non-theme */\n  position: relative;\n  top: -0.05em;\n  /* seems to be a good adjustment across browsers */\n  margin: 0 0.2em;\n  vertical-align: middle;\n}\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n.fc-state-hover,\n.fc-state-active,\n.fc-state-disabled {\n  color: #2c2c2c;\n  background-color: #e6e6e6;\n}\n\n.fc button[disabled],\n.fc button[disabled]:focus,\n.fc button[disabled]:hover {\n  background-color: #e3e3e3;\n  border-color: #e3e3e3;\n  cursor: default;\n  opacity: 0.65;\n  filter: alpha(opacity=65);\n  color: #66615b;\n}\n\n.fc-state-hover {\n  background-color: #f5f5f5;\n}\n\n.fc .fc-state-active,\n.fc .fc-state-active:focus,\n.fc .fc-state-active:hover,\n.fc .fc-state-active:active:focus,\n.fc .fc-state-active:active:hover,\n.fc .fc-state-active:active {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n.fc-button-group {\n  display: inline-block;\n}\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n.fc .fc-button-group > * {\n  /* extra precedence b/c buttons have margin set to zero */\n  float: left;\n  margin: 0 2px 0 0;\n}\n\n.fc .fc-button-group > :first-child {\n  /* same */\n  margin-left: 0;\n}\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover {\n  position: absolute;\n  -webkit-box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n}\n\n.fc-popover .fc-header {\n  /* TODO: be more consistent with fc-head/fc-body */\n  padding: 2px 4px;\n}\n\n.fc-popover .fc-header .fc-title {\n  margin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n  cursor: pointer;\n}\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n  float: left;\n}\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n  float: right;\n}\n\n/* unthemed */\n.fc-unthemed .fc-popover {\n  border-width: 1px;\n  border-style: solid;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  font-size: 0.9em;\n  margin-top: 2px;\n}\n\n/* jqui themed */\n.fc-popover > .ui-widget-header + .ui-widget-content {\n  border-top: 0;\n  /* where they meet, let the header have the border */\n}\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n.fc-divider {\n  border-style: solid;\n  border-width: 1px;\n}\n\nhr.fc-divider {\n  height: 0;\n  margin: 0;\n  padding: 0 0 2px;\n  /* height is unreliable across browsers, so use padding */\n  border-width: 1px 0;\n}\n\n.fc-clear {\n  clear: both;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n  /* these element should always cling to top-left/right corners */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fc-bg {\n  bottom: 0;\n  /* strech bg to bottom edge */\n}\n\n.fc-bg table {\n  height: 100%;\n  /* strech bg to bottom edge */\n}\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n.fc table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */\n}\n\n.fc th {\n  text-align: right;\n  border-bottom-width: 1px;\n  font-size: 1em;\n  text-transform: uppercase;\n  color: #9a9a9a;\n  font-weight: 400;\n  padding-bottom: 3px;\n}\n\n.fc td {\n  border-style: solid;\n  border-width: 1px;\n  padding: 0;\n  vertical-align: top;\n}\n\n.fc td.fc-today {\n  border-style: double;\n  /* overcome neighboring borders */\n}\n\n.fc .fc-widget-header {\n  border: 0;\n}\n\n.fc .fc-head .fc-widget-header {\n  margin-top: 15px;\n}\n\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-row {\n  /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n  /* no visible border by default. but make available if need be (scrollbar width compensation) */\n  border-style: solid;\n  border-width: 0;\n}\n\n.fc-row table {\n  /* don't put left/right border on anything within a fake row.\n\t   the outer tbody will worry about this */\n  border-left: 0 hidden transparent;\n  border-right: 0 hidden transparent;\n  /* no bottom borders on rows */\n  border-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n  border-top: 0 hidden transparent;\n  /* no top border on first row */\n}\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n.fc-row {\n  position: relative;\n}\n\n.fc-row .fc-bg {\n  z-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n  bottom: 0;\n  /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n  height: 100%;\n  /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n  border-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n  z-index: 2;\n}\n\n.fc-row .fc-highlight-skeleton {\n  z-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n.fc-row .fc-content-skeleton {\n  position: relative;\n  z-index: 4;\n  padding-bottom: 2px;\n  /* matches the space above the events */\n}\n\n.fc-row .fc-helper-skeleton {\n  z-index: 5;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n  /* see-through to the background below */\n  background: none;\n  /* in case <td>s are globally styled */\n  border-color: transparent;\n  /* don't put a border between events and/or the day number */\n  border-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td,\n.fc-row .fc-helper-skeleton tbody td {\n  /* don't put a border between event cells */\n  border-top: 0;\n}\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n.fc-scroller {\n  /* this class goes on elements for guaranteed vertical scrollbars */\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.fc-scroller > * {\n  /* we expect an immediate inner element */\n  position: relative;\n  /* re-scope all positions */\n  width: 100%;\n  /* hack to force re-sizing this inner element when scrollbars appear/disappear */\n  overflow: hidden;\n  /* don't let negative margins or absolute positioning create further scroll */\n}\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.fc-event {\n  position: relative;\n  /* for resize handle and other inner positioning */\n  display: block;\n  /* make the <a> tag block */\n  font-size: 0.85em;\n  line-height: 1.3;\n  border-radius: 2px;\n  background-color: rgba(81, 203, 206, 0.2);\n  /* default BACKGROUND color */\n  font-weight: normal;\n  /* undo jqui's ui-widget-header bold */\n}\n.fc-event.event-azure {\n  background-color: rgba(81, 188, 218, 0.2);\n}\n.fc-event.event-green {\n  background-color: rgba(107, 208, 152, 0.2);\n}\n.fc-event.event-orange {\n  background-color: rgba(251, 198, 88, 0.2);\n}\n.fc-event.event-red {\n  background-color: rgba(239, 129, 87, 0.2);\n}\n\n/* overpower some of bootstrap's and jqui's styles on <a> tags */\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n  color: #2c2c2c;\n  /* default TEXT color */\n  text-decoration: none;\n  /* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n  cursor: pointer;\n  /* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* to override an event's custom cursor */\n  cursor: not-allowed;\n}\n\n.fc-event .fc-bg {\n  /* the generic .fc-bg already does position */\n  z-index: 1;\n  background: #ffffff;\n  opacity: 0.25;\n  filter: alpha(opacity=25);\n  /* for IE */\n}\n\n.fc-event .fc-content {\n  position: relative;\n  z-index: 2;\n}\n\n.fc-event .fc-resizer {\n  position: absolute;\n  z-index: 3;\n}\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n  margin-left: 0;\n  border-left-width: 0;\n  padding-left: 1px;\n  /* replace the border with padding */\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n  margin-right: 0;\n  border-right-width: 0;\n  padding-right: 1px;\n  /* replace the border with padding */\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n/* resizer */\n.fc-h-event .fc-resizer {\n  /* positioned it to overcome the event's borders */\n  top: -1px;\n  bottom: -1px;\n  left: -1px;\n  right: -1px;\n  width: 5px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-ltr .fc-h-event .fc-start-resizer:before,\n.fc-ltr .fc-h-event .fc-start-resizer:after,\n.fc-rtl .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer:before,\n.fc-rtl .fc-h-event .fc-end-resizer:after {\n  right: auto;\n  /* ignore the right and only use the left */\n  cursor: w-resize;\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-ltr .fc-h-event .fc-end-resizer:before,\n.fc-ltr .fc-h-event .fc-end-resizer:after,\n.fc-rtl .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer:before,\n.fc-rtl .fc-h-event .fc-start-resizer:after {\n  left: auto;\n  /* ignore the left and only use the right */\n  cursor: e-resize;\n}\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-day-grid-event {\n  margin: 2px 5px 0;\n  /* spacing between events and edges */\n  padding: 1px 2px;\n}\n\n.fc-day-grid-event .fc-content {\n  /* force events to be one-line tall */\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n  font-weight: bold;\n}\n\n.fc-day-grid-event .fc-resizer {\n  /* enlarge the default hit area */\n  left: -3px;\n  right: -3px;\n  width: 7px;\n}\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n/* \"more\" link that represents hidden events */\na.fc-more {\n  margin: 1px 3px;\n  font-size: 0.85em;\n  cursor: pointer;\n  text-decoration: none;\n}\n\na.fc-more:hover {\n  text-decoration: underline;\n}\n\n.fc-limited {\n  /* rows and cells that are hidden because of a \"more\" link */\n  display: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n.fc-day-grid .fc-row {\n  z-index: 1;\n  /* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n  z-index: 2;\n  width: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n  padding: 10px;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n.fc-toolbar {\n  text-align: center;\n  margin-bottom: 1em;\n}\n\n.fc-toolbar .fc-left {\n  float: left;\n  min-width: 260px;\n}\n\n.fc-toolbar .fc-right {\n  float: right;\n}\n\n.fc-toolbar .fc-center {\n  display: inline-block;\n}\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * {\n  /* extra precedence to override button border margins */\n  float: left;\n  margin-left: 0.75em;\n}\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child {\n  /* extra precedence to override button border margins */\n  margin-left: 0;\n}\n\n/* title text */\n.fc-toolbar h2 {\n  margin: 0;\n}\n\n/* button layering (for border precedence) */\n.fc-toolbar button {\n  position: relative;\n}\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n  z-index: 2;\n}\n\n.fc-toolbar .fc-state-down {\n  z-index: 3;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n  z-index: 4;\n}\n\n.fc-toolbar button:focus {\n  z-index: 5;\n}\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.fc-view,\n.fc-view > table {\n  /* so dragged elements can be above the view's main element */\n  position: relative;\n  z-index: 1;\n}\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n/* day row structure */\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n  /* we are sure there are no day numbers in these views, so... */\n  padding-top: 1px;\n  /* add a pixel to make sure there are 2px padding above events */\n  padding-bottom: 1em;\n  /* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-basic-view .fc-body .fc-row {\n  min-height: 4em;\n  /* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n.fc-row.fc-rigid {\n  overflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n/* week and day number styling */\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n  padding: 0 2px;\n}\n\n.fc-basic-view td.fc-week-number span,\n.fc-basic-view td.fc-day-number {\n  padding: 8px;\n}\n\n.fc-basic-view .fc-week-number {\n  text-align: center;\n}\n\n.fc-basic-view .fc-week-number span {\n  /* work around the way we do column resizing and ensure a minimum width */\n  display: inline-block;\n  min-width: 1.25em;\n}\n\n.fc-ltr .fc-basic-view .fc-day-number {\n  text-align: right;\n}\n\n.fc-rtl .fc-basic-view .fc-day-number {\n  text-align: left;\n}\n\n.fc-day-number.fc-other-month {\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  /* for IE */\n  /* opacity with small font can sometimes look too faded\n\t   might want to set the 'color' property instead\n\t   making day-numbers bold also fixes the problem */\n}\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n.fc-agenda-view .fc-day-grid {\n  position: relative;\n  z-index: 2;\n  /* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row {\n  min-height: 3em;\n  /* all-day section will never get shorter than this */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n  padding-top: 1px;\n  /* add a pixel to make sure there are 2px padding above events */\n  padding-bottom: 1em;\n  /* give space underneath events for clicking/selecting days */\n}\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-axis {\n  /* .fc to overcome default cell styles */\n  vertical-align: middle;\n  padding: 0 4px;\n  white-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n  text-align: right;\n}\n\n.fc-rtl .fc-axis {\n  text-align: left;\n}\n\n.ui-widget td.fc-axis {\n  font-weight: normal;\n  /* overcome jqui theme making it bold */\n}\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid-container,\n.fc-time-grid {\n  /* so slats/bg/content/etc positions get scoped within here */\n  position: relative;\n  z-index: 1;\n}\n\n.fc-time-grid {\n  min-height: 100%;\n  /* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table {\n  /* don't put outer borders on slats/bg/content/etc */\n  border: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n  z-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr {\n  /* the <hr> AgendaView injects when grid is shorter than scroller */\n  position: relative;\n  z-index: 2;\n}\n\n.fc-time-grid .fc-bgevent-skeleton,\n.fc-time-grid .fc-content-skeleton {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fc-time-grid .fc-bgevent-skeleton {\n  z-index: 3;\n}\n\n.fc-time-grid .fc-highlight-skeleton {\n  z-index: 4;\n}\n\n.fc-time-grid .fc-content-skeleton {\n  z-index: 5;\n}\n\n.fc-time-grid .fc-helper-skeleton {\n  z-index: 6;\n}\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats td {\n  height: 1.5em;\n  border-bottom: 0;\n  /* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n  border-top-style: dotted;\n}\n\n.fc-time-grid .fc-slats .ui-widget-content {\n  /* for jqui theme */\n  background: none;\n  /* see through to fc-bg */\n}\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-highlight-container {\n  /* a div within a cell within the fc-highlight-skeleton */\n  position: relative;\n  /* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n  position: absolute;\n  left: 0;\n  right: 0;\n  /* top and bottom will be in by JS */\n}\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-event-container,\n.fc-time-grid .fc-bgevent-container {\n  /* a div within a cell within the fc-bgevent-skeleton */\n  position: relative;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container {\n  /* space on the sides of events for LTR (default) */\n  margin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container {\n  /* space on the sides of events for RTL */\n  margin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n  position: absolute;\n  z-index: 1;\n  /* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n  /* background events always span full width */\n  left: 0;\n  right: 0;\n}\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n.fc-v-event.fc-not-start {\n  /* events that are continuing from another day */\n  /* replace space made by the top border with padding */\n  border-top-width: 0;\n  padding-top: 1px;\n  /* remove top rounded corners */\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.fc-v-event.fc-not-end {\n  /* replace space made by the top border with padding */\n  border-bottom-width: 0;\n  padding-bottom: 1px;\n  /* remove bottom rounded corners */\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-time-grid-event {\n  overflow: hidden;\n  /* don't let the bg flow over rounded corners */\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n  padding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n  font-size: 0.85em;\n  white-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n.fc-time-grid-event.fc-short .fc-content {\n  /* don't wrap to second line (now that contents will be inline) */\n  white-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n  /* put the time and title on the same line */\n  display: inline-block;\n  vertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n  display: none;\n  /* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n  content: attr(data-start);\n  /* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n  content: \"\\000A0-\\000A0\";\n  /* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n  font-size: 0.85em;\n  /* make the title text the same size as the time */\n  padding: 0;\n  /* undo padding from above */\n}\n\n/* resizer */\n.fc-time-grid-event .fc-resizer {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 8px;\n  overflow: hidden;\n  line-height: 8px;\n  font-size: 11px;\n  font-family: monospace;\n  text-align: center;\n  cursor: s-resize;\n}\n\n.fc-time-grid-event .fc-resizer:after {\n  content: \"=\";\n}\n\n.card-calendar .content {\n  padding: 0 !important;\n}\n\n.card-calendar .fc-toolbar {\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.card-calendar .fc td:first-child {\n  border-left: 0;\n}\n\n.card-calendar .fc td:last-child {\n  border-right: 0;\n}\n\n.card-calendar .fc-basic-view td:last-child.fc-week-number span,\n.card-calendar .fc-basic-view td:last-child.fc-day-number {\n  padding-right: 15px;\n}\n\n.card-calendar .fc .fc-day-header:last-child {\n  padding-right: 15px;\n}\n\n.card-calendar .fc .fc-row:last-child td {\n  border-bottom: 0;\n}\n\n.card-calendar .fc .fc-body .fc-widget-content {\n  border-bottom: 0;\n}\n\n/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: \"nucleo-icons\";\n  src: url(\"~assets/fonts/nucleo-icons.eot\");\n  src: url(\"~assets/fonts/nucleo-icons.eot\") format(\"embedded-opentype\"),\n    url(\"~assets/fonts/nucleo-icons.woff2\") format(\"woff2\"),\n    url(\"~assets/fonts/nucleo-icons.woff\") format(\"woff\"),\n    url(\"~assets/fonts/nucleo-icons.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 \"nucleo-icons\";\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n\n.nc-icon.x2 {\n  font-size: 2em;\n}\n\n.nc-icon.x3 {\n  font-size: 3em;\n}\n\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n\n.nc-icon.circle {\n  border-radius: 50%;\n}\n\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n\n.nc-icon-ul > li {\n  position: relative;\n}\n\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/*------------------------\n\tfont icons\n-------------------------*/\n.nc-air-baloon::before {\n  content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n  content: \"\\ea02\";\n}\n\n.nc-alert-circle-i::before {\n  content: \"\\ea04\";\n}\n\n.nc-align-center::before {\n  content: \"\\ea03\";\n}\n\n.nc-align-left-2::before {\n  content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n  content: \"\\ea06\";\n}\n\n.nc-app::before {\n  content: \"\\ea07\";\n}\n\n.nc-atom::before {\n  content: \"\\ea08\";\n}\n\n.nc-badge::before {\n  content: \"\\ea09\";\n}\n\n.nc-bag-16::before {\n  content: \"\\ea0a\";\n}\n\n.nc-bank::before {\n  content: \"\\ea0b\";\n}\n\n.nc-basket::before {\n  content: \"\\ea0c\";\n}\n\n.nc-bell-55::before {\n  content: \"\\ea0d\";\n}\n\n.nc-bold::before {\n  content: \"\\ea0e\";\n}\n\n.nc-book-bookmark::before {\n  content: \"\\ea0f\";\n}\n\n.nc-bookmark-2::before {\n  content: \"\\ea10\";\n}\n\n.nc-box-2::before {\n  content: \"\\ea11\";\n}\n\n.nc-box::before {\n  content: \"\\ea12\";\n}\n\n.nc-briefcase-24::before {\n  content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n  content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n  content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n  content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n  content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n  content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n  content: \"\\ea19\";\n}\n\n.nc-calendar-60::before {\n  content: \"\\ea1a\";\n}\n\n.nc-camera-compact::before {\n  content: \"\\ea1b\";\n}\n\n.nc-caps-small::before {\n  content: \"\\ea1c\";\n}\n\n.nc-cart-simple::before {\n  content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n  content: \"\\ea1e\";\n}\n\n.nc-chart-pie-36::before {\n  content: \"\\ea1f\";\n}\n\n.nc-chat-33::before {\n  content: \"\\ea20\";\n}\n\n.nc-check-2::before {\n  content: \"\\ea21\";\n}\n\n.nc-circle-10::before {\n  content: \"\\ea22\";\n}\n\n.nc-cloud-download-93::before {\n  content: \"\\ea23\";\n}\n\n.nc-cloud-upload-94::before {\n  content: \"\\ea24\";\n}\n\n.nc-compass-05::before {\n  content: \"\\ea25\";\n}\n\n.nc-controller-modern::before {\n  content: \"\\ea26\";\n}\n\n.nc-credit-card::before {\n  content: \"\\ea27\";\n}\n\n.nc-delivery-fast::before {\n  content: \"\\ea28\";\n}\n\n.nc-diamond::before {\n  content: \"\\ea29\";\n}\n\n.nc-email-85::before {\n  content: \"\\ea2a\";\n}\n\n.nc-favourite-28::before {\n  content: \"\\ea2b\";\n}\n\n.nc-glasses-2::before {\n  content: \"\\ea2c\";\n}\n\n.nc-globe-2::before {\n  content: \"\\ea2d\";\n}\n\n.nc-globe::before {\n  content: \"\\ea2e\";\n}\n\n.nc-hat-3::before {\n  content: \"\\ea2f\";\n}\n\n.nc-headphones::before {\n  content: \"\\ea30\";\n}\n\n.nc-html5::before {\n  content: \"\\ea31\";\n}\n\n.nc-image::before {\n  content: \"\\ea32\";\n}\n\n.nc-istanbul::before {\n  content: \"\\ea33\";\n}\n\n.nc-key-25::before {\n  content: \"\\ea34\";\n}\n\n.nc-laptop::before {\n  content: \"\\ea35\";\n}\n\n.nc-layout-11::before {\n  content: \"\\ea36\";\n}\n\n.nc-lock-circle-open::before {\n  content: \"\\ea37\";\n}\n\n.nc-map-big::before {\n  content: \"\\ea38\";\n}\n\n.nc-minimal-down::before {\n  content: \"\\ea39\";\n}\n\n.nc-minimal-left::before {\n  content: \"\\ea3a\";\n}\n\n.nc-minimal-right::before {\n  content: \"\\ea3b\";\n}\n\n.nc-minimal-up::before {\n  content: \"\\ea3c\";\n}\n\n.nc-mobile::before {\n  content: \"\\ea3d\";\n}\n\n.nc-money-coins::before {\n  content: \"\\ea3e\";\n}\n\n.nc-note-03::before {\n  content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n  content: \"\\ea40\";\n}\n\n.nc-paper::before {\n  content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n  content: \"\\ea42\";\n}\n\n.nc-planet::before {\n  content: \"\\ea43\";\n}\n\n.nc-refresh-69::before {\n  content: \"\\ea44\";\n}\n\n.nc-ruler-pencil::before {\n  content: \"\\ea45\";\n}\n\n.nc-satisfied::before {\n  content: \"\\ea46\";\n}\n\n.nc-scissors::before {\n  content: \"\\ea47\";\n}\n\n.nc-send::before {\n  content: \"\\ea48\";\n}\n\n.nc-settings-gear-65::before {\n  content: \"\\ea49\";\n}\n\n.nc-settings::before {\n  content: \"\\ea4a\";\n}\n\n.nc-share-66::before {\n  content: \"\\ea4b\";\n}\n\n.nc-shop::before {\n  content: \"\\ea4c\";\n}\n\n.nc-simple-add::before {\n  content: \"\\ea4d\";\n}\n\n.nc-simple-delete::before {\n  content: \"\\ea4e\";\n}\n\n.nc-simple-remove::before {\n  content: \"\\ea4f\";\n}\n\n.nc-single-02::before {\n  content: \"\\ea50\";\n}\n\n.nc-single-copy-04::before {\n  content: \"\\ea51\";\n}\n\n.nc-sound-wave::before {\n  content: \"\\ea52\";\n}\n\n.nc-spaceship::before {\n  content: \"\\ea53\";\n}\n\n.nc-sun-fog-29::before {\n  content: \"\\ea54\";\n}\n\n.nc-support-17::before {\n  content: \"\\ea55\";\n}\n\n.nc-tablet-2::before {\n  content: \"\\ea56\";\n}\n\n.nc-tag-content::before {\n  content: \"\\ea57\";\n}\n\n.nc-tap-01::before {\n  content: \"\\ea58\";\n}\n\n.nc-tie-bow::before {\n  content: \"\\ea59\";\n}\n\n.nc-tile-56::before {\n  content: \"\\ea5a\";\n}\n\n.nc-time-alarm::before {\n  content: \"\\ea5b\";\n}\n\n.nc-touch-id::before {\n  content: \"\\ea5c\";\n}\n\n.nc-trophy::before {\n  content: \"\\ea5d\";\n}\n\n.nc-tv-2::before {\n  content: \"\\ea5e\";\n}\n\n.nc-umbrella-13::before {\n  content: \"\\ea5f\";\n}\n\n.nc-user-run::before {\n  content: \"\\ea60\";\n}\n\n.nc-vector::before {\n  content: \"\\ea61\";\n}\n\n.nc-watch-time::before {\n  content: \"\\ea62\";\n}\n\n.nc-world-2::before {\n  content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n  content: \"\\ea64\";\n}\n\n/* all icon font classes list here */\n.btn,\n.navbar .navbar-nav > a.btn {\n  border-width: 2px;\n  font-weight: 600;\n  font-size: 0.8571em;\n  line-height: 1.35em;\n  text-transform: uppercase;\n  border: none;\n  margin: 10px 1px;\n  border-radius: 3px;\n  padding: 11px 22px;\n  cursor: pointer;\n  background-color: #0fa0cf;\n  color: #ffffff;\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n}\n.btn:hover,\n.btn:focus,\n.btn:active,\n.btn.active,\n.btn:active:focus,\n.btn:active:hover,\n.btn.active:focus,\n.btn.active:hover,\n.show > .btn.dropdown-toggle,\n.show > .btn.dropdown-toggle:focus,\n.show > .btn.dropdown-toggle:hover,\n.navbar .navbar-nav > a.btn:hover,\n.navbar .navbar-nav > a.btn:focus,\n.navbar .navbar-nav > a.btn:active,\n.navbar .navbar-nav > a.btn.active,\n.navbar .navbar-nav > a.btn:active:focus,\n.navbar .navbar-nav > a.btn:active:hover,\n.navbar .navbar-nav > a.btn.active:focus,\n.navbar .navbar-nav > a.btn.active:hover,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,\n.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {\n  background-color: #45bd5b;\n  color: #ffffff;\n  box-shadow: none;\n}\n.btn:not([data-action]):hover,\n.navbar .navbar-nav > a.btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn.disabled,\n.btn.disabled:hover,\n.btn.disabled:focus,\n.btn.disabled.focus,\n.btn.disabled:active,\n.btn.disabled.active,\n.btn:disabled,\n.btn:disabled:hover,\n.btn:disabled:focus,\n.btn:disabled.focus,\n.btn:disabled:active,\n.btn:disabled.active,\n.btn[disabled],\n.btn[disabled]:hover,\n.btn[disabled]:focus,\n.btn[disabled].focus,\n.btn[disabled]:active,\n.btn[disabled].active,\nfieldset[disabled] .btn,\nfieldset[disabled] .btn:hover,\nfieldset[disabled] .btn:focus,\nfieldset[disabled] .btn.focus,\nfieldset[disabled] .btn:active,\nfieldset[disabled] .btn.active,\n.navbar .navbar-nav > a.btn.disabled,\n.navbar .navbar-nav > a.btn.disabled:hover,\n.navbar .navbar-nav > a.btn.disabled:focus,\n.navbar .navbar-nav > a.btn.disabled.focus,\n.navbar .navbar-nav > a.btn.disabled:active,\n.navbar .navbar-nav > a.btn.disabled.active,\n.navbar .navbar-nav > a.btn:disabled,\n.navbar .navbar-nav > a.btn:disabled:hover,\n.navbar .navbar-nav > a.btn:disabled:focus,\n.navbar .navbar-nav > a.btn:disabled.focus,\n.navbar .navbar-nav > a.btn:disabled:active,\n.navbar .navbar-nav > a.btn:disabled.active,\n.navbar .navbar-nav > a.btn[disabled],\n.navbar .navbar-nav > a.btn[disabled]:hover,\n.navbar .navbar-nav > a.btn[disabled]:focus,\n.navbar .navbar-nav > a.btn[disabled].focus,\n.navbar .navbar-nav > a.btn[disabled]:active,\n.navbar .navbar-nav > a.btn[disabled].active,\nfieldset[disabled] .navbar .navbar-nav > a.btn,\nfieldset[disabled] .navbar .navbar-nav > a.btn:hover,\nfieldset[disabled] .navbar .navbar-nav > a.btn:focus,\nfieldset[disabled] .navbar .navbar-nav > a.btn.focus,\nfieldset[disabled] .navbar .navbar-nav > a.btn:active,\nfieldset[disabled] .navbar .navbar-nav > a.btn.active {\n  background-color: #66615b;\n  border-color: #66615b;\n}\n.btn.btn-simple,\n.navbar .navbar-nav > a.btn.btn-simple {\n  color: #66615b;\n  border-color: #66615b;\n}\n.btn.btn-simple:hover,\n.btn.btn-simple:focus,\n.btn.btn-simple:active,\n.navbar .navbar-nav > a.btn.btn-simple:hover,\n.navbar .navbar-nav > a.btn.btn-simple:focus,\n.navbar .navbar-nav > a.btn.btn-simple:active {\n  background-color: transparent;\n  color: #403d39;\n  border-color: #403d39;\n  box-shadow: none;\n}\n.btn.btn-link,\n.navbar .navbar-nav > a.btn.btn-link {\n  color: #66615b;\n}\n.btn.btn-link:hover,\n.btn.btn-link:focus,\n.btn.btn-link:active,\n.btn.btn-link:active:focus,\n.navbar .navbar-nav > a.btn.btn-link:hover,\n.navbar .navbar-nav > a.btn.btn-link:focus,\n.navbar .navbar-nav > a.btn.btn-link:active,\n.navbar .navbar-nav > a.btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #403d39;\n  text-decoration: none;\n  box-shadow: none;\n}\n.btn:hover,\n.btn:focus,\n.navbar .navbar-nav > a.btn:hover,\n.navbar .navbar-nav > a.btn:focus {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  outline: 0 !important;\n}\n.btn:active,\n.btn.active,\n.open > .btn.dropdown-toggle,\n.navbar .navbar-nav > a.btn:active,\n.navbar .navbar-nav > a.btn.active,\n.open > .navbar .navbar-nav > a.btn.dropdown-toggle {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0 !important;\n}\n.btn .badge,\n.navbar .navbar-nav > a.btn .badge {\n  margin: 0;\n}\n.btn.btn-icon,\n.navbar .navbar-nav > a.btn.btn-icon {\n  height: 2.375rem;\n  min-width: 2.375rem;\n  width: 2.375rem;\n  padding: 0;\n  font-size: 0.9375rem;\n  overflow: hidden;\n  position: relative;\n  line-height: normal;\n}\n.btn.btn-icon.btn-simple,\n.navbar .navbar-nav > a.btn.btn-icon.btn-simple {\n  padding: 0;\n}\n.btn.btn-icon.btn-sm,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm {\n  height: 1.875rem;\n  min-width: 1.875rem;\n  width: 1.875rem;\n}\n.btn.btn-icon.btn-sm .fa,\n.btn.btn-icon.btn-sm .far,\n.btn.btn-icon.btn-sm .fas,\n.btn.btn-icon.btn-sm .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,\n.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {\n  font-size: 0.6875rem;\n}\n.btn.btn-icon.btn-lg,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg {\n  height: 3.6rem;\n  min-width: 3.6rem;\n  width: 3.6rem;\n}\n.btn.btn-icon.btn-lg .fa,\n.btn.btn-icon.btn-lg .far,\n.btn.btn-icon.btn-lg .fas,\n.btn.btn-icon.btn-lg .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,\n.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {\n  font-size: 1.325rem;\n}\n.btn.btn-icon:not(.btn-footer) .nc-icon,\n.btn.btn-icon:not(.btn-footer) .fa,\n.btn.btn-icon:not(.btn-footer) .far,\n.btn.btn-icon:not(.btn-footer) .fas,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,\n.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-12px, -12px);\n  line-height: 1.5626rem;\n  width: 24px;\n}\n.btn.btn-icon.btn-neutral,\n.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {\n  font-size: 20px;\n}\n.btn:not(.btn-icon) .nc-icon,\n.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {\n  position: relative;\n  top: 1px;\n}\n\n.btn-primary {\n  background-color: #51cbce;\n  color: #ffffff;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.btn-primary:active:focus,\n.btn-primary:active:hover,\n.btn-primary.active:focus,\n.btn-primary.active:hover,\n.show > .btn-primary.dropdown-toggle,\n.show > .btn-primary.dropdown-toggle:focus,\n.show > .btn-primary.dropdown-toggle:hover {\n  background-color: #34b5b8 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-primary:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-primary.disabled,\n.btn-primary.disabled:hover,\n.btn-primary.disabled:focus,\n.btn-primary.disabled.focus,\n.btn-primary.disabled:active,\n.btn-primary.disabled.active,\n.btn-primary:disabled,\n.btn-primary:disabled:hover,\n.btn-primary:disabled:focus,\n.btn-primary:disabled.focus,\n.btn-primary:disabled:active,\n.btn-primary:disabled.active,\n.btn-primary[disabled],\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus,\n.btn-primary[disabled].focus,\n.btn-primary[disabled]:active,\n.btn-primary[disabled].active,\nfieldset[disabled] .btn-primary,\nfieldset[disabled] .btn-primary:hover,\nfieldset[disabled] .btn-primary:focus,\nfieldset[disabled] .btn-primary.focus,\nfieldset[disabled] .btn-primary:active,\nfieldset[disabled] .btn-primary.active {\n  background-color: #51cbce;\n  border-color: #51cbce;\n}\n.btn-primary.btn-simple {\n  color: #51cbce;\n  border-color: #51cbce;\n}\n.btn-primary.btn-simple:hover,\n.btn-primary.btn-simple:focus,\n.btn-primary.btn-simple:active {\n  background-color: transparent;\n  color: #34b5b8;\n  border-color: #34b5b8;\n  box-shadow: none;\n}\n.btn-primary.btn-link {\n  color: #51cbce;\n}\n.btn-primary.btn-link:hover,\n.btn-primary.btn-link:focus,\n.btn-primary.btn-link:active,\n.btn-primary.btn-link:active:focus {\n  background-color: transparent;\n  color: #34b5b8;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.btn-success {\n  background-color: #6bd098;\n  color: #ffffff;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.btn-success:active:focus,\n.btn-success:active:hover,\n.btn-success.active:focus,\n.btn-success.active:hover,\n.show > .btn-success.dropdown-toggle,\n.show > .btn-success.dropdown-toggle:focus,\n.show > .btn-success.dropdown-toggle:hover {\n  background-color: #44c47d !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-success:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-success.disabled,\n.btn-success.disabled:hover,\n.btn-success.disabled:focus,\n.btn-success.disabled.focus,\n.btn-success.disabled:active,\n.btn-success.disabled.active,\n.btn-success:disabled,\n.btn-success:disabled:hover,\n.btn-success:disabled:focus,\n.btn-success:disabled.focus,\n.btn-success:disabled:active,\n.btn-success:disabled.active,\n.btn-success[disabled],\n.btn-success[disabled]:hover,\n.btn-success[disabled]:focus,\n.btn-success[disabled].focus,\n.btn-success[disabled]:active,\n.btn-success[disabled].active,\nfieldset[disabled] .btn-success,\nfieldset[disabled] .btn-success:hover,\nfieldset[disabled] .btn-success:focus,\nfieldset[disabled] .btn-success.focus,\nfieldset[disabled] .btn-success:active,\nfieldset[disabled] .btn-success.active {\n  background-color: #6bd098;\n  border-color: #6bd098;\n}\n.btn-success.btn-simple {\n  color: #6bd098;\n  border-color: #6bd098;\n}\n.btn-success.btn-simple:hover,\n.btn-success.btn-simple:focus,\n.btn-success.btn-simple:active {\n  background-color: transparent;\n  color: #44c47d;\n  border-color: #44c47d;\n  box-shadow: none;\n}\n.btn-success.btn-link {\n  color: #6bd098;\n}\n.btn-success.btn-link:hover,\n.btn-success.btn-link:focus,\n.btn-success.btn-link:active,\n.btn-success.btn-link:active:focus {\n  background-color: transparent;\n  color: #44c47d;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.btn-info {\n  background-color: #0fa0cf;\n  color: #ffffff;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.btn-info:active:focus,\n.btn-info:active:hover,\n.btn-info.active:focus,\n.btn-info.active:hover,\n.show > .btn-info.dropdown-toggle,\n.show > .btn-info.dropdown-toggle:focus,\n.show > .btn-info.dropdown-toggle:hover {\n  background-color: #2ba9cd !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-info:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-info.disabled,\n.btn-info.disabled:hover,\n.btn-info.disabled:focus,\n.btn-info.disabled.focus,\n.btn-info.disabled:active,\n.btn-info.disabled.active,\n.btn-info:disabled,\n.btn-info:disabled:hover,\n.btn-info:disabled:focus,\n.btn-info:disabled.focus,\n.btn-info:disabled:active,\n.btn-info:disabled.active,\n.btn-info[disabled],\n.btn-info[disabled]:hover,\n.btn-info[disabled]:focus,\n.btn-info[disabled].focus,\n.btn-info[disabled]:active,\n.btn-info[disabled].active,\nfieldset[disabled] .btn-info,\nfieldset[disabled] .btn-info:hover,\nfieldset[disabled] .btn-info:focus,\nfieldset[disabled] .btn-info.focus,\nfieldset[disabled] .btn-info:active,\nfieldset[disabled] .btn-info.active {\n  background-color: #0fa0cf;\n  border-color: #0fa0cf;\n}\n.btn-info.btn-simple {\n  color: #0fa0cf;\n  border-color: #0fa0cf;\n}\n.btn-info.btn-simple:hover,\n.btn-info.btn-simple:focus,\n.btn-info.btn-simple:active {\n  background-color: transparent;\n  color: #2ba9cd;\n  border-color: #2ba9cd;\n  box-shadow: none;\n}\n.btn-info.btn-link {\n  color: #0fa0cf;\n}\n.btn-info.btn-link:hover,\n.btn-info.btn-link:focus,\n.btn-info.btn-link:active,\n.btn-info.btn-link:active:focus {\n  background-color: transparent;\n  color: #2ba9cd;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.btn-warning {\n  background-color: #fbc658;\n  color: #ffffff;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.btn-warning:active:focus,\n.btn-warning:active:hover,\n.btn-warning.active:focus,\n.btn-warning.active:hover,\n.show > .btn-warning.dropdown-toggle,\n.show > .btn-warning.dropdown-toggle:focus,\n.show > .btn-warning.dropdown-toggle:hover {\n  background-color: #fab526 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-warning:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-warning.disabled,\n.btn-warning.disabled:hover,\n.btn-warning.disabled:focus,\n.btn-warning.disabled.focus,\n.btn-warning.disabled:active,\n.btn-warning.disabled.active,\n.btn-warning:disabled,\n.btn-warning:disabled:hover,\n.btn-warning:disabled:focus,\n.btn-warning:disabled.focus,\n.btn-warning:disabled:active,\n.btn-warning:disabled.active,\n.btn-warning[disabled],\n.btn-warning[disabled]:hover,\n.btn-warning[disabled]:focus,\n.btn-warning[disabled].focus,\n.btn-warning[disabled]:active,\n.btn-warning[disabled].active,\nfieldset[disabled] .btn-warning,\nfieldset[disabled] .btn-warning:hover,\nfieldset[disabled] .btn-warning:focus,\nfieldset[disabled] .btn-warning.focus,\nfieldset[disabled] .btn-warning:active,\nfieldset[disabled] .btn-warning.active {\n  background-color: #fbc658;\n  border-color: #fbc658;\n}\n.btn-warning.btn-simple {\n  color: #fbc658;\n  border-color: #fbc658;\n}\n.btn-warning.btn-simple:hover,\n.btn-warning.btn-simple:focus,\n.btn-warning.btn-simple:active {\n  background-color: transparent;\n  color: #fab526;\n  border-color: #fab526;\n  box-shadow: none;\n}\n.btn-warning.btn-link {\n  color: #fbc658;\n}\n.btn-warning.btn-link:hover,\n.btn-warning.btn-link:focus,\n.btn-warning.btn-link:active,\n.btn-warning.btn-link:active:focus {\n  background-color: transparent;\n  color: #fab526;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.btn-danger {\n  background-color: #ef8157;\n  color: #ffffff;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.show > .btn-danger.dropdown-toggle,\n.show > .btn-danger.dropdown-toggle:focus,\n.show > .btn-danger.dropdown-toggle:hover {\n  background-color: #eb6532 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-danger:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-danger.disabled,\n.btn-danger.disabled:hover,\n.btn-danger.disabled:focus,\n.btn-danger.disabled.focus,\n.btn-danger.disabled:active,\n.btn-danger.disabled.active,\n.btn-danger:disabled,\n.btn-danger:disabled:hover,\n.btn-danger:disabled:focus,\n.btn-danger:disabled.focus,\n.btn-danger:disabled:active,\n.btn-danger:disabled.active,\n.btn-danger[disabled],\n.btn-danger[disabled]:hover,\n.btn-danger[disabled]:focus,\n.btn-danger[disabled].focus,\n.btn-danger[disabled]:active,\n.btn-danger[disabled].active,\nfieldset[disabled] .btn-danger,\nfieldset[disabled] .btn-danger:hover,\nfieldset[disabled] .btn-danger:focus,\nfieldset[disabled] .btn-danger.focus,\nfieldset[disabled] .btn-danger:active,\nfieldset[disabled] .btn-danger.active {\n  background-color: #ef8157;\n  border-color: #ef8157;\n}\n.btn-danger.btn-simple {\n  color: #ef8157;\n  border-color: #ef8157;\n}\n.btn-danger.btn-simple:hover,\n.btn-danger.btn-simple:focus,\n.btn-danger.btn-simple:active {\n  background-color: transparent;\n  color: #eb6532;\n  border-color: #eb6532;\n  box-shadow: none;\n}\n.btn-danger.btn-link {\n  color: #ef8157;\n}\n.btn-danger.btn-link:hover,\n.btn-danger.btn-link:focus,\n.btn-danger.btn-link:active,\n.btn-danger.btn-link:active:focus {\n  background-color: transparent;\n  color: #eb6532;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.btn-outline-default {\n  background: transparent;\n  border: 2px solid #66615b !important;\n  color: #66615b;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-default:hover,\n.btn-outline-default:focus,\n.btn-outline-default:active,\n.btn-outline-default:focus:active,\n.btn-outline-default.active,\n.open > .btn-outline-default.dropdown-toggle {\n  background-color: #66615b !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #66615b !important;\n}\n.btn-outline-default:hover .caret,\n.btn-outline-default:focus .caret,\n.btn-outline-default:active .caret,\n.btn-outline-default:focus:active .caret,\n.btn-outline-default.active .caret,\n.open > .btn-outline-default.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-default .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-default.disabled,\n.btn-outline-default.disabled:hover,\n.btn-outline-default.disabled:focus,\n.btn-outline-default.disabled.focus,\n.btn-outline-default.disabled:active,\n.btn-outline-default.disabled.active,\n.btn-outline-default:disabled,\n.btn-outline-default:disabled:hover,\n.btn-outline-default:disabled:focus,\n.btn-outline-default:disabled.focus,\n.btn-outline-default:disabled:active,\n.btn-outline-default:disabled.active,\n.btn-outline-default[disabled],\n.btn-outline-default[disabled]:hover,\n.btn-outline-default[disabled]:focus,\n.btn-outline-default[disabled].focus,\n.btn-outline-default[disabled]:active,\n.btn-outline-default[disabled].active,\nfieldset[disabled] .btn-outline-default,\nfieldset[disabled] .btn-outline-default:hover,\nfieldset[disabled] .btn-outline-default:focus,\nfieldset[disabled] .btn-outline-default.focus,\nfieldset[disabled] .btn-outline-default:active,\nfieldset[disabled] .btn-outline-default.active {\n  background-color: transparent !important;\n  border-color: #66615b !important;\n}\n\n.btn-outline-primary {\n  background: transparent;\n  border: 2px solid #51cbce !important;\n  color: #51cbce;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:active,\n.btn-outline-primary:focus:active,\n.btn-outline-primary.active,\n.open > .btn-outline-primary.dropdown-toggle {\n  background-color: #51cbce !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #51cbce !important;\n}\n.btn-outline-primary:hover .caret,\n.btn-outline-primary:focus .caret,\n.btn-outline-primary:active .caret,\n.btn-outline-primary:focus:active .caret,\n.btn-outline-primary.active .caret,\n.open > .btn-outline-primary.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-primary .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-primary.disabled,\n.btn-outline-primary.disabled:hover,\n.btn-outline-primary.disabled:focus,\n.btn-outline-primary.disabled.focus,\n.btn-outline-primary.disabled:active,\n.btn-outline-primary.disabled.active,\n.btn-outline-primary:disabled,\n.btn-outline-primary:disabled:hover,\n.btn-outline-primary:disabled:focus,\n.btn-outline-primary:disabled.focus,\n.btn-outline-primary:disabled:active,\n.btn-outline-primary:disabled.active,\n.btn-outline-primary[disabled],\n.btn-outline-primary[disabled]:hover,\n.btn-outline-primary[disabled]:focus,\n.btn-outline-primary[disabled].focus,\n.btn-outline-primary[disabled]:active,\n.btn-outline-primary[disabled].active,\nfieldset[disabled] .btn-outline-primary,\nfieldset[disabled] .btn-outline-primary:hover,\nfieldset[disabled] .btn-outline-primary:focus,\nfieldset[disabled] .btn-outline-primary.focus,\nfieldset[disabled] .btn-outline-primary:active,\nfieldset[disabled] .btn-outline-primary.active {\n  background-color: transparent !important;\n  border-color: #51cbce !important;\n}\n\n.btn-outline-success {\n  background: transparent;\n  border: 2px solid #6bd098 !important;\n  color: #6bd098;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-success:hover,\n.btn-outline-success:focus,\n.btn-outline-success:active,\n.btn-outline-success:focus:active,\n.btn-outline-success.active,\n.open > .btn-outline-success.dropdown-toggle {\n  background-color: #6bd098 !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #6bd098 !important;\n}\n.btn-outline-success:hover .caret,\n.btn-outline-success:focus .caret,\n.btn-outline-success:active .caret,\n.btn-outline-success:focus:active .caret,\n.btn-outline-success.active .caret,\n.open > .btn-outline-success.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-success .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-success.disabled,\n.btn-outline-success.disabled:hover,\n.btn-outline-success.disabled:focus,\n.btn-outline-success.disabled.focus,\n.btn-outline-success.disabled:active,\n.btn-outline-success.disabled.active,\n.btn-outline-success:disabled,\n.btn-outline-success:disabled:hover,\n.btn-outline-success:disabled:focus,\n.btn-outline-success:disabled.focus,\n.btn-outline-success:disabled:active,\n.btn-outline-success:disabled.active,\n.btn-outline-success[disabled],\n.btn-outline-success[disabled]:hover,\n.btn-outline-success[disabled]:focus,\n.btn-outline-success[disabled].focus,\n.btn-outline-success[disabled]:active,\n.btn-outline-success[disabled].active,\nfieldset[disabled] .btn-outline-success,\nfieldset[disabled] .btn-outline-success:hover,\nfieldset[disabled] .btn-outline-success:focus,\nfieldset[disabled] .btn-outline-success.focus,\nfieldset[disabled] .btn-outline-success:active,\nfieldset[disabled] .btn-outline-success.active {\n  background-color: transparent !important;\n  border-color: #6bd098 !important;\n}\n\n.btn-outline-info {\n  background: transparent;\n  border: 2px solid #0fa0cf !important;\n  color: #0fa0cf;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-info:hover,\n.btn-outline-info:focus,\n.btn-outline-info:active,\n.btn-outline-info:focus:active,\n.btn-outline-info.active,\n.open > .btn-outline-info.dropdown-toggle {\n  background-color: #0fa0cf !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #0fa0cf !important;\n}\n.btn-outline-info:hover .caret,\n.btn-outline-info:focus .caret,\n.btn-outline-info:active .caret,\n.btn-outline-info:focus:active .caret,\n.btn-outline-info.active .caret,\n.open > .btn-outline-info.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-info .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-info.disabled,\n.btn-outline-info.disabled:hover,\n.btn-outline-info.disabled:focus,\n.btn-outline-info.disabled.focus,\n.btn-outline-info.disabled:active,\n.btn-outline-info.disabled.active,\n.btn-outline-info:disabled,\n.btn-outline-info:disabled:hover,\n.btn-outline-info:disabled:focus,\n.btn-outline-info:disabled.focus,\n.btn-outline-info:disabled:active,\n.btn-outline-info:disabled.active,\n.btn-outline-info[disabled],\n.btn-outline-info[disabled]:hover,\n.btn-outline-info[disabled]:focus,\n.btn-outline-info[disabled].focus,\n.btn-outline-info[disabled]:active,\n.btn-outline-info[disabled].active,\nfieldset[disabled] .btn-outline-info,\nfieldset[disabled] .btn-outline-info:hover,\nfieldset[disabled] .btn-outline-info:focus,\nfieldset[disabled] .btn-outline-info.focus,\nfieldset[disabled] .btn-outline-info:active,\nfieldset[disabled] .btn-outline-info.active {\n  background-color: transparent !important;\n  border-color: #0fa0cf !important;\n}\n\n.btn-outline-warning {\n  background: transparent;\n  border: 2px solid #fbc658 !important;\n  color: #fbc658;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-warning:hover,\n.btn-outline-warning:focus,\n.btn-outline-warning:active,\n.btn-outline-warning:focus:active,\n.btn-outline-warning.active,\n.open > .btn-outline-warning.dropdown-toggle {\n  background-color: #fbc658 !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #fbc658 !important;\n}\n.btn-outline-warning:hover .caret,\n.btn-outline-warning:focus .caret,\n.btn-outline-warning:active .caret,\n.btn-outline-warning:focus:active .caret,\n.btn-outline-warning.active .caret,\n.open > .btn-outline-warning.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-warning .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-warning.disabled,\n.btn-outline-warning.disabled:hover,\n.btn-outline-warning.disabled:focus,\n.btn-outline-warning.disabled.focus,\n.btn-outline-warning.disabled:active,\n.btn-outline-warning.disabled.active,\n.btn-outline-warning:disabled,\n.btn-outline-warning:disabled:hover,\n.btn-outline-warning:disabled:focus,\n.btn-outline-warning:disabled.focus,\n.btn-outline-warning:disabled:active,\n.btn-outline-warning:disabled.active,\n.btn-outline-warning[disabled],\n.btn-outline-warning[disabled]:hover,\n.btn-outline-warning[disabled]:focus,\n.btn-outline-warning[disabled].focus,\n.btn-outline-warning[disabled]:active,\n.btn-outline-warning[disabled].active,\nfieldset[disabled] .btn-outline-warning,\nfieldset[disabled] .btn-outline-warning:hover,\nfieldset[disabled] .btn-outline-warning:focus,\nfieldset[disabled] .btn-outline-warning.focus,\nfieldset[disabled] .btn-outline-warning:active,\nfieldset[disabled] .btn-outline-warning.active {\n  background-color: transparent !important;\n  border-color: #fbc658 !important;\n}\n\n.btn-outline-danger {\n  background: transparent;\n  border: 2px solid #ef8157 !important;\n  color: #ef8157;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-danger:hover,\n.btn-outline-danger:focus,\n.btn-outline-danger:active,\n.btn-outline-danger:focus:active,\n.btn-outline-danger.active,\n.open > .btn-outline-danger.dropdown-toggle {\n  background-color: #ef8157 !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #ef8157 !important;\n}\n.btn-outline-danger:hover .caret,\n.btn-outline-danger:focus .caret,\n.btn-outline-danger:active .caret,\n.btn-outline-danger:focus:active .caret,\n.btn-outline-danger.active .caret,\n.open > .btn-outline-danger.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-danger .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-danger.disabled,\n.btn-outline-danger.disabled:hover,\n.btn-outline-danger.disabled:focus,\n.btn-outline-danger.disabled.focus,\n.btn-outline-danger.disabled:active,\n.btn-outline-danger.disabled.active,\n.btn-outline-danger:disabled,\n.btn-outline-danger:disabled:hover,\n.btn-outline-danger:disabled:focus,\n.btn-outline-danger:disabled.focus,\n.btn-outline-danger:disabled:active,\n.btn-outline-danger:disabled.active,\n.btn-outline-danger[disabled],\n.btn-outline-danger[disabled]:hover,\n.btn-outline-danger[disabled]:focus,\n.btn-outline-danger[disabled].focus,\n.btn-outline-danger[disabled]:active,\n.btn-outline-danger[disabled].active,\nfieldset[disabled] .btn-outline-danger,\nfieldset[disabled] .btn-outline-danger:hover,\nfieldset[disabled] .btn-outline-danger:focus,\nfieldset[disabled] .btn-outline-danger.focus,\nfieldset[disabled] .btn-outline-danger:active,\nfieldset[disabled] .btn-outline-danger.active {\n  background-color: transparent !important;\n  border-color: #ef8157 !important;\n}\n\n.btn-outline-neutral {\n  background: transparent;\n  border: 2px solid #ffffff !important;\n  color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.btn-outline-neutral:hover,\n.btn-outline-neutral:focus,\n.btn-outline-neutral:active,\n.btn-outline-neutral:focus:active,\n.btn-outline-neutral.active,\n.open > .btn-outline-neutral.dropdown-toggle {\n  background-color: #ffffff !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  border-color: #ffffff !important;\n}\n.btn-outline-neutral:hover .caret,\n.btn-outline-neutral:focus .caret,\n.btn-outline-neutral:active .caret,\n.btn-outline-neutral:focus:active .caret,\n.btn-outline-neutral.active .caret,\n.open > .btn-outline-neutral.dropdown-toggle .caret {\n  border-top-color: rgba(255, 255, 255, 0.8) !important;\n}\n.btn-outline-neutral .caret {\n  border-top-color: #ffffff !important;\n}\n.btn-outline-neutral.disabled,\n.btn-outline-neutral.disabled:hover,\n.btn-outline-neutral.disabled:focus,\n.btn-outline-neutral.disabled.focus,\n.btn-outline-neutral.disabled:active,\n.btn-outline-neutral.disabled.active,\n.btn-outline-neutral:disabled,\n.btn-outline-neutral:disabled:hover,\n.btn-outline-neutral:disabled:focus,\n.btn-outline-neutral:disabled.focus,\n.btn-outline-neutral:disabled:active,\n.btn-outline-neutral:disabled.active,\n.btn-outline-neutral[disabled],\n.btn-outline-neutral[disabled]:hover,\n.btn-outline-neutral[disabled]:focus,\n.btn-outline-neutral[disabled].focus,\n.btn-outline-neutral[disabled]:active,\n.btn-outline-neutral[disabled].active,\nfieldset[disabled] .btn-outline-neutral,\nfieldset[disabled] .btn-outline-neutral:hover,\nfieldset[disabled] .btn-outline-neutral:focus,\nfieldset[disabled] .btn-outline-neutral.focus,\nfieldset[disabled] .btn-outline-neutral:active,\nfieldset[disabled] .btn-outline-neutral.active {\n  background-color: transparent !important;\n  border-color: #ffffff !important;\n}\n.btn-outline-neutral:hover,\n.btn-outline-neutral:focus {\n  color: #403d39;\n  background-color: #ffffff;\n}\n\n.btn-neutral {\n  background-color: #ffffff;\n  color: #51cbce;\n  color: #66615b;\n}\n.btn-neutral:hover,\n.btn-neutral:focus,\n.btn-neutral:active,\n.btn-neutral.active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n  background-color: #ffffff !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.btn-neutral:not([data-action]):hover {\n  box-shadow: none;\n}\n.btn-neutral.disabled,\n.btn-neutral.disabled:hover,\n.btn-neutral.disabled:focus,\n.btn-neutral.disabled.focus,\n.btn-neutral.disabled:active,\n.btn-neutral.disabled.active,\n.btn-neutral:disabled,\n.btn-neutral:disabled:hover,\n.btn-neutral:disabled:focus,\n.btn-neutral:disabled.focus,\n.btn-neutral:disabled:active,\n.btn-neutral:disabled.active,\n.btn-neutral[disabled],\n.btn-neutral[disabled]:hover,\n.btn-neutral[disabled]:focus,\n.btn-neutral[disabled].focus,\n.btn-neutral[disabled]:active,\n.btn-neutral[disabled].active,\nfieldset[disabled] .btn-neutral,\nfieldset[disabled] .btn-neutral:hover,\nfieldset[disabled] .btn-neutral:focus,\nfieldset[disabled] .btn-neutral.focus,\nfieldset[disabled] .btn-neutral:active,\nfieldset[disabled] .btn-neutral.active {\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n.btn-neutral.btn-danger {\n  color: #ef8157;\n}\n.btn-neutral.btn-danger:hover,\n.btn-neutral.btn-danger:focus,\n.btn-neutral.btn-danger:active,\n.btn-neutral.btn-danger:active:focus {\n  color: #eb6532 !important;\n}\n.btn-neutral.btn-info {\n  color: #0fa0cf !important;\n}\n.btn-neutral.btn-info:hover,\n.btn-neutral.btn-info:focus,\n.btn-neutral.btn-info:active,\n.btn-neutral.btn-info:active:focus {\n  color: #2ba9cd !important;\n}\n.btn-neutral.btn-warning {\n  color: #fbc658 !important;\n}\n.btn-neutral.btn-warning:hover,\n.btn-neutral.btn-warning:focus,\n.btn-neutral.btn-warning:active,\n.btn-neutral.btn-warning:active:focus {\n  color: #fab526 !important;\n}\n.btn-neutral.btn-success {\n  color: #6bd098 !important;\n}\n.btn-neutral.btn-success:hover,\n.btn-neutral.btn-success:focus,\n.btn-neutral.btn-success:active,\n.btn-neutral.btn-success:active:focus {\n  color: #44c47d !important;\n}\n.btn-neutral.btn-default {\n  color: #66615b !important;\n}\n.btn-neutral.btn-default:hover,\n.btn-neutral.btn-default:focus,\n.btn-neutral.btn-default:active,\n.btn-neutral.btn-default:active:focus {\n  color: #403d39 !important;\n}\n.btn-neutral.active,\n.btn-neutral:active,\n.btn-neutral:active:focus,\n.btn-neutral:active:hover,\n.btn-neutral.active:focus,\n.btn-neutral.active:hover,\n.show > .btn-neutral.dropdown-toggle,\n.show > .btn-neutral.dropdown-toggle:focus,\n.show > .btn-neutral.dropdown-toggle:hover {\n  background-color: #ffffff !important;\n  color: #34b5b8 !important;\n  box-shadow: none !important;\n}\n.btn-neutral:hover,\n.btn-neutral:focus {\n  color: #34b5b8 !important;\n}\n.btn-neutral:hover:not(.nav-link),\n.btn-neutral:focus:not(.nav-link) {\n  box-shadow: none;\n}\n.btn-neutral.btn-simple {\n  color: #ffffff;\n  border-color: #ffffff;\n}\n.btn-neutral.btn-simple:hover,\n.btn-neutral.btn-simple:focus,\n.btn-neutral.btn-simple:active {\n  background-color: transparent;\n  color: #ffffff;\n  border-color: #ffffff;\n  box-shadow: none;\n}\n.btn-neutral.btn-link {\n  color: #ffffff;\n}\n.btn-neutral.btn-link:hover,\n.btn-neutral.btn-link:focus,\n.btn-neutral.btn-link:active,\n.btn-neutral.btn-link:active:focus {\n  background-color: transparent;\n  color: #ffffff;\n  text-decoration: none;\n  box-shadow: none;\n}\n.btn-neutral:hover,\n.btn-neutral:focus {\n  color: #403d39;\n}\n.btn-neutral.btn-border:hover,\n.btn-neutral.btn-border:focus {\n  color: #66615b;\n}\n.btn-neutral.btn-border:active,\n.btn-neutral.btn-border.active,\n.open > .btn-neutral.btn-border.dropdown-toggle {\n  background-color: #ffffff;\n  color: #66615b;\n}\n.btn-neutral.btn-link:active,\n.btn-neutral.btn-link.active {\n  background-color: transparent;\n}\n\n.btn:disabled,\n.btn[disabled],\n.btn.disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n}\n\n.btn-simple {\n  border: 1px solid;\n  border-color: #66615b;\n  padding: 10px 22px;\n  background-color: transparent;\n}\n\n.btn-simple.disabled,\n.btn-simple.disabled:hover,\n.btn-simple.disabled:focus,\n.btn-simple.disabled.focus,\n.btn-simple.disabled:active,\n.btn-simple.disabled.active,\n.btn-simple:disabled,\n.btn-simple:disabled:hover,\n.btn-simple:disabled:focus,\n.btn-simple:disabled.focus,\n.btn-simple:disabled:active,\n.btn-simple:disabled.active,\n.btn-simple[disabled],\n.btn-simple[disabled]:hover,\n.btn-simple[disabled]:focus,\n.btn-simple[disabled].focus,\n.btn-simple[disabled]:active,\n.btn-simple[disabled].active,\nfieldset[disabled] .btn-simple,\nfieldset[disabled] .btn-simple:hover,\nfieldset[disabled] .btn-simple:focus,\nfieldset[disabled] .btn-simple.focus,\nfieldset[disabled] .btn-simple:active,\nfieldset[disabled] .btn-simple.active,\n.btn-link.disabled,\n.btn-link.disabled:hover,\n.btn-link.disabled:focus,\n.btn-link.disabled.focus,\n.btn-link.disabled:active,\n.btn-link.disabled.active,\n.btn-link:disabled,\n.btn-link:disabled:hover,\n.btn-link:disabled:focus,\n.btn-link:disabled.focus,\n.btn-link:disabled:active,\n.btn-link:disabled.active,\n.btn-link[disabled],\n.btn-link[disabled]:hover,\n.btn-link[disabled]:focus,\n.btn-link[disabled].focus,\n.btn-link[disabled]:active,\n.btn-link[disabled].active,\nfieldset[disabled] .btn-link,\nfieldset[disabled] .btn-link:hover,\nfieldset[disabled] .btn-link:focus,\nfieldset[disabled] .btn-link.focus,\nfieldset[disabled] .btn-link:active,\nfieldset[disabled] .btn-link.active {\n  background-color: transparent;\n}\n\n.btn-link {\n  border: 0;\n  padding: 0.5rem 0.7rem;\n  background-color: transparent;\n}\n\n.btn-lg {\n  font-size: 1rem;\n  border-radius: 6px;\n  padding: 15px 48px;\n}\n.btn-lg.btn-simple {\n  padding: 14px 47px;\n}\n\n.btn-sm {\n  font-size: 0.8571em;\n  border-radius: 3px;\n  padding: 5px 15px;\n}\n.btn-sm.btn-simple {\n  padding: 4px 14px;\n}\n\n.btn-wd {\n  min-width: 140px;\n}\n\n.btn-group.select {\n  width: 100%;\n}\n\n.btn-group.select .btn {\n  text-align: left;\n}\n\n.btn-group.select .caret {\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\n  right: 8px;\n}\n\n.btn-group .btn + .btn {\n  margin-left: -3px;\n}\n\n.btn-group .btn:focus {\n  background-color: #0fa0cf !important;\n}\n\n.btn-round {\n  border-width: 1px;\n  border-radius: 30px;\n  padding-right: 23px;\n  padding-left: 23px;\n}\n.btn-round.btn-simple {\n  padding: 10px 22px;\n}\n\n.no-caret.dropdown-toggle::after {\n  display: none;\n}\n\n.btn.btn-facebook {\n  background-color: #3b5998;\n  color: #ffffff;\n}\n.btn.btn-facebook:focus,\n.btn.btn-facebook:active,\n.btn.btn-facebook:hover {\n  background-color: #344e86 !important;\n  color: #ffffff !important;\n}\n.btn.btn-facebook.btn-simple {\n  color: #3b5998;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #3b5998;\n}\n.btn.btn-facebook.btn-simple:hover,\n.btn.btn-facebook.btn-simple:focus,\n.btn.btn-facebook.btn-simple:active {\n  color: #344e86;\n  border-color: #344e86;\n}\n.btn.btn-facebook.btn-neutral {\n  color: #3b5998;\n  background-color: #ffffff;\n}\n.btn.btn-facebook.btn-neutral:hover,\n.btn.btn-facebook.btn-neutral:focus,\n.btn.btn-facebook.btn-neutral:active {\n  color: #344e86 !important;\n}\n\n.btn.btn-twitter {\n  background-color: #55acee;\n  color: #ffffff;\n}\n.btn.btn-twitter:focus,\n.btn.btn-twitter:active,\n.btn.btn-twitter:hover {\n  background-color: #3ea1ec !important;\n  color: #ffffff !important;\n}\n.btn.btn-twitter.btn-simple {\n  color: #55acee;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #55acee;\n}\n.btn.btn-twitter.btn-simple:hover,\n.btn.btn-twitter.btn-simple:focus,\n.btn.btn-twitter.btn-simple:active {\n  color: #3ea1ec;\n  border-color: #3ea1ec;\n}\n.btn.btn-twitter.btn-neutral {\n  color: #55acee;\n  background-color: #ffffff;\n}\n.btn.btn-twitter.btn-neutral:hover,\n.btn.btn-twitter.btn-neutral:focus,\n.btn.btn-twitter.btn-neutral:active {\n  color: #3ea1ec !important;\n}\n\n.btn.btn-pinterest {\n  background-color: #cc2127;\n  color: #ffffff;\n}\n.btn.btn-pinterest:focus,\n.btn.btn-pinterest:active,\n.btn.btn-pinterest:hover {\n  background-color: #dd2e34 !important;\n  color: #ffffff !important;\n}\n.btn.btn-pinterest.btn-simple {\n  color: #cc2127;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #cc2127;\n}\n.btn.btn-pinterest.btn-simple:hover,\n.btn.btn-pinterest.btn-simple:focus,\n.btn.btn-pinterest.btn-simple:active {\n  color: #dd2e34;\n  border-color: #dd2e34;\n}\n.btn.btn-pinterest.btn-neutral {\n  color: #cc2127;\n  background-color: #ffffff;\n}\n.btn.btn-pinterest.btn-neutral:hover,\n.btn.btn-pinterest.btn-neutral:focus,\n.btn.btn-pinterest.btn-neutral:active {\n  color: #dd2e34 !important;\n}\n\n.btn.btn-google {\n  background-color: #dd4b39;\n  color: #ffffff;\n}\n.btn.btn-google:focus,\n.btn.btn-google:active,\n.btn.btn-google:hover {\n  background-color: #d73925 !important;\n  color: #ffffff !important;\n}\n.btn.btn-google.btn-simple {\n  color: #dd4b39;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #dd4b39;\n}\n.btn.btn-google.btn-simple:hover,\n.btn.btn-google.btn-simple:focus,\n.btn.btn-google.btn-simple:active {\n  color: #d73925;\n  border-color: #d73925;\n}\n.btn.btn-google.btn-neutral {\n  color: #dd4b39;\n  background-color: #ffffff;\n}\n.btn.btn-google.btn-neutral:hover,\n.btn.btn-google.btn-neutral:focus,\n.btn.btn-google.btn-neutral:active {\n  color: #d73925 !important;\n}\n\n.btn.btn-linkedin {\n  background-color: #0077b5;\n  color: #ffffff;\n}\n.btn.btn-linkedin:focus,\n.btn.btn-linkedin:active,\n.btn.btn-linkedin:hover {\n  background-color: #00669c !important;\n  color: #ffffff !important;\n}\n.btn.btn-linkedin.btn-simple {\n  color: #0077b5;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #0077b5;\n}\n.btn.btn-linkedin.btn-simple:hover,\n.btn.btn-linkedin.btn-simple:focus,\n.btn.btn-linkedin.btn-simple:active {\n  color: #00669c;\n  border-color: #00669c;\n}\n.btn.btn-linkedin.btn-neutral {\n  color: #0077b5;\n  background-color: #ffffff;\n}\n.btn.btn-linkedin.btn-neutral:hover,\n.btn.btn-linkedin.btn-neutral:focus,\n.btn.btn-linkedin.btn-neutral:active {\n  color: #00669c !important;\n}\n\n.btn.btn-dribbble {\n  background-color: #ea4c89;\n  color: #ffffff;\n}\n.btn.btn-dribbble:focus,\n.btn.btn-dribbble:active,\n.btn.btn-dribbble:hover {\n  background-color: #ed679b !important;\n  color: #ffffff !important;\n}\n.btn.btn-dribbble.btn-simple {\n  color: #ea4c89;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #ea4c89;\n}\n.btn.btn-dribbble.btn-simple:hover,\n.btn.btn-dribbble.btn-simple:focus,\n.btn.btn-dribbble.btn-simple:active {\n  color: #ed679b;\n  border-color: #ed679b;\n}\n.btn.btn-dribbble.btn-neutral {\n  color: #ea4c89;\n  background-color: #ffffff;\n}\n.btn.btn-dribbble.btn-neutral:hover,\n.btn.btn-dribbble.btn-neutral:focus,\n.btn.btn-dribbble.btn-neutral:active {\n  color: #ed679b !important;\n}\n\n.btn.btn-github {\n  background-color: #333333;\n  color: #ffffff;\n}\n.btn.btn-github:focus,\n.btn.btn-github:active,\n.btn.btn-github:hover {\n  background-color: #424242 !important;\n  color: #ffffff !important;\n}\n.btn.btn-github.btn-simple {\n  color: #333333;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #333333;\n}\n.btn.btn-github.btn-simple:hover,\n.btn.btn-github.btn-simple:focus,\n.btn.btn-github.btn-simple:active {\n  color: #424242;\n  border-color: #424242;\n}\n.btn.btn-github.btn-neutral {\n  color: #333333;\n  background-color: #ffffff;\n}\n.btn.btn-github.btn-neutral:hover,\n.btn.btn-github.btn-neutral:focus,\n.btn.btn-github.btn-neutral:active {\n  color: #424242 !important;\n}\n\n.btn.btn-youtube {\n  background-color: #e52d27;\n  color: #ffffff;\n}\n.btn.btn-youtube:focus,\n.btn.btn-youtube:active,\n.btn.btn-youtube:hover {\n  background-color: #e84842 !important;\n  color: #ffffff !important;\n}\n.btn.btn-youtube.btn-simple {\n  color: #e52d27;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #e52d27;\n}\n.btn.btn-youtube.btn-simple:hover,\n.btn.btn-youtube.btn-simple:focus,\n.btn.btn-youtube.btn-simple:active {\n  color: #e84842;\n  border-color: #e84842;\n}\n.btn.btn-youtube.btn-neutral {\n  color: #e52d27;\n  background-color: #ffffff;\n}\n.btn.btn-youtube.btn-neutral:hover,\n.btn.btn-youtube.btn-neutral:focus,\n.btn.btn-youtube.btn-neutral:active {\n  color: #e84842 !important;\n}\n\n.btn.btn-instagram {\n  background-color: #125688;\n  color: #ffffff;\n}\n.btn.btn-instagram:focus,\n.btn.btn-instagram:active,\n.btn.btn-instagram:hover {\n  background-color: #1667a3 !important;\n  color: #ffffff !important;\n}\n.btn.btn-instagram.btn-simple {\n  color: #125688;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #125688;\n}\n.btn.btn-instagram.btn-simple:hover,\n.btn.btn-instagram.btn-simple:focus,\n.btn.btn-instagram.btn-simple:active {\n  color: #1667a3;\n  border-color: #1667a3;\n}\n.btn.btn-instagram.btn-neutral {\n  color: #125688;\n  background-color: #ffffff;\n}\n.btn.btn-instagram.btn-neutral:hover,\n.btn.btn-instagram.btn-neutral:focus,\n.btn.btn-instagram.btn-neutral:active {\n  color: #1667a3 !important;\n}\n\n.btn.btn-reddit {\n  background-color: #ff4500;\n  color: #ffffff;\n}\n.btn.btn-reddit:focus,\n.btn.btn-reddit:active,\n.btn.btn-reddit:hover {\n  background-color: #ff5b1f !important;\n  color: #ffffff !important;\n}\n.btn.btn-reddit.btn-simple {\n  color: #ff4500;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #ff4500;\n}\n.btn.btn-reddit.btn-simple:hover,\n.btn.btn-reddit.btn-simple:focus,\n.btn.btn-reddit.btn-simple:active {\n  color: #ff5b1f;\n  border-color: #ff5b1f;\n}\n.btn.btn-reddit.btn-neutral {\n  color: #ff4500;\n  background-color: #ffffff;\n}\n.btn.btn-reddit.btn-neutral:hover,\n.btn.btn-reddit.btn-neutral:focus,\n.btn.btn-reddit.btn-neutral:active {\n  color: #ff5b1f !important;\n}\n\n.btn.btn-tumblr {\n  background-color: #35465c;\n  color: #ffffff;\n}\n.btn.btn-tumblr:focus,\n.btn.btn-tumblr:active,\n.btn.btn-tumblr:hover {\n  background-color: #40556f !important;\n  color: #ffffff !important;\n}\n.btn.btn-tumblr.btn-simple {\n  color: #35465c;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #35465c;\n}\n.btn.btn-tumblr.btn-simple:hover,\n.btn.btn-tumblr.btn-simple:focus,\n.btn.btn-tumblr.btn-simple:active {\n  color: #40556f;\n  border-color: #40556f;\n}\n.btn.btn-tumblr.btn-neutral {\n  color: #35465c;\n  background-color: #ffffff;\n}\n.btn.btn-tumblr.btn-neutral:hover,\n.btn.btn-tumblr.btn-neutral:focus,\n.btn.btn-tumblr.btn-neutral:active {\n  color: #40556f !important;\n}\n\n.btn.btn-behance {\n  background-color: #1769ff;\n  color: #ffffff;\n}\n.btn.btn-behance:focus,\n.btn.btn-behance:active,\n.btn.btn-behance:hover {\n  background-color: #367dff !important;\n  color: #ffffff !important;\n}\n.btn.btn-behance.btn-simple {\n  color: #1769ff;\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #1769ff;\n}\n.btn.btn-behance.btn-simple:hover,\n.btn.btn-behance.btn-simple:focus,\n.btn.btn-behance.btn-simple:active {\n  color: #367dff;\n  border-color: #367dff;\n}\n.btn.btn-behance.btn-neutral {\n  color: #1769ff;\n  background-color: #ffffff;\n}\n.btn.btn-behance.btn-neutral:hover,\n.btn.btn-behance.btn-neutral:focus,\n.btn.btn-behance.btn-neutral:active {\n  color: #367dff !important;\n}\n\n.icon-property,\n.btn-rotate i,\n.btn-magnify i,\n.btn-move-left i,\n.btn-move-right i {\n  -webkit-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  -moz-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  -o-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  -ms-transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);\n  position: relative;\n  display: inline-block;\n}\n\n#animated-buttons .btn i {\n  position: relative;\n  top: 3px;\n  margin-top: -3px;\n}\n\n.btn-rotate:hover i,\n.btn-rotate:focus i {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(53deg);\n  -ms-transform: rotate(53deg);\n  transform: rotate(53deg);\n}\n\n.btn-magnify:hover i,\n.btn-magnify:focus i {\n  -webkit-transform: scale(1.22);\n  -moz-transform: scale(1.22);\n  -o-transform: scale(1.22);\n  -ms-transform: scale(1.22);\n  transform: scale(1.22);\n}\n\n.btn-move-left i {\n  margin-right: 0;\n}\n\n.btn-move-left:hover i,\n.btn-move-left:focus i {\n  -webkit-transform: translate3d(-5px, 0, 0);\n  -moz-transform: translate3d(-5px, 0, 0);\n  -o-transform: translate3d(-5px, 0, 0);\n  -ms-transform: translate3d(-5px, 0, 0);\n  transform: translate3d(-5px, 0, 0);\n}\n\n.btn-move-right i {\n  margin-right: 0;\n}\n\n.btn-move-right:hover i,\n.btn-move-right:focus i {\n  -webkit-transform: translate3d(5px, 0, 0);\n  -moz-transform: translate3d(5px, 0, 0);\n  -o-transform: translate3d(5px, 0, 0);\n  -ms-transform: translate3d(5px, 0, 0);\n  transform: translate3d(5px, 0, 0);\n}\n\n::-moz-placeholder {\n  color: #9a9a9a;\n}\n\n:-ms-input-placeholder {\n  color: #9a9a9a;\n}\n\n::-webkit-input-placeholder {\n  color: #9a9a9a;\n}\n\n.form-control {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  color: #66615b;\n  line-height: normal;\n  font-size: 14px;\n  -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.form-control:focus {\n  border: 1px solid #9a9a9a;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0 !important;\n  color: #66615b;\n}\n.form-control:focus + .input-group-append .input-group-text,\n.form-control:focus ~ .input-group-append .input-group-text,\n.form-control:focus + .input-group-prepend .input-group-text,\n.form-control:focus ~ .input-group-prepend .input-group-text {\n  border: 1px solid #ccc;\n  border-left: none;\n  background-color: transparent;\n}\n.has-success .form-control,\n.has-error .form-control,\n.has-success .form-control:focus,\n.has-error .form-control:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.has-success .form-control {\n  border: 1px solid #ccc;\n  color: #66615b;\n}\n.has-success .form-control.form-control-success {\n  padding-right: 2.5em !important;\n}\n.has-success .form-control:focus {\n  border: 1px solid #6bd098;\n  color: #6bd098;\n}\n.has-danger .form-control {\n  background-color: #ffc0a4;\n  border: 1px solid #ef8157;\n  color: #ef8157;\n}\n.has-danger .form-control.form-control-danger {\n  padding-right: 2.5em !important;\n}\n.has-danger .form-control:focus {\n  background-color: #ffffff;\n  border: 1px solid #ef8157;\n}\n.form-control + .form-control-feedback {\n  border-radius: 6px;\n  font-size: 14px;\n  margin-top: -7px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  vertical-align: middle;\n}\n.open .form-control {\n  border-radius: 6px 6px 0 0;\n  border-bottom-color: transparent;\n}\n.form-control + .input-group-append .input-group-text,\n.form-control + .input-group-prepend .input-group-text {\n  background-color: #ffffff;\n}\n\n.form-group.no-border.form-control-lg .input-group-append .input-group-text,\n.input-group.no-border.form-control-lg .input-group-append .input-group-text {\n  padding: 15px 0 15px 11px;\n}\n\n.form-group.no-border.form-control-lg .form-control,\n.input-group.no-border.form-control-lg .form-control {\n  padding: 15px 11px;\n}\n.form-group.no-border.form-control-lg\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.form-group.no-border.form-control-lg\n  .form-control\n  + .input-group-append\n  .input-group-text,\n.input-group.no-border.form-control-lg\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.input-group.no-border.form-control-lg\n  .form-control\n  + .input-group-append\n  .input-group-text {\n  padding: 15px 11px 15px 0;\n}\n\n.form-group.form-control-lg .form-control,\n.input-group.form-control-lg .form-control {\n  padding: 14px 10px;\n}\n.form-group.form-control-lg\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.form-group.form-control-lg\n  .form-control\n  + .input-group-append\n  .input-group-text,\n.input-group.form-control-lg\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.input-group.form-control-lg\n  .form-control\n  + .input-group-append\n  .input-group-text {\n  padding: 14px 10px 14px 0;\n}\n\n.form-group.form-control-lg .input-group-prepend .input-group-text,\n.form-group.form-control-lg .input-group-append .input-group-text,\n.input-group.form-control-lg .input-group-prepend .input-group-text,\n.input-group.form-control-lg .input-group-append .input-group-text {\n  padding: 14px 0 15px 10px;\n}\n.form-group.form-control-lg\n  .input-group-prepend\n  .input-group-text\n  + .form-control,\n.form-group.form-control-lg\n  .input-group-append\n  .input-group-text\n  + .form-control,\n.input-group.form-control-lg\n  .input-group-prepend\n  .input-group-text\n  + .form-control,\n.input-group.form-control-lg\n  .input-group-append\n  .input-group-text\n  + .form-control {\n  padding: 15px 10px 15px 8px;\n}\n\n.form-group.no-border .form-control,\n.input-group.no-border .form-control {\n  padding: 11px 11px;\n}\n.form-group.no-border .form-control + .input-group-prepend .input-group-text,\n.form-group.no-border .form-control + .input-group-append .input-group-text,\n.input-group.no-border .form-control + .input-group-prepend .input-group-text,\n.input-group.no-border .form-control + .input-group-append .input-group-text {\n  padding: 11px 11px 11px 0;\n}\n\n.form-group.no-border .input-group-prepend .input-group-text,\n.form-group.no-border .input-group-append .input-group-text,\n.input-group.no-border .input-group-prepend .input-group-text,\n.input-group.no-border .input-group-append .input-group-text {\n  padding: 11px 0 11px 11px;\n}\n\n.form-group .form-control,\n.input-group .form-control {\n  padding: 10px 10px 10px 10px;\n}\n.form-group .form-control + .input-group-prepend .input-group-text,\n.form-group .form-control + .input-group-append .input-group-text,\n.input-group .form-control + .input-group-prepend .input-group-text,\n.input-group .form-control + .input-group-append .input-group-text {\n  padding: 10px 10px 10px 0;\n}\n\n.form-group .input-group-prepend .input-group-text,\n.form-group .input-group-append .input-group-text,\n.input-group .input-group-prepend .input-group-text,\n.input-group .input-group-append .input-group-text {\n  padding: 10px 0 10px 10px;\n}\n.form-group .input-group-prepend .input-group-text + .form-control,\n.form-group .input-group-prepend .input-group-text ~ .form-control,\n.form-group .input-group-append .input-group-text + .form-control,\n.form-group .input-group-append .input-group-text ~ .form-control,\n.input-group .input-group-prepend .input-group-text + .form-control,\n.input-group .input-group-prepend .input-group-text ~ .form-control,\n.input-group .input-group-append .input-group-text + .form-control,\n.input-group .input-group-append .input-group-text ~ .form-control {\n  padding: 10px 11px 11px 8px;\n}\n\n.input-group.has-success .input-group-prepend .input-group-text,\n.input-group.has-success .input-group-append .input-group-text {\n  border: 1px solid #ccc;\n  color: #66615b;\n  background-color: #ffffff;\n  border-right: none;\n}\n\n.form-group.no-border .form-control,\n.form-group.no-border .form-control + .input-group-prepend .input-group-text,\n.form-group.no-border .form-control + .input-group-append .input-group-text,\n.input-group.no-border .form-control,\n.input-group.no-border .form-control + .input-group-prepend .input-group-text,\n.input-group.no-border .form-control + .input-group-append .input-group-text {\n  background-color: rgba(222, 222, 222, 0.3);\n  border: medium none;\n}\n.form-group.no-border .form-control:focus,\n.form-group.no-border .form-control:active,\n.form-group.no-border .form-control:active,\n.form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.input-group.no-border .form-control:focus,\n.input-group.no-border .form-control:active,\n.input-group.no-border .form-control:active,\n.input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active {\n  border: medium none;\n  background-color: rgba(222, 222, 222, 0.5);\n}\n\n.form-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.form-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text,\n.input-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.input-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(222, 222, 222, 0.5);\n}\n\n.form-group.no-border .input-group-prepend .input-group-text,\n.form-group.no-border .input-group-append .input-group-text,\n.input-group.no-border .input-group-prepend .input-group-text,\n.input-group.no-border .input-group-append .input-group-text {\n  background-color: rgba(222, 222, 222, 0.3);\n  border: none;\n}\n\n.has-error .form-control-feedback,\n.has-error .control-label {\n  color: #ef8157;\n}\n\n.has-success .form-control-feedback,\n.has-success .control-label {\n  color: #6bd098;\n}\n\n.input-group.has-danger .input-group-prepend {\n  border-radius: 4px;\n}\n.input-group.has-danger .input-group-prepend .input-group-text {\n  border: 1px solid #ef8157;\n  border-right: none;\n}\n\n.input-group.has-danger .error {\n  display: block;\n  width: 100%;\n  color: #ef8157;\n  margin-top: 3px;\n}\n\n.input-group.has-success .input-group-prepend {\n  border-radius: 4px;\n}\n.input-group.has-success .input-group-prepend .input-group-text {\n  border-right: none;\n}\n\n.input-group-focus .input-group-prepend .input-group-text,\n.input-group-focus .input-group-append .input-group-text {\n  background-color: #ffffff;\n  border-color: #9a9a9a;\n}\n\n.input-group-focus.no-border .input-group-prepend .input-group-text,\n.input-group-focus.no-border .input-group-append .input-group-text {\n  background-color: rgba(222, 222, 222, 0.5);\n}\n\n.input-group-focus.has-danger .input-group-append .input-group-text,\n.input-group-focus.has-danger .input-group-prepend .input-group-text {\n  background-color: #ffc0a4;\n}\n\n.input-group-focus.has-success .input-group-append .input-group-text,\n.input-group-focus.has-success .input-group-prepend .input-group-text {\n  background-color: #abf3cb;\n  border: 1px solid #6bd098;\n  border-right: none;\n}\n\n.input-group-append .input-group-text,\n.input-group-prepend .input-group-text {\n  background-color: transparent;\n  border: 1px solid #e3e3e3;\n  color: #66615b;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n}\n.input-group-append .input-group-text i,\n.input-group-prepend .input-group-text i {\n  opacity: 0.5;\n}\n.has-danger .input-group-append .input-group-text,\n.has-danger .input-group-prepend .input-group-text {\n  background-color: #ffc0a4;\n}\n.has-success .input-group-append .input-group-text,\n.has-success .input-group-prepend .input-group-text {\n  background-color: #abf3cb;\n}\n.has-danger.input-group-focus .input-group-append .input-group-text,\n.has-danger.input-group-focus .input-group-prepend .input-group-text {\n  background-color: #ffffff;\n  color: #ef8157;\n}\n.has-success.input-group-focus .input-group-append .input-group-text,\n.has-success.input-group-focus .input-group-prepend .input-group-text {\n  background-color: #ffffff;\n  color: #6bd098;\n}\n.has-danger .form-control:focus + .input-group-append .input-group-text,\n.has-danger .form-control:focus + .input-group-prepend .input-group-text {\n  color: #ef8157;\n}\n.has-success .form-control:focus + .input-group-append .input-group-text,\n.has-success .form-control:focus + .input-group-prepend .input-group-text {\n  color: #6bd098;\n}\n.input-group-append .input-group-text + .form-control,\n.input-group-append .input-group-text ~ .form-control,\n.input-group-prepend .input-group-text + .form-control,\n.input-group-prepend .input-group-text ~ .form-control {\n  padding: -0.5rem 0.7rem;\n  padding-left: 18px;\n}\n.input-group-append .input-group-text i,\n.input-group-prepend .input-group-text i {\n  width: 17px;\n}\n\n.input-group-append,\n.input-group-prepend {\n  margin: 0;\n}\n\n.input-group-append .input-group-text {\n  border-left: none;\n}\n\n.input-group-prepend .input-group-text {\n  border-right: none;\n}\n\n.input-group,\n.form-group {\n  margin-bottom: 10px;\n  position: relative;\n}\n.input-group .form-control-static,\n.form-group .form-control-static {\n  margin-top: 9px;\n}\n.input-group.has-danger .error,\n.form-group.has-danger .error {\n  color: #ef8157;\n}\n\n.input-group[disabled] .input-group-prepend .input-group-text,\n.input-group[disabled] .input-group-append .input-group-text {\n  background-color: #e3e3e3;\n}\n\n.input-group .form-control:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0 none;\n}\n\n.input-group .form-control:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-right: 0 none;\n}\n\n.input-group .form-control:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n  border-left: 0 none;\n}\n\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #e3e3e3;\n  color: #66615b;\n  cursor: not-allowed;\n}\n\n.input-group-btn .btn {\n  border-width: 1px;\n  padding: 11px 0.7rem;\n}\n\n.input-group-btn .btn-default:not(.btn-fill) {\n  border-color: #dddddd;\n}\n\n.input-group-btn:last-child > .btn {\n  margin-left: 0;\n}\n\ntextarea.form-control {\n  max-width: 100%;\n  max-height: 80px;\n  padding: 10px 10px 0 0;\n  resize: none;\n  border: none;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  line-height: 2;\n}\n\n.has-success.form-group .form-control,\n.has-success.form-group.no-border .form-control,\n.has-danger.form-group .form-control,\n.has-danger.form-group.no-border .form-control {\n  padding-right: 32px;\n}\n\n.form.form-newsletter .form-group {\n  float: left;\n  width: 78%;\n  margin-right: 2%;\n  margin-top: 9px;\n}\n\n.input-group .input-group-btn {\n  padding: 0 12px;\n}\n\n.form-group input[type=\"file\"] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.form-text {\n  font-size: 0.8571em;\n}\n\n.form-control-lg {\n  padding: 0;\n  font-size: inherit;\n  line-height: 0;\n  border-radius: 0;\n}\n\n.form-horizontal .col-form-label,\n.form-horizontal .label-on-right {\n  padding: 10px 5px 0 15px;\n  text-align: right;\n  max-width: 180px;\n}\n\n.form-horizontal .checkbox-radios {\n  margin-bottom: 15px;\n}\n.form-horizontal .checkbox-radios .form-check:first-child {\n  margin-top: 8px;\n}\n\n.form-horizontal .label-on-right {\n  text-align: left;\n  padding: 10px 15px 0 5px;\n}\n\n.form-horizontal .form-check-inline {\n  margin-top: 6px;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: \"Montserrat\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 400;\n}\n\na {\n  color: #51cbce;\n}\na:hover,\na:focus {\n  color: #51cbce;\n}\n\nh1,\n.h1 {\n  font-size: 3.5em;\n  line-height: 1.15;\n  margin-bottom: 30px;\n}\nh1 small,\n.h1 small {\n  font-weight: 700;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n\nh2,\n.h2 {\n  font-size: 2.5em;\n  margin-bottom: 30px;\n}\n\nh3,\n.h3 {\n  font-size: 2em;\n  margin-bottom: 30px;\n  line-height: 1.4em;\n}\n\nh4,\n.h4 {\n  font-size: 1.714em;\n  line-height: 1.45em;\n  margin-top: 30px;\n  margin-bottom: 15px;\n}\nh4 + .category,\nh4.title + .category,\n.h4 + .category,\n.h4.title + .category {\n  margin-top: -10px;\n}\n\nh5,\n.h5 {\n  font-size: 1.57em;\n  line-height: 1.4em;\n  margin-bottom: 15px;\n}\n\nh6,\n.h6 {\n  font-size: 1em;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\np.description {\n  font-size: 1.14em;\n}\n\n.title {\n  font-weight: 700;\n}\n.title.title-up {\n  text-transform: uppercase;\n}\n.title.title-up a {\n  color: #2c2c2c;\n  text-decoration: none;\n}\n.title + .category {\n  margin-top: -10px;\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats {\n  color: #9a9a9a;\n  font-weight: 300;\n}\n\n.category,\n.card-category {\n  text-transform: capitalize;\n  font-weight: 400;\n  color: #9a9a9a;\n  font-size: 0.7142em;\n}\n\n.card-category {\n  font-size: 1em;\n}\n\n.text-primary,\na.text-primary:focus,\na.text-primary:hover {\n  color: #51cbce !important;\n}\n\n.text-info,\na.text-info:focus,\na.text-info:hover {\n  color: #0fa0cf !important;\n}\n\n.text-success,\na.text-success:focus,\na.text-success:hover {\n  color: #6bd098 !important;\n}\n\n.text-warning,\na.text-warning:focus,\na.text-warning:hover {\n  color: #fbc658 !important;\n}\n\n.text-danger,\na.text-danger:focus,\na.text-danger:hover {\n  color: #ef8157 !important;\n}\n\n.text-gray,\na.text-gray:focus,\na.text-gray:hover {\n  color: #e3e3e3 !important;\n}\n\n.blockquote {\n  border-left: none;\n  border: 1px solid #66615b;\n  padding: 20px;\n  font-size: 1.1em;\n  line-height: 1.8;\n}\n.blockquote small {\n  color: #66615b;\n  font-size: 0.8571em;\n  text-transform: uppercase;\n}\n.blockquote.blockquote-primary {\n  border-color: #51cbce;\n  color: #51cbce;\n}\n.blockquote.blockquote-primary small {\n  color: #51cbce;\n}\n.blockquote.blockquote-danger {\n  border-color: #ef8157;\n  color: #ef8157;\n}\n.blockquote.blockquote-danger small {\n  color: #ef8157;\n}\n.blockquote.blockquote-white {\n  border-color: rgba(255, 255, 255, 0.8);\n  color: #ffffff;\n}\n.blockquote.blockquote-white small {\n  color: rgba(255, 255, 255, 0.8);\n}\n\nbody {\n  color: #2c2c2c;\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n    \"Segoe UI Symbol\";\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n.main {\n  position: relative;\n  background: #ffffff;\n}\n\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.animation-transition-general,\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize,\n.sidebar .nav p,\n.off-canvas-sidebar .nav p,\n.sidebar .logo a.logo-mini,\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-normal,\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo,\n.sidebar .user a,\n.off-canvas-sidebar .user a,\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span,\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] i,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general,\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize,\n.sidebar .nav p,\n.off-canvas-sidebar .nav p,\n.sidebar .logo a.logo-mini,\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-normal,\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo,\n.sidebar .user a,\n.off-canvas-sidebar .user a,\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span,\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] i {\n  -webkit-transition: all 300ms ease 0s;\n  -moz-transition: all 300ms ease 0s;\n  -o-transition: all 300ms ease 0s;\n  -ms-transition: all 300ms ease 0s;\n  transition: all 300ms ease 0s;\n}\n\n.dropdown-toggle:after,\n.bootstrap-switch-label:before,\n.caret {\n  -webkit-transition: all 150ms ease 0s;\n  -moz-transition: all 150ms ease 0s;\n  -o-transition: all 150ms ease 0s;\n  -ms-transition: all 150ms ease 0s;\n  transition: all 150ms ease 0s;\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.button-bar {\n  display: block;\n  position: relative;\n  width: 22px;\n  height: 1px;\n  border-radius: 1px;\n  background: #ffffff;\n}\n.button-bar + .button-bar {\n  margin-top: 7px;\n}\n.button-bar:nth-child(2) {\n  width: 17px;\n}\n\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid\\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.offline-doc .navbar.navbar-transparent {\n  padding-top: 25px;\n  border-bottom: none;\n}\n.offline-doc .navbar.navbar-transparent .navbar-minimize {\n  display: none;\n}\n.offline-doc .navbar.navbar-transparent .navbar-brand,\n.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {\n  color: #ffffff !important;\n}\n\n.offline-doc .footer {\n  z-index: 3 !important;\n}\n\n.offline-doc .page-header .container {\n  z-index: 3;\n}\n\n.offline-doc .page-header:after {\n  background-color: rgba(0, 0, 0, 0.5);\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n}\n\n.fixed-plugin .dropdown-menu li {\n  padding: 2px !important;\n}\n\n.badge.badge-default {\n  border-color: #66615b;\n  background-color: #66615b;\n}\n\n.badge.badge-primary {\n  border-color: #51cbce;\n  background-color: #51cbce;\n}\n\n.badge.badge-info {\n  border-color: #0fa0cf;\n  background-color: #0fa0cf;\n}\n\n.badge.badge-success {\n  border-color: #6bd098;\n  background-color: #6bd098;\n}\n\n.badge.badge-warning {\n  border-color: #fbc658;\n  background-color: #fbc658;\n}\n\n.badge.badge-danger {\n  border-color: #ef8157;\n  background-color: #ef8157;\n}\n\n.badge.badge-neutral {\n  border-color: #ffffff;\n  background-color: #ffffff;\n  color: inherit;\n}\n\n.card-user form .form-group {\n  margin-bottom: 20px;\n}\n\n.ct-label.ct-horizontal.ct-end,\n.ct-label.ct-vertical.ct-start {\n  font-size: 14px;\n}\n\n.ct-chart.ct-perfect-fourth .ct-chart-pie .ct-label {\n  font-size: 14px;\n}\n\n.card .card-footer .footer-line {\n  padding-top: 3px;\n}\n\n.card.bootstrap-table .dropdown-item.active {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n.card .team-members .avatar {\n  margin-top: 5px;\n}\n\n.card .team-members .text-right .btn {\n  margin-top: 5px;\n}\n\n.btn-group-sm .btn-round {\n  border-radius: 30px;\n}\n\n.heart {\n  color: #eb5e28;\n  animation: hearthing 1s ease infinite;\n}\n\n@keyframes hearthing {\n  0% {\n    transform: scale(0.75);\n  }\n  20% {\n    transform: scale(1);\n  }\n  40% {\n    transform: scale(0.75);\n  }\n  60% {\n    transform: scale(1);\n  }\n  80% {\n    transform: scale(0.75);\n  }\n  100% {\n    transform: scale(0.75);\n  }\n}\n\n.datepicker .table-condensed tbody > tr:first-of-type .day {\n  padding-top: 5px;\n}\n\n.navbar {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n  min-height: 53px;\n  margin-bottom: 20px;\n}\n.navbar a {\n  vertical-align: middle;\n}\n.navbar a:not(.btn):not(.dropdown-item) {\n  color: #ffffff;\n}\n.navbar a.dropdown-item {\n  color: #66615b;\n}\n.navbar.bg-white .input-group .form-control,\n.navbar.bg-white .input-group.no-border .form-control {\n  color: #66615b;\n}\n.navbar.bg-white .input-group .form-control::-moz-placeholder,\n.navbar.bg-white .input-group.no-border .form-control::-moz-placeholder {\n  color: #66615b;\n}\n.navbar.bg-white .input-group .form-control:-ms-input-placeholder,\n.navbar.bg-white .input-group.no-border .form-control:-ms-input-placeholder {\n  color: #66615b;\n}\n.navbar.bg-white .input-group .form-control::-webkit-input-placeholder,\n.navbar.bg-white\n  .input-group.no-border\n  .form-control::-webkit-input-placeholder {\n  color: #66615b;\n}\n.navbar.bg-white .input-group-prepend .input-group-text i,\n.navbar.bg-white .input-group-append .input-group-text i {\n  color: #66615b;\n  opacity: 0.5;\n}\n.navbar .form-group,\n.navbar .input-group {\n  margin: 0;\n  margin-left: -3px;\n  margin-right: 5px;\n}\n.navbar .form-group .form-group-addon,\n.navbar .form-group .input-group-prepend .input-group-text,\n.navbar .form-group .input-group-append .input-group-text,\n.navbar .input-group .form-group-addon,\n.navbar .input-group .input-group-prepend .input-group-text,\n.navbar .input-group .input-group-append .input-group-text {\n  color: #66615b;\n}\n.navbar .form-group .form-group-addon i,\n.navbar .form-group .input-group-prepend .input-group-text i,\n.navbar .form-group .input-group-append .input-group-text i,\n.navbar .input-group .form-group-addon i,\n.navbar .input-group .input-group-prepend .input-group-text i,\n.navbar .input-group .input-group-append .input-group-text i {\n  opacity: 1;\n}\n.navbar .form-group.no-border .form-control,\n.navbar .input-group.no-border .form-control {\n  color: #66615b;\n}\n.navbar .form-group.no-border .form-control::-moz-placeholder,\n.navbar .input-group.no-border .form-control::-moz-placeholder {\n  color: #66615b;\n}\n.navbar .form-group.no-border .form-control:-ms-input-placeholder,\n.navbar .input-group.no-border .form-control:-ms-input-placeholder {\n  color: #66615b;\n}\n.navbar .form-group.no-border .form-control::-webkit-input-placeholder,\n.navbar .input-group.no-border .form-control::-webkit-input-placeholder {\n  color: #66615b;\n}\n.navbar p {\n  display: inline-block;\n  margin: 0;\n  line-height: 1.8em;\n  font-size: 1em;\n  font-weight: 400;\n}\n.navbar.navbar-absolute {\n  position: absolute;\n  width: 100%;\n  padding-top: 10px;\n  z-index: 100;\n}\n.documentation .navbar.fixed-top {\n  left: 0;\n  width: initial;\n}\n.navbar .navbar-wrapper {\n  display: inline-flex;\n  align-items: center;\n}\n.navbar .navbar-wrapper .navbar-minimize {\n  padding-right: 10px;\n}\n.navbar .navbar-wrapper .navbar-minimize .btn {\n  margin: 0;\n}\n.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {\n  padding-left: 0;\n}\n.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {\n  width: 22px;\n}\n.navbar .navbar-nav.navbar-logo {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 49px;\n  top: -4px;\n}\n.navbar .navbar-nav .nav-link.btn {\n  padding: 11px 22px;\n}\n.navbar .navbar-nav .nav-link.btn.btn-lg {\n  padding: 15px 48px;\n}\n.navbar .navbar-nav .nav-link.btn.btn-sm {\n  padding: 5px 15px;\n}\n.navbar .navbar-nav .nav-link {\n  text-transform: uppercase;\n  font-size: 0.7142em;\n  padding: 0.5rem 0.7rem;\n  line-height: 1.625rem;\n  margin-right: 3px;\n}\n.navbar .navbar-nav .nav-link i.fa + p,\n.navbar .navbar-nav .nav-link i.nc-icon + p {\n  margin-left: 3px;\n}\n.navbar .navbar-nav .nav-link i.fa,\n.navbar .navbar-nav .nav-link i.nc-icon {\n  font-size: 18px;\n  position: relative;\n  top: 3px;\n  text-align: center;\n  width: 21px;\n}\n.navbar .navbar-nav .nav-link i.nc-icon {\n  top: 4px;\n  font-size: 16px;\n}\n.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {\n  width: 27px;\n  height: 27px;\n}\n.navbar .navbar-nav .nav-link.disabled {\n  opacity: 0.5;\n  color: #ffffff;\n}\n.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,\n.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {\n  border-radius: 3px;\n  color: #66615b;\n}\n.navbar .logo-container {\n  width: 27px;\n  height: 27px;\n  overflow: hidden;\n  margin: 0 auto;\n  border-radius: 50%;\n  border: 1px solid transparent;\n}\n.navbar .navbar-brand {\n  text-transform: capitalize;\n  font-size: 20px;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  line-height: 1.625rem;\n}\n.navbar .navbar-toggler {\n  width: 37px;\n  height: 27px;\n  vertical-align: middle;\n  outline: 0;\n  cursor: pointer;\n}\n.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  margin: 0 auto;\n}\n.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {\n  width: 17px;\n}\n.navbar.navbar-transparent {\n  background-color: transparent !important;\n  box-shadow: none;\n  border-bottom: 1px solid #ddd;\n}\n.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {\n  color: #66615b;\n}\n.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {\n  opacity: 0.5;\n  color: #66615b;\n}\n.navbar.navbar-transparent .button-bar {\n  background: #66615b;\n}\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {\n  color: #66615b;\n}\n.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,\n.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {\n  color: #51cbce;\n}\n.navbar.bg-white a:not(.dropdown-item):not(.btn) {\n  color: #66615b;\n}\n.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {\n  opacity: 0.5;\n  color: #66615b;\n}\n.navbar.bg-white .button-bar {\n  background: #66615b;\n}\n.navbar.bg-white .nav-item.active .nav-link:not(.btn),\n.navbar.bg-white .nav-item .nav-link:not(.btn):focus,\n.navbar.bg-white .nav-item .nav-link:not(.btn):hover,\n.navbar.bg-white .nav-item .nav-link:not(.btn):active {\n  color: #0fa0cf;\n}\n.navbar.bg-white .logo-container {\n  border: 1px solid #66615b;\n}\n.navbar .navbar-collapse .nav-item a {\n  font-size: 14px;\n}\n\n.bg-default {\n  background-color: #66615b !important;\n}\n\n.bg-primary {\n  background-color: #51cbce !important;\n}\n\n.bg-info {\n  background-color: #0fa0cf !important;\n}\n\n.bg-success {\n  background-color: #6bd098 !important;\n}\n\n.bg-danger {\n  background-color: #ef8157 !important;\n}\n\n.bg-warning {\n  background-color: #fbc658 !important;\n}\n\n.bg-white {\n  background-color: #ffffff !important;\n}\n\n.dropdown .dropdown-menu,\n.dropup .dropdown-menu,\n.bootstrap-select .dropdown-menu {\n  display: block;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  -webkit-box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n  visibility: hidden;\n  position: absolute;\n  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n    opacity 0.3s ease 0s, height 0s linear 0.35s;\n}\n.dropdown .dropdown-menu[x-placement=\"top-start\"],\n.dropup .dropdown-menu[x-placement=\"top-start\"],\n.bootstrap-select .dropdown-menu[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(-20px, 0px, 0) !important;\n  -moz-transform: translate3d(-20px, 0px, 0) !important;\n  -o-transform: translate3d(-20px, 0px, 0) !important;\n  -ms-transform: translate3d(-20px, 0px, 0) !important;\n  transform: translate3d(-20px, 0px, 0) !important;\n}\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"],\n.dropup .dropdown-menu[x-placement=\"bottom-start\"],\n.bootstrap-select .dropdown-menu[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(-20px, 0px, 0) !important;\n  -moz-transform: translate3d(-20px, 0px, 0) !important;\n  -o-transform: translate3d(-20px, 0px, 0) !important;\n  -ms-transform: translate3d(-20px, 0px, 0) !important;\n  transform: translate3d(-20px, 0px, 0) !important;\n}\n\n.dropdown.show .dropdown-menu,\n.dropup.show .dropdown-menu,\n.bootstrap-select.show .dropdown-menu {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  visibility: visible;\n}\n.dropdown.show .dropdown-menu[x-placement=\"top-start\"],\n.dropup.show .dropdown-menu[x-placement=\"top-start\"],\n.bootstrap-select.show .dropdown-menu[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(-20px, -50px, 0) !important;\n  -moz-transform: translate3d(-20px, -50px, 0) !important;\n  -o-transform: translate3d(-20px, -50px, 0) !important;\n  -ms-transform: translate3d(-20px, -50px, 0) !important;\n  transform: translate3d(-20px, -50px, 0) !important;\n  top: auto !important;\n  bottom: 0 !important;\n}\n.dropdown.show .dropdown-menu[x-placement=\"bottom-start\"],\n.dropup.show .dropdown-menu[x-placement=\"bottom-start\"],\n.bootstrap-select.show .dropdown-menu[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(-20px, 50px, 0) !important;\n  -moz-transform: translate3d(-20px, 50px, 0) !important;\n  -o-transform: translate3d(-20px, 50px, 0) !important;\n  -ms-transform: translate3d(-20px, 50px, 0) !important;\n  transform: translate3d(-20px, 50px, 0) !important;\n  bottom: auto !important;\n  top: 0 !important;\n}\n\n.dropup .dropdown-menu,\n.dropdown-btn .dropdown-menu {\n  -webkit-transform: translate3d(-20px, 0px, 0) !important;\n  -moz-transform: translate3d(-20px, 0px, 0) !important;\n  -o-transform: translate3d(-20px, 0px, 0) !important;\n  -ms-transform: translate3d(-20px, 0px, 0) !important;\n  transform: translate3d(-20px, 0px, 0) !important;\n  top: auto !important;\n  bottom: 0 !important;\n}\n\n.dropup.show .dropdown-menu,\n.dropdown-btn.show .dropdown-menu {\n  opacity: 1;\n  visibility: visible;\n}\n.dropup.show .dropdown-menu .dropdown-menu.inner,\n.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {\n  -webkit-transform: translate3d(0, 0px, 0) !important;\n  -moz-transform: translate3d(0, 0px, 0) !important;\n  -o-transform: translate3d(0, 0px, 0) !important;\n  -ms-transform: translate3d(0, 0px, 0) !important;\n  transform: translate3d(0, 0px, 0) !important;\n}\n\n.bootstrap-select.show .dropdown-menu.show[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(-20px, -60px, 0) !important;\n  -moz-transform: translate3d(-20px, -60px, 0) !important;\n  -o-transform: translate3d(-20px, -60px, 0) !important;\n  -ms-transform: translate3d(-20px, -60px, 0) !important;\n  transform: translate3d(-20px, -60px, 0) !important;\n  top: auto !important;\n  bottom: 0 !important;\n}\n\n.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {\n  border-radius: 0 0 12px 12px;\n}\n\n.bootstrap-select.dropup.show:before {\n  top: -1px !important;\n}\n\n.bootstrap-select.dropup.show:after {\n  top: -2px !important;\n}\n\n.dropdown-menu {\n  background-color: #ffffff;\n  border: 0 none;\n  border-radius: 12px;\n  margin-top: 10px;\n  padding: 0px;\n}\n.dropdown-menu .divider {\n  background-color: #f1eae0;\n  margin: 0px;\n}\n.dropdown-menu .dropdown-header {\n  color: #9a9a9a;\n  font-size: 0.8571em;\n  padding: 10px 15px;\n}\n.dropdown-menu .no-notification {\n  color: #9a9a9a;\n  font-size: 1.2em;\n  padding: 30px 30px;\n  text-align: center;\n}\n.dropdown-menu .dropdown-item {\n  color: #66615b;\n  font-size: 14px;\n  padding: 10px 45px 10px 15px;\n  clear: both;\n  white-space: nowrap;\n  width: 100%;\n  display: block;\n}\n.dropdown-menu .dropdown-item img {\n  margin-top: -3px;\n}\n.dropdown-menu .dropdown-item:focus {\n  outline: 0 !important;\n}\n.btn-group.select .dropdown-menu {\n  min-width: 100%;\n}\n.dropdown-menu .dropdown-item:first-child {\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n.dropdown-menu .dropdown-item:last-child {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n.select .dropdown-menu .dropdown-item:first-child {\n  border-radius: 0;\n  border-bottom: 0 none;\n}\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus {\n  color: #ffffff !important;\n  opacity: 1;\n  text-decoration: none;\n}\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus {\n  background-color: #66615b;\n}\n.dropdown-menu.dropdown-primary .dropdown-item:hover,\n.dropdown-menu.dropdown-primary .dropdown-item:focus {\n  background-color: #6dd3d6;\n}\n.dropdown-menu.dropdown-info .dropdown-item:hover,\n.dropdown-menu.dropdown-info .dropdown-item:focus {\n  background-color: #6ec7e0;\n}\n.dropdown-menu.dropdown-success .dropdown-item:hover,\n.dropdown-menu.dropdown-success .dropdown-item:focus {\n  background-color: #86d9ab;\n}\n.dropdown-menu.dropdown-warning .dropdown-item:hover,\n.dropdown-menu.dropdown-warning .dropdown-item:focus {\n  background-color: #fcd27b;\n}\n.dropdown-menu.dropdown-danger .dropdown-item:hover,\n.dropdown-menu.dropdown-danger .dropdown-item:focus {\n  background-color: #f29978;\n}\n\n.dropdown-divider {\n  margin: 0 !important;\n}\n\n.btn-group.select.open {\n  overflow: visible;\n}\n\n.dropdown-menu-right {\n  right: -2px;\n  left: auto;\n}\n\n.navbar-nav .dropdown-menu:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:before,\n.card.card-just-text .dropdown .dropdown-menu:before,\n.card-just-text .dropdown .dropdown-menu:before,\n.dropdown-btn .dropdown-menu:before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -12px;\n}\n\n.navbar-nav .dropdown-menu:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:after,\n.card.card-just-text .dropdown .dropdown-menu:after,\n.card-just-text .dropdown .dropdown-menu:after,\n.dropdown-btn .dropdown-menu:after {\n  border-bottom: 11px solid #ffffff;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -11px;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:before,\n.dropdown\n  .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:before {\n  left: 30px !important;\n  right: auto;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:after,\n.dropdown\n  .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:after {\n  left: 30px !important;\n  right: auto;\n}\n\n@media screen and (min-width: 768px) {\n  .navbar-form {\n    margin-top: 21px;\n    margin-bottom: 21px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n  .navbar-search-form {\n    display: none;\n  }\n  .navbar-nav .dropdown-item .dropdown-menu,\n  .dropdown .dropdown-menu,\n  .dropdown-btn .dropdown-menu {\n    transform: translate3d(0px, -40px, 0px);\n    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n      opacity 0.3s ease 0s, height 0s linear 0.35s;\n  }\n  .navbar-nav .dropdown-item.show .dropdown-menu,\n  .dropdown.show .dropdown-menu,\n  .dropdown-btn.show .dropdown-menu {\n    transform: translate3d(0px, 0px, 0px);\n    visibility: visible !important;\n  }\n  .bootstrap-select .dropdown-menu {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n  }\n  .bootstrap-datetimepicker-widget {\n    visibility: visible !important;\n  }\n  .bootstrap-select .show .dropdown-menu {\n    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n      opacity 0.3s ease 0s, height 0s linear 0.35s;\n    transform: translate3d(0px, 0px, 0px);\n  }\n  .navbar-nav.navbar-right li .dropdown-menu:before,\n  .navbar-nav.navbar-right li .dropdown-menu:after {\n    left: auto;\n    right: 12px;\n  }\n  .footer:not(.footer-big) nav ul li:first-child {\n    margin-left: 0;\n  }\n  body > .navbar-collapse.collapse {\n    display: none !important;\n  }\n}\n\n.dropdown-sharing .dropup-item {\n  color: #66615b;\n  font-size: 14px;\n}\n.dropdown-sharing .dropup-item .social-line {\n  line-height: 28px;\n  padding: 10px 20px 5px 20px !important;\n}\n.dropdown-sharing .dropup-item .social-line [class*=\"icon-\"] {\n  font-size: 20px;\n}\n.dropdown-sharing .dropup-item:last-child {\n  margin: 0 13px;\n  display: block;\n}\n.dropdown-sharing .dropup-item .btn {\n  margin: 10px;\n}\n\n.dropdown-sharing .dropup-item:hover .social-line,\n.dropdown-sharing .dropup-item:hover .action-line,\n.dropdown-sharing .dropup-item:focus .social-line,\n.dropdown-sharing .dropup-item:focus .action-line {\n  background-color: #ffffff;\n  color: #66615b;\n  opacity: 1;\n  text-decoration: none;\n}\n\n.show .dropdown-sharing,\n.show .dropdown-actions {\n  margin-bottom: 1px;\n}\n\n.dropdown-actions .dropdown-item {\n  margin: -15px 35px;\n}\n.dropdown-actions .dropdown-item .action-line {\n  padding: 5px 10px;\n  line-height: 24px;\n  font-weight: bold;\n}\n.dropdown-actions .dropdown-item .action-line [class*=\"icon-\"] {\n  font-size: 24px;\n}\n.dropdown-actions .dropdown-item .action-line .col-sm-9 {\n  line-height: 34px;\n}\n.dropdown-actions .dropdown-item .link-danger {\n  color: #ef8157;\n}\n.dropdown-actions .dropdown-item .link-danger:hover,\n.dropdown-actions .dropdown-item .link-danger:active,\n.dropdown-actions .dropdown-item .link-danger:focus {\n  color: #ef8157;\n}\n\n.dropdown-actions li:hover a,\n.dropdown-actions li:focus a {\n  color: #66615b;\n  opacity: 1;\n  text-decoration: none;\n}\n\n.dropdown-actions .action-line .icon-simple {\n  margin-left: -15px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:before,\n.dropup .dropdown-menu:before {\n  border-top: 11px solid #dcd9d1;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  bottom: -12px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:after,\n.dropup .dropdown-menu:after {\n  border-top: 11px solid #fff;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  bottom: -11px;\n}\n\n.dropup .dropdown-toggle:after,\n.dropdown .dropdown-toggle:after {\n  margin-left: 0;\n}\n\n.dropdown-notification .dropdown-notification-list .notification-item {\n  border-bottom: 1px solid #f1eae0;\n  font-size: 16px;\n  color: #66615b;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item\n  .notification-text {\n  padding-left: 40px;\n  position: relative;\n  min-width: 330px;\n  min-height: 70px;\n  white-space: normal;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item\n  .notification-text\n  .label {\n  display: block;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  left: 7px;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item\n  .notification-text\n  .message {\n  font-size: 0.9em;\n  line-height: 0.7;\n  margin-left: 10px;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item\n  .notification-text\n  .time {\n  color: #9a9a9a;\n  font-size: 0.7em;\n  margin-left: 10px;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item\n  .read-notification {\n  font-size: 12px;\n  opacity: 0;\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  margin-top: -12px;\n}\n.dropdown-notification .dropdown-notification-list .notification-item:hover {\n  text-decoration: none;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item:hover\n  .notification-text {\n  color: #66615b;\n  background-color: #f0efeb !important;\n}\n.dropdown-notification\n  .dropdown-notification-list\n  .notification-item:hover\n  .read-notification {\n  opacity: 1 !important;\n}\n\n.dropdown-notification .dropdown-footer {\n  background-color: #e8e7e3;\n  border-radius: 0 0 8px 8px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu {\n  list-style: outside none none;\n  padding: 0px 5px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu li {\n  display: inline-block;\n  text-align: left;\n  padding: 0 10px;\n}\n.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {\n  color: #9c9b99;\n  font-size: 0.9em;\n  line-height: 35px;\n}\n\n.alert {\n  border: 0;\n  border-radius: 3px;\n  color: #ffffff;\n  padding-top: 0.9rem;\n  padding-bottom: 0.9rem;\n  position: relative;\n}\n.alert.alert-success {\n  background-color: #7ed6a5;\n}\n.alert.alert-danger {\n  background-color: #f1926e;\n}\n.alert.alert-warning {\n  background-color: #fccf71;\n}\n.alert.alert-info {\n  background-color: #66c4de;\n}\n.alert.alert-primary {\n  background-color: #65d1d4;\n}\n.alert .close {\n  color: #ffffff;\n  opacity: 0.9;\n  text-shadow: none;\n  line-height: 0;\n  outline: 0;\n}\n.alert .close i.fa,\n.alert .close i.nc-icon {\n  font-size: 14px !important;\n}\n.alert .close:hover,\n.alert .close:focus {\n  opacity: 1;\n}\n.alert span[data-notify=\"icon\"] {\n  font-size: 27px;\n  display: block;\n  left: 19px;\n  position: absolute;\n  top: 50%;\n  margin-top: -11px;\n}\n.alert button.close {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  margin-top: -13px;\n  width: 25px;\n  height: 25px;\n  padding: 3px;\n}\n.alert .close ~ span {\n  display: block;\n  max-width: 89%;\n}\n.alert.alert-with-icon {\n  padding-left: 65px;\n}\n\nimg {\n  max-width: 100%;\n  border-radius: 3px;\n}\n\n.img-raised {\n  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n}\n\n.table .img-wrapper {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.table .img-row {\n  max-width: 60px;\n  width: 60px;\n}\n\n.table .form-check {\n  margin: 0;\n}\n.table .form-check label .form-check-sign::before,\n.table .form-check label .form-check-sign::after {\n  top: -17px;\n  left: 4px;\n}\n\n.table .btn {\n  margin: 0;\n}\n\n.table small,\n.table .small {\n  font-weight: 300;\n}\n\n.card-tasks .card-body .table {\n  margin-bottom: 0;\n}\n.card-tasks .card-body .table > thead > tr > th,\n.card-tasks .card-body .table > tbody > tr > th,\n.card-tasks .card-body .table > tfoot > tr > th,\n.card-tasks .card-body .table > thead > tr > td,\n.card-tasks .card-body .table > tbody > tr > td,\n.card-tasks .card-body .table > tfoot > tr > td {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.table > thead > tr > th {\n  font-size: 14px;\n  font-weight: 700;\n  padding-bottom: 0;\n  text-transform: uppercase;\n  border: 0;\n}\n\n.table .radio,\n.table .checkbox {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 0;\n  width: 15px;\n}\n.table .radio .icons,\n.table .checkbox .icons {\n  position: relative;\n}\n.table .radio label:after,\n.table .radio label:before,\n.table .checkbox label:after,\n.table .checkbox label:before {\n  top: -17px;\n  left: -3px;\n}\n\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 12px 7px;\n  vertical-align: middle;\n}\n\n.table .th-description {\n  max-width: 150px;\n}\n\n.table .td-price {\n  font-size: 26px;\n  font-weight: 300;\n  margin-top: 5px;\n  position: relative;\n  top: 4px;\n  text-align: right;\n}\n\n.table .td-total {\n  font-weight: 700;\n  font-size: 1.57em;\n  padding-top: 20px;\n  text-align: right;\n}\n\n.table .td-actions .btn {\n  margin: 0px;\n}\n\n.table > tbody > tr {\n  position: relative;\n}\n\n.table-shopping > thead > tr > th {\n  font-size: 1em;\n  text-transform: uppercase;\n}\n\n.table-shopping > tbody > tr > td {\n  font-size: 1em;\n}\n.table-shopping > tbody > tr > td b {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.table-shopping .td-name {\n  font-weight: 400;\n  font-size: 1.5em;\n}\n.table-shopping .td-name small {\n  color: #9a9a9a;\n  font-size: 0.75em;\n  font-weight: 300;\n}\n\n.table-shopping .td-number {\n  font-weight: 300;\n  font-size: 1.714em;\n}\n\n.table-shopping .td-name {\n  min-width: 200px;\n}\n\n.table-shopping .td-number {\n  text-align: right;\n  min-width: 170px;\n}\n.table-shopping .td-number small {\n  margin-right: 3px;\n}\n\n.table-shopping .img-container {\n  width: 120px;\n  max-height: 160px;\n  overflow: hidden;\n  display: block;\n}\n.table-shopping .img-container img {\n  width: 100%;\n}\n\n.table-responsive {\n  overflow: scroll;\n  padding-bottom: 10px;\n}\n\n#tables .table-responsive {\n  margin-bottom: 30px;\n}\n\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\n\n.footer {\n  padding: 24px 0;\n}\n.footer.footer-default {\n  background-color: #f2f2f2;\n}\n.footer nav {\n  display: inline-block;\n  float: left;\n  padding-left: 0;\n}\n.footer ul {\n  margin-bottom: 0;\n  padding: 0;\n  list-style: none;\n}\n.footer ul li {\n  display: inline-block;\n}\n.footer ul li a {\n  color: inherit;\n  padding: 0.5rem;\n  font-size: 0.8571em;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n.footer ul li a:hover {\n  text-decoration: none;\n}\n.footer .copyright {\n  font-size: 0.8571em;\n  line-height: 1.8;\n}\n.footer:after {\n  display: table;\n  clear: both;\n  content: \" \";\n}\n\n.fixed-plugin {\n  position: fixed;\n  right: 0;\n  width: 64px;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1031;\n  border-radius: 8px 0 0 8px;\n  text-align: center;\n  top: 120px;\n}\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n  transition: all 0.34s;\n  -webkit-transition: all 0.34s;\n  -moz-transition: all 0.34s;\n}\n.fixed-plugin .fa-cog {\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 0 0 6px 6px;\n  width: auto;\n}\n.fixed-plugin .dropdown-menu {\n  right: 80px;\n  left: auto !important;\n  top: -52px !important;\n  width: 290px;\n  border-radius: 10px;\n  padding: 0 10px;\n}\n.fixed-plugin .dropdown .dropdown-menu .nc-icon {\n  top: 2px;\n  right: 10px;\n  font-size: 14px;\n}\n.fixed-plugin .dropdown-menu:after,\n.fixed-plugin .dropdown-menu:before {\n  right: 10px;\n  margin-left: auto;\n  left: auto;\n}\n.fixed-plugin .fa-circle-thin {\n  color: #ffffff;\n}\n.fixed-plugin .active .fa-circle-thin {\n  color: #00bbff;\n}\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n  color: #777777;\n  text-align: center;\n}\n.fixed-plugin img {\n  border-radius: 0;\n  width: 100%;\n  height: 100px;\n  margin: 0 auto;\n}\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n  box-shadow: none;\n}\n.fixed-plugin .badge {\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 23px;\n  margin-right: 5px;\n  position: relative;\n  width: 23px;\n}\n.fixed-plugin .badge.badge-light {\n  border: 1px solid #e3e3e3;\n}\n.fixed-plugin .badge.badge-light.active,\n.fixed-plugin .badge.badge-light:hover {\n  border: 3px solid #0bf;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n  border-color: #00bbff;\n}\n.fixed-plugin .badge-blue {\n  background-color: #0fa0cf;\n}\n.fixed-plugin .badge-green {\n  background-color: #6bd098;\n}\n.fixed-plugin .badge-orange {\n  background-color: #51cbce;\n}\n.fixed-plugin .badge-yellow {\n  background-color: #fbc658;\n}\n.fixed-plugin .badge-red {\n  background-color: #ef8157;\n}\n.fixed-plugin h5 {\n  font-size: 14px;\n  margin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n  display: block;\n  padding: 15px 2px;\n  width: 25%;\n  float: left;\n}\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n  width: 100%;\n  height: 35px;\n  min-height: inherit;\n}\n.fixed-plugin li.button-container {\n  height: auto;\n}\n.fixed-plugin li.button-container div {\n  margin-bottom: 5px;\n}\n.fixed-plugin #sharrreTitle {\n  text-align: center;\n  padding: 10px 0;\n  height: 50px;\n}\n.fixed-plugin li.header-title {\n  height: 30px;\n  line-height: 25px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  text-transform: uppercase;\n}\n.fixed-plugin .adjustments-line p {\n  float: left;\n  display: inline-block;\n  margin-bottom: 0;\n  font-size: 1em;\n  color: #3c4858;\n}\n.fixed-plugin .adjustments-line a {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line a .badge-colors {\n  position: relative;\n  top: -2px;\n}\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line .togglebutton {\n  text-align: center;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch {\n  position: relative;\n  left: -10px;\n  font-size: 0.7142em;\n  color: #66615b;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {\n  left: 10px;\n}\n.fixed-plugin .adjustments-line .togglebutton .toggle {\n  margin-right: 0;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: 1px solid #ddd;\n  border-radius: 0;\n  margin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n  font-size: 16px;\n  text-align: center;\n  border-radius: 10px;\n  background-color: #fff;\n  border: 3px solid #fff;\n  padding-left: 0;\n  padding-right: 0;\n  opacity: 1;\n  cursor: pointer;\n  display: block;\n  max-height: 100px;\n  overflow: hidden;\n  padding: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n  margin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {\n  background-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n  border-color: rgba(0, 187, 255, 0.53);\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n  border-color: #00bbff;\n  background-color: #ffffff;\n}\n.fixed-plugin .btn-social {\n  width: 50%;\n  display: block;\n  width: 48%;\n  float: left;\n  font-weight: 600;\n}\n.fixed-plugin .btn-social i {\n  margin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child {\n  margin-right: 2%;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n  transform-origin: 0 0;\n}\n.fixed-plugin .dropdown .dropdown-menu:before {\n  border-bottom: 16px solid rgba(0, 0, 0, 0);\n  border-left: 16px solid rgba(0, 0, 0, 0.2);\n  border-top: 16px solid rgba(0, 0, 0, 0);\n  right: -27px;\n  bottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n  border-bottom: 16px solid rgba(0, 0, 0, 0);\n  border-left: 16px solid #ffffff;\n  border-top: 16px solid rgba(0, 0, 0, 0);\n  right: -26px;\n  bottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 16px;\n  transform: translateY(-50px);\n  -webkit-transform: translateY(-50px);\n  -moz-transform: translateY(-50px);\n}\n.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {\n  transform: translate3d(0, -60px, 0) !important;\n  bottom: auto !important;\n  top: 0 !important;\n}\n.fixed-plugin .bootstrap-switch {\n  margin: 0;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(0, -100px, 0) !important;\n  -moz-transform: translate3d(0, -100px, 0) !important;\n  -o-transform: translate3d(0, -100px, 0) !important;\n  -ms-transform: translate3d(0, -100px, 0) !important;\n  transform: translate3d(0, -100px, 0) !important;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after {\n  top: 100px;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(0, 100px, 0) !important;\n  -moz-transform: translate3d(0, 100px, 0) !important;\n  -o-transform: translate3d(0, 100px, 0) !important;\n  -ms-transform: translate3d(0, 100px, 0) !important;\n  transform: translate3d(0, 100px, 0) !important;\n}\n\n.fixed-plugin\n  .show-dropdown.show\n  .dropdown-menu.show[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(0, -60px, 0) !important;\n  -moz-transform: translate3d(0, -60px, 0) !important;\n  -o-transform: translate3d(0, -60px, 0) !important;\n  -ms-transform: translate3d(0, -60px, 0) !important;\n  transform: translate3d(0, -60px, 0) !important;\n}\n\n.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(0, 470px, 0) !important;\n  -moz-transform: translate3d(0, 470px, 0) !important;\n  -o-transform: translate3d(0, 470px, 0) !important;\n  -ms-transform: translate3d(0, 470px, 0) !important;\n  transform: translate3d(0, 470px, 0) !important;\n}\n\n.from-check,\n.form-check-radio {\n  margin-bottom: 12px;\n  position: relative;\n}\n\n.form-check {\n  padding-left: 0;\n  margin-bottom: 0.5rem;\n}\n.form-check .form-check-label {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding-left: 35px;\n  line-height: 26px;\n  margin-bottom: 0;\n}\n.form-check .form-check-sign::before,\n.form-check .form-check-sign::after {\n  content: \" \";\n  display: inline-block;\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  left: 0;\n  cursor: pointer;\n  border-radius: 6px;\n  top: 0;\n  background-color: #aaa7a4;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n.form-check .form-check-sign::after {\n  font-family: \"FontAwesome\";\n  content: \"\\f00c\";\n  top: -1px;\n  text-align: center;\n  font-size: 15px;\n  opacity: 0;\n  color: #fff;\n  border: 0;\n  background-color: inherit;\n}\n.form-check.disabled .form-check-label {\n  color: #9a9a9a;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"] {\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after {\n  opacity: 1;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after {\n  cursor: not-allowed;\n}\n\n.form-check\n  .form-check-label\n  input[type=\"checkbox\"]:disabled\n  + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\n  pointer-events: none !important;\n}\n\n.form-check-radio {\n  margin-left: -3px;\n}\n.form-check-radio .form-check-label {\n  padding-left: 2rem;\n}\n.form-check-radio.disabled .form-check-label {\n  color: #9a9a9a;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-check-radio .form-check-sign::before {\n  font-family: \"FontAwesome\";\n  content: \"\\f10c\";\n  font-size: 22px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  position: absolute;\n  opacity: 0.5;\n  left: 5px;\n  top: -5px;\n}\n\n.form-check-label input[type=\"checkbox\"]:checked + .form-check-sign:before {\n  background-color: #66615b;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n  opacity: 0;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n  content: \" \";\n  display: block;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n  font-family: \"FontAwesome\";\n  content: \"\\f192\";\n  top: -5px;\n  position: absolute;\n  left: 5px;\n  opacity: 1;\n  font-size: 22px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n  opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n  color: #9a9a9a;\n}\n\n.progress {\n  background-color: #dddddd;\n  border-radius: 3px;\n  box-shadow: none;\n  height: 8px;\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n.progress-bar {\n  background-color: #51cbce;\n}\n\n.progress-bar-primary {\n  background-color: #51cbce;\n}\n\n.progress-bar-info {\n  background-color: #0fa0cf;\n}\n\n.progress-bar-success {\n  background-color: #6bd098;\n}\n\n.progress-bar-warning {\n  background-color: #fbc658;\n}\n\n.progress-bar-danger {\n  background-color: #ef8157;\n}\n\n/*           badges             */\n.badge {\n  padding: 4px 8px;\n  text-transform: uppercase;\n  font-size: 0.7142em;\n  line-height: 12px;\n  background-color: transparent;\n  border: 1px solid;\n  text-decoration: none;\n  color: #ffffff;\n  margin-bottom: 5px;\n}\n.badge:hover,\n.badge:focus {\n  text-decoration: none;\n}\n\n.badge-icon {\n  padding: 0.4em 0.55em;\n}\n.badge-icon i {\n  font-size: 0.8em;\n}\n\n.badge-default {\n  border-color: #66615b;\n  background-color: #66615b;\n}\n\n.badge-primary {\n  border-color: #51cbce;\n  background-color: #51cbce;\n}\n\n.badge-info {\n  border-color: #0fa0cf;\n  background-color: #0fa0cf;\n}\n\n.badge-success {\n  border-color: #6bd098;\n  background-color: #6bd098;\n}\n\n.badge-warning {\n  border-color: #fbc658;\n  background-color: #fbc658;\n}\n\n.badge-danger {\n  border-color: #ef8157;\n  background-color: #ef8157;\n}\n\n.badge-neutral {\n  border-color: #ffffff;\n  background-color: #ffffff;\n  color: inherit;\n}\n\n.badge-primary[href]:focus,\n.badge-primary[href]:hover {\n  color: #ffffff;\n  background-color: #45c7cb;\n  border-color: #45c7cb;\n}\n\n.badge-warning[href]:focus,\n.badge-warning[href]:hover {\n  color: #ffffff;\n  background-color: #fbc149;\n  border-color: #fbc149;\n}\n\n.badge-info[href]:focus,\n.badge-info[href]:hover {\n  color: #ffffff;\n  background-color: #44b7d7;\n  border-color: #44b7d7;\n}\n\n.badge-danger[href]:focus,\n.badge-danger[href]:hover {\n  color: #ffffff;\n  background-color: #ee7749;\n  border-color: #ee7749;\n}\n\n.badge-success[href]:focus,\n.badge-success[href]:hover {\n  color: #ffffff;\n  background-color: #5fcc90;\n  border-color: #5fcc90;\n}\n\n.badge-default[href]:focus,\n.badge-default[href]:hover {\n  color: #ffffff;\n  background-color: #5e5954;\n  border-color: #5e5954;\n}\n\n.pagination .page-item .page-link {\n  border: 0;\n  border-radius: 30px !important;\n  transition: all 0.3s;\n  padding: 0px 11px;\n  margin: 0 3px;\n  min-width: 30px;\n  text-align: center;\n  height: 30px;\n  line-height: 30px;\n  color: #2c2c2c;\n  cursor: pointer;\n  font-size: 14px;\n  text-transform: uppercase;\n  background: transparent;\n  outline: none;\n}\n.pagination .page-item .page-link:hover,\n.pagination .page-item .page-link:focus {\n  color: #2c2c2c;\n  background-color: rgba(222, 222, 222, 0.3);\n  border: none;\n}\n.pagination .page-item .page-link:focus,\n.pagination .page-item .page-link:active:focus {\n  box-shadow: none;\n}\n\n.pagination .arrow-margin-left,\n.pagination .arrow-margin-right {\n  position: absolute;\n}\n\n.pagination .arrow-margin-right {\n  right: 0;\n}\n\n.pagination .arrow-margin-left {\n  left: 0;\n}\n\n.pagination .page-item.active > .page-link {\n  color: #ffffff;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.pagination .page-item.active > .page-link,\n.pagination .page-item.active > .page-link:focus,\n.pagination .page-item.active > .page-link:hover {\n  background-color: #51cbce;\n  border-color: #51cbce;\n  color: #ffffff;\n}\n\n.pagination .page-item.disabled > .page-link {\n  opacity: 0.5;\n}\n\n.pagination.pagination-info .page-item.active > .page-link,\n.pagination.pagination-info .page-item.active > .page-link:focus,\n.pagination.pagination-info .page-item.active > .page-link:hover {\n  background-color: #0fa0cf;\n  border-color: #0fa0cf;\n}\n\n.pagination.pagination-success .page-item.active > .page-link,\n.pagination.pagination-success .page-item.active > .page-link:focus,\n.pagination.pagination-success .page-item.active > .page-link:hover {\n  background-color: #6bd098;\n  border-color: #6bd098;\n}\n\n.pagination.pagination-primary .page-item.active > .page-link,\n.pagination.pagination-primary .page-item.active > .page-link:focus,\n.pagination.pagination-primary .page-item.active > .page-link:hover {\n  background-color: #51cbce;\n  border-color: #51cbce;\n}\n\n.pagination.pagination-warning .page-item.active > .page-link,\n.pagination.pagination-warning .page-item.active > .page-link:focus,\n.pagination.pagination-warning .page-item.active > .page-link:hover {\n  background-color: #fbc658;\n  border-color: #fbc658;\n}\n\n.pagination.pagination-danger .page-item.active > .page-link,\n.pagination.pagination-danger .page-item.active > .page-link:focus,\n.pagination.pagination-danger .page-item.active > .page-link:hover {\n  background-color: #ef8157;\n  border-color: #ef8157;\n}\n\n.pagination.pagination-neutral .page-item > .page-link {\n  color: #ffffff;\n}\n.pagination.pagination-neutral .page-item > .page-link:focus,\n.pagination.pagination-neutral .page-item > .page-link:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.pagination.pagination-neutral .page-item.active > .page-link,\n.pagination.pagination-neutral .page-item.active > .page-link:focus,\n.pagination.pagination-neutral .page-item.active > .page-link:hover {\n  background-color: #ffffff;\n  border-color: #ffffff;\n  color: #51cbce;\n}\n\n.info.info-hover .info-title {\n  transition: color 0.4s;\n}\n\n.info.info-hover:hover .icon {\n  -webkit-transform: translate3d(0, -0.5rem, 0) !important;\n  -moz-transform: translate3d(0, -0.5rem, 0) !important;\n  -o-transform: translate3d(0, -0.5rem, 0) !important;\n  -ms-transform: translate3d(0, -0.5rem, 0) !important;\n  transform: translate3d(0, -0.5rem, 0) !important;\n}\n.info.info-hover:hover .icon.icon-primary.icon-circle {\n  box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);\n}\n.info.info-hover:hover .icon.icon-info.icon-circle {\n  box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);\n}\n.info.info-hover:hover .icon.icon-success.icon-circle {\n  box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);\n}\n.info.info-hover:hover .icon.icon-warning.icon-circle {\n  box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);\n}\n.info.info-hover:hover .icon.icon-danger.icon-circle {\n  box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);\n}\n.info.info-hover:hover .icon.icon-info + .info-title {\n  color: #0fa0cf;\n}\n.info.info-hover:hover .icon.icon-warning + .info-title {\n  color: #fbc658;\n}\n.info.info-hover:hover .icon.icon-danger + .info-title {\n  color: #ef8157;\n}\n.info.info-hover:hover .icon.icon-primary + .info-title {\n  color: #51cbce;\n}\n.info.info-hover:hover .icon.icon-success + .info-title {\n  color: #6bd098;\n}\n\n.info .icon {\n  color: #66615b;\n  transition: transform 0.4s, box-shadow 0.4s;\n}\n.info .icon > i {\n  font-size: 2.3em;\n}\n.info .icon.icon-circle {\n  max-width: 70px;\n  width: 70px;\n  height: 70px;\n  margin: 0 auto;\n  border-radius: 50%;\n  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n  font-size: 0.7142em;\n  background-color: #ffffff;\n  position: relative;\n}\n.info .icon.icon-circle i {\n  line-height: 2.6em;\n}\n\n.info .info-title {\n  margin: 15px 0 5px;\n  padding: 0 15px;\n  color: #2c2c2c;\n  font-weight: 700;\n}\n\n.info p {\n  color: #66615b;\n  padding: 0 15px;\n  font-size: 1.1em;\n}\n\n.info-horizontal {\n  text-align: left !important;\n}\n.info-horizontal .icon {\n  float: left;\n  margin-top: 23px;\n  margin-right: 10px;\n}\n.info-horizontal .icon > i {\n  font-size: 2em;\n}\n.info-horizontal .icon.icon-circle {\n  width: 65px;\n  height: 65px;\n  max-width: 65px;\n  margin-top: 8px;\n}\n.info-horizontal .icon.icon-circle i {\n  display: table;\n  margin: 0 auto;\n  line-height: 3.5;\n  font-size: 1.9em;\n}\n.info-horizontal .description {\n  overflow: hidden;\n}\n\n.icon.icon-primary {\n  color: #51cbce;\n}\n.icon.icon-primary.icon-circle {\n  box-shadow: 0px 9px 30px -6px rgba(81, 203, 206, 0.5);\n}\n\n.icon.icon-info {\n  color: #0fa0cf;\n}\n.icon.icon-info.icon-circle {\n  box-shadow: 0px 9px 30px -6px rgba(81, 188, 218, 0.5);\n}\n\n.icon.icon-success {\n  color: #6bd098;\n}\n.icon.icon-success.icon-circle {\n  box-shadow: 0px 9px 30px -6px rgba(107, 208, 152, 0.5);\n}\n\n.icon.icon-warning {\n  color: #fbc658;\n}\n.icon.icon-warning.icon-circle {\n  box-shadow: 0px 9px 30px -6px rgba(251, 198, 88, 0.5);\n}\n\n.icon.icon-danger {\n  color: #ef8157;\n}\n.icon.icon-danger.icon-circle {\n  box-shadow: 0px 9px 30px -6px rgba(239, 129, 87, 0.5);\n}\n\n.icon.icon-white {\n  color: #ffffff;\n}\n\n/*             Navigation Pills               */\n.nav-pills .nav-item + .nav-link {\n  margin-left: 0;\n}\n\n.nav-pills .nav-item .nav-link {\n  border: 1px solid #66615b;\n  border-radius: 0;\n  color: #66615b;\n  font-weight: 700;\n  margin-left: -1px;\n  padding: 10px 25px;\n}\n\n.nav-pills .nav-item.active .nav-link,\n.nav-pills .nav-item.active .nav-link:hover,\n.nav-pills .nav-item.active .nav-link:focus {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n.nav-pills .nav-item:first-child .nav-link {\n  border-radius: 30px 0 0 30px !important;\n  margin: 0;\n}\n\n.nav-pills .nav-item:last-child .nav-link {\n  border-radius: 0 30px 30px 0 !important;\n}\n\n.nav-pills .nav-item .nav-link.active {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n.nav-pills-primary .nav-item .nav-link {\n  border: 1px solid #51cbce;\n  color: #51cbce;\n}\n.nav-pills-primary .nav-item .nav-link.active {\n  border: 1px solid #51cbce;\n  background: #51cbce;\n  color: #ffffff;\n}\n\n.nav-pills-danger .nav-item .nav-link {\n  border: 1px solid #ef8157;\n  color: #ef8157;\n}\n.nav-pills-danger .nav-item .nav-link.active {\n  border: 1px solid #ef8157;\n  background: #ef8157;\n  color: #ffffff;\n}\n\n.nav-pills-info .nav-item .nav-link {\n  border: 1px solid #0fa0cf;\n  color: #0fa0cf;\n}\n.nav-pills-info .nav-item .nav-link.active {\n  border: 1px solid #0fa0cf;\n  background: #0fa0cf;\n  color: #ffffff;\n}\n\n.nav-pills-success .nav-item .nav-link {\n  border: 1px solid #6bd098;\n  color: #6bd098;\n}\n.nav-pills-success .nav-item .nav-link.active {\n  border: 1px solid #6bd098;\n  background: #6bd098;\n  color: #ffffff;\n}\n\n.nav-pills-warning .nav-item .nav-link {\n  border: 1px solid #fbc658;\n  color: #fbc658;\n}\n.nav-pills-warning .nav-item .nav-link.active {\n  border: 1px solid #fbc658;\n  background: #fbc658;\n  color: #ffffff;\n}\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link {\n  border-bottom-left-radius: 20px;\n  border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active {\n  background-color: #66615b !important;\n}\n\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active {\n  background-color: #51cbce !important;\n}\n\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active {\n  background-color: #0fa0cf !important;\n}\n\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active {\n  background-color: #fbc658 !important;\n}\n\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active {\n  background-color: #6bd098 !important;\n}\n\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active {\n  background-color: #ef8157 !important;\n}\n\n/*             Navigation Tabs                 */\n.nav-tabs-navigation {\n  text-align: center;\n  border-bottom: 1px solid #f1eae0;\n  margin-bottom: 30px;\n}\n.nav-tabs-navigation .nav > .nav-item > .nav-link {\n  padding-bottom: 20px;\n}\n\n.nav-tabs-wrapper {\n  display: inline-block;\n  margin-bottom: -6px;\n  margin-left: 1.25%;\n  margin-right: 1.25%;\n  position: relative;\n  width: auto;\n}\n\n.nav-tabs {\n  border-bottom: 0 none;\n  font-size: 14px;\n  font-weight: 400;\n}\n.nav-tabs .nav-item .nav-link {\n  border: 0 none;\n  color: #a49e93;\n  background-color: transparent;\n}\n.nav-tabs .nav-item .nav-link:hover {\n  color: #66615b;\n}\n.nav-tabs .nav-item .nav-link.active {\n  color: #66615b;\n}\n.nav-tabs .nav-item {\n  color: #66615b;\n  position: relative;\n}\n.nav-tabs .nav-item .nav-link.active,\n.nav-tabs .nav-item .nav-link.active:hover,\n.nav-tabs .nav-item .nav-link.active:focus {\n  background-color: transparent;\n  border: 0 none;\n}\n.nav-tabs .nav-item .nav-link.active:after,\n.nav-tabs .nav-item .nav-link.active:hover:after,\n.nav-tabs .nav-item .nav-link.active:focus:after {\n  border-bottom: 11px solid #ffffff;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 40%;\n  bottom: 5px;\n}\n.nav-tabs .nav-item .nav-link.active:before,\n.nav-tabs .nav-item .nav-link.active:hover:before,\n.nav-tabs .nav-item .nav-link.active:focus:before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 40%;\n  bottom: 6px;\n}\n.nav-tabs .nav-item.show .nav-link {\n  background-color: transparent;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -6px;\n  margin-left: -46px;\n  border-radius: 8px;\n}\n.nav-tabs .dropdown-menu .dropdown-item:hover,\n.nav-tabs .dropdown-menu .dropdown-item.active {\n  color: #ffffff;\n  background-color: #68b3c8;\n}\n.nav-tabs .dropdown-menu :before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -11px;\n}\n.nav-tabs .dropdown-menu :after {\n  border-bottom: 11px solid #fffcf5;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -10px;\n}\n\n.profile-content .tab-content .tab-pane {\n  min-height: 200px;\n}\n\n.profile-content .tab-content #tweets,\n.profile-content .tab-content #connections,\n.profile-content .tab-content #media {\n  height: 100%;\n}\n\n.nav-text,\n.nav-icons {\n  margin: 0 0 10px 0;\n}\n.nav-text > li > a,\n.nav-icons > li > a {\n  display: block;\n  padding: 0px 0.7rem;\n  color: #9a9a9a;\n  text-align: center;\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n}\n.nav-text > li > a:hover,\n.nav-text > li > a:focus,\n.nav-icons > li > a:hover,\n.nav-icons > li > a:focus {\n  background-color: transparent;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.nav-text > li:first-child a,\n.nav-icons > li:first-child a {\n  padding-left: 0;\n}\n.nav-text > li.active a,\n.nav-icons > li.active a {\n  color: #0fa0cf;\n}\n\n.nav-icons > li {\n  display: inline-block;\n}\n.nav-icons > li > a {\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n.nav-icons > li > a i {\n  font-size: 1.714em;\n  margin-bottom: 10px;\n  width: 1.714em;\n}\n\n.nav-icons.nav-stacked > li {\n  display: block;\n}\n.nav-icons.nav-stacked > li > a {\n  margin-bottom: 20px;\n}\n\n.nav-blue > li.active a {\n  color: #51cbce;\n}\n\n.nav-azure > li.active a {\n  color: #0fa0cf;\n}\n\n.nav-green > li.active a {\n  color: #6bd098;\n}\n\n.nav-orange > li.active a {\n  color: #fbc658;\n}\n\n.nav-red > li.active a {\n  color: #ef8157;\n}\n\n.nav-text {\n  margin: 0 0 10px 0;\n}\n.nav-text > li > a {\n  font-size: 1em;\n  text-transform: uppercase;\n  padding: 3px 0;\n  text-align: left;\n  font-weight: 600;\n}\n.nav-text > li:first-child > a {\n  padding-top: 0;\n}\n.nav-text h4 {\n  margin-top: 0;\n}\n\n.nav-text:not(.nav-stacked) > li {\n  display: inline-block;\n}\n\n.nav-text:not(.nav-stacked) > li > a {\n  margin-right: 15px;\n}\n\n.tab-space {\n  padding: 20px 0 50px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active.show:before {\n  border-right: 11px solid #f1eae0;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active.show:after {\n  border-right: 11px solid #ffffff;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: -1px;\n  bottom: 20px;\n}\n\n#second-tabs {\n  margin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n  border-right: 1px solid #f1eae0;\n  font-size: 16px;\n  padding: 0 37px;\n  border-bottom: none;\n}\n\n.popover {\n  font-size: 14px;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  border: none;\n  line-height: 1.7;\n  max-width: 240px;\n}\n.popover.bs-popover-top .arrow:before,\n.popover.bs-popover-left .arrow:before,\n.popover.bs-popover-right .arrow:before,\n.popover.bs-popover-bottom .arrow:before {\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.popover .popover-header {\n  color: rgba(182, 182, 182, 0.6);\n  font-size: 14px;\n  text-transform: capitalize;\n  font-weight: 600;\n  margin: 0;\n  margin-top: 5px;\n  border: none;\n  background-color: transparent;\n}\n.popover:before {\n  display: none;\n}\n.popover.bs-tether-element-attached-top:after {\n  border-bottom-color: #ffffff;\n  top: -9px;\n}\n.popover.popover-primary {\n  background-color: #51cbce;\n}\n.popover.popover-primary .popover-body {\n  color: #ffffff;\n}\n.popover.popover-primary.bs-popover-right .arrow:after {\n  border-right-color: #51cbce;\n}\n.popover.popover-primary.bs-popover-top .arrow:after {\n  border-top-color: #51cbce;\n}\n.popover.popover-primary.bs-popover-bottom .arrow:after {\n  border-bottom-color: #51cbce;\n}\n.popover.popover-primary.bs-popover-left .arrow:after {\n  border-left-color: #51cbce;\n}\n.popover.popover-primary .popover-header {\n  color: #ffffff;\n  opacity: 0.6;\n}\n.popover.popover-info {\n  background-color: #0fa0cf;\n}\n.popover.popover-info .popover-body {\n  color: #ffffff;\n}\n.popover.popover-info.bs-popover-right .arrow:after {\n  border-right-color: #0fa0cf;\n}\n.popover.popover-info.bs-popover-top .arrow:after {\n  border-top-color: #0fa0cf;\n}\n.popover.popover-info.bs-popover-bottom .arrow:after {\n  border-bottom-color: #0fa0cf;\n}\n.popover.popover-info.bs-popover-left .arrow:after {\n  border-left-color: #0fa0cf;\n}\n.popover.popover-info .popover-header {\n  color: #ffffff;\n  opacity: 0.6;\n}\n.popover.popover-warning {\n  background-color: #fbc658;\n}\n.popover.popover-warning .popover-body {\n  color: #ffffff;\n}\n.popover.popover-warning.bs-popover-right .arrow:after {\n  border-right-color: #fbc658;\n}\n.popover.popover-warning.bs-popover-top .arrow:after {\n  border-top-color: #fbc658;\n}\n.popover.popover-warning.bs-popover-bottom .arrow:after {\n  border-bottom-color: #fbc658;\n}\n.popover.popover-warning.bs-popover-left .arrow:after {\n  border-left-color: #fbc658;\n}\n.popover.popover-warning .popover-header {\n  color: #ffffff;\n  opacity: 0.6;\n}\n.popover.popover-danger {\n  background-color: #ef8157;\n}\n.popover.popover-danger .popover-body {\n  color: #ffffff;\n}\n.popover.popover-danger.bs-popover-right .arrow:after {\n  border-right-color: #ef8157;\n}\n.popover.popover-danger.bs-popover-top .arrow:after {\n  border-top-color: #ef8157;\n}\n.popover.popover-danger.bs-popover-bottom .arrow:after {\n  border-bottom-color: #ef8157;\n}\n.popover.popover-danger.bs-popover-left .arrow:after {\n  border-left-color: #ef8157;\n}\n.popover.popover-danger .popover-header {\n  color: #ffffff;\n  opacity: 0.6;\n}\n.popover.popover-success {\n  background-color: #6bd098;\n}\n.popover.popover-success .popover-body {\n  color: #ffffff;\n}\n.popover.popover-success.bs-popover-right .arrow:after {\n  border-right-color: #6bd098;\n}\n.popover.popover-success.bs-popover-top .arrow:after {\n  border-top-color: #6bd098;\n}\n.popover.popover-success.bs-popover-bottom .arrow:after {\n  border-bottom-color: #6bd098;\n}\n.popover.popover-success.bs-popover-left .arrow:after {\n  border-left-color: #6bd098;\n}\n.popover.popover-success .popover-header {\n  color: #ffffff;\n  opacity: 0.6;\n}\n\n.tooltip.bs-tooltip-right .arrow:before {\n  border-right-color: #ffffff;\n}\n\n.tooltip.bs-tooltip-top .arrow:before {\n  border-top-color: #ffffff;\n}\n\n.tooltip.bs-tooltip-bottom .arrow:before {\n  border-bottom-color: #ffffff;\n}\n\n.tooltip.bs-tooltip-left .arrow:before {\n  border-left-color: #ffffff;\n}\n\n.tooltip-inner {\n  padding: 0.5rem 0.7rem;\n  min-width: 130px;\n  background-color: #ffffff;\n  font-size: 14px;\n  color: inherit;\n  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n  border-bottom: 1px solid #dddddd;\n  padding: 20px;\n  text-align: center;\n  display: block !important;\n}\n.modal-header.no-border-header {\n  border-bottom: 0 none !important;\n}\n.modal-header.no-border-header .modal-title {\n  margin-top: 20px;\n}\n.modal-header button.close:focus {\n  outline: none;\n}\n.modal-header .modal-profile {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 6.4;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.modal-header .modal-profile i {\n  font-size: 30px;\n}\n\n.modal-dialog.modal-sm .modal-header button.close,\n.modal-dialog.modal-register .modal-header button.close {\n  margin-top: 0;\n}\n\n.modal-content {\n  border: 0 none;\n  border-radius: 10px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-content .modal-header h6 {\n  margin-top: 10px;\n}\n\n.modal-dialog {\n  padding-top: 60px;\n}\n\n.modal-body {\n  padding: 20px 50px;\n  color: #000;\n}\n\n.modal-footer {\n  border-top: 1px solid #dddddd;\n  padding: 0px;\n}\n.modal-footer.no-border-footer {\n  border-top: 0 none;\n}\n\n.modal-footer .left-side,\n.modal-footer .right-side {\n  display: inline-block;\n  text-align: center;\n  width: 50%;\n  padding: 5px;\n}\n\n.modal-footer .btn-link {\n  padding: 20px;\n  width: 100%;\n  margin: 0;\n}\n\n.modal-footer .divider {\n  background-color: #dddddd;\n  display: inline-block;\n  float: inherit;\n  height: 63px;\n  margin: 0px -3px;\n  width: 1px;\n}\n\n.modal-register .modal-footer {\n  text-align: center;\n  margin-bottom: 25px;\n  padding: 20px 0 15px;\n}\n.modal-register .modal-footer span {\n  width: 100%;\n}\n\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n  display: block;\n}\n\n.carousel .carousel-inner {\n  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n}\n\n.carousel .nc-icon {\n  font-size: 2em;\n}\n\n.wrapper {\n  position: relative;\n  top: 0;\n  height: 100vh;\n}\n.wrapper.wrapper-full-page {\n  min-height: 100vh;\n  height: auto;\n}\n\n.sidebar,\n.off-canvas-sidebar {\n  position: fixed;\n  top: 0;\n  height: 100%;\n  bottom: 0;\n  width: 260px;\n  left: 0;\n  z-index: 999;\n}\n.sidebar .sidebar-wrapper,\n.off-canvas-sidebar .sidebar-wrapper {\n  position: relative;\n  height: calc(100vh - 75px);\n  overflow: auto;\n  width: 260px;\n  z-index: 4;\n  padding-bottom: 100px;\n}\n\n:not(.dates-container)::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,\n.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {\n  display: none !important;\n}\n.sidebar .sidebar-wrapper .navbar-form,\n.off-canvas-sidebar .sidebar-wrapper .navbar-form {\n  border: none;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span {\n  display: inline-block;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal {\n  margin: 0;\n  position: relative;\n  transform: translateX(0px);\n  opacity: 1;\n  white-space: nowrap;\n  display: block;\n  line-height: 20px;\n  z-index: 1;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon {\n  text-transform: uppercase;\n  width: 34px;\n  margin-right: 10px;\n  margin-left: 0px;\n  font-size: 12px;\n  text-align: center;\n  line-height: 20px;\n  position: relative;\n  float: left;\n  z-index: 1;\n  display: inherit;\n  color: rgba(255, 255, 255, 0.5);\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal {\n  text-transform: capitalize;\n}\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a i,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i {\n  font-size: 17px;\n  line-height: 20px;\n  width: 26px;\n}\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize {\n  position: absolute;\n  right: 20px;\n  top: 2px;\n  opacity: 1;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n.sidebar .nav,\n.off-canvas-sidebar .nav {\n  margin-top: 20px;\n  display: block;\n}\n.sidebar .nav .caret,\n.off-canvas-sidebar .nav .caret {\n  top: 14px;\n  position: absolute;\n  right: 10px;\n}\n.sidebar .nav li > a + div .nav li > a,\n.off-canvas-sidebar .nav li > a + div .nav li > a {\n  margin-top: 7px;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n  margin: 10px 15px 0;\n  color: #ffffff;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  text-transform: uppercase;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 10px 8px;\n  line-height: 30px;\n  opacity: 0.7;\n}\n.sidebar .nav li .nav > li > a,\n.off-canvas-sidebar .nav li .nav > li > a {\n  padding: 5px 8px;\n}\n.sidebar .nav li.active > a,\n.sidebar .nav li.active > a > i,\n.off-canvas-sidebar .nav li.active > a,\n.off-canvas-sidebar .nav li.active > a > i {\n  opacity: 1;\n}\n.sidebar .nav li:hover:not(.active) > a,\n.sidebar .nav li:focus:not(.active) > a,\n.off-canvas-sidebar .nav li:hover:not(.active) > a,\n.off-canvas-sidebar .nav li:focus:not(.active) > a {\n  opacity: 1;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] >,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] > {\n  background-color: transparent;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #ef8157;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i + div .nav .active a,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a {\n  background-color: transparent;\n  box-shadow: none;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a:after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 5px);\n  z-index: 0;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n  margin-top: 0;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n  margin: 0;\n  line-height: 30px;\n  position: relative;\n  display: block;\n  height: auto;\n  white-space: nowrap;\n  font-weight: 600;\n}\n.sidebar .nav i,\n.off-canvas-sidebar .nav i {\n  font-size: 24px;\n  float: left;\n  margin-right: 12px;\n  line-height: 30px;\n  width: 34px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  position: relative;\n}\n.sidebar .nav .collapse .nav,\n.sidebar .nav .collapsing .nav,\n.off-canvas-sidebar .nav .collapse .nav,\n.off-canvas-sidebar .nav .collapsing .nav {\n  margin-top: 0;\n}\n.sidebar .sidebar-background,\n.off-canvas-sidebar .sidebar-background {\n  position: absolute;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center center;\n}\n.sidebar .sidebar-background:after,\n.off-canvas-sidebar .sidebar-background:after {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  display: block;\n  background: #ffffff;\n  opacity: 1;\n}\n.sidebar .logo,\n.off-canvas-sidebar .logo {\n  position: relative;\n  padding: 7px 0.7rem;\n  z-index: 4;\n}\n.sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n  opacity: 0;\n  float: left;\n  width: 34px;\n  text-align: center;\n  margin-left: 10px;\n  margin-right: 12px;\n}\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-normal {\n  display: block;\n  opacity: 1;\n  padding: 11px 0 8px;\n  -webkit-transform: translate3d(0px, 0, 0);\n  -moz-transform: translate3d(0px, 0, 0);\n  -o-transform: translate3d(0px, 0, 0);\n  -ms-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.sidebar .logo:after,\n.off-canvas-sidebar .logo:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 15px;\n  height: 1px;\n  width: calc(100% - 30px);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.sidebar .logo p,\n.off-canvas-sidebar .logo p {\n  float: left;\n  font-size: 20px;\n  margin: 10px 10px;\n  color: #ffffff;\n  line-height: 20px;\n  font-family: \"Muli\", \"Helvetica\", Arial, sans-serif;\n}\n.sidebar .logo .simple-text,\n.off-canvas-sidebar .logo .simple-text {\n  text-transform: uppercase;\n  padding: 0.5rem 0;\n  display: block;\n  white-space: nowrap;\n  font-size: 1rem;\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 400;\n  line-height: 30px;\n  overflow: hidden;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n.sidebar:before,\n.sidebar:after,\n.off-canvas-sidebar:before,\n.off-canvas-sidebar:after {\n  display: block;\n  content: \"\";\n  opacity: 1;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.sidebar:after,\n.off-canvas-sidebar:after {\n  /* background: #66615B;\n    background: -webkit-linear-gradient(#66615B 0%, #000 80%);\n    background: -o-linear-gradient(#66615B 0%, #000 80%);\n    background: -moz-linear-gradient(#66615B 0%, #000 80%);\n    background: linear-gradient(#66615B 0%, #000 80%); */\n  z-index: 3;\n}\n.sidebar[data-color=\"white\"]:after,\n.off-canvas-sidebar[data-color=\"white\"]:after {\n  background: #ffffff;\n}\n.sidebar[data-color=\"white\"] .nav li a,\n.sidebar[data-color=\"white\"] .nav li a i,\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  .sidebar-mini-icon,\n.sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a i,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a {\n  color: #66615b;\n  opacity: 0.7;\n}\n.sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a {\n  opacity: 1;\n}\n.sidebar[data-color=\"white\"] .logo .simple-text,\n.off-canvas-sidebar[data-color=\"white\"] .logo .simple-text {\n  color: #66615b;\n}\n.sidebar[data-color=\"white\"] .logo:after,\n.off-canvas-sidebar[data-color=\"white\"] .logo:after {\n  background-color: #66615b;\n  opacity: 0.4;\n}\n.sidebar[data-color=\"white\"] .user .info a span,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-normal,\n.off-canvas-sidebar[data-color=\"white\"] .user .info a span,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-normal {\n  color: #66615b !important;\n}\n.sidebar[data-color=\"white\"] .user:after,\n.off-canvas-sidebar[data-color=\"white\"] .user:after {\n  background-color: #66615b;\n  opacity: 0.4;\n}\n.sidebar[data-color=\"brown\"]:after,\n.off-canvas-sidebar[data-color=\"brown\"]:after {\n  background: #66615b;\n}\n.sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #51cbce;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"info\"] .nav li.active > a,\n.sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #0fa0cf;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"success\"] .nav li.active > a,\n.sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #6bd098;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #fbc658;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #ef8157;\n  opacity: 1;\n}\n.sidebar .user,\n.off-canvas-sidebar .user {\n  padding-bottom: 20px;\n  margin: 20px auto 0;\n  position: relative;\n}\n.sidebar .user:after,\n.off-canvas-sidebar .user:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 15px;\n  height: 1px;\n  width: calc(100% - 30px);\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo {\n  width: 34px;\n  height: 34px;\n  overflow: hidden;\n  float: left;\n  z-index: 5;\n  margin-right: 10px;\n  border-radius: 50%;\n  margin-left: 23px;\n}\n.sidebar .user .photo img,\n.off-canvas-sidebar .user .photo img {\n  width: 100%;\n}\n.sidebar .user a,\n.off-canvas-sidebar .user a {\n  color: #ffffff;\n  text-decoration: none;\n  padding: 0.5rem 15px;\n  white-space: nowrap;\n}\n.sidebar .user .info > a,\n.off-canvas-sidebar .user .info > a {\n  display: block;\n  line-height: 18px;\n}\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span {\n  display: block;\n  position: relative;\n  opacity: 1;\n}\n.sidebar .user .info .caret,\n.off-canvas-sidebar .user .info .caret {\n  position: absolute;\n  top: 8px;\n  right: 18px;\n}\n\n.visible-on-sidebar-regular {\n  display: inline-block !important;\n}\n\n.visible-on-sidebar-mini {\n  display: none !important;\n}\n\n.off-canvas-sidebar .nav > li > a,\n.off-canvas-sidebar .nav > li > a:hover {\n  color: #ffffff;\n}\n\n.off-canvas-sidebar .nav > li > a:focus {\n  background: rgba(200, 200, 200, 0.2);\n}\n\n.main-panel {\n  position: relative;\n  float: right;\n  width: calc(100% - 260px);\n  background-color: #eef2f3;\n  -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n}\n.main-panel > .content {\n  padding: 0 30px 30px;\n  min-height: calc(100vh - 123px);\n  margin-top: 93px;\n}\n.main-panel > .navbar {\n  margin-bottom: 0;\n}\n.main-panel .header {\n  margin-bottom: 50px;\n}\n\n.perfect-scrollbar-on .sidebar,\n.perfect-scrollbar-on .main-panel {\n  height: 100%;\n  max-height: 100%;\n}\n\n@media (min-width: 991px) {\n  .sidebar,\n  .main-panel,\n  .sidebar-wrapper {\n    -webkit-transition-property: top, bottom, width;\n    transition-property: top, bottom, width;\n    -webkit-transition-duration: 0.2s, 0.2s, 0.35s;\n    transition-duration: 0.2s, 0.2s, 0.35s;\n    -webkit-transition-timing-function: linear, linear, ease;\n    transition-timing-function: linear, linear, ease;\n    -webkit-overflow-scrolling: touch;\n  }\n  .sidebar-mini .visible-on-sidebar-regular {\n    display: none !important;\n  }\n  .sidebar-mini .visible-on-sidebar-mini {\n    display: inline-block !important;\n  }\n  .sidebar-mini .sidebar,\n  .sidebar-mini .sidebar .sidebar-wrapper {\n    width: 80px;\n  }\n  .sidebar-mini .main-panel {\n    width: calc(100% - 80px);\n  }\n  .sidebar-mini .sidebar {\n    display: block;\n    z-index: 999;\n  }\n  .sidebar-mini .sidebar .logo a.logo-normal {\n    opacity: 0;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    -moz-transform: translate3d(-25px, 0, 0);\n    -o-transform: translate3d(-25px, 0, 0);\n    -ms-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n  .sidebar-mini .sidebar .logo a.logo-mini {\n    opacity: 1;\n  }\n  .sidebar-mini\n    .sidebar\n    .sidebar-wrapper\n    > .nav\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini\n    .sidebar\n    .sidebar-wrapper\n    .user\n    .info\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {\n    -webkit-transform: translate3d(-25px, 0, 0);\n    -moz-transform: translate3d(-25px, 0, 0);\n    -o-transform: translate3d(-25px, 0, 0);\n    -ms-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n    opacity: 0;\n  }\n  .sidebar-mini .sidebar:hover {\n    width: 260px;\n  }\n  .sidebar-mini .sidebar:hover .logo a.logo-normal {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n  .sidebar-mini .sidebar:hover .navbar-minimize {\n    opacity: 1;\n  }\n  .sidebar-mini .sidebar:hover .sidebar-wrapper {\n    width: 260px;\n  }\n  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,\n  .sidebar-mini\n    .sidebar:hover\n    .sidebar-wrapper\n    > .nav\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini\n    .sidebar:hover\n    .sidebar-wrapper\n    .user\n    .info\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n    opacity: 1;\n  }\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141e30;\n  /* fallback for old browsers */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#0c2646),\n    color-stop(60%, #204065),\n    to(#2a5788)\n  );\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n}\n.panel-header .header .title {\n  color: #ffffff;\n}\n.panel-header .header .category {\n  max-width: 600px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0 auto;\n  font-size: 13px;\n}\n.panel-header .header .category a {\n  color: #ffffff;\n}\n\n.panel-header-sm {\n  height: 135px;\n}\n\n.panel-header-lg {\n  height: 380px;\n}\n\n.sidebar .logo .simple-text .logo-img {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 34px;\n  width: 34px;\n  background: #ffffff;\n  border-radius: 50%;\n  text-align: center;\n  overflow: hidden;\n}\n.sidebar .logo .simple-text .logo-img img {\n  width: 51%;\n  vertical-align: unset;\n  height: 55px;\n}\n\n.sidebar[data-color=\"white\"] {\n  border-right: 1px solid #ddd;\n}\n\n.card-timeline .timeline {\n  list-style: none;\n  padding: 20px 0 20px;\n  position: relative;\n}\n.card-timeline .timeline:before {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 3px;\n  background-color: #dbdbdb;\n  left: 50%;\n  margin-left: -1.5px;\n}\n.card-timeline .timeline .timeline-footer .btn {\n  margin: 0;\n}\n.card-timeline .timeline h6 {\n  color: #9a9a9a;\n  font-weight: 400;\n  margin: 10px 0px 0px;\n}\n.card-timeline .timeline.timeline-simple:before {\n  left: 5%;\n}\n.card-timeline .timeline.timeline-simple > li > .timeline-panel {\n  width: 86%;\n}\n.card-timeline .timeline.timeline-simple > li > .timeline-badge {\n  left: 5%;\n}\n.card-timeline .timeline > li {\n  margin-bottom: 20px;\n  position: relative;\n}\n.card-timeline .timeline > li:before,\n.card-timeline .timeline > li:after {\n  content: \" \";\n  display: table;\n}\n.card-timeline .timeline > li:after {\n  clear: both;\n}\n.card-timeline .timeline > li > .timeline-panel {\n  width: 45%;\n  float: left;\n  padding: 20px;\n  border-radius: 3px;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  background-color: #ffffff;\n  color: #2c2c2c;\n  margin-bottom: 20px;\n  position: relative;\n}\n.card-timeline .timeline > li > .timeline-panel:before {\n  position: absolute;\n  top: 26px;\n  right: -15px;\n  display: inline-block;\n  border-top: 15px solid transparent;\n  border-left: 15px solid #e3e3e3;\n  border-right: 0 solid #e3e3e3;\n  border-bottom: 15px solid transparent;\n  content: \" \";\n}\n.card-timeline .timeline > li > .timeline-panel:after {\n  position: absolute;\n  top: 27px;\n  right: -14px;\n  display: inline-block;\n  border-top: 14px solid transparent;\n  border-left: 14px solid #ffffff;\n  border-right: 0 solid #ffffff;\n  border-bottom: 14px solid transparent;\n  content: \" \";\n}\n.card-timeline .timeline > li > .timeline-badge {\n  color: #ffffff;\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  margin-left: -25px;\n  background-color: #9a9a9a;\n  z-index: 100;\n  border-top-right-radius: 50%;\n  border-top-left-radius: 50%;\n  border-bottom-right-radius: 50%;\n  border-bottom-left-radius: 50%;\n  border: 3px solid #eef2f3;\n}\n.card-timeline .timeline > li > .timeline-badge [class^=\"fa-\"],\n.card-timeline .timeline > li > .timeline-badge [class*=\" fa-\"] {\n  line-height: inherit;\n}\n.card-timeline .timeline > li > .timeline-badge .nc-icon {\n  line-height: 2.1;\n  width: 25px;\n  text-align: center;\n  font-size: 21px;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel {\n  float: right;\n  background-color: #fff;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {\n  border-left-width: 0;\n  border-right-width: 15px;\n  left: -15px;\n  right: auto;\n}\n.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {\n  border-left-width: 0;\n  border-right-width: 14px;\n  left: -14px;\n  right: auto;\n}\n\n.card-timeline .timeline-heading {\n  margin-bottom: 15px;\n}\n\n.card-timeline .timeline-badge.primary {\n  background-color: #0fa0cf !important;\n}\n\n.card-timeline .timeline-badge.info {\n  background-color: #0fa0cf !important;\n}\n\n.card-timeline .timeline-badge.success {\n  background-color: #6bd098 !important;\n}\n\n.card-timeline .timeline-badge.warning {\n  background-color: #fbc658 !important;\n}\n\n.card-timeline .timeline-badge.danger {\n  background-color: #ef8157 !important;\n}\n\n.card-timeline .timeline-title {\n  margin-top: 0;\n  color: inherit;\n}\n\n.card-timeline .timeline-body > p,\n.card-timeline .timeline-body > ul {\n  margin-bottom: 0;\n}\n\n.card-timeline .timeline-body > p + p {\n  margin-top: 5px;\n}\n\n.card {\n  border-radius: 12px;\n  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\n  background-color: #ffffff;\n  color: #252422;\n  margin-bottom: 20px;\n  position: relative;\n  border: 0 none;\n  -webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n    box-shadow 200ms ease;\n  -moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n    box-shadow 200ms ease;\n  -o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n    box-shadow 200ms ease;\n  -ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n    box-shadow 200ms ease;\n  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),\n    box-shadow 200ms ease;\n}\n.card .card-body {\n  padding: 15px 15px 10px 15px;\n}\n.card .card-body.table-full-width {\n  padding-left: 0;\n  padding-right: 0;\n}\n.card .card-header {\n  padding: 15px 15px 0;\n  border: 0;\n}\n.card .card-header:not([data-background-color]) {\n  background-color: transparent;\n}\n.card .card-header .card-title {\n  margin-top: 10px;\n}\n.card .map {\n  border-radius: 3px;\n}\n.card .map.map-big {\n  height: 400px;\n}\n.card[data-background-color=\"orange\"] {\n  background-color: #51cbce;\n}\n.card[data-background-color=\"orange\"] .card-header {\n  background-color: #51cbce;\n}\n.card[data-background-color=\"orange\"] .card-footer .stats {\n  color: #ffffff;\n}\n.card[data-background-color=\"red\"] {\n  background-color: #ef8157;\n}\n.card[data-background-color=\"yellow\"] {\n  background-color: #fbc658;\n}\n.card[data-background-color=\"blue\"] {\n  background-color: #0fa0cf;\n}\n.card[data-background-color=\"green\"] {\n  background-color: #6bd098;\n}\n.card .image {\n  overflow: hidden;\n  height: 200px;\n  position: relative;\n}\n.card .avatar {\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-bottom: 15px;\n}\n.card .numbers {\n  font-size: 2em;\n}\n.card .big-title {\n  font-size: 12px;\n  text-align: center;\n  font-weight: 500;\n  padding-bottom: 15px;\n}\n.card label {\n  font-size: 0.8571em;\n  margin-bottom: 5px;\n  color: #9a9a9a;\n}\n.card .card-footer {\n  background-color: transparent;\n  border: 0;\n}\n.card .card-footer .stats i {\n  margin-right: 5px;\n  position: relative;\n  top: 0px;\n  color: #66615b;\n}\n.card .card-footer .btn {\n  margin: 0;\n}\n.card.card-plain {\n  background-color: transparent;\n  box-shadow: none;\n  border-radius: 0;\n}\n.card.card-plain .card-body {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.card.card-plain img {\n  border-radius: 12px;\n}\n\n.card-chart .card-header .card-title {\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.card-chart .card-header .card-category {\n  margin-bottom: 5px;\n}\n\n.card-chart .table {\n  margin-bottom: 0;\n}\n.card-chart .table td {\n  border-top: none;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.card-chart .card-progress {\n  margin-top: 30px;\n}\n\n.card-chart .chart-area {\n  height: 190px;\n  width: calc(100% + 30px);\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.card-chart .card-footer {\n  margin-top: 15px;\n}\n.card-chart .card-footer .stats {\n  color: #9a9a9a;\n}\n\n.card-chart .dropdown {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}\n.card-chart .dropdown .btn {\n  margin: 0;\n}\n\n.map {\n  height: 500px;\n}\n\n.card-user .image {\n  height: 130px;\n}\n.card-user .image img {\n  border-radius: 12px;\n}\n\n.card-user .author {\n  text-align: center;\n  text-transform: none;\n  margin-top: -77px;\n}\n.card-user .author a + p.description {\n  margin-top: -7px;\n}\n\n.card-user .avatar {\n  width: 124px;\n  height: 124px;\n  border: 1px solid #ffffff;\n  position: relative;\n}\n\n.card-user .card-body {\n  min-height: 240px;\n}\n\n.card-user hr {\n  margin: 5px 15px 15px;\n}\n\n.card-user .card-body + .card-footer {\n  padding-top: 0;\n}\n\n.card-user .card-footer h5 {\n  font-size: 1.25em;\n  margin-bottom: 0;\n}\n\n.card-user .button-container {\n  margin-bottom: 6px;\n  text-align: center;\n}\n\n.card-background {\n  background-position: center center;\n  background-size: cover;\n  text-align: center;\n}\n.card-background .card-body {\n  position: relative;\n  z-index: 2;\n  min-height: 370px;\n  max-width: 530px;\n  margin: 0 auto;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n.card-background .card-footer {\n  position: relative;\n  z-index: 2;\n}\n.card-background.card-background-product .card-body {\n  max-width: 400px;\n}\n.card-background.card-background-product .card-body .card-title {\n  margin-top: 30px;\n}\n.card-background .stats {\n  color: #ffffff;\n}\n.card-background .card-footer .stats-link > a {\n  color: #ffffff;\n  line-height: 1.9;\n}\n.card-background .category,\n.card-background .card-description,\n.card-background small {\n  color: rgba(255, 255, 255, 0.8);\n}\n.card-background .card-title {\n  color: #ffffff;\n  margin-top: 130px;\n}\n.card-background:not(.card-pricing) .btn {\n  margin-bottom: 0;\n}\n.card-background::after {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.63);\n  border-radius: 6px;\n}\n\n.card-collapse {\n  padding-bottom: 10px;\n}\n.card-collapse .card {\n  margin-bottom: 0px;\n}\n.card-collapse .card .card-header {\n  position: relative;\n  padding: 20px 0;\n}\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] {\n  display: block;\n  color: #444;\n}\n.card-collapse .card .card-header a[data-toggle=\"collapse\"] i {\n  float: right;\n  position: relative;\n  color: #f96332;\n  top: 3px;\n  right: 5px;\n}\n.card-collapse .card .card-header:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: #e3e3e3;\n}\n.card-collapse .card .card-body {\n  padding: 20px 15px;\n}\n\n.card-contributions .card-description {\n  max-width: 350px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.card-contributions .card-title {\n  padding-top: 35px;\n}\n\n.card-contributions .card-stats {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  padding: 11px;\n}\n\n.card-contributions .card-footer [class*=\"col-\"]:not(:first-child):before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 1px;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.card-contributions .bootstrap-switch {\n  margin: 0;\n}\n\n.card-contributions span {\n  padding-left: 15px;\n  text-align: left;\n  max-width: 125px;\n}\n\n.card .info-area {\n  padding: 40px 0 40px;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.card-lock .card-header img {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  margin-top: -70px;\n}\n\n.card-pricing {\n  text-align: center;\n}\n.card-pricing .card-body {\n  padding: 15px !important;\n}\n.card-pricing .card-category {\n  margin: 10px 0 10px;\n  color: #2c2c2c;\n}\n.card-pricing .card-icon {\n  padding: 15px 0 5px;\n  transform: translateY(0%);\n  color: #2c2c2c;\n}\n.card-pricing .card-icon.icon-info {\n  color: #0fa0cf;\n}\n.card-pricing .card-icon.icon-danger {\n  color: #ef8157;\n}\n.card-pricing .card-icon.icon-primary {\n  color: #51cbce;\n}\n.card-pricing .card-icon.icon-success {\n  color: #6bd098;\n}\n.card-pricing .card-icon.icon-warning {\n  color: #fbc658;\n}\n.card-pricing .card-icon i {\n  font-size: 40px;\n  width: 105px;\n  border: 2px solid #ccc;\n  border-radius: 50%;\n  height: 105px;\n  line-height: 105px;\n}\n.card-pricing .card-title {\n  margin-top: 30px !important;\n}\n.card-pricing ul {\n  list-style: none;\n  padding: 0;\n  max-width: 240px;\n  margin: 20px auto;\n}\n.card-pricing ul li {\n  padding: 5px 0;\n  list-style-type: none;\n}\n.card-pricing ul li b {\n  font-weight: 600;\n  color: #2c2c2c;\n}\n.card-pricing .btn-neutral {\n  color: #66615b;\n}\n.card-pricing .btn-neutral:hover,\n.card-pricing .btn-neutral :focus {\n  color: #403d39;\n}\n.card-pricing.card-background-image ul li {\n  color: #ffffff;\n  text-align: center;\n  border-color: rgba(255, 255, 255, 0.3);\n}\n.card-pricing.card-background-image ul li b {\n  color: #ffffff !important;\n}\n.card-pricing.card-background-image .card-description {\n  color: #ffffff !important;\n}\n.card-pricing.card-background-image .card-title small {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.card-pricing.card-plain .card-category,\n.card-pricing.card-plain .card-title {\n  color: #2c2c2c;\n}\n\n.card-pricing.card-plain ul li b {\n  font-weight: 600;\n  color: #2c2c2c;\n}\n\n.card[data-background=\"image\"] .card-icon i,\n.card[data-background=\"color\"] .card-icon i,\n.card[data-color] .card-icon i {\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.card-profile {\n  margin-top: 30px;\n  text-align: center;\n}\n.card-profile .card-body .card-title {\n  margin-top: 0;\n}\n.card-profile [class*=\"col-\"] .card-description {\n  margin-bottom: 0;\n}\n.card-profile [class*=\"col-\"] .card-description + .card-footer {\n  margin-top: 8px;\n}\n.card-profile .card-header-avatar {\n  max-width: 130px;\n  max-height: 130px;\n  margin: -60px auto 0;\n}\n.card-profile .card-header-avatar img {\n  border-radius: 50% !important;\n}\n.card-profile .card-header-avatar + .card-body {\n  margin-top: 15px;\n}\n.card-plain.card-profile .card-header-avatar {\n  margin-top: 0;\n}\n.card-profile .card-body .card-avatar {\n  margin: 0 auto 30px;\n}\n\n.card-signup .header {\n  margin-left: 20px;\n  margin-right: 20px;\n  padding: 30px 0;\n}\n\n.card-signup .text-divider {\n  margin-top: 30px;\n  margin-bottom: 0px;\n  text-align: center;\n}\n\n.card-signup .content {\n  padding: 0px 30px;\n}\n\n.card-signup .form-check {\n  margin-top: 20px;\n}\n.card-signup .form-check label {\n  margin-left: 7px;\n  padding-left: 38px;\n}\n\n.card-signup .social-line {\n  margin-top: 20px;\n  text-align: center;\n}\n.card-signup .social-line .btn.btn-icon,\n.card-signup .social-line .btn.btn-icon .btn-icon {\n  margin-left: 5px;\n  margin-right: 5px;\n  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\n}\n\n.card-signup .card-footer {\n  margin-bottom: 10px;\n  margin-top: 24px;\n}\n\n.card-stats-mini.card-background::after {\n  background-image: linear-gradient(to right, #434343 0%, black 100%);\n  opacity: 0.94;\n}\n\n.card-stats-mini .card-body::after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n\n.card-stats-mini .card-footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 0 15px;\n}\n\n.card-stats-mini.card-background .card-body {\n  min-height: auto;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.card-stats-mini .card-title {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n.card-stats-mini .info-area {\n  text-align: left;\n  width: 40%;\n  float: left;\n  padding: 15px 0;\n}\n.card-stats-mini .info-area .icon > i {\n  font-size: 2em;\n}\n\n.card-stats-mini .chart-area {\n  float: left;\n  width: 60%;\n}\n\n.card-stats-mini .stats {\n  text-align: left;\n  color: #ffffff;\n}\n\n.card-contributions hr {\n  margin: 5px 15px;\n}\n\n.card-stats .card-body {\n  padding: 15px 15px 0px;\n}\n.card-stats .card-body .numbers {\n  text-align: right;\n  font-size: 2em;\n}\n.card-stats .card-body .numbers p {\n  margin-bottom: 0;\n}\n.card-stats .card-body .numbers .card-category {\n  color: #9a9a9a;\n  font-size: 15px;\n  line-height: 1.4em;\n}\n\n.card-stats .card-footer {\n  padding: 0px 15px 15px;\n}\n.card-stats .card-footer .stats {\n  color: #9a9a9a;\n}\n.card-stats .card-footer hr {\n  margin-top: 10px;\n  margin-bottom: 15px;\n}\n\n.card-stats .icon-big {\n  font-size: 3em;\n  min-height: 64px;\n}\n.card-stats .icon-big i {\n  line-height: 59px;\n}\n\n.card-subcategories .card-body {\n  padding-bottom: 30px;\n}\n\n.card-testimonial {\n  margin-top: 30px;\n  text-align: center;\n}\n.card-testimonial .icon {\n  padding: 0;\n}\n.card-testimonial .icon i {\n  font-size: 30px;\n  border: 0;\n  display: block;\n  line-height: 100px;\n  margin: 0px auto;\n  margin-bottom: 0px;\n}\n.card-testimonial .card-body {\n  padding: 15px 30px;\n}\n.card-testimonial .card-body .card-description {\n  font-style: italic;\n  font-size: 16px;\n}\n.card-testimonial .card-body .card-category {\n  margin-bottom: 20px;\n}\n.card-testimonial .card-body + .card-footer {\n  padding-top: 0;\n  margin-top: -20px;\n}\n.card-testimonial .card-avatar {\n  margin-top: 0;\n}\n.card-testimonial .card-avatar .img {\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n}\n.card-testimonial .card-footer .card-title {\n  color: #2c2c2c;\n  text-align: center;\n}\n.card-testimonial .card-footer .card-category {\n  color: #9a9a9a;\n}\n.card-testimonial .card-footer .card-avatar {\n  margin-top: 20px;\n}\n.card-testimonial .card-footer .card-avatar .img {\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n}\n\n.card-testimonial .card-description + .card-title {\n  margin-top: 30px;\n}\n.card-testimonial .card-description + .card-title .card-image .img {\n  border-radius: 12px;\n}\n.card-testimonial .card-description + .card-title .card-image .card-title {\n  text-align: center;\n}\n\n.card-tasks {\n  text-align: left;\n}\n.card-tasks .table tbody td:last-child {\n  padding-right: 0;\n  display: inline-flex;\n}\n.card-tasks .table tbody td:last-child .btn {\n  padding: 3px;\n}\n.card-tasks .table tbody td:first-child {\n  padding-left: 0;\n}\n.card-tasks .table tbody td {\n  padding: 12px 8px !important;\n}\n.card-tasks .table-full-width {\n  padding-bottom: 0 !important;\n}\n.card-tasks .card-footer {\n  padding-top: 0;\n}\n.card-tasks .table {\n  margin-bottom: 0 !important;\n}\n\n.login-page .content .container {\n  margin-top: 8vh;\n}\n\n.login-page .card-login {\n  border-radius: 6px;\n  padding-bottom: 0.7rem;\n}\n.login-page .card-login .btn-wd {\n  min-width: 180px;\n}\n.login-page .card-login .logo-container {\n  width: 65px;\n  margin: 0 auto;\n  margin-bottom: 55px;\n}\n.login-page .card-login .logo-container img {\n  width: 100%;\n}\n.login-page .card-login .input-group:last-child {\n  margin-bottom: 40px;\n}\n.login-page .card-login.card-plain .form-control::-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-ms-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-control:focus {\n  border-color: #ffffff;\n  background-color: transparent;\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .has-success:after,\n.login-page .card-login.card-plain .has-danger:after {\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .has-danger .form-control {\n  background-color: transparent;\n}\n.login-page .card-login.card-plain .input-group-prepend .input-group-text,\n.login-page .card-login.card-plain .input-group-append .input-group-text {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: transparent;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control,\n.login-page .card-login.card-plain .input-group.no-border .form-control {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .input-group-addon,\n.login-page .card-login.card-plain .form-group.no-border .input-group-addon,\n.login-page .card-login.card-plain .input-group.no-border .input-group-addon {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.login-page .link {\n  font-size: 10px;\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.full-page > .content,\n.full-page > .footer {\n  position: relative;\n  z-index: 4;\n}\n\n.full-page.section-image {\n  position: initial;\n}\n\n.full-page > .content {\n  padding-top: 21vh;\n}\n\n.full-page .footer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n.full-page .footer .container {\n  color: #ffffff;\n}\n\n.full-page .full-page-background {\n  position: absolute;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center center;\n}\n\n.full-page:after {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.full-page.pricing-page .description {\n  margin-bottom: 65px;\n}\n\n.full-page.register-page .content > .container {\n  margin-top: 5vh;\n}\n\n.full-page.register-page .info-horizontal {\n  padding: 0px 0px 20px;\n}\n\n.full-page.register-page .info-horizontal {\n  text-align: left !important;\n}\n.full-page.register-page .info-horizontal .icon {\n  margin-top: 0;\n}\n.full-page.register-page .info-horizontal .icon > i {\n  font-size: 2em;\n}\n.full-page.register-page .info-horizontal .icon.icon-circle {\n  width: 65px;\n  height: 65px;\n  max-width: 65px;\n  margin-top: 8px;\n}\n.full-page.register-page .info-horizontal .icon.icon-circle i {\n  display: table;\n  margin: 0 auto;\n  line-height: 3.5;\n  font-size: 1.9em;\n}\n.full-page.register-page .info-horizontal .description {\n  overflow: hidden;\n}\n\n.full-page.lock-page .content > .container {\n  margin-top: 10vh;\n}\n\n.register-page .navbar .navbar-collapse .nav-item .nav-link,\n.login-page .navbar .navbar-collapse .nav-item .nav-link,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link {\n  text-transform: capitalize;\n  color: #ffffff !important;\n}\n\n.register-page .navbar.navbar-transparent,\n.login-page .navbar.navbar-transparent,\n.lock-page .navbar.navbar-transparent {\n  border-bottom: 1px solid transparent;\n  margin-top: 25px;\n}\n\n.register-page .navbar .navbar-brand,\n.login-page .navbar .navbar-brand,\n.lock-page .navbar .navbar-brand {\n  color: #ffffff !important;\n}\n\n@media screen and (max-width: 991px) {\n  .register-page\n    .navbar.bg-white\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,\n  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n    background: #66615b !important;\n  }\n  .register-page\n    .navbar.bg-white\n    .navbar-collapse\n    .navbar-nav\n    .nav-item\n    .nav-link,\n  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,\n  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {\n    color: #66615b !important;\n  }\n  .register-page .navbar.bg-white .navbar-brand,\n  .login-page .navbar.bg-white .navbar-brand,\n  .lock-page .navbar.bg-white .navbar-brand {\n    color: #66615b !important;\n  }\n  .register-page .navbar.navbar-transparent .navbar-toggle,\n  .login-page .navbar.navbar-transparent .navbar-toggle,\n  .lock-page .navbar.navbar-transparent .navbar-toggle {\n    display: none;\n  }\n  .register-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .login-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .lock-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab {\n    background: #ffffff !important;\n  }\n}\n\n.section {\n  padding: 70px 0;\n  position: relative;\n  background: #ffffff;\n}\n.section .row + .category {\n  margin-top: 15px;\n}\n\n.section-navbars {\n  padding-bottom: 0;\n}\n\n.section-full-screen {\n  height: 100vh;\n}\n\n.section-signup {\n  padding-top: 20vh;\n}\n\n.parallax-s {\n  overflow: hidden;\n  height: 500px;\n  width: 100%;\n}\n\n.section-image {\n  background-size: cover;\n  background-position: center center;\n  position: relative;\n  width: 100%;\n}\n.section-image .title,\n.section-image .card-plain .card-title {\n  color: #ffffff;\n}\n.section-image .nav-pills .nav-link {\n  background-color: #ffffff;\n}\n.section-image .nav-pills .nav-link:hover,\n.section-image .nav-pills .nav-link:focus {\n  background-color: #ffffff;\n}\n.section-image .info-title,\n.section-image .info-area.info-horizontal .icon i,\n.section-image .card-pricing.card-plain ul li {\n  color: #ffffff;\n}\n.section-image .description,\n.section-image .info-area .icon:not(.icon-circle) {\n  color: rgba(255, 255, 255, 0.8);\n}\n.section-image .card:not(.card-plain) .info-title {\n  color: #2c2c2c;\n}\n.section-image .card:not(.card-plain) .info-area p,\n.section-image .card:not(.card-plain) .info-area .icon,\n.section-image .card:not(.card-plain) .description {\n  color: #9a9a9a;\n}\n.section-image .footer {\n  color: #ffffff;\n}\n.section-image .card-plain [class*=\"text-\"],\n.section-image .card-plain ul li b {\n  color: #ffffff;\n}\n.section-image .card-plain .category {\n  color: rgba(255, 255, 255, 0.5);\n}\n.section-image:after {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.7);\n}\n.section-image .container {\n  z-index: 2;\n  position: relative;\n}\n\n.page-header {\n  min-height: 100vh;\n  max-height: 999px;\n  padding: 0;\n  color: #ffffff;\n  position: relative;\n}\n.page-header .page-header-image {\n  position: absolute;\n  background-size: cover;\n  background-position: center center;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.page-header .content-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  -ms-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: #ffffff;\n  padding: 0 15px;\n  width: 100%;\n  max-width: 880px;\n}\n.page-header footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n.page-header .container {\n  height: 100%;\n  z-index: 1;\n}\n.page-header .category,\n.page-header .description {\n  color: rgba(255, 255, 255, 0.8);\n}\n.page-header.page-header-small {\n  min-height: 60vh;\n  max-height: 440px;\n}\n.page-header.page-header-mini {\n  min-height: 40vh;\n  max-height: 340px;\n}\n.page-header .title {\n  margin-bottom: 15px;\n}\n.page-header .title + h4 {\n  margin-top: 10px;\n}\n.page-header:after,\n.page-header:before {\n  position: absolute;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n}\n.page-header:before {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.page-header[filter-color=\"orange\"] {\n  background: rgba(44, 44, 44, 0.2);\n  /* For browsers that do not support gradients */\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(44, 44, 44, 0.2),\n    rgba(224, 23, 3, 0.6)\n  );\n  /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(\n    90deg,\n    rgba(44, 44, 44, 0.2),\n    rgba(224, 23, 3, 0.6)\n  );\n  /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(44, 44, 44, 0.2),\n    rgba(224, 23, 3, 0.6)\n  );\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(\n    0deg,\n    rgba(44, 44, 44, 0.2),\n    rgba(224, 23, 3, 0.6)\n  );\n  /* Standard syntax */\n}\n\n.clear-filter:after,\n.clear-filter:before {\n  display: none;\n}\n\n.section-story-overview {\n  padding: 50px 0;\n}\n.section-story-overview .image-container {\n  height: 335px;\n  position: relative;\n  background-position: center center;\n  background-size: cover;\n  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n  border-radius: 0.25rem;\n}\n.section-story-overview .image-container + .category {\n  padding-top: 15px;\n}\n.section-story-overview .image-container.image-right {\n  z-index: 2;\n}\n.section-story-overview .image-container.image-right + h3.title {\n  margin-top: 120px;\n}\n.section-story-overview .image-container.image-left {\n  z-index: 1;\n}\n.section-story-overview .image-container img {\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: auto;\n  position: absolute;\n}\n.section-story-overview .image-container:nth-child(2) {\n  margin-top: 420px;\n  margin-left: -105px;\n}\n.section-story-overview p.blockquote {\n  width: 220px;\n  min-height: 180px;\n  text-align: left;\n  position: absolute;\n  top: 376px;\n  right: 155px;\n  z-index: 0;\n}\n\n.section-nucleo-icons .nucleo-container img {\n  width: auto;\n  left: 0;\n  top: 0;\n  height: 100%;\n  position: absolute;\n}\n\n.section-nucleo-icons .nucleo-container {\n  height: 335px;\n  position: relative;\n}\n\n.section-nucleo-icons h5 {\n  margin-bottom: 35px;\n}\n\n.section-nucleo-icons .icons-container {\n  position: relative;\n  max-width: 450px;\n  height: 300px;\n  max-height: 300px;\n  margin: 0 auto;\n}\n\n.section-nucleo-icons .icons-container i {\n  font-size: 34px;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(1) {\n  top: 5%;\n  left: 7%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(2) {\n  top: 28%;\n  left: 24%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(3) {\n  top: 40%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(4) {\n  top: 18%;\n  left: 62%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(5) {\n  top: 74%;\n  left: 3%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(6) {\n  top: 36%;\n  left: 44%;\n  font-size: 65px;\n  color: #f96332;\n  padding: 1px;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(7) {\n  top: 59%;\n  left: 26%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(8) {\n  top: 60%;\n  left: 69%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(9) {\n  top: 72%;\n  left: 47%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(10) {\n  top: 88%;\n  left: 27%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(11) {\n  top: 31%;\n  left: 80%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(12) {\n  top: 88%;\n  left: 68%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(13) {\n  top: 5%;\n  left: 81%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(14) {\n  top: 58%;\n  left: 90%;\n}\n\n.section-nucleo-icons .icons-container i:nth-child(15) {\n  top: 6%;\n  left: 40%;\n}\n\n.section-images {\n  max-height: 670px;\n  height: 670px;\n}\n.section-images .hero-images-container,\n.section-images .hero-images-container-1,\n.section-images .hero-images-container-2 {\n  margin-top: -38vh;\n}\n.section-images .hero-images-container {\n  max-width: 670px;\n}\n.section-images .hero-images-container-1 {\n  max-width: 390px;\n  position: absolute;\n  top: 55%;\n  right: 18%;\n}\n.section-images .hero-images-container-2 {\n  max-width: 225px;\n  position: absolute;\n  top: 68%;\n  right: 12%;\n}\n\n[data-background-color=\"gray\"] {\n  background-color: #cac7c3;\n}\n\n[data-background-color=\"orange\"] {\n  background-color: #e95e38;\n}\n\n[data-background-color=\"black\"] {\n  background-color: #2c2c2c;\n}\n\n[data-background-color]:not([data-background-color=\"gray\"]) {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .separator-line {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .footer.footer-white\n  .footer-brand,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .footer.footer-white\n  ul\n  li\n  > a.nav-link:not(.btn-icon) {\n  color: initial;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .pagination\n  .page-item.disabled\n  > .page-link {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .category,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .card-description,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .category,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .category {\n  color: #9a9a9a;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .card-title,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card:not(.card-plain)\n  .card-title {\n  color: initial;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .carousel\n  .carousel-inner {\n  box-shadow: none;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .title,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .social-description\n  h2,\n[data-background-color]:not([data-background-color=\"gray\"]) p,\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote,\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote small,\n[data-background-color]:not([data-background-color=\"gray\"]) h1,\n[data-background-color]:not([data-background-color=\"gray\"]) h2,\n[data-background-color]:not([data-background-color=\"gray\"]) h3,\n[data-background-color]:not([data-background-color=\"gray\"]) h4,\n[data-background-color]:not([data-background-color=\"gray\"]) h5,\n[data-background-color]:not([data-background-color=\"gray\"]) h6,\n[data-background-color]:not([data-background-color=\"gray\"])\n  a:not(.btn):not(.dropdown-item):not(.card-link),\n[data-background-color]:not([data-background-color=\"gray\"]) .icons-container i,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing ul li,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .info.info-horizontal\n  .icon\n  i,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card-pricing.card-plain\n  ul\n  li {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card\n  a:not(.btn):not(.dropdown-item) {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card\n  a:not(.btn):not(.dropdown-item):hover,\n[data-background-color]:not([data-background-color=\"gray\"]).card\n  a:not(.btn):not(.dropdown-item):focus {\n  border-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).footer hr,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n  .icon\n  i,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing ul li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card-footer\n  .stats\n  i,\n[data-background-color]:not([data-background-color=\"gray\"]).card-plain\n  .category,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card-plain\n  .category,\n[data-background-color]:not([data-background-color=\"gray\"]) .card-header:after {\n  color: rgba(255, 255, 255, 0.5);\n}\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n  ul\n  li\n  i,\n[data-background-color]:not([data-background-color=\"gray\"]).card-pricing\n  ul\n  li\n  b,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card-pricing.card-plain\n  ul\n  li\n  b,\n[data-background-color]:not([data-background-color=\"gray\"]) .card-category,\n[data-background-color]:not([data-background-color=\"gray\"]) .author span,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .card-pricing.card-plain\n  ul\n  li\n  i {\n  color: rgba(255, 255, 255, 0.8) !important;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .separator {\n  background-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .navbar.bg-white p {\n  color: #66615b;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .description,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .social-description\n  p {\n  color: rgba(255, 255, 255, 0.8);\n}\n[data-background-color]:not([data-background-color=\"gray\"]) p.blockquote {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .checkbox\n  label::before,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .checkbox\n  label::after,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .radio\n  label::before,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .radio\n  label::after {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .checkbox\n  label::after,\n[data-background-color]:not([data-background-color=\"gray\"]) .checkbox label,\n[data-background-color]:not([data-background-color=\"gray\"]) .radio label {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .checkbox\n  input[type=\"checkbox\"]:disabled\n  + label,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .radio\n  input[type=\"radio\"]:disabled\n  + label {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .radio\n  input[type=\"radio\"]:not(:disabled):hover\n  + label::after,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .radio\n  input[type=\"radio\"]:checked\n  + label::after {\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-control::-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-control:-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-control::-webkit-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-control:-ms-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .form-control {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-control:focus {\n  border-color: #ffffff;\n  background-color: transparent;\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .has-success:after,\n[data-background-color]:not([data-background-color=\"gray\"]) .has-danger:after {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .has-danger\n  .form-control {\n  background-color: transparent;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group-append\n  .input-group-text {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group-focus\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: transparent;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .input-group-append\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .form-group.no-border\n  .input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .input-group.no-border\n  .input-group-addon {\n  color: rgba(255, 255, 255, 0.8);\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .subscribe-line\n  .form-control {\n  background-color: transparent;\n  border: 1px solid #e3e3e3;\n  color: #2c2c2c;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .subscribe-line\n  .form-control:last-child {\n  border-left: 0 none;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .subscribe-line\n  .input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .subscribe-line\n  .form-group.no-border\n  .input-group-addon,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .subscribe-line\n  .input-group.no-border\n  .input-group-addon {\n  color: #555555;\n  border: 1px solid #e3e3e3;\n}\n[data-background-color]:not([data-background-color=\"gray\"]) .btn.btn-simple {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .btn.btn-simple:hover,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .btn.btn-simple:hover,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .btn.btn-simple:focus,\n[data-background-color]:not([data-background-color=\"gray\"])\n  .btn.btn-simple:active {\n  background-color: transparent;\n  border-color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"])\n  .nav-tabs\n  > .nav-item\n  > .nav-link\n  i.nc-icon {\n  color: #ffffff;\n}\n[data-background-color]:not([data-background-color=\"gray\"]).section-nucleo-icons\n  .icons-container\n  i:nth-child(6) {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 991px) {\n  .navbar {\n    padding: 0;\n  }\n  .navbar.navbar-absolute {\n    padding-top: 0;\n  }\n  .navbar .navbar-brand {\n    font-size: 16px;\n    margin-right: 0;\n  }\n  .profile-photo .profile-photo-small {\n    margin-left: -2px;\n  }\n  .button-dropdown {\n    display: none;\n  }\n  #minimizeSidebar {\n    display: none;\n  }\n  .navbar .container-fluid {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n  .navbar .navbar-collapse .input-group {\n    margin: 0;\n    margin-top: 5px;\n  }\n  .navbar .navbar-nav .nav-item:first-child {\n    margin-top: 10px;\n  }\n  .navbar .navbar-nav .nav-item:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  .navbar .dropdown.show .dropdown-menu {\n    display: block;\n  }\n  .navbar .dropdown .dropdown-menu {\n    display: none;\n  }\n  .navbar .dropdown.show .dropdown-menu,\n  .navbar .dropdown .dropdown-menu {\n    border: 0;\n    transition: none;\n    -webkit-box-shadow: none;\n    width: auto;\n    margin: 0px 1rem;\n    margin-top: 0px;\n    box-shadow: none;\n    position: static;\n    padding-left: 10px;\n  }\n  .navbar .dropdown.show .dropdown-menu:before,\n  .navbar .dropdown .dropdown-menu:before {\n    display: none;\n  }\n  .navbar .dropdown-menu .dropdown-item:focus,\n  .navbar .dropdown-menu .dropdown-item:hover {\n    color: #ffffff;\n  }\n  .navbar.bg-white .dropdown-menu .dropdown-item:focus,\n  .navbar.bg-white .dropdown-menu .dropdown-item:hover {\n    color: #66615b;\n  }\n  .navbar .navbar-toggler-bar {\n    display: block;\n    position: relative;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: #66615b;\n  }\n  .navbar .navbar-toggler-bar + .navbar-toggler-bar {\n    margin-top: 7px;\n  }\n  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {\n    margin-top: 3px;\n  }\n  .navbar .navbar-toggler-bar.bar2 {\n    width: 17px;\n    transition: width 0.2s linear;\n  }\n  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {\n    background-color: #66615b;\n  }\n  .navbar .toggled .navbar-toggler-bar {\n    width: 24px;\n  }\n  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {\n    margin-top: 5px;\n  }\n  .wrapper {\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  }\n  .nav-open .main-panel {\n    right: 0;\n    -webkit-transform: translate3d(260px, 0, 0);\n    -moz-transform: translate3d(260px, 0, 0);\n    -o-transform: translate3d(260px, 0, 0);\n    -ms-transform: translate3d(260px, 0, 0);\n    transform: translate3d(260px, 0, 0);\n  }\n  .nav-open .sidebar {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n  }\n  .nav-open body {\n    position: relative;\n    overflow-x: hidden;\n  }\n  .nav-open .menu-on-right .main-panel {\n    -webkit-transform: translate3d(-260px, 0, 0);\n    -moz-transform: translate3d(-260px, 0, 0);\n    -o-transform: translate3d(-260px, 0, 0);\n    -ms-transform: translate3d(-260px, 0, 0);\n    transform: translate3d(-260px, 0, 0);\n  }\n  .nav-open .menu-on-right .navbar-collapse,\n  .nav-open .menu-on-right .sidebar {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n  }\n  .nav-open .menu-on-right .navbar-translate {\n    -webkit-transform: translate3d(-300px, 0, 0);\n    -moz-transform: translate3d(-300px, 0, 0);\n    -o-transform: translate3d(-300px, 0, 0);\n    -ms-transform: translate3d(-300px, 0, 0);\n    transform: translate3d(-300px, 0, 0);\n  }\n  .nav-open .menu-on-right #bodyClick {\n    right: 260px;\n    left: auto;\n  }\n  .menu-on-right .sidebar {\n    left: auto;\n    right: 0;\n    -webkit-transform: translate3d(260px, 0, 0);\n    -moz-transform: translate3d(260px, 0, 0);\n    -o-transform: translate3d(260px, 0, 0);\n    -ms-transform: translate3d(260px, 0, 0);\n    transform: translate3d(260px, 0, 0);\n  }\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    -webkit-animation: topbar-back 500ms linear 0s;\n    -moz-animation: topbar-back 500ms linear 0s;\n    animation: topbar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    -webkit-animation: bottombar-back 500ms linear 0s;\n    -moz-animation: bottombar-back 500ms linear 0s;\n    animation: bottombar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar1 {\n    top: 6px;\n    -webkit-animation: topbar-x 500ms linear 0s;\n    -moz-animation: topbar-x 500ms linear 0s;\n    animation: topbar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 6px;\n    -webkit-animation: bottombar-x 500ms linear 0s;\n    -moz-animation: bottombar-x 500ms linear 0s;\n    animation: bottombar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  @keyframes topbar-x {\n    0% {\n      top: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      transform: rotate(145deg);\n    }\n    75% {\n      transform: rotate(130deg);\n    }\n    100% {\n      transform: rotate(135deg);\n    }\n  }\n  @-webkit-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -webkit-transform: rotate(145deg);\n    }\n    75% {\n      -webkit-transform: rotate(130deg);\n    }\n    100% {\n      -webkit-transform: rotate(135deg);\n    }\n  }\n  @-moz-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -moz-transform: rotate(145deg);\n    }\n    75% {\n      -moz-transform: rotate(130deg);\n    }\n    100% {\n      -moz-transform: rotate(135deg);\n    }\n  }\n  @keyframes topbar-back {\n    0% {\n      top: 6px;\n      transform: rotate(135deg);\n    }\n    45% {\n      transform: rotate(-10deg);\n    }\n    75% {\n      transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -webkit-transform: rotate(135deg);\n    }\n    45% {\n      -webkit-transform: rotate(-10deg);\n    }\n    75% {\n      -webkit-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -moz-transform: rotate(135deg);\n    }\n    45% {\n      -moz-transform: rotate(-10deg);\n    }\n    75% {\n      -moz-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      transform: rotate(-145deg);\n    }\n    75% {\n      transform: rotate(-130deg);\n    }\n    100% {\n      transform: rotate(-135deg);\n    }\n  }\n  @-webkit-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -webkit-transform: rotate(-145deg);\n    }\n    75% {\n      -webkit-transform: rotate(-130deg);\n    }\n    100% {\n      -webkit-transform: rotate(-135deg);\n    }\n  }\n  @-moz-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -moz-transform: rotate(-145deg);\n    }\n    75% {\n      -moz-transform: rotate(-130deg);\n    }\n    100% {\n      -moz-transform: rotate(-135deg);\n    }\n  }\n  @keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      transform: rotate(-135deg);\n    }\n    45% {\n      transform: rotate(10deg);\n    }\n    75% {\n      transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -webkit-transform: rotate(-135deg);\n    }\n    45% {\n      -webkit-transform: rotate(10deg);\n    }\n    75% {\n      -webkit-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -moz-transform: rotate(-135deg);\n    }\n    45% {\n      -moz-transform: rotate(10deg);\n    }\n    75% {\n      -moz-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @-moz-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    left: 260px;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  }\n  .footer .copyright {\n    text-align: right;\n  }\n  .section-nucleo-icons .icons-container {\n    margin-top: 65px;\n  }\n  .navbar-nav .nav-link i.fa,\n  .navbar-nav .nav-link i.nc-icon {\n    opacity: 0.5;\n  }\n  .sidebar,\n  .bootstrap-navbar {\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100%;\n    width: 260px;\n    right: auto;\n    left: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -webkit-transform: translate3d(-260px, 0, 0);\n    -moz-transform: translate3d(-260px, 0, 0);\n    -o-transform: translate3d(-260px, 0, 0);\n    -ms-transform: translate3d(-260px, 0, 0);\n    transform: translate3d(-260px, 0, 0);\n  }\n  .main-panel {\n    width: 100%;\n  }\n  .timeline:before {\n    left: 5% !important;\n  }\n  .timeline > li > .timeline-badge {\n    left: 5% !important;\n  }\n  .timeline > li > .timeline-panel {\n    float: right !important;\n    width: 82% !important;\n  }\n  .timeline > li > .timeline-panel:before {\n    border-left-width: 0 !important;\n    border-right-width: 15px !important;\n    left: -15px !important;\n    right: auto !important;\n  }\n  .timeline > li > .timeline-panel:after {\n    border-left-width: 0 !important;\n    border-right-width: 14px !important;\n    left: -14px !important;\n    right: auto !important;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .nav-tabs-navigation.verical-navs {\n    padding: 0px 2px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .footer .footer-nav {\n    padding-left: 21px;\n  }\n  .footer .credits {\n    padding-right: 15px;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .navbar-collapse {\n    background: none !important;\n  }\n  .navbar .navbar-toggle {\n    display: none;\n  }\n  .navbar-nav .nav-link.profile-photo {\n    padding: 0;\n    margin: 7px 0.7rem;\n  }\n  .section-nucleo-icons .icons-container {\n    margin: 0 0 0 auto;\n  }\n  .dropdown-menu .dropdown-item {\n    color: inherit;\n  }\n  .footer .copyright {\n    float: right;\n    padding-right: 15px;\n  }\n  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):before,\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li:before {\n    border-right: 17px solid #dddddd;\n    border-top: 17px solid transparent;\n    border-bottom: 17px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: -16px;\n    opacity: 1;\n    top: 7px;\n    transition: opacity 150ms ease-in;\n  }\n  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):after,\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li:after {\n    border-right: 17px solid #eef2f3;\n    border-top: 17px solid transparent;\n    border-bottom: 17px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: -17px;\n    opacity: 1;\n    top: 7px;\n    transition: opacity 150ms ease-in;\n  }\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li\n    a:before,\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li\n    a:after {\n    top: 0;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n  /* .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  } */\n  .footer nav {\n    display: block;\n    margin-bottom: 5px;\n    float: none;\n  }\n  .landing-page .section-story-overview .image-container:nth-child(2) {\n    margin-left: 0;\n    margin-bottom: 30px;\n  }\n  .card .form-horizontal .col-md-3.col-form-label {\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .nav-tabs-navigation.verical-navs {\n    padding: 0 28px;\n  }\n  .typography-line {\n    padding-left: 23% !important;\n  }\n  .typography-line span {\n    width: 60px !important;\n  }\n  .login-page .navbar,\n  .lock-page .navbar,\n  .register-page .navbar {\n    padding: 0.5rem 1rem;\n  }\n  .footer .footer-nav,\n  .footer .credits {\n    margin: 0 auto !important;\n  }\n  .footer .footer-nav {\n    margin-bottom: 10px !important;\n  }\n  .register-page .content {\n    padding-top: 5vh;\n  }\n  .register-page .footer {\n    position: relative;\n  }\n  .register-page .info-area.info-horizontal {\n    margin-top: 0;\n  }\n}\n\n@media screen and (max-width: 374px) {\n  .login-page .content {\n    padding-top: 10vh;\n  }\n}\n\n@media screen and (max-width: 413px) {\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {\n    width: 225px !important;\n  }\n  .fixed-plugin\n    .dropdown.show-dropdown.show\n    .dropdown-menu.show[x-placement=\"top-start\"] {\n    transform: translate3d(0, 400px, 0) !important;\n  }\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {\n    bottom: 360px !important;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .navbar[class*=\"navbar-toggleable-\"] .container {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .card-contributions .card-stats {\n    flex-direction: column;\n  }\n  .card-contributions .card-stats .bootstrap-switch {\n    margin-bottom: 15px;\n  }\n  .footer .copyright {\n    text-align: center;\n  }\n  .section-nucleo-icons .icons-container i {\n    font-size: 30px;\n  }\n  .section-nucleo-icons .icons-container i:nth-child(6) {\n    font-size: 48px;\n  }\n  .page-header .container h6.category-absolute {\n    width: 90%;\n  }\n  .card-timeline .timeline .timeline-panel {\n    width: 38%;\n    padding: 15px;\n  }\n}\n\n.alert .close {\n  font-size: 1.8rem;\n  font-weight: 300;\n}\n\n/*           badges             */\n.badge + .badge {\n  margin-left: 5px;\n}\n\n.btn i,\n.navbar .navbar-nav > a.btn i {\n  margin-right: 3px;\n}\n\n.table not(.btn-group) .btn + .btn,\n.table .btn-group + .btn-group {\n  margin-left: 4px;\n}\n\n.btn + .btn,\n.btn-group + .btn-group {\n  margin-left: 5px;\n}\n\n.card .card-footer .stats i {\n  margin-right: 9px;\n}\n\n.card .card-footer .legend i {\n  margin-right: 4px;\n}\n\n.dropup .dropdown-toggle:after,\n.dropdown .dropdown-toggle:after {\n  margin-left: 3px;\n}\n\n.login-page .card-login {\n  border-radius: 6px;\n  padding-bottom: 0.7rem;\n}\n.login-page .card-login .btn-wd {\n  min-width: 180px;\n}\n.login-page .card-login .logo-container {\n  width: 65px;\n  margin: 0 auto;\n  margin-bottom: 55px;\n}\n.login-page .card-login .logo-container img {\n  width: 100%;\n}\n.login-page .card-login .input-group:last-child {\n  margin-bottom: 40px;\n}\n.login-page .card-login.card-plain .form-control::-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-moz-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control:-ms-input-placeholder {\n  color: #ebebeb;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.login-page .card-login.card-plain .form-control {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-control:focus {\n  border-color: #ffffff;\n  background-color: transparent;\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .has-success:after,\n.login-page .card-login.card-plain .has-danger:after {\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .has-danger .form-control {\n  background-color: transparent;\n}\n.login-page .card-login.card-plain .input-group-prepend .input-group-text,\n.login-page .card-login.card-plain .input-group-append .input-group-text {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: transparent;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control,\n.login-page .card-login.card-plain .input-group.no-border .form-control {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .form-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .form-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:focus,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active,\n.login-page .card-login.card-plain .input-group.no-border .form-control:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-prepend\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:focus,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control\n  + .input-group-append\n  .input-group-text:active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .form-control:focus\n  + .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border\n  .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #ffffff;\n}\n.login-page\n  .card-login.card-plain\n  .form-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .form-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border.input-group-focus\n  .input-group-prepend\n  .input-group-text,\n.login-page\n  .card-login.card-plain\n  .input-group.no-border.input-group-focus\n  .input-group-append\n  .input-group-text {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.login-page .card-login.card-plain .input-group-addon,\n.login-page .card-login.card-plain .form-group.no-border .input-group-addon,\n.login-page .card-login.card-plain .input-group.no-border .input-group-addon {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.login-page .link {\n  font-size: 10px;\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.full-page {\n  align-items: center;\n  min-height: 100vh;\n  padding: 100px 0 120px;\n}\n.full-page > .footer {\n  position: relative;\n  z-index: 4;\n}\n.full-page .footer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n.full-page .footer .container {\n  color: #ffffff;\n}\n.full-page .full-page-background {\n  position: absolute;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center center;\n}\n.full-page:after {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.full-page .pricing-page .description {\n  margin-bottom: 65px;\n}\n.full-page .register-page > .container {\n  margin-top: 5vh;\n}\n.full-page .register-page .info-horizontal {\n  padding: 0px 0px 20px;\n}\n.full-page .register-page .info-horizontal {\n  text-align: left !important;\n}\n.full-page .register-page .info-horizontal .icon {\n  margin-top: 0;\n}\n.full-page .register-page .info-horizontal .icon > i {\n  font-size: 2em;\n}\n.full-page .register-page .info-horizontal .icon.icon-circle {\n  width: 65px;\n  height: 65px;\n  max-width: 65px;\n  margin-top: 8px;\n}\n.full-page .register-page .info-horizontal .icon.icon-circle i {\n  display: table;\n  margin: 0 auto;\n  line-height: 3.5;\n  font-size: 1.9em;\n}\n.full-page .register-page .info-horizontal .description {\n  overflow: hidden;\n}\n\n.register-page .navbar .navbar-collapse .nav-item .nav-link,\n.login-page .navbar .navbar-collapse .nav-item .nav-link,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link {\n  text-transform: capitalize;\n  color: #ffffff !important;\n}\n.register-page .navbar .navbar-collapse .nav-item .nav-link i,\n.login-page .navbar .navbar-collapse .nav-item .nav-link i,\n.lock-page .navbar .navbar-collapse .nav-item .nav-link i {\n  margin-right: 4px;\n}\n\n.register-page .navbar.navbar-transparent,\n.login-page .navbar.navbar-transparent,\n.lock-page .navbar.navbar-transparent {\n  border-bottom: 1px solid transparent;\n  margin-top: 25px;\n}\n\n.register-page .navbar .navbar-brand,\n.login-page .navbar .navbar-brand,\n.lock-page .navbar .navbar-brand {\n  color: #ffffff !important;\n}\n\n.register-page,\n.login-page,\n.lock-page {\n  width: 100%;\n}\n\n@media screen and (max-width: 991px) {\n  .register-page\n    .navbar.bg-white\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,\n  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n    background: #66615b !important;\n  }\n  .register-page\n    .navbar.bg-white\n    .navbar-collapse\n    .navbar-nav\n    .nav-item\n    .nav-link,\n  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,\n  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {\n    color: #66615b !important;\n  }\n  .register-page .navbar.bg-white .navbar-brand,\n  .login-page .navbar.bg-white .navbar-brand,\n  .lock-page .navbar.bg-white .navbar-brand {\n    color: #66615b !important;\n  }\n  .register-page .navbar.navbar-transparent .navbar-toggle,\n  .login-page .navbar.navbar-transparent .navbar-toggle,\n  .lock-page .navbar.navbar-transparent .navbar-toggle {\n    display: none;\n  }\n  .register-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .login-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab,\n  .lock-page\n    .navbar.navbar-transparent\n    .navbar-toggler\n    .navbar-toggler-bar.navbar-kebab {\n    background: #ffffff !important;\n  }\n}\n\n.btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  direction: ltr;\n}\n\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n}\n.fileinput input[type=\"file\"] {\n  display: none;\n}\n\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 250px;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.fileinput .thumbnail.img-circle {\n  border-radius: 50%;\n  max-width: 100px;\n}\n\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n\n.fileinput .btn {\n  vertical-align: middle;\n}\n\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n\n.fileinput.input-group {\n  display: table;\n}\n\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: #fbc658;\n}\n\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: #fbc658;\n}\n\n.form-group.has-error .fileinput .fileinput-preview {\n  color: #ef8157;\n}\n\n.form-group.has-error .fileinput .thumbnail {\n  border-color: #ef8157;\n}\n\n.form-group.has-success .fileinput .fileinput-preview {\n  color: #6bd098;\n}\n\n.form-group.has-success .fileinput .thumbnail {\n  border-color: #6bd098;\n}\n\n.input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n\n.thumbnail {\n  border: 0 none;\n  border-radius: 3px;\n  padding: 0;\n}\n\n.picture-container {\n  position: relative;\n  cursor: pointer;\n  text-align: center;\n}\n\n.picture {\n  width: 106px;\n  height: 106px;\n  background-color: #999999;\n  border: 1px solid #e3e3e3;\n  color: #ffffff;\n  border-radius: 50%;\n  margin: 5px auto;\n  overflow: hidden;\n  transition: all 0.2s;\n  -webkit-transition: all 0.2s;\n}\n.picture:hover {\n  border-color: #2ca8ff;\n}\n\n.picture input[type=\"file\"] {\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  opacity: 0 !important;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.picture-src {\n  width: 100%;\n}\n\n.fixed-plugin {\n  position: fixed;\n  right: 0;\n  width: 64px;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1031;\n  border-radius: 8px 0 0 8px;\n  text-align: center;\n  top: 120px;\n}\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n  transition: all 0.34s;\n  -webkit-transition: all 0.34s;\n  -moz-transition: all 0.34s;\n}\n.fixed-plugin .fa-cog {\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 0 0 6px 6px;\n  width: auto;\n}\n.fixed-plugin .dropdown-menu {\n  right: 80px;\n  left: auto !important;\n  top: -52px !important;\n  width: 290px;\n  border-radius: 10px;\n  padding: 0 10px;\n}\n.fixed-plugin .dropdown .dropdown-menu .nc-icon {\n  top: 2px;\n  right: 10px;\n  font-size: 14px;\n}\n.fixed-plugin .dropdown-menu:after,\n.fixed-plugin .dropdown-menu:before {\n  right: 10px;\n  margin-left: auto;\n  left: auto;\n}\n.fixed-plugin .fa-circle-thin {\n  color: #ffffff;\n}\n.fixed-plugin .active .fa-circle-thin {\n  color: #00bbff;\n}\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n  color: #777777;\n  text-align: center;\n}\n.fixed-plugin img {\n  border-radius: 0;\n  width: 100%;\n  height: 100px;\n  margin: 0 auto;\n}\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n  box-shadow: none;\n}\n.fixed-plugin .badge {\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 23px;\n  margin-right: 5px;\n  position: relative;\n  width: 23px;\n}\n.fixed-plugin .badge.badge-light {\n  border-color: #f5f5f5;\n  background-color: #f5f5f5;\n  border: 3px solid #ffffff;\n}\n.fixed-plugin .badge.badge-dark {\n  border-color: #2c2c2c;\n  background-color: #2c2c2c;\n  border: 3px solid #ffffff;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n  border-color: #00bbff;\n}\n.fixed-plugin .badge-blue {\n  background-color: #0fa0cf;\n}\n.fixed-plugin .badge-green {\n  background-color: #6bd098;\n}\n.fixed-plugin .badge-orange {\n  background-color: #51cbce;\n}\n.fixed-plugin .badge-yellow {\n  background-color: #fbc658;\n}\n.fixed-plugin .badge-red {\n  background-color: #ef8157;\n}\n.fixed-plugin h5 {\n  font-size: 14px;\n  margin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n  display: block;\n  padding: 15px 2px;\n  width: 25%;\n  float: left;\n}\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n  width: 100%;\n  height: 35px;\n  min-height: inherit;\n}\n.fixed-plugin li.button-container {\n  height: auto;\n}\n.fixed-plugin li.button-container div {\n  margin-bottom: 5px;\n}\n.fixed-plugin #sharrreTitle {\n  text-align: center;\n  padding: 10px 0;\n  height: 50px;\n}\n.fixed-plugin li.header-title {\n  height: 30px;\n  line-height: 25px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  text-transform: uppercase;\n}\n.fixed-plugin .adjustments-line p {\n  float: left;\n  display: inline-block;\n  margin-bottom: 0;\n  font-size: 1em;\n  color: #3c4858;\n}\n.fixed-plugin .adjustments-line a {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line a .badge-colors {\n  position: relative;\n  top: -2px;\n}\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line .togglebutton {\n  text-align: center;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch {\n  position: relative;\n  left: -10px;\n  font-size: 0.7142em;\n  color: #66615b;\n}\n.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {\n  left: 10px;\n}\n.fixed-plugin .adjustments-line .togglebutton .toggle {\n  margin-right: 0;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: 1px solid #ddd;\n  border-radius: 0;\n  margin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n  font-size: 16px;\n  text-align: center;\n  border-radius: 10px;\n  background-color: #fff;\n  border: 3px solid #fff;\n  padding-left: 0;\n  padding-right: 0;\n  opacity: 1;\n  cursor: pointer;\n  display: block;\n  max-height: 100px;\n  overflow: hidden;\n  padding: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n  margin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {\n  background-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n  border-color: rgba(0, 187, 255, 0.53);\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n  border-color: #00bbff;\n  background-color: #ffffff;\n}\n.fixed-plugin .btn-social {\n  width: 50%;\n  display: block;\n  width: 48%;\n  float: left;\n  font-weight: 600;\n}\n.fixed-plugin .btn-social i {\n  margin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child {\n  margin-right: 2%;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n  transform-origin: 0 0;\n}\n.fixed-plugin .dropdown .dropdown-menu:before {\n  border-bottom: 16px solid rgba(0, 0, 0, 0);\n  border-left: 16px solid rgba(0, 0, 0, 0.2);\n  border-top: 16px solid rgba(0, 0, 0, 0);\n  right: -27px;\n  bottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n  border-bottom: 16px solid rgba(0, 0, 0, 0);\n  border-left: 16px solid #ffffff;\n  border-top: 16px solid rgba(0, 0, 0, 0);\n  right: -26px;\n  bottom: 425px;\n}\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 16px;\n  transform: translateY(-50px);\n  -webkit-transform: translateY(-50px);\n  -moz-transform: translateY(-50px);\n}\n.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {\n  transform: translate3d(0, -60px, 0) !important;\n  bottom: auto !important;\n  top: 0 !important;\n}\n.fixed-plugin .bootstrap-switch {\n  margin: 0;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(0, -100px, 0) !important;\n  -moz-transform: translate3d(0, -100px, 0) !important;\n  -o-transform: translate3d(0, -100px, 0) !important;\n  -ms-transform: translate3d(0, -100px, 0) !important;\n  transform: translate3d(0, -100px, 0) !important;\n}\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after {\n  top: 100px;\n}\n\n.fixed-plugin .show-dropdown .dropdown-menu[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(0, 100px, 0) !important;\n  -moz-transform: translate3d(0, 100px, 0) !important;\n  -o-transform: translate3d(0, 100px, 0) !important;\n  -ms-transform: translate3d(0, 100px, 0) !important;\n  transform: translate3d(0, 100px, 0) !important;\n}\n\n.fixed-plugin\n  .show-dropdown.show\n  .dropdown-menu.show[x-placement=\"bottom-start\"] {\n  -webkit-transform: translate3d(0, -60px, 0) !important;\n  -moz-transform: translate3d(0, -60px, 0) !important;\n  -o-transform: translate3d(0, -60px, 0) !important;\n  -ms-transform: translate3d(0, -60px, 0) !important;\n  transform: translate3d(0, -60px, 0) !important;\n}\n\n.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=\"top-start\"] {\n  -webkit-transform: translate3d(0, 470px, 0) !important;\n  -moz-transform: translate3d(0, 470px, 0) !important;\n  -o-transform: translate3d(0, 470px, 0) !important;\n  -ms-transform: translate3d(0, 470px, 0) !important;\n  transform: translate3d(0, 470px, 0) !important;\n}\n\n.form-control {\n  height: unset;\n}\n\n.form-group input[type=\"file\"] {\n  opacity: 1;\n  position: unset;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: unset;\n  z-index: unset;\n}\n\n.modal-footer .left-side,\n.modal-footer .right-side {\n  display: flex;\n  flex: 1;\n  text-align: center;\n  width: unset;\n  padding: 5px;\n}\n\n.navbar .navbar-nav .nav-link i.fa + p,\n.navbar .navbar-nav .nav-link i.nc-icon + p {\n  margin-left: 7px;\n}\n\n/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: \"nucleo-icons\";\n  src: url(\"~assets/fonts/nucleo-icons.eot\");\n  src: url(\"~assets/fonts/nucleo-icons.eot\") format(\"embedded-opentype\"),\n    url(\"~assets/fonts/nucleo-icons.woff2\") format(\"woff2\"),\n    url(\"~assets/fonts/nucleo-icons.woff\") format(\"woff\"),\n    url(\"~assets/fonts/nucleo-icons.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* all icon font classes list here */\n/*             Navigation Pills               */\n.nav-pills .nav-item + .nav-link {\n  margin-left: 0;\n}\n\n.nav-pills .nav-item .nav-link {\n  border: 1px solid #66615b;\n  border-radius: 0;\n  color: #66615b;\n  font-weight: 700;\n  margin-left: -1px;\n  padding: 10px 25px;\n}\n\n.nav-pills .nav-item.active .nav-link,\n.nav-pills .nav-item.active .nav-link:hover,\n.nav-pills .nav-item.active .nav-link:focus {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n.nav-pills:not(.flex-column) .nav-item:first-child .nav-link {\n  border-radius: 30px 0 0 30px !important;\n  margin: 0;\n}\n\n.nav-pills:not(.flex-column) .nav-item:last-child .nav-link {\n  border-radius: 0 30px 30px 0 !important;\n}\n\n.nav-pills.flex-column .nav-item .nav-link {\n  border-radius: 30px !important;\n  margin-bottom: 15px;\n}\n\n.nav-pills .nav-item .nav-link.active {\n  background-color: #66615b;\n  color: #ffffff;\n}\n\n.nav-pills-primary .nav-item .nav-link {\n  border: 1px solid #51cbce;\n  color: #51cbce;\n}\n.nav-pills-primary .nav-item .nav-link.active {\n  border: 1px solid #51cbce;\n  background: #51cbce;\n  color: #ffffff;\n}\n\n.nav-pills-danger .nav-item .nav-link {\n  border: 1px solid #ef8157;\n  color: #ef8157;\n}\n.nav-pills-danger .nav-item .nav-link.active {\n  border: 1px solid #ef8157;\n  background: #ef8157;\n  color: #ffffff;\n}\n\n.nav-pills-info .nav-item .nav-link {\n  border: 1px solid #0fa0cf;\n  color: #0fa0cf;\n}\n.nav-pills-info .nav-item .nav-link.active {\n  border: 1px solid #0fa0cf;\n  background: #0fa0cf;\n  color: #ffffff;\n}\n\n.nav-pills-success .nav-item .nav-link {\n  border: 1px solid #6bd098;\n  color: #6bd098;\n}\n.nav-pills-success .nav-item .nav-link.active {\n  border: 1px solid #6bd098;\n  background: #6bd098;\n  color: #ffffff;\n}\n\n.nav-pills-warning .nav-item .nav-link {\n  border: 1px solid #fbc658;\n  color: #fbc658;\n}\n.nav-pills-warning .nav-item .nav-link.active {\n  border: 1px solid #fbc658;\n  background: #fbc658;\n  color: #ffffff;\n}\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link {\n  border-bottom-left-radius: 20px;\n  border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active {\n  background-color: #66615b !important;\n}\n\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active {\n  background-color: #51cbce !important;\n}\n\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active {\n  background-color: #0fa0cf !important;\n}\n\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active {\n  background-color: #fbc658 !important;\n}\n\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active {\n  background-color: #6bd098 !important;\n}\n\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active {\n  background-color: #ef8157 !important;\n}\n\n@media screen and (max-width: 991px) {\n  .navbar {\n    padding: 0;\n  }\n  .navbar.navbar-absolute {\n    padding-top: 0;\n  }\n  .navbar .navbar-brand {\n    font-size: 16px;\n    margin-right: 0;\n  }\n  .profile-photo .profile-photo-small {\n    margin-left: -2px;\n  }\n  .button-dropdown {\n    display: none;\n  }\n  #minimizeSidebar {\n    display: none;\n  }\n  .navbar .container-fluid {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n  .navbar .navbar-collapse .input-group {\n    margin: 0;\n    margin-top: 5px;\n  }\n  .navbar .navbar-nav .nav-item:first-child {\n    margin-top: 10px;\n  }\n  .navbar .navbar-nav .nav-item:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  .navbar .dropdown.show .dropdown-menu {\n    display: block !important;\n    transform: translate3d(0px, 0px, 0px) !important;\n  }\n  .navbar .dropdown .dropdown-menu {\n    display: none;\n  }\n  .navbar .dropdown.show .dropdown-menu,\n  .navbar .dropdown .dropdown-menu {\n    border: 0;\n    transition: none;\n    -webkit-box-shadow: none;\n    width: auto;\n    margin: 0px 1rem;\n    margin-top: 0px;\n    box-shadow: none;\n    position: static !important;\n    padding-left: 10px;\n  }\n  .navbar .dropdown.show .dropdown-menu:before,\n  .navbar .dropdown .dropdown-menu:before {\n    display: none;\n  }\n  .navbar .dropdown-menu .dropdown-item:focus,\n  .navbar .dropdown-menu .dropdown-item:hover {\n    color: #ffffff;\n  }\n  .navbar.bg-white .dropdown-menu .dropdown-item:focus,\n  .navbar.bg-white .dropdown-menu .dropdown-item:hover {\n    color: #66615b;\n  }\n  .navbar .navbar-toggler-bar {\n    display: block;\n    position: relative;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: #66615b;\n  }\n  .navbar .navbar-toggler-bar + .navbar-toggler-bar {\n    margin-top: 7px;\n  }\n  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {\n    margin-top: 3px;\n  }\n  .navbar .navbar-toggler-bar.bar2 {\n    width: 17px;\n    transition: width 0.2s linear;\n  }\n  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {\n    background-color: #66615b;\n  }\n  .navbar .toggled .navbar-toggler-bar {\n    width: 24px;\n  }\n  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {\n    margin-top: 5px;\n  }\n  .wrapper {\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  }\n  .nav-open .main-panel {\n    right: 0;\n    -webkit-transform: translate3d(260px, 0, 0);\n    -moz-transform: translate3d(260px, 0, 0);\n    -o-transform: translate3d(260px, 0, 0);\n    -ms-transform: translate3d(260px, 0, 0);\n    transform: translate3d(260px, 0, 0);\n  }\n  .nav-open .sidebar {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n  }\n  .nav-open body {\n    position: relative;\n    overflow-x: hidden;\n  }\n  .nav-open .menu-on-right .main-panel {\n    -webkit-transform: translate3d(-260px, 0, 0);\n    -moz-transform: translate3d(-260px, 0, 0);\n    -o-transform: translate3d(-260px, 0, 0);\n    -ms-transform: translate3d(-260px, 0, 0);\n    transform: translate3d(-260px, 0, 0);\n  }\n  .nav-open .menu-on-right .navbar-collapse,\n  .nav-open .menu-on-right .sidebar {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n  }\n  .nav-open .menu-on-right .navbar-translate {\n    -webkit-transform: translate3d(-300px, 0, 0);\n    -moz-transform: translate3d(-300px, 0, 0);\n    -o-transform: translate3d(-300px, 0, 0);\n    -ms-transform: translate3d(-300px, 0, 0);\n    transform: translate3d(-300px, 0, 0);\n  }\n  .nav-open .menu-on-right #bodyClick {\n    left: auto;\n  }\n  .menu-on-right .sidebar {\n    left: auto;\n    right: 0;\n    -webkit-transform: translate3d(260px, 0, 0);\n    -moz-transform: translate3d(260px, 0, 0);\n    -o-transform: translate3d(260px, 0, 0);\n    -ms-transform: translate3d(260px, 0, 0);\n    transform: translate3d(260px, 0, 0);\n  }\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    -webkit-animation: topbar-back 500ms linear 0s;\n    -moz-animation: topbar-back 500ms linear 0s;\n    animation: topbar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    -webkit-animation: bottombar-back 500ms linear 0s;\n    -moz-animation: bottombar-back 500ms linear 0s;\n    animation: bottombar-back 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar1 {\n    top: 6px;\n    -webkit-animation: topbar-x 500ms linear 0s;\n    -moz-animation: topbar-x 500ms linear 0s;\n    animation: topbar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 6px;\n    -webkit-animation: bottombar-x 500ms linear 0s;\n    -moz-animation: bottombar-x 500ms linear 0s;\n    animation: bottombar-x 500ms 0s;\n    -webkit-animation-fill-mode: forwards;\n    -moz-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n  }\n  @keyframes topbar-x {\n    0% {\n      top: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      transform: rotate(145deg);\n    }\n    75% {\n      transform: rotate(130deg);\n    }\n    100% {\n      transform: rotate(135deg);\n    }\n  }\n  @-webkit-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -webkit-transform: rotate(145deg);\n    }\n    75% {\n      -webkit-transform: rotate(130deg);\n    }\n    100% {\n      -webkit-transform: rotate(135deg);\n    }\n  }\n  @-moz-keyframes topbar-x {\n    0% {\n      top: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      top: 6px;\n      -moz-transform: rotate(145deg);\n    }\n    75% {\n      -moz-transform: rotate(130deg);\n    }\n    100% {\n      -moz-transform: rotate(135deg);\n    }\n  }\n  @keyframes topbar-back {\n    0% {\n      top: 6px;\n      transform: rotate(135deg);\n    }\n    45% {\n      transform: rotate(-10deg);\n    }\n    75% {\n      transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -webkit-transform: rotate(135deg);\n    }\n    45% {\n      -webkit-transform: rotate(-10deg);\n    }\n    75% {\n      -webkit-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes topbar-back {\n    0% {\n      top: 6px;\n      -moz-transform: rotate(135deg);\n    }\n    45% {\n      -moz-transform: rotate(-10deg);\n    }\n    75% {\n      -moz-transform: rotate(5deg);\n    }\n    100% {\n      top: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      transform: rotate(-145deg);\n    }\n    75% {\n      transform: rotate(-130deg);\n    }\n    100% {\n      transform: rotate(-135deg);\n    }\n  }\n  @-webkit-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -webkit-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -webkit-transform: rotate(-145deg);\n    }\n    75% {\n      -webkit-transform: rotate(-130deg);\n    }\n    100% {\n      -webkit-transform: rotate(-135deg);\n    }\n  }\n  @-moz-keyframes bottombar-x {\n    0% {\n      bottom: 0px;\n      -moz-transform: rotate(0deg);\n    }\n    45% {\n      bottom: 6px;\n      -moz-transform: rotate(-145deg);\n    }\n    75% {\n      -moz-transform: rotate(-130deg);\n    }\n    100% {\n      -moz-transform: rotate(-135deg);\n    }\n  }\n  @keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      transform: rotate(-135deg);\n    }\n    45% {\n      transform: rotate(10deg);\n    }\n    75% {\n      transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -webkit-transform: rotate(-135deg);\n    }\n    45% {\n      -webkit-transform: rotate(10deg);\n    }\n    75% {\n      -webkit-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -webkit-transform: rotate(0);\n    }\n  }\n  @-moz-keyframes bottombar-back {\n    0% {\n      bottom: 6px;\n      -moz-transform: rotate(-135deg);\n    }\n    45% {\n      -moz-transform: rotate(10deg);\n    }\n    75% {\n      -moz-transform: rotate(-5deg);\n    }\n    100% {\n      bottom: 0px;\n      -moz-transform: rotate(0);\n    }\n  }\n  @-webkit-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @-moz-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  }\n  .footer .copyright {\n    text-align: right;\n  }\n  .section-nucleo-icons .icons-container {\n    margin-top: 65px;\n  }\n  .navbar-nav .nav-link i.fa,\n  .navbar-nav .nav-link i.nc-icon {\n    opacity: 0.5;\n  }\n  .sidebar,\n  .bootstrap-navbar {\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100%;\n    width: 260px;\n    right: auto;\n    left: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n    -webkit-transform: translate3d(-260px, 0, 0);\n    -moz-transform: translate3d(-260px, 0, 0);\n    -o-transform: translate3d(-260px, 0, 0);\n    -ms-transform: translate3d(-260px, 0, 0);\n    transform: translate3d(-260px, 0, 0);\n  }\n  .main-panel {\n    width: 100%;\n  }\n  .timeline:before {\n    left: 5% !important;\n  }\n  .timeline > li > .timeline-badge {\n    left: 5% !important;\n  }\n  .timeline > li > .timeline-panel {\n    float: right !important;\n    width: 82% !important;\n  }\n  .timeline > li > .timeline-panel:before {\n    border-left-width: 0 !important;\n    border-right-width: 15px !important;\n    left: -15px !important;\n    right: auto !important;\n  }\n  .timeline > li > .timeline-panel:after {\n    border-left-width: 0 !important;\n    border-right-width: 14px !important;\n    left: -14px !important;\n    right: auto !important;\n  }\n  .fixed-plugin {\n    width: 54px;\n  }\n  .fixed-plugin .dropdown-menu {\n    max-width: 230px;\n    right: 80px;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .nav-tabs-navigation.verical-navs {\n    padding: 0px 2px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .footer .footer-nav {\n    padding-left: 21px;\n  }\n  .footer .credits {\n    padding-right: 15px;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .navbar-collapse {\n    background: none !important;\n  }\n  .navbar .navbar-toggle {\n    display: none;\n  }\n  .navbar-nav .nav-link.profile-photo {\n    padding: 0;\n    margin: 7px 0.7rem;\n  }\n  .section-nucleo-icons .icons-container {\n    margin: 0 0 0 auto;\n  }\n  .dropdown-menu .dropdown-item {\n    color: inherit;\n  }\n  .footer .copyright {\n    float: right;\n    padding-right: 15px;\n  }\n  .sidebar\n    .sidebar-wrapper\n    li\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li.active\n    a:before {\n    top: -2px;\n  }\n  .sidebar\n    .sidebar-wrapper\n    li\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li.active\n    a:after {\n    top: -1px;\n  }\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li:before,\n  .sidebar\n    .sidebar-wrapper\n    li.active\n    > [data-toggle=\"collapse\"]\n    + div\n    .nav\n    li:after {\n    display: none !important;\n  }\n  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):before {\n    border-right: 18px solid #dddddd;\n    border-top: 18px solid transparent;\n    border-bottom: 18px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: -15px;\n    opacity: 1;\n    top: 6px;\n    transition: opacity 150ms ease-in;\n  }\n  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=\"collapse\"]):after {\n    border-right: 17px solid #eef2f3;\n    border-top: 17px solid transparent;\n    border-bottom: 17px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: -15px;\n    opacity: 1;\n    top: 7px;\n    transition: opacity 150ms ease-in;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n  /* .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  } */\n  .footer nav {\n    display: block;\n    margin-bottom: 5px;\n    float: none;\n  }\n  .landing-page .section-story-overview .image-container:nth-child(2) {\n    margin-left: 0;\n    margin-bottom: 30px;\n  }\n  .card .form-horizontal .col-md-3.col-form-label {\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .typography-line {\n    padding-left: 23% !important;\n  }\n  .typography-line span {\n    width: 60px !important;\n  }\n  .login-page .navbar,\n  .lock-page .navbar,\n  .register-page .navbar {\n    padding: 0.5rem 1rem;\n  }\n  .footer .footer-nav,\n  .footer .credits {\n    margin: 0 auto !important;\n  }\n  .footer .footer-nav {\n    margin-bottom: 10px !important;\n  }\n  .register-page .content {\n    padding-top: 5vh;\n  }\n  .register-page .footer {\n    position: relative;\n  }\n  .register-page .info-area.info-horizontal {\n    margin-top: 0;\n  }\n}\n\n@media screen and (max-width: 413px) {\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {\n    width: 225px !important;\n  }\n  .fixed-plugin\n    .dropdown.show-dropdown.show\n    .dropdown-menu.show[x-placement=\"top-start\"] {\n    transform: translate3d(0, 400px, 0) !important;\n  }\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before,\n  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {\n    bottom: 360px !important;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .navbar[class*=\"navbar-toggleable-\"] .container {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .card-contributions .card-stats {\n    flex-direction: column;\n  }\n  .card-contributions .card-stats .bootstrap-switch {\n    margin-bottom: 15px;\n  }\n  .footer .copyright {\n    text-align: center;\n  }\n  .section-nucleo-icons .icons-container i {\n    font-size: 30px;\n  }\n  .section-nucleo-icons .icons-container i:nth-child(6) {\n    font-size: 48px;\n  }\n  .page-header .container h6.category-absolute {\n    width: 90%;\n  }\n  .card-timeline .timeline .timeline-panel {\n    width: 38%;\n    padding: 15px;\n  }\n}\n\n.wrapper {\n  position: relative;\n  top: 0;\n  height: 100vh;\n  overflow-x: hidden;\n}\n.wrapper.wrapper-full-page {\n  min-height: 100vh;\n  height: auto;\n}\n\n.sidebar,\n.off-canvas-sidebar {\n  position: fixed;\n  top: 0;\n  height: 100%;\n  bottom: 0;\n  width: 260px;\n  left: 0;\n  z-index: 999;\n}\n.sidebar .sidebar-wrapper,\n.off-canvas-sidebar .sidebar-wrapper {\n  position: relative;\n  height: calc(100vh - 75px);\n  overflow: auto;\n  width: 260px;\n  z-index: 4;\n  padding-bottom: 100px;\n}\n.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,\n.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {\n  display: none !important;\n}\n.sidebar .sidebar-wrapper .navbar-form,\n.off-canvas-sidebar .sidebar-wrapper .navbar-form {\n  border: none;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  span {\n  display: inline-block;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal {\n  margin: 0;\n  position: relative;\n  transform: translateX(0px);\n  opacity: 1;\n  white-space: nowrap;\n  display: block;\n  line-height: 20px;\n  z-index: 1;\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-mini-icon {\n  text-transform: uppercase;\n  width: 34px;\n  margin-right: 10px;\n  margin-left: 0px;\n  font-size: 12px;\n  text-align: center;\n  line-height: 20px;\n  position: relative;\n  float: left;\n  z-index: 1;\n  display: inherit;\n  color: rgba(255, 255, 255, 0.5);\n}\n.sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  .sidebar-normal {\n  text-transform: capitalize;\n}\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a i,\n.sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  > .nav\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i,\n.off-canvas-sidebar\n  .sidebar-wrapper\n  .user\n  .info\n  [data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a\n  i {\n  font-size: 17px;\n  line-height: 20px;\n  width: 26px;\n}\n.sidebar .navbar-minimize,\n.off-canvas-sidebar .navbar-minimize {\n  position: absolute;\n  right: 20px;\n  top: 2px;\n  opacity: 1;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n.sidebar .nav,\n.off-canvas-sidebar .nav {\n  margin-top: 20px;\n  display: block;\n}\n.sidebar .nav .caret,\n.off-canvas-sidebar .nav .caret {\n  top: 14px;\n  position: absolute;\n  right: 10px;\n}\n.sidebar .nav li > a + div .nav li > a,\n.off-canvas-sidebar .nav li > a + div .nav li > a {\n  margin-top: 7px;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n  margin: 10px 15px 0;\n  color: #ffffff;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  text-transform: uppercase;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 10px 8px;\n  line-height: 30px;\n  opacity: 0.7;\n}\n.sidebar .nav li .nav > li > a,\n.off-canvas-sidebar .nav li .nav > li > a {\n  padding: 5px 8px;\n}\n.sidebar .nav li.active > a,\n.sidebar .nav li.active > a > i,\n.off-canvas-sidebar .nav li.active > a,\n.off-canvas-sidebar .nav li.active > a > i {\n  opacity: 1;\n}\n.sidebar .nav li:hover:not(.active) > a,\n.sidebar .nav li:focus:not(.active) > a,\n.off-canvas-sidebar .nav li:hover:not(.active) > a,\n.off-canvas-sidebar .nav li:focus:not(.active) > a {\n  opacity: 1;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] >,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] > {\n  background-color: transparent;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #ef8157;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a,\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] i + div .nav .active a,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a {\n  background-color: transparent;\n  box-shadow: none;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav .active a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  i\n  + div\n  .nav\n  .active\n  a:after,\n.off-canvas-sidebar\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a\n  + div\n  .nav\n  .active\n  a:after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 5px);\n  z-index: 0;\n}\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav,\n.off-canvas-sidebar .nav li.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n  margin-top: 0;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n  margin: 0;\n  line-height: 30px;\n  position: relative;\n  display: block;\n  height: auto;\n  white-space: nowrap;\n  font-weight: 600;\n}\n.sidebar .nav i,\n.off-canvas-sidebar .nav i {\n  font-size: 24px;\n  float: left;\n  margin-right: 12px;\n  line-height: 30px;\n  width: 34px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  position: relative;\n}\n.sidebar .nav .collapse .nav,\n.sidebar .nav .collapsing .nav,\n.off-canvas-sidebar .nav .collapse .nav,\n.off-canvas-sidebar .nav .collapsing .nav {\n  margin-top: 0;\n}\n.sidebar .sidebar-background,\n.off-canvas-sidebar .sidebar-background {\n  position: absolute;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center center;\n}\n.sidebar .sidebar-background:after,\n.off-canvas-sidebar .sidebar-background:after {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  display: block;\n  background: #ffffff;\n  opacity: 1;\n}\n.sidebar .logo,\n.off-canvas-sidebar .logo {\n  position: relative;\n  padding: 7px 0.7rem;\n  z-index: 4;\n}\n.sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n  opacity: 0;\n  float: left;\n  width: 34px;\n  text-align: center;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.sidebar .logo a.logo-normal,\n.off-canvas-sidebar .logo a.logo-normal {\n  display: block;\n  opacity: 1;\n  padding: 11px 0 8px;\n  -webkit-transform: translate3d(0px, 0, 0);\n  -moz-transform: translate3d(0px, 0, 0);\n  -o-transform: translate3d(0px, 0, 0);\n  -ms-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.sidebar .logo:after,\n.off-canvas-sidebar .logo:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 15px;\n  height: 1px;\n  width: calc(100% - 30px);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.sidebar .logo p,\n.off-canvas-sidebar .logo p {\n  float: left;\n  font-size: 20px;\n  margin: 10px 10px;\n  color: #ffffff;\n  line-height: 20px;\n  font-family: \"Muli\", \"Helvetica\", Arial, sans-serif;\n}\n.sidebar .logo .simple-text,\n.off-canvas-sidebar .logo .simple-text {\n  text-transform: uppercase;\n  padding: 0.5rem 0;\n  display: block;\n  white-space: nowrap;\n  font-size: 1rem;\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 400;\n  line-height: 30px;\n  overflow: hidden;\n}\n.sidebar .logo-tim,\n.off-canvas-sidebar .logo-tim {\n  border-radius: 50%;\n  border: 1px solid #333;\n  display: block;\n  height: 61px;\n  width: 61px;\n  float: left;\n  overflow: hidden;\n}\n.sidebar .logo-tim img,\n.off-canvas-sidebar .logo-tim img {\n  width: 60px;\n  height: 60px;\n}\n.sidebar:before,\n.sidebar:after,\n.off-canvas-sidebar:before,\n.off-canvas-sidebar:after {\n  display: block;\n  content: \"\";\n  opacity: 1;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.sidebar:after,\n.off-canvas-sidebar:after {\n  /* background: #66615B;\n    background: -webkit-linear-gradient(#66615B 0%, #000 80%);\n    background: -o-linear-gradient(#66615B 0%, #000 80%);\n    background: -moz-linear-gradient(#66615B 0%, #000 80%);\n    background: linear-gradient(#66615B 0%, #000 80%); */\n  z-index: 3;\n}\n.sidebar[data-color=\"white\"]:after,\n.off-canvas-sidebar[data-color=\"white\"]:after {\n  background: #ffffff;\n}\n.sidebar[data-color=\"white\"] .nav li a,\n.sidebar[data-color=\"white\"] .nav li a i,\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  .sidebar-mini-icon,\n.sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a i,\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-color=\"white\"] .nav li a[data-toggle=\"collapse\"] i,\n.off-canvas-sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"]\n  .nav\n  li\n  a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li\n  > a {\n  color: #66615b;\n  opacity: 0.7;\n}\n.sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:hover:not(.active) > a,\n.off-canvas-sidebar[data-color=\"white\"] .nav li:focus:not(.active) > a {\n  opacity: 1;\n}\n.sidebar[data-color=\"white\"] .logo .simple-text,\n.off-canvas-sidebar[data-color=\"white\"] .logo .simple-text {\n  color: #66615b;\n}\n.sidebar[data-color=\"white\"] .logo:after,\n.off-canvas-sidebar[data-color=\"white\"] .logo:after {\n  background-color: #66615b;\n  opacity: 0.4;\n}\n.sidebar[data-color=\"white\"] .user .info a span,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.sidebar[data-color=\"white\"] .user .nav .sidebar-normal,\n.off-canvas-sidebar[data-color=\"white\"] .user .info a span,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-mini-icon,\n.off-canvas-sidebar[data-color=\"white\"] .user .nav .sidebar-normal {\n  color: #66615b !important;\n}\n.sidebar[data-color=\"white\"] .user:after,\n.off-canvas-sidebar[data-color=\"white\"] .user:after {\n  background-color: #66615b;\n  opacity: 0.4;\n}\n.sidebar[data-color=\"brown\"]:after,\n.off-canvas-sidebar[data-color=\"brown\"]:after {\n  background: #66615b;\n}\n.sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"primary\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"primary\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #51cbce;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"info\"] .nav li.active > a,\n.sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"info\"] .nav li.active > a[data-toggle=\"collapse\"] i,\n.sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"info\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"info\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #0fa0cf;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"success\"] .nav li.active > a,\n.sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"success\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"success\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #6bd098;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"warning\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"warning\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #fbc658;\n  opacity: 1;\n}\n.sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.sidebar[data-active-color=\"danger\"] .nav li.active > a[data-toggle=\"collapse\"],\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a,\n.off-canvas-sidebar[data-active-color=\"danger\"] .nav li.active > a i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"],\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  i,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  .sidebar-mini-icon,\n.off-canvas-sidebar[data-active-color=\"danger\"]\n  .nav\n  li.active\n  > a[data-toggle=\"collapse\"]\n  ~ div\n  > ul\n  > li.active\n  > a {\n  color: #ef8157;\n  opacity: 1;\n}\n.sidebar .user,\n.off-canvas-sidebar .user {\n  padding-bottom: 20px;\n  margin: 20px auto 0;\n  position: relative;\n}\n.sidebar .user:after,\n.off-canvas-sidebar .user:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 15px;\n  height: 1px;\n  width: calc(100% - 30px);\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.sidebar .user .photo,\n.off-canvas-sidebar .user .photo {\n  width: 34px;\n  height: 34px;\n  overflow: hidden;\n  float: left;\n  z-index: 5;\n  margin-right: 12px;\n  border-radius: 50%;\n  margin-left: 23px;\n}\n.sidebar .user .photo img,\n.off-canvas-sidebar .user .photo img {\n  width: 100%;\n}\n.sidebar .user a,\n.off-canvas-sidebar .user a {\n  color: #ffffff;\n  text-decoration: none;\n  padding: 0.5rem 15px;\n  white-space: nowrap;\n}\n.sidebar .user .info > a,\n.off-canvas-sidebar .user .info > a {\n  display: block;\n  line-height: 18px;\n}\n.sidebar .user .info > a > span,\n.off-canvas-sidebar .user .info > a > span {\n  display: block;\n  position: relative;\n  opacity: 1;\n}\n.sidebar .user .info .caret,\n.off-canvas-sidebar .user .info .caret {\n  position: absolute;\n  top: 8px;\n  right: 18px;\n}\n\n.visible-on-sidebar-regular {\n  display: inline-block !important;\n}\n\n.visible-on-sidebar-mini {\n  display: none !important;\n}\n\n.off-canvas-sidebar .nav > li > a,\n.off-canvas-sidebar .nav > li > a:hover {\n  color: #ffffff;\n}\n\n.off-canvas-sidebar .nav > li > a:focus {\n  background: rgba(200, 200, 200, 0.2);\n}\n\n.main-panel {\n  position: relative;\n  float: right;\n  background-color: #eef2f3;\n  -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n}\n.main-panel > .content {\n  padding: 0 30px 30px;\n  min-height: calc(100vh - 123px);\n\n  margin-top: 93px;\n}\n.main-panel > .map-content {\n  min-height: calc(100vh - 123px);\n  margin-top: 63px;\n}\n.main-panel > .navbar {\n  margin-bottom: 0;\n}\n.main-panel .header {\n  margin-bottom: 50px;\n}\n\n.perfect-scrollbar-on .sidebar,\n.perfect-scrollbar-on .main-panel {\n  height: 100%;\n  max-height: 100%;\n}\n\n@media (min-width: 991px) {\n  .sidebar,\n  .main-panel,\n  .sidebar-wrapper {\n    -webkit-transition-property: top, bottom, width;\n    transition-property: top, bottom, width;\n    -webkit-transition-duration: 0.2s, 0.2s, 0.35s;\n    transition-duration: 0.2s, 0.2s, 0.35s;\n    -webkit-transition-timing-function: linear, linear, ease;\n    transition-timing-function: linear, linear, ease;\n    -webkit-overflow-scrolling: touch;\n  }\n  .sidebar-mini .visible-on-sidebar-regular {\n    display: none !important;\n  }\n  .sidebar-mini .visible-on-sidebar-mini {\n    display: inline-block !important;\n  }\n  .sidebar-mini .sidebar,\n  .sidebar-mini .sidebar .sidebar-wrapper {\n    width: 80px;\n  }\n  .sidebar-mini .main-panel {\n    width: calc(100% - 80px);\n  }\n  .sidebar-mini .sidebar {\n    display: block;\n    z-index: 999;\n  }\n  .sidebar-mini .sidebar .logo a.logo-normal {\n    opacity: 0;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    -moz-transform: translate3d(-25px, 0, 0);\n    -o-transform: translate3d(-25px, 0, 0);\n    -ms-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n  .sidebar-mini .sidebar .logo a.logo-mini {\n    opacity: 1;\n  }\n  .sidebar-mini\n    .sidebar\n    .sidebar-wrapper\n    > .nav\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini\n    .sidebar\n    .sidebar-wrapper\n    .user\n    .info\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {\n    -webkit-transform: translate3d(-25px, 0, 0);\n    -moz-transform: translate3d(-25px, 0, 0);\n    -o-transform: translate3d(-25px, 0, 0);\n    -ms-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n    opacity: 0;\n  }\n  .sidebar-mini .sidebar:hover {\n    width: 260px;\n  }\n  .sidebar-mini .sidebar:hover .logo a.logo-normal {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n  .sidebar-mini .sidebar:hover .navbar-minimize {\n    opacity: 1;\n  }\n  .sidebar-mini .sidebar:hover .sidebar-wrapper {\n    width: 260px;\n  }\n  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,\n  .sidebar-mini\n    .sidebar:hover\n    .sidebar-wrapper\n    > .nav\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini\n    .sidebar:hover\n    .sidebar-wrapper\n    .user\n    .info\n    [data-toggle=\"collapse\"]\n    ~ div\n    > ul\n    > li\n    > a\n    .sidebar-normal,\n  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {\n    -webkit-transform: translate3d(0px, 0, 0);\n    -moz-transform: translate3d(0px, 0, 0);\n    -o-transform: translate3d(0px, 0, 0);\n    -ms-transform: translate3d(0px, 0, 0);\n    transform: translate3d(0px, 0, 0);\n    opacity: 1;\n  }\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141e30;\n  /* fallback for old browsers */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#0c2646),\n    color-stop(60%, #204065),\n    to(#2a5788)\n  );\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n}\n.panel-header .header .title {\n  color: #ffffff;\n}\n.panel-header .header .category {\n  max-width: 600px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0 auto;\n  font-size: 13px;\n}\n.panel-header .header .category a {\n  color: #ffffff;\n}\n\n.panel-header-sm {\n  height: 135px;\n}\n\n.panel-header-lg {\n  height: 380px;\n}\n\n.sidebar .logo .simple-text .logo-img {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 34px;\n  width: 34px;\n  background: #ffffff;\n  border-radius: 50%;\n  text-align: center;\n  overflow: hidden;\n}\n.sidebar .logo .simple-text .logo-img img {\n  width: 51%;\n  vertical-align: unset;\n  height: 51%;\n}\n\n.sidebar[data-color=\"white\"] {\n  border-right: 1px solid #ddd;\n}\n\n/*             Navigation Tabs                 */\n.nav-tabs-navigation {\n  text-align: center;\n  border-bottom: 1px solid #f1eae0;\n  margin-bottom: 30px;\n}\n.nav-tabs-navigation .nav > .nav-item > .nav-link {\n  padding-bottom: 20px;\n}\n\n.nav-tabs-wrapper {\n  display: inline-block;\n  margin-bottom: -6px;\n  position: relative;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.nav-tabs {\n  justify-content: center;\n  border-bottom: 0 none;\n  font-size: 14px;\n  font-weight: 400;\n}\n.nav-tabs .nav-item .nav-link {\n  border: 0 none;\n  color: #a49e93;\n  background-color: transparent;\n}\n.nav-tabs .nav-item .nav-link:hover {\n  color: #66615b;\n}\n.nav-tabs .nav-item .nav-link.active {\n  color: #66615b;\n}\n.nav-tabs .nav-item {\n  color: #66615b;\n  position: relative;\n}\n.nav-tabs .nav-item .nav-link.active,\n.nav-tabs .nav-item .nav-link.active:hover,\n.nav-tabs .nav-item .nav-link.active:focus {\n  background-color: transparent;\n  border: 0 none;\n}\n.nav-tabs .nav-item .nav-link.active:after,\n.nav-tabs .nav-item .nav-link.active:hover:after,\n.nav-tabs .nav-item .nav-link.active:focus:after {\n  border-bottom: 11px solid #ffffff;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 40%;\n  bottom: 5px;\n}\n.nav-tabs .nav-item .nav-link.active:before,\n.nav-tabs .nav-item .nav-link.active:hover:before,\n.nav-tabs .nav-item .nav-link.active:focus:before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 40%;\n  bottom: 6px;\n}\n.nav-tabs .nav-item.show .nav-link {\n  background-color: transparent;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -6px;\n  margin-left: -46px;\n  border-radius: 8px;\n}\n.nav-tabs .dropdown-menu .dropdown-item:hover,\n.nav-tabs .dropdown-menu .dropdown-item.active {\n  color: #ffffff;\n  background-color: #68b3c8;\n}\n.nav-tabs .dropdown-menu :before {\n  border-bottom: 11px solid #f1eae0;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -11px;\n}\n.nav-tabs .dropdown-menu :after {\n  border-bottom: 11px solid #fffcf5;\n  border-left: 11px solid rgba(0, 0, 0, 0);\n  border-right: 11px solid rgba(0, 0, 0, 0);\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: -10px;\n}\n\n.profile-content .tab-content .tab-pane {\n  min-height: 200px;\n}\n\n.profile-content .tab-content #tweets,\n.profile-content .tab-content #connections,\n.profile-content .tab-content #media {\n  height: 100%;\n}\n\n.nav-text,\n.nav-icons {\n  margin: 0 0 10px 0;\n}\n.nav-text > li > a,\n.nav-icons > li > a {\n  display: block;\n  padding: 0px 0.7rem;\n  color: #9a9a9a;\n  text-align: center;\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n}\n.nav-text > li > a:hover,\n.nav-text > li > a:focus,\n.nav-icons > li > a:hover,\n.nav-icons > li > a:focus {\n  background-color: transparent;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.nav-text > li:first-child a,\n.nav-icons > li:first-child a {\n  padding-left: 0;\n}\n.nav-text > li.active a,\n.nav-icons > li.active a {\n  color: #0fa0cf;\n}\n\n.nav-icons > li {\n  display: inline-block;\n}\n.nav-icons > li > a {\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n.nav-icons > li > a i {\n  font-size: 1.714em;\n  margin-bottom: 10px;\n  width: 1.714em;\n}\n\n.nav-icons.nav-stacked > li {\n  display: block;\n}\n.nav-icons.nav-stacked > li > a {\n  margin-bottom: 20px;\n}\n\n.nav-blue > li.active a {\n  color: #51cbce;\n}\n\n.nav-azure > li.active a {\n  color: #0fa0cf;\n}\n\n.nav-green > li.active a {\n  color: #6bd098;\n}\n\n.nav-orange > li.active a {\n  color: #fbc658;\n}\n\n.nav-red > li.active a {\n  color: #ef8157;\n}\n\n.nav-text {\n  margin: 0 0 10px 0;\n}\n.nav-text > li > a {\n  font-size: 1em;\n  text-transform: uppercase;\n  padding: 3px 0;\n  text-align: left;\n  font-weight: 600;\n}\n.nav-text > li:first-child > a {\n  padding-top: 0;\n}\n.nav-text h4 {\n  margin-top: 0;\n}\n\n.nav-text:not(.nav-stacked) > li {\n  display: inline-block;\n}\n\n.nav-text:not(.nav-stacked) > li > a {\n  margin-right: 15px;\n}\n\n.tab-space {\n  padding: 20px 0 50px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active:focus:before,\n.verical-navs .nav-stacked .nav-link.active.show:before {\n  border-right: 11px solid #f1eae0;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active:focus:after,\n.verical-navs .nav-stacked .nav-link.active.show:after {\n  border-right: 11px solid #ffffff;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: -1px;\n  bottom: 20px;\n}\n\n#second-tabs {\n  margin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n  border-right: 1px solid #f1eae0;\n  font-size: 16px;\n  border-bottom: none;\n}\n\n.card-timeline .timeline h6 i {\n  margin-right: 4px;\n}\n\n/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */\n/* Functional styling;\n* These styles are required for noUiSlider to function.\n* You don't need to change these rules to apply your design.\n*/\n/*\n\nThis file was modified by Creative-Tim\n\n*/\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n/* Wrapper for all connect elements.\n*/\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  transform-origin: 0 0;\n}\n\n/* Offset direction\n*/\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n\n/* Give origins 0 height/width so they don't interfere with clicking the\n* connect elements.\n*/\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n\n.noUi-handle {\n  position: absolute;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n\n/* Slider size and handle placement;\n*/\n.noUi-horizontal {\n  height: 8px;\n}\n\n.noUi-horizontal .noUi-handle {\n  background: #fff;\n  background: linear-gradient(180deg, #fff 0, #f1f1f2);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$white-color\",endColorstr=\"#f1f1f2\",GradientType=0);\n  border-radius: 50%;\n  box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);\n  height: 15px;\n  width: 15px;\n  cursor: pointer;\n  margin-left: -10px;\n  margin-top: -4px;\n}\n\n.noUi-vertical {\n  width: 8px;\n}\n\n.noUi-vertical .noUi-handle {\n  background: #fff;\n  background: linear-gradient(180deg, #fff 0, #f1f1f2);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$white-color\",endColorstr=\"#f1f1f2\",GradientType=0);\n  border-radius: 50%;\n  box-shadow: inset 0 1px 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  width: 15px;\n  height: 15px;\n  left: -4px;\n  top: -10px;\n}\n\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -5px;\n  left: auto;\n}\n\n/* Styling;\n* Giving the connect element a border radius causes issues with using transform: scale\n*/\n.noUi-target {\n  background-color: rgba(182, 182, 182, 0.3);\n  border-radius: 3px;\n}\n\n.noUi-connects {\n  border-radius: 3px;\n}\n\n.noUi-connect {\n  background: #888;\n  border-radius: 3px;\n  -webkit-transition: background 450ms;\n  transition: background 450ms;\n}\n\n/* Handles and cursors;\n*/\n.noUi-draggable {\n  cursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n\n.noUi-handle {\n  border-radius: 3px;\n  background: #fff;\n  cursor: default;\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\n  -webkit-transition: 300ms ease 0s;\n  -moz-transition: 300ms ease 0s;\n  -ms-transition: 300ms ease 0s;\n  -o-transform: 300ms ease 0s;\n  transition: 300ms ease 0s;\n}\n.noUi-handle:focus {\n  outline: none;\n}\n\n.noUi-active {\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;\n}\n\n/* Disabled state;\n*/\n[disabled] .noUi-connect {\n  background: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n\n/* Base;\n*\n*/\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n\n/* Values;\n*\n*/\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n\n/* Markings;\n*\n*/\n.noUi-marker {\n  position: absolute;\n  background: #ccc;\n}\n\n.noUi-marker-sub {\n  background: #aaa;\n}\n\n.noUi-marker-large {\n  background: #aaa;\n}\n\n/* Horizontal layout;\n*\n*/\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n\n/* Vertical layout;\n*\n*/\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%, 0);\n  padding-left: 25px;\n}\n\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.slider.slider-neutral .noUi-connect,\n.slider.slider-neutral.noUi-connect {\n  background-color: #ffffff;\n}\n\n.slider.slider-neutral.noUi-target {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.slider.slider-neutral .noUi-handle {\n  background-color: #ffffff;\n}\n\n.slider.slider-primary .noUi-connect,\n.slider.slider-primary.noUi-connect {\n  background-color: #51cbce;\n}\n\n.slider.slider-info .noUi-connect,\n.slider.slider-info.noUi-connect {\n  background-color: #0fa0cf;\n}\n\n.slider.slider-success .noUi-connect,\n.slider.slider-success.noUi-connect {\n  background-color: #6bd098;\n}\n\n.slider.slider-warning .noUi-connect,\n.slider.slider-warning.noUi-connect {\n  background-color: #fbc658;\n}\n\n.slider.slider-danger .noUi-connect,\n.slider.slider-danger.noUi-connect {\n  background-color: #ef8157;\n}\n\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: #333333;\n  opacity: 0.3;\n}\n\n.rbc-header {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: right;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 1em;\n  min-height: 0;\n  border-bottom: 1px solid #ddd;\n  color: #999999;\n}\n.rbc-header:last-child span {\n  padding-right: 15px;\n}\n\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n  min-height: 153px;\n}\n\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  font-family: inherit;\n  line-height: 1.5em;\n  color: inherit;\n  font-weight: 500;\n  margin: 0;\n  font-size: 2.5em;\n}\n\n.rbc-toolbar button {\n  background-color: #66615b;\n  color: #ffffff;\n  border-width: 2px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 5px 1px;\n  border: none;\n  margin: 10px 1px;\n  border-radius: 30px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n}\n.rbc-toolbar button:hover,\n.rbc-toolbar button:focus,\n.rbc-toolbar button:active,\n.rbc-toolbar button.active,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.active:focus,\n.rbc-toolbar button.active:hover,\n.show > .rbc-toolbar button.dropdown-toggle,\n.show > .rbc-toolbar button.dropdown-toggle:focus,\n.show > .rbc-toolbar button.dropdown-toggle:hover {\n  background-color: #403d39 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.rbc-toolbar button:not([data-action]):hover {\n  box-shadow: none;\n}\n.rbc-toolbar button.disabled,\n.rbc-toolbar button.disabled:hover,\n.rbc-toolbar button.disabled:focus,\n.rbc-toolbar button.disabled.focus,\n.rbc-toolbar button.disabled:active,\n.rbc-toolbar button.disabled.active,\n.rbc-toolbar button:disabled,\n.rbc-toolbar button:disabled:hover,\n.rbc-toolbar button:disabled:focus,\n.rbc-toolbar button:disabled.focus,\n.rbc-toolbar button:disabled:active,\n.rbc-toolbar button:disabled.active,\n.rbc-toolbar button[disabled],\n.rbc-toolbar button[disabled]:hover,\n.rbc-toolbar button[disabled]:focus,\n.rbc-toolbar button[disabled].focus,\n.rbc-toolbar button[disabled]:active,\n.rbc-toolbar button[disabled].active,\nfieldset[disabled] .rbc-toolbar button,\nfieldset[disabled] .rbc-toolbar button:hover,\nfieldset[disabled] .rbc-toolbar button:focus,\nfieldset[disabled] .rbc-toolbar button.focus,\nfieldset[disabled] .rbc-toolbar button:active,\nfieldset[disabled] .rbc-toolbar button.active {\n  background-color: #66615b;\n  border-color: #66615b;\n}\n.rbc-toolbar button.btn-simple {\n  color: #66615b;\n  border-color: #66615b;\n}\n.rbc-toolbar button.btn-simple:hover,\n.rbc-toolbar button.btn-simple:focus,\n.rbc-toolbar button.btn-simple:active {\n  background-color: transparent;\n  color: #403d39;\n  border-color: #403d39;\n  box-shadow: none;\n}\n.rbc-toolbar button.btn-link {\n  color: #66615b;\n}\n.rbc-toolbar button.btn-link:hover,\n.rbc-toolbar button.btn-link:focus,\n.rbc-toolbar button.btn-link:active,\n.rbc-toolbar button.btn-link:active:focus {\n  background-color: transparent;\n  color: #403d39;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.rbc-toolbar button:focus {\n  outline: none;\n}\n\n.rbc-btn-group {\n  display: inline-block;\n}\n\n.rbc-btn-group button {\n  margin: 0 0 0 2px;\n  border-radius: 30px;\n}\n\n@media screen and (max-width: 526px) {\n  .rbc-btn-group button {\n    margin: 2px !important;\n  }\n}\n\n.rbc-btn-group button + button {\n  margin: 0 0 0 2px;\n  border-radius: 30px;\n}\n\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 2px 6px 1px;\n}\n\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #ddd;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n  border-left: none;\n  border-right: none;\n}\n\n.rbc-month-view {\n  border-top: none;\n}\n\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #ddd;\n}\n\n.rbc-date-cell {\n  flex: 1 1;\n  min-width: 0;\n  padding-left: 5px;\n  text-align: left;\n}\n\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #ddd;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #ddd;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n\n.rbc-day-slot .rbc-event {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n  font-weight: bold;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot {\n  border-top: 1px dotted #ddd;\n}\n\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n\n.rbc-slot-selecting {\n  cursor: move;\n}\n\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #ddd;\n  min-height: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #ddd;\n}\n\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 0;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #ddd;\n  overflow-y: auto;\n  position: relative;\n}\n\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n\n.rbc-event {\n  width: 100%;\n  position: relative;\n  /* for resize handle and other inner positioning */\n  display: block;\n  /* make the <a> tag block */\n  font-size: 0.85em;\n  border-radius: 2px;\n  padding: 0;\n  background-color: rgba(81, 203, 206, 0.2);\n  /* default BACKGROUND color */\n  font-weight: normal;\n  /* undo jqui's ui-widget-header bold */\n  text-align: left;\n  border: none;\n  padding-bottom: 1px;\n  line-height: 1.2;\n}\n.rbc-event.event-azure {\n  background-color: rgba(81, 188, 218, 0.2);\n}\n.rbc-event.event-green {\n  background-color: rgba(107, 208, 152, 0.2);\n}\n.rbc-event.event-orange {\n  background-color: rgba(251, 198, 88, 0.2);\n}\n.rbc-event.event-red {\n  background-color: rgba(239, 129, 87, 0.2);\n}\n.rbc-event .rbc-event-content {\n  position: relative;\n  z-index: 2;\n  white-space: nowrap;\n  overflow: hidden;\n  color: inherit;\n  padding: 0 5px;\n}\n\n.rbc-day-slot .rbc-event {\n  display: block !important;\n  height: unset !important;\n  max-height: unset !important;\n}\n\n.rbc-today {\n  background-color: #f5f5f5;\n}\n\n@media screen and (max-width: 1373px) {\n  .rbc-toolbar {\n    display: block;\n  }\n  .rbc-toolbar .rbc-btn-group {\n    display: block;\n    text-align: center;\n  }\n  .rbc-toolbar .rbc-toolbar-label {\n    display: block;\n    flex-grow: unset;\n    padding: 0;\n  }\n}\n\n.sweet-alert:focus {\n  outline: none;\n}\n\n.sweet-alert {\n  margin: auto !important;\n}\n\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out 0.15s,\n    box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block !important;\n  height: 100%;\n  color: #fff;\n  padding: 6px 10px;\n  font-size: 11px;\n  text-indent: -5px;\n  line-height: 15px;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n.bootstrap-switch .bootstrap-switch-handle-on i,\n.bootstrap-switch .bootstrap-switch-handle-off i,\n.bootstrap-switch .bootstrap-switch-label i {\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: #66615b;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n  color: #fff;\n  background: #7a9e9f;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n  color: #fff;\n  background: #68b3c8;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n  color: #fff;\n  background: #7ac29a;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n  background: #f3bb45;\n  color: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n  color: #fff;\n  background: #eb5e28;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #fff;\n  background: #cfcfca;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #ffffff;\n  box-shadow: 0 1px 1px #ffffff inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type=\"radio\"],\n.bootstrap-switch input[type=\"checkbox\"] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n.bootstrap-switch input[type=\"radio\"].form-control,\n.bootstrap-switch input[type=\"checkbox\"].form-control {\n  height: auto;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n  background-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n  background-color: #cfcfca;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {\n  background-color: #eb5e28;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {\n  background-color: #f3bb45;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {\n  background-color: #7ac29a;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {\n  background-color: #7a9e9f;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {\n  background-color: #68b3c8;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {\n  background-color: #66615b;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n  background-color: #cfcfca;\n}\n\n.bootstrap-switch.wrapper {\n  min-height: auto;\n  height: auto;\n}\n\n.card-wizard {\n  min-height: 410px;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  opacity: 0;\n  -webkit-transition: all 300ms linear;\n  -moz-transition: all 300ms linear;\n  -o-transition: all 300ms linear;\n  -ms-transition: all 300ms linear;\n  transition: all 300ms linear;\n}\n.card-wizard[data-color=\"primary\"] .moving-tab {\n  color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .picture:hover {\n  border-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .choice:hover .icon,\n.card-wizard[data-color=\"primary\"] .choice.active .icon {\n  border-color: #51cbce;\n  color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #51cbce;\n}\n.card-wizard[data-color=\"primary\"]\n  .radio\n  input[type=\"radio\"]:checked\n  ~ .circle {\n  border-color: #51cbce;\n}\n.card-wizard[data-color=\"white\"] .moving-tab {\n  color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .picture:hover {\n  border-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .choice:hover .icon,\n.card-wizard[data-color=\"white\"] .choice.active .icon {\n  border-color: #ffffff;\n  color: #ffffff;\n}\n.card-wizard[data-color=\"white\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #ffffff;\n}\n.card-wizard[data-color=\"white\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #ffffff;\n}\n.card-wizard[data-color=\"green\"] .moving-tab {\n  color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .picture:hover {\n  border-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .choice:hover .icon,\n.card-wizard[data-color=\"green\"] .choice.active .icon {\n  border-color: #6bd098;\n  color: #6bd098;\n}\n.card-wizard[data-color=\"green\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #6bd098;\n}\n.card-wizard[data-color=\"green\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #6bd098;\n}\n.card-wizard[data-color=\"blue\"] .moving-tab {\n  color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .picture:hover {\n  border-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .choice:hover .icon,\n.card-wizard[data-color=\"blue\"] .choice.active .icon {\n  border-color: #0fa0cf;\n  color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #0fa0cf;\n}\n.card-wizard[data-color=\"blue\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #0fa0cf;\n}\n.card-wizard[data-color=\"orange\"] .moving-tab {\n  color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .picture:hover {\n  border-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .choice:hover .icon,\n.card-wizard[data-color=\"orange\"] .choice.active .icon {\n  border-color: #fbc658;\n  color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #fbc658;\n}\n.card-wizard[data-color=\"orange\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #fbc658;\n}\n.card-wizard[data-color=\"red\"] .moving-tab {\n  color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .picture:hover {\n  border-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .choice:hover .icon,\n.card-wizard[data-color=\"red\"] .choice.active .icon {\n  border-color: #ef8157;\n  color: #ef8157;\n}\n.card-wizard[data-color=\"red\"]\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + .checkbox-material\n  .check {\n  background-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .check {\n  background-color: #ef8157;\n}\n.card-wizard[data-color=\"red\"] .radio input[type=\"radio\"]:checked ~ .circle {\n  border-color: #ef8157;\n}\n.card-wizard.active {\n  opacity: 1;\n}\n.card-wizard .card-header {\n  padding: 15px 0 !important;\n  padding-bottom: 40px;\n  background-color: transparent;\n}\n.card-wizard .card-header .card-title {\n  color: #252422;\n}\n.card-wizard .card-header .card-title + .description {\n  color: #9a9a9a;\n}\n.card-wizard .nav-pills .nav-item .nav-link {\n  padding: 12px;\n}\n.card-wizard .nav-pills .nav-item .nav-link,\n.card-wizard .nav-pills .nav-item .nav-link.active,\n.card-wizard .nav-pills .nav-item .nav-link:hover,\n.card-wizard .nav-pills .nav-item .nav-link:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:focus,\n.card-wizard .nav-pills .nav-item .nav-link.active:hover {\n  background-color: transparent;\n  box-shadow: none;\n}\n.card-wizard .picture-container {\n  position: relative;\n  cursor: pointer;\n  text-align: center;\n}\n.card-wizard .wizard-navigation {\n  position: relative;\n}\n.card-wizard .wizard-navigation .nav-link {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.card-wizard .wizard-navigation .nav-link i,\n.card-wizard .moving-tab i {\n  display: inline-block;\n  font-size: 19px;\n  line-height: initial;\n  margin-right: 6px;\n  padding: 0;\n  vertical-align: bottom;\n}\n.card-wizard .moving-tab i {\n  margin-right: 9px;\n}\n.card-wizard .picture {\n  width: 106px;\n  height: 106px;\n  background-color: #999999;\n  border: 1px solid #e3e3e3;\n  color: #ffffff;\n  border-radius: 50%;\n  margin: 5px auto;\n  overflow: hidden;\n  transition: all 0.2s;\n  -webkit-transition: all 0.2s;\n}\n.card-wizard .picture:hover {\n  border-color: #2ca8ff;\n}\n.card-wizard .moving-tab {\n  position: absolute;\n  text-align: center;\n  padding: 12px;\n  font-size: 12px;\n  text-transform: uppercase;\n  -webkit-font-smoothing: subpixel-antialiased;\n  top: 0px;\n  left: 0px;\n  background-color: #66615b;\n  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n  color: #ffffff !important;\n  cursor: pointer;\n  font-weight: 500;\n}\n.card-wizard .picture input[type=\"file\"] {\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  opacity: 0 !important;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.card-wizard .picture-src {\n  width: 100%;\n}\n.card-wizard .tab-content {\n  min-height: 355px;\n  padding: 20px 0;\n}\n.card-wizard .wizard-footer {\n  padding: 0 15px;\n}\n.card-wizard .wizard-footer .checkbox {\n  margin-top: 16px;\n}\n.card-wizard .disabled {\n  display: none;\n}\n.card-wizard .wizard-header {\n  text-align: center;\n  padding: 25px 0 35px;\n}\n.card-wizard .wizard-header h5 {\n  margin: 5px 0 0;\n}\n.card-wizard .nav-pills > li {\n  text-align: center;\n}\n.card-wizard .btn {\n  text-transform: uppercase;\n}\n.card-wizard .info-text {\n  text-align: center;\n  font-weight: 300;\n  margin: 10px 0 30px;\n}\n.card-wizard .choice {\n  text-align: center;\n  cursor: pointer;\n  margin-top: 20px;\n}\n.card-wizard .choice[disabled] {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.card-wizard .choice .icon {\n  text-align: center;\n  vertical-align: middle;\n  height: 116px;\n  width: 116px;\n  border-radius: 50%;\n  color: #66615b;\n  margin: 0 auto 20px;\n  border: 1px solid #e3e3e3;\n  transition: all 0.2s;\n  -webkit-transition: all 0.2s;\n}\n.card-wizard .choice i {\n  font-size: 30px;\n  line-height: 116px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.card-wizard .choice:hover .icon,\n.card-wizard .choice.active .icon {\n  border-color: #2ca8ff;\n}\n.card-wizard .choice input[type=\"radio\"],\n.card-wizard .choice input[type=\"checkbox\"] {\n  position: absolute;\n  left: -10000px;\n  z-index: -1;\n}\n.card-wizard .btn-finish {\n  display: none;\n}\n.card-wizard .card-title + .description {\n  font-size: 17px;\n  margin-bottom: 32px;\n}\n.card-wizard .wizard-title {\n  margin: 0;\n}\n.card-wizard .nav-pills {\n  background-color: #9a9a9a;\n}\n.card-wizard .nav-pills > li + li {\n  margin-left: 0;\n}\n.card-wizard .nav-pills > li > a {\n  border: 0 !important;\n  border-radius: 0;\n  line-height: 18px;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 100px;\n  text-align: center;\n  color: #ffffff !important;\n}\n.card-wizard .nav-pills > li.active > a,\n.card-wizard .nav-pills > li.active > a:hover,\n.card-wizard .nav-pills > li.active > a:focus,\n.card-wizard .nav-pills > li > a:hover,\n.card-wizard .nav-pills > li > a:focus {\n  background-color: inherit;\n  box-shadow: none;\n}\n.card-wizard .nav-pills > li i {\n  display: block;\n  font-size: 30px;\n  padding: 15px 0;\n}\n.card-wizard .form-group.select-wizard {\n  margin-top: 15px;\n}\n.card-wizard .dropdown.show .dropdown-menu,\n.card-wizard .dropup.show .dropdown-menu {\n  -webkit-transform: translate3d(0, 0px, 0) !important;\n  -moz-transform: translate3d(0, 0px, 0) !important;\n  -o-transform: translate3d(0, 0px, 0) !important;\n  -ms-transform: translate3d(0, 0px, 0) !important;\n  transform: translate3d(0, 0px, 0) !important;\n}\n\n/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n}\n.rdt .rdtPicker {\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n  margin-top: -20px;\n  visibility: hidden;\n  display: block;\n  opacity: 0;\n}\n.rdt.rdtOpen .rdtPicker {\n  opacity: 1;\n  visibility: visible;\n  margin-top: 0;\n}\n\n.rdtPicker {\n  display: none;\n  position: absolute;\n  width: 260px;\n  padding: 4px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.125rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n}\n.rdtPicker:before {\n  display: inline-block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  content: \"\";\n  top: -5px;\n  left: 10px;\n  right: auto;\n  color: #ffffff;\n  border-bottom: 0.4em solid;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n}\n.rdtPicker:after {\n  border-bottom: 0.4em solid #ffffff;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: -5px;\n  left: 10px;\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: #ffffff !important;\n}\n\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n\n.rdtPicker td {\n  cursor: pointer;\n}\n\n.rdtDay {\n  height: 30px;\n  line-height: 33px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n}\n.rdtDay.rdtToday.rdtActive,\n.rdtDay.rdtActive,\n.rdtDay.rdtActive:hover {\n  background-color: #51cbce !important;\n  color: #ffffff;\n}\n\n.rdtDays tr .dow {\n  text-align: center;\n  border-bottom: 1px solid #e3e3e3;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: inherit;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n\n.rdtDays tr .rdtOld,\n.rdtDays tr .rdtNew {\n  color: #dddddd;\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n  background: #eeeeee;\n  cursor: pointer;\n}\n\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n}\n\n.rdtPicker th.rdtSwitch {\n  width: 50px;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 21px;\n  vertical-align: top;\n  border-radius: 50%;\n  line-height: 33px;\n}\n\n.rdtPicker .dow,\n.rdtPicker th.rdtSwitch,\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev,\n.rdtPicker .rdtTimeToggle {\n  color: #51cbce;\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Chrome/Safari/Opera */\n  -khtml-user-select: none;\n  /* Konqueror */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\n\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters > div {\n  float: left;\n  width: 40px;\n  font-weight: inherit;\n  margin: 3px;\n  border-radius: 50%;\n}\n\n.rdtCounters .rdtCounterSeparator {\n  width: 0;\n  border: 1px solid transparent;\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n}\n.rdtCounter .rdtCount {\n  padding: 7px;\n  height: 40px;\n  border: 1px solid transparent;\n}\n\n.rdtCounters .rdtCounter:last-child .rdtCount {\n  color: #51cbce;\n  border-radius: 50%;\n  border: 1px solid #51cbce;\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: #dddddd;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Chrome/Safari/Opera */\n  -khtml-user-select: none;\n  /* Konqueror */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n}\n.rdtMonths .rdtMonth,\n.rdtMonths .rdtYear,\n.rdtYears .rdtMonth,\n.rdtYears .rdtYear {\n  display: inline-block;\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  margin: 3px 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n.rdtMonths .rdtMonth.rdtActive,\n.rdtMonths .rdtYear.rdtActive,\n.rdtYears .rdtMonth.rdtActive,\n.rdtYears .rdtYear.rdtActive {\n  background-color: #51cbce !important;\n  color: #ffffff;\n}\n\nsvg {\n  touch-action: none;\n}\n\n.jvectormap-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  touch-action: none;\n}\n\n.jvectormap-tip {\n  position: absolute;\n  display: none;\n  border: solid 1px #cdcdcd;\n  border-radius: 3px;\n  background: #292929;\n  color: white;\n  font-family: sans-serif, Verdana;\n  font-size: smaller;\n  padding: 3px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n  position: absolute;\n  left: 10px;\n  border-radius: 3px;\n  background: #292929;\n  padding: 3px;\n  color: white;\n  cursor: pointer;\n  line-height: 10px;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 10px;\n  height: 10px;\n}\n\n.jvectormap-zoomin {\n  top: 10px;\n}\n\n.jvectormap-zoomout {\n  top: 30px;\n}\n\n.jvectormap-goback {\n  bottom: 10px;\n  z-index: 1000;\n  padding: 6px;\n}\n\n.jvectormap-spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: center no-repeat\n    url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n  font-weight: bold;\n  font-size: 14px;\n  text-align: center;\n}\n\n.jvectormap-legend-cnt {\n  position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n  bottom: 0;\n  right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n  top: 0;\n  right: 0;\n}\n\n.jvectormap-legend {\n  background: black;\n  color: white;\n  border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n  float: left;\n  margin: 0 10px 10px 0;\n  padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n  float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n  margin: 10px 10px 0 0;\n  padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n  width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n  font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n  text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 20px;\n  padding-left: 3px;\n}\n\n/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n.react-select .react-select__menu {\n  top: 105%;\n  max-width: 94%;\n  width: 94%;\n  right: 3%;\n  border-radius: 12px;\n  border: 0;\n  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n    opacity 0.3s ease 0s, height 0s linear 0.35s;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  max-height: 200px;\n  position: absolute;\n  z-index: 2;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 10px;\n  margin-bottom: unset;\n  margin-top: unset;\n}\n.react-select .react-select__menu:before {\n  border-bottom: 11px solid #f1eae0;\n  top: -11px;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n}\n.react-select .react-select__menu:after {\n  top: -10px;\n  border-bottom: 11px solid #fffcf5;\n  border-left: 11px solid transparent;\n  border-right: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n}\n\n.react-select .react-select__menu-list {\n  max-height: 198px;\n  overflow-y: auto;\n  padding-bottom: unset;\n  padding-top: unset;\n  position: relative;\n}\n\n.react-select .react-select__option {\n  font-size: 0.8571em;\n  padding-top: 0.6rem;\n  padding-bottom: 0.6rem;\n  margin-top: 5px;\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  display: block;\n  outline: none;\n  color: #292b2c;\n}\n\n.react-select .react-select__menu .react-select__option,\n.react-select .react-select__menu .react-select__option:active {\n  background-color: transparent;\n}\n\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-selected,\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-selected:active,\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-selected.react-select__option--is-focused,\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {\n  background-color: #dddddd;\n}\n\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-focused,\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-focused:active {\n  background-color: #f5f5f5;\n}\n\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-disabled,\n.react-select\n  .react-select__menu\n  .react-select__option.react-select__option--is-disabled:active {\n  color: #cccccc;\n  cursor: default;\n}\n\n.react-select .react-select__control {\n  border-radius: 4px;\n  min-height: 40px;\n  height: 40px;\n  box-sizing: border-box;\n  border-collapse: separate;\n  display: table;\n  width: 100%;\n}\n.react-select .react-select__control,\n.react-select .react-select__control:hover {\n  border: 1px solid #e3e3e3;\n  box-shadow: none;\n  background-color: transparent;\n}\n.react-select\n  .react-select__control.react-select__control--is-focused\n  .react-select__dropdown-indicator:after {\n  transform: rotate(180deg);\n  top: -4px;\n}\n.react-select .react-select__control.react-select__control--is-focused,\n.react-select .react-select__control.react-select__control--is-focused:hover {\n  border: 1px solid #51cbce;\n  box-shadow: none;\n}\n.react-select\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value {\n  display: inline-flex;\n  border-radius: 4px;\n  background-color: transparent;\n}\n.react-select\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value\n  + div:not(.react-select__multi-value) {\n  display: inline-flex;\n}\n.react-select\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value\n  .react-select__multi-value__label {\n  font-size: 0.9em;\n}\n.react-select\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value {\n  top: 48%;\n  color: #2c2c2c;\n}\n.react-select .react-select__control .react-select__placeholder {\n  color: #9a9a9a;\n  line-height: normal;\n  font-size: 0.8571em;\n  top: 48%;\n}\n.react-select .react-select__control .react-select__value-container,\n.react-select .react-select__control .react-select__indicators {\n  display: table-cell;\n}\n.react-select .react-select__control .react-select__indicators {\n  width: 60px;\n  padding-right: 10px;\n  align-items: flex-end;\n  vertical-align: middle;\n  text-align: right;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__indicator-separator {\n  display: none;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__indicator {\n  padding: 0;\n  display: inline-block;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__dropdown-indicator:after {\n  transition: all 150ms ease 0s;\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n  position: relative;\n  content: \"\";\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__dropdown-indicator:hover:after {\n  border-top-color: #666666;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__dropdown-indicator\n  > * {\n  display: none;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__clear-indicator:before {\n  content: \"\\D7\";\n  display: inline-block;\n  font-size: 18px;\n  line-height: 1;\n  top: 2px;\n  position: relative;\n  margin-right: 3px;\n}\n.react-select\n  .react-select__control\n  .react-select__indicators\n  .react-select__clear-indicator\n  > * {\n  display: none;\n}\n\n.react-select.primary .react-select__control.react-select__control--is-focused,\n.react-select.primary\n  .react-select__control.react-select__control--is-focused:hover {\n  border-color: #51cbce;\n}\n\n.react-select.primary\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value,\n.react-select.primary\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value__label {\n  color: #51cbce;\n}\n\n.react-select.primary .react-select__multi-value {\n  border: 1px solid #51cbce;\n}\n.react-select.primary\n  .react-select__multi-value\n  .react-select__multi-value__remove {\n  color: rgba(249, 99, 50, 0.3);\n  border-left: 1px solid rgba(249, 99, 50, 0.3);\n}\n.react-select.primary\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #51cbce;\n  background-color: transparent;\n}\n\n.react-select.success .react-select__control.react-select__control--is-focused,\n.react-select.success\n  .react-select__control.react-select__control--is-focused:hover {\n  border-color: #6bd098;\n}\n\n.react-select.success\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value,\n.react-select.success\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value__label {\n  color: #6bd098;\n}\n\n.react-select.success .react-select__multi-value {\n  border: 1px solid #6bd098;\n}\n.react-select.success\n  .react-select__multi-value\n  .react-select__multi-value__remove {\n  color: rgba(24, 206, 15, 0.3);\n  border-left: 1px solid rgba(24, 206, 15, 0.3);\n}\n.react-select.success\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #6bd098;\n  background-color: transparent;\n}\n\n.react-select.info .react-select__control.react-select__control--is-focused,\n.react-select.info\n  .react-select__control.react-select__control--is-focused:hover {\n  border-color: #0fa0cf;\n}\n\n.react-select.info\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value,\n.react-select.info\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value__label {\n  color: #0fa0cf;\n}\n\n.react-select.info .react-select__multi-value {\n  border: 1px solid #0fa0cf;\n}\n.react-select.info\n  .react-select__multi-value\n  .react-select__multi-value__remove {\n  color: rgba(44, 168, 255, 0.3);\n  border-left: 1px solid rgba(44, 168, 255, 0.3);\n}\n.react-select.info\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #0fa0cf;\n  background-color: transparent;\n}\n\n.react-select.warning .react-select__control.react-select__control--is-focused,\n.react-select.warning\n  .react-select__control.react-select__control--is-focused:hover {\n  border-color: #fbc658;\n}\n\n.react-select.warning\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value,\n.react-select.warning\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value__label {\n  color: #fbc658;\n}\n\n.react-select.warning .react-select__multi-value {\n  border: 1px solid #fbc658;\n}\n.react-select.warning\n  .react-select__multi-value\n  .react-select__multi-value__remove {\n  color: rgba(255, 178, 54, 0.3);\n  border-left: 1px solid rgba(255, 178, 54, 0.3);\n}\n.react-select.warning\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #fbc658;\n  background-color: transparent;\n}\n\n.react-select.danger .react-select__control.react-select__control--is-focused,\n.react-select.danger\n  .react-select__control.react-select__control--is-focused:hover {\n  border-color: #ef8157;\n}\n\n.react-select.danger\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__single-value,\n.react-select.danger\n  .react-select__control\n  .react-select__value-container--has-value\n  .react-select__multi-value__label {\n  color: #ef8157;\n}\n\n.react-select.danger .react-select__multi-value {\n  border: 1px solid #ef8157;\n}\n.react-select.danger\n  .react-select__multi-value\n  .react-select__multi-value__remove {\n  color: rgba(255, 54, 54, 0.3);\n  border-left: 1px solid rgba(255, 54, 54, 0.3);\n}\n.react-select.danger\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #ef8157;\n  background-color: transparent;\n}\n\n.react-select .react-select__multi-value {\n  border: 1px solid #9a9a9a;\n}\n.react-select .react-select__multi-value .react-select__multi-value__remove {\n  position: relative;\n  color: rgba(222, 222, 222, 0.8);\n  border-left: 1px solid rgba(222, 222, 222, 0.8);\n}\n.react-select\n  .react-select__multi-value\n  .react-select__multi-value__remove:hover {\n  color: #9a9a9a;\n  background-color: transparent;\n}\n\n.react-select.react-select--is-disabled\n  .react-select__multi-value--is-disabled\n  .react-select__multi-value__remove {\n  display: none;\n}\n\n.react-select.react-select--is-disabled\n  .react-select__multi-value--is-disabled.react-select__multi-value {\n  background-color: #fcfcfc;\n  border: 1px solid #e3e3e3;\n}\n\n.react-select.react-select--is-disabled .react-select__control--is-disabled {\n  background-color: #f9f9f9;\n}\n\n.ReactTable {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: transparent;\n}\n.ReactTable.primary-pagination .-pagination .-btn {\n  background-color: #51cbce;\n  color: #ffffff;\n}\n.ReactTable.primary-pagination .-pagination .-btn:hover,\n.ReactTable.primary-pagination .-pagination .-btn:focus,\n.ReactTable.primary-pagination .-pagination .-btn:active,\n.ReactTable.primary-pagination .-pagination .-btn.active,\n.ReactTable.primary-pagination .-pagination .-btn:active:focus,\n.ReactTable.primary-pagination .-pagination .-btn:active:hover,\n.ReactTable.primary-pagination .-pagination .-btn.active:focus,\n.ReactTable.primary-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n  > .ReactTable.primary-pagination\n  .-pagination\n  .-btn.dropdown-toggle:hover {\n  background-color: #34b5b8 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.ReactTable.primary-pagination .-pagination .-btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn.disabled,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.primary-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.primary-pagination .-pagination .-btn.disabled:active,\n.ReactTable.primary-pagination .-pagination .-btn.disabled.active,\n.ReactTable.primary-pagination .-pagination .-btn:disabled,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.primary-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.primary-pagination .-pagination .-btn:disabled:active,\n.ReactTable.primary-pagination .-pagination .-btn:disabled.active,\n.ReactTable.primary-pagination .-pagination .-btn[disabled],\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.primary-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.primary-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.primary-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.active {\n  background-color: #51cbce;\n  border-color: #51cbce;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple {\n  color: #51cbce;\n  border-color: #51cbce;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.primary-pagination .-pagination .-btn.btn-simple:active {\n  background-color: transparent;\n  color: #34b5b8;\n  border-color: #34b5b8;\n  box-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-link {\n  color: #51cbce;\n}\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.primary-pagination .-pagination .-btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #34b5b8;\n  text-decoration: none;\n  box-shadow: none;\n}\n.ReactTable.primary-pagination .-pagination .-btn:disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.ReactTable.info-pagination .-pagination .-btn {\n  background-color: #0fa0cf;\n  color: #ffffff;\n}\n.ReactTable.info-pagination .-pagination .-btn:hover,\n.ReactTable.info-pagination .-pagination .-btn:focus,\n.ReactTable.info-pagination .-pagination .-btn:active,\n.ReactTable.info-pagination .-pagination .-btn.active,\n.ReactTable.info-pagination .-pagination .-btn:active:focus,\n.ReactTable.info-pagination .-pagination .-btn:active:hover,\n.ReactTable.info-pagination .-pagination .-btn.active:focus,\n.ReactTable.info-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:hover {\n  background-color: #2ba9cd !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.ReactTable.info-pagination .-pagination .-btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn.disabled,\n.ReactTable.info-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.info-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.info-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.info-pagination .-pagination .-btn.disabled:active,\n.ReactTable.info-pagination .-pagination .-btn.disabled.active,\n.ReactTable.info-pagination .-pagination .-btn:disabled,\n.ReactTable.info-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.info-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.info-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.info-pagination .-pagination .-btn:disabled:active,\n.ReactTable.info-pagination .-pagination .-btn:disabled.active,\n.ReactTable.info-pagination .-pagination .-btn[disabled],\n.ReactTable.info-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.info-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.info-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.info-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.info-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.active {\n  background-color: #0fa0cf;\n  border-color: #0fa0cf;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-simple {\n  color: #0fa0cf;\n  border-color: #0fa0cf;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.info-pagination .-pagination .-btn.btn-simple:active {\n  background-color: transparent;\n  color: #2ba9cd;\n  border-color: #2ba9cd;\n  box-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-link {\n  color: #0fa0cf;\n}\n.ReactTable.info-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.info-pagination .-pagination .-btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #2ba9cd;\n  text-decoration: none;\n  box-shadow: none;\n}\n.ReactTable.info-pagination .-pagination .-btn:disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.ReactTable.success-pagination .-pagination .-btn {\n  background-color: #6bd098;\n  color: #ffffff;\n}\n.ReactTable.success-pagination .-pagination .-btn:hover,\n.ReactTable.success-pagination .-pagination .-btn:focus,\n.ReactTable.success-pagination .-pagination .-btn:active,\n.ReactTable.success-pagination .-pagination .-btn.active,\n.ReactTable.success-pagination .-pagination .-btn:active:focus,\n.ReactTable.success-pagination .-pagination .-btn:active:hover,\n.ReactTable.success-pagination .-pagination .-btn.active:focus,\n.ReactTable.success-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n  > .ReactTable.success-pagination\n  .-pagination\n  .-btn.dropdown-toggle:hover {\n  background-color: #44c47d !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.ReactTable.success-pagination .-pagination .-btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn.disabled,\n.ReactTable.success-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.success-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.success-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.success-pagination .-pagination .-btn.disabled:active,\n.ReactTable.success-pagination .-pagination .-btn.disabled.active,\n.ReactTable.success-pagination .-pagination .-btn:disabled,\n.ReactTable.success-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.success-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.success-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.success-pagination .-pagination .-btn:disabled:active,\n.ReactTable.success-pagination .-pagination .-btn:disabled.active,\n.ReactTable.success-pagination .-pagination .-btn[disabled],\n.ReactTable.success-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.success-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.success-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.success-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.success-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.active {\n  background-color: #6bd098;\n  border-color: #6bd098;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-simple {\n  color: #6bd098;\n  border-color: #6bd098;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.success-pagination .-pagination .-btn.btn-simple:active {\n  background-color: transparent;\n  color: #44c47d;\n  border-color: #44c47d;\n  box-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-link {\n  color: #6bd098;\n}\n.ReactTable.success-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.success-pagination .-pagination .-btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #44c47d;\n  text-decoration: none;\n  box-shadow: none;\n}\n.ReactTable.success-pagination .-pagination .-btn:disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.ReactTable.warning-pagination .-pagination .-btn {\n  background-color: #fbc658;\n  color: #ffffff;\n}\n.ReactTable.warning-pagination .-pagination .-btn:hover,\n.ReactTable.warning-pagination .-pagination .-btn:focus,\n.ReactTable.warning-pagination .-pagination .-btn:active,\n.ReactTable.warning-pagination .-pagination .-btn.active,\n.ReactTable.warning-pagination .-pagination .-btn:active:focus,\n.ReactTable.warning-pagination .-pagination .-btn:active:hover,\n.ReactTable.warning-pagination .-pagination .-btn.active:focus,\n.ReactTable.warning-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show\n  > .ReactTable.warning-pagination\n  .-pagination\n  .-btn.dropdown-toggle:hover {\n  background-color: #fab526 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.ReactTable.warning-pagination .-pagination .-btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn.disabled,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.warning-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.warning-pagination .-pagination .-btn.disabled:active,\n.ReactTable.warning-pagination .-pagination .-btn.disabled.active,\n.ReactTable.warning-pagination .-pagination .-btn:disabled,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.warning-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.warning-pagination .-pagination .-btn:disabled:active,\n.ReactTable.warning-pagination .-pagination .-btn:disabled.active,\n.ReactTable.warning-pagination .-pagination .-btn[disabled],\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.warning-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.warning-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.warning-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.active {\n  background-color: #fbc658;\n  border-color: #fbc658;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple {\n  color: #fbc658;\n  border-color: #fbc658;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.warning-pagination .-pagination .-btn.btn-simple:active {\n  background-color: transparent;\n  color: #fab526;\n  border-color: #fab526;\n  box-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-link {\n  color: #fbc658;\n}\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.warning-pagination .-pagination .-btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #fab526;\n  text-decoration: none;\n  box-shadow: none;\n}\n.ReactTable.warning-pagination .-pagination .-btn:disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.ReactTable.danger-pagination .-pagination .-btn {\n  background-color: #ef8157;\n  color: #ffffff;\n}\n.ReactTable.danger-pagination .-pagination .-btn:hover,\n.ReactTable.danger-pagination .-pagination .-btn:focus,\n.ReactTable.danger-pagination .-pagination .-btn:active,\n.ReactTable.danger-pagination .-pagination .-btn.active,\n.ReactTable.danger-pagination .-pagination .-btn:active:focus,\n.ReactTable.danger-pagination .-pagination .-btn:active:hover,\n.ReactTable.danger-pagination .-pagination .-btn.active:focus,\n.ReactTable.danger-pagination .-pagination .-btn.active:hover,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:focus,\n.show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:hover {\n  background-color: #eb6532 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n.ReactTable.danger-pagination .-pagination .-btn:not([data-action]):hover {\n  box-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn.disabled,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:hover,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:focus,\n.ReactTable.danger-pagination .-pagination .-btn.disabled.focus,\n.ReactTable.danger-pagination .-pagination .-btn.disabled:active,\n.ReactTable.danger-pagination .-pagination .-btn.disabled.active,\n.ReactTable.danger-pagination .-pagination .-btn:disabled,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:hover,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:focus,\n.ReactTable.danger-pagination .-pagination .-btn:disabled.focus,\n.ReactTable.danger-pagination .-pagination .-btn:disabled:active,\n.ReactTable.danger-pagination .-pagination .-btn:disabled.active,\n.ReactTable.danger-pagination .-pagination .-btn[disabled],\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:hover,\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:focus,\n.ReactTable.danger-pagination .-pagination .-btn[disabled].focus,\n.ReactTable.danger-pagination .-pagination .-btn[disabled]:active,\n.ReactTable.danger-pagination .-pagination .-btn[disabled].active,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:hover,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:focus,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.focus,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:active,\nfieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.active {\n  background-color: #ef8157;\n  border-color: #ef8157;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple {\n  color: #ef8157;\n  border-color: #ef8157;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:hover,\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:focus,\n.ReactTable.danger-pagination .-pagination .-btn.btn-simple:active {\n  background-color: transparent;\n  color: #eb6532;\n  border-color: #eb6532;\n  box-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-link {\n  color: #ef8157;\n}\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:hover,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:focus,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:active,\n.ReactTable.danger-pagination .-pagination .-btn.btn-link:active:focus {\n  background-color: transparent;\n  color: #eb6532;\n  text-decoration: none;\n  box-shadow: none;\n}\n.ReactTable.danger-pagination .-pagination .-btn:disabled {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.ReactTable .actions-right {\n  text-align: right;\n}\n\n.ReactTable .actions-left {\n  text-align: left;\n}\n\n.ReactTable .actions-center {\n  text-align: center;\n}\n\n.ReactTable * {\n  box-sizing: border-box;\n}\n\n.ReactTable .rt-table {\n  -webkit-box-flex: 1;\n  -ms-flex: auto 1;\n  flex: auto 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n\n.ReactTable .rt-thead {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 28px;\n  background-color: inherit;\n  padding-left: 0.8em;\n}\n.ReactTable .rt-thead.-filters input:focus,\n.ReactTable .rt-thead.-filters select:focus {\n  outline: none;\n  border: 1px solid #aaa;\n  color: #333;\n}\n\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n\n.ReactTable .rt-thead .rt-th:last-child {\n  text-align: right;\n}\n\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {\n  opacity: 0.6;\n  content: \"\\F0DC\";\n  position: relative;\n  display: inline-block;\n  bottom: 0px;\n  right: -7px;\n  font-family: \"FontAwesome\";\n}\n\n.ReactTable\n  .rt-thead\n  .rt-th.-cursor-pointer.-sort-desc\n  > div:first-of-type:after {\n  content: \"\\F0DD\";\n  top: -3px;\n  position: relative;\n  display: inline-block;\n  bottom: 0px;\n  right: -7px;\n  font-family: \"FontAwesome\";\n  opacity: 1;\n}\n\n.ReactTable\n  .rt-thead\n  .rt-th.-cursor-pointer.-sort-asc\n  > div:first-of-type:after {\n  content: \"\\F0DE\";\n  top: 3px;\n  position: relative;\n  display: inline-block;\n  bottom: 0px;\n  right: -7px;\n  font-family: \"FontAwesome\";\n  opacity: 1;\n}\n\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  font-size: 1.063rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 2.5em !important;\n  padding: 5px 5px;\n  line-height: normal;\n  position: relative;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n}\n\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-resizable-header-content:focus {\n  outline: none;\n}\n\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n\n.ReactTable .rt-tbody {\n  -webkit-box-flex: 99999;\n  -ms-flex: 99999 1 auto;\n  flex: 99999 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n}\n\n.ReactTable .rt-tr-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.ReactTable .rt-tr {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 12px 7px;\n  overflow: hidden;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n  line-height: 2;\n}\n\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  color: transparent;\n  margin: 0 10px;\n}\n\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n\n.ReactTable .rt-expander.-open:after {\n  -webkit-transform: translate(-50%, -50%) rotate(0);\n  transform: translate(-50%, -50%) rotate(0);\n}\n\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n\n.ReactTable .rt-tfoot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable .-pagination {\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 3px;\n}\n\n.ReactTable .-pagination input,\n.ReactTable .-pagination select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 28px;\n  background-color: inherit;\n  text-align: center;\n}\n.ReactTable .-pagination input:focus,\n.ReactTable .-pagination select:focus {\n  outline: none;\n  border: 1px solid #aaa;\n  color: #333;\n}\n\n.ReactTable .-pagination .-btn {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 3px;\n  padding: 6px;\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.6);\n  background: rgba(0, 0, 0, 0.1);\n  transition: all 0.1s ease;\n  cursor: pointer;\n  outline: none;\n}\n\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  text-align: center;\n}\n\n.ReactTable .-pagination .-center {\n  -webkit-box-flex: 1.5;\n  -ms-flex: 1.5;\n  flex: 1.5;\n  text-align: center;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n\n.ReactTable .-pagination .-pageInfo {\n  display: inline-block;\n  margin: 3px 10px;\n  white-space: nowrap;\n}\n\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n}\n\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.6);\n  -webkit-transform: translateY(-52%);\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n\n.ReactTable .-loading.-active > div {\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n}\n\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ReactTable .rt-thead .rt-th:focus {\n  outline: none;\n}\n\n.ReactTable .rt-thead .rt-th {\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border: 0;\n}\n\n.ReactTable .rt-table {\n  border: 1px solid #dee2e6;\n}\n\n.ReactTable .rt-table .rt-td {\n  border-top: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n}\n\n.ReactTable .btn.btn-icon {\n  margin: 0 3px;\n  padding: 5px 8px;\n}\n\n.react-tagsinput {\n  display: inline-block;\n  padding: 4px 6px;\n  max-width: 100%;\n  line-height: 22px;\n}\n\n.react-tagsinput-tag {\n  transition: all 0.17s linear;\n  cursor: pointer;\n  margin: 5px 3px 5px 0;\n  position: relative;\n  padding: 4px 8px 3px 0.8em;\n  border-radius: 12px;\n  color: #fff;\n  font-size: 0.75em;\n  font-weight: 500;\n  display: inline-block;\n  line-height: 1.5em;\n  text-transform: uppercase;\n  border: 1px solid;\n}\n\n.react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.react-tagsinput-tag a::before {\n  font-family: \"nucleo-icons\";\n  content: \"\\ea4f\";\n  padding: 0px 2px;\n}\n\n.react-tagsinput-tag a {\n  cursor: pointer;\n  position: absolute;\n  top: 3px;\n  right: 0px;\n  opacity: 0;\n  background-color: transparent;\n}\n\n.react-tagsinput-input {\n  background: transparent;\n  border: 0;\n  color: #777;\n  font-family: sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 6px;\n  margin-top: 1px;\n  outline: none;\n  padding: 5px;\n  width: 80px;\n}\n\n.react-tagsinput .react-tagsinput-tag {\n  -webkit-transition: all 300ms ease 0s;\n  -moz-transition: all 300ms ease 0s;\n  -o-transition: all 300ms ease 0s;\n  -ms-transition: all 300ms ease 0s;\n  transition: all 300ms ease 0s;\n  border-color: #66615b;\n  background-color: #66615b;\n}\n.react-tagsinput .react-tagsinput-tag:hover {\n  padding-right: 22px;\n}\n.react-tagsinput .react-tagsinput-tag:hover a {\n  opacity: 1;\n  padding-right: 4px;\n}\n.react-tagsinput .react-tagsinput-tag.primary {\n  border-color: #51cbce;\n  background-color: #51cbce;\n}\n.react-tagsinput .react-tagsinput-tag.info {\n  border-color: #0fa0cf;\n  background-color: #0fa0cf;\n}\n.react-tagsinput .react-tagsinput-tag.success {\n  border-color: #6bd098;\n  background-color: #6bd098;\n}\n.react-tagsinput .react-tagsinput-tag.warning {\n  border-color: #fbc658;\n  background-color: #fbc658;\n}\n.react-tagsinput .react-tagsinput-tag.danger {\n  border-color: #ef8157;\n  background-color: #ef8157;\n}\n.react-tagsinput .react-tagsinput-tag.neutral {\n  border-color: #ffffff;\n  background-color: #ffffff;\n  color: inherit;\n}\n\n/*# sourceMappingURL=paper-dashboard.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
